/*!
 * pixi.js - v4.4.5
 * Compiled Wed, 04 Nov 2020 21:40:25 UTC
 *
 * pixi.js is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.PIXI = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
    /**
     * Bit twiddling hacks for JavaScript.
     *
     * Author: Mikola Lysenko
     *
     * Ported from Stanford bit twiddling hack library:
     *    http://graphics.stanford.edu/~seander/bithacks.html
     */
    
    "use strict"; "use restrict";
    
    //Number of bits in an integer
    var INT_BITS = 32;
    
    //Constants
    exports.INT_BITS  = INT_BITS;
    exports.INT_MAX   =  0x7fffffff;
    exports.INT_MIN   = -1<<(INT_BITS-1);
    
    //Returns -1, 0, +1 depending on sign of x
    exports.sign = function(v) {
      return (v > 0) - (v < 0);
    }
    
    //Computes absolute value of integer
    exports.abs = function(v) {
      var mask = v >> (INT_BITS-1);
      return (v ^ mask) - mask;
    }
    
    //Computes minimum of integers x and y
    exports.min = function(x, y) {
      return y ^ ((x ^ y) & -(x < y));
    }
    
    //Computes maximum of integers x and y
    exports.max = function(x, y) {
      return x ^ ((x ^ y) & -(x < y));
    }
    
    //Checks if a number is a power of two
    exports.isPow2 = function(v) {
      return !(v & (v-1)) && (!!v);
    }
    
    //Computes log base 2 of v
    exports.log2 = function(v) {
      var r, shift;
      r =     (v > 0xFFFF) << 4; v >>>= r;
      shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
      shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
      shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
      return r | (v >> 1);
    }
    
    //Computes log base 10 of v
    exports.log10 = function(v) {
      return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
              (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
              (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
    }
    
    //Counts number of bits
    exports.popCount = function(v) {
      v = v - ((v >>> 1) & 0x55555555);
      v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
      return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
    }
    
    //Counts number of trailing zeros
    function countTrailingZeros(v) {
      var c = 32;
      v &= -v;
      if (v) c--;
      if (v & 0x0000FFFF) c -= 16;
      if (v & 0x00FF00FF) c -= 8;
      if (v & 0x0F0F0F0F) c -= 4;
      if (v & 0x33333333) c -= 2;
      if (v & 0x55555555) c -= 1;
      return c;
    }
    exports.countTrailingZeros = countTrailingZeros;
    
    //Rounds to next power of 2
    exports.nextPow2 = function(v) {
      v += v === 0;
      --v;
      v |= v >>> 1;
      v |= v >>> 2;
      v |= v >>> 4;
      v |= v >>> 8;
      v |= v >>> 16;
      return v + 1;
    }
    
    //Rounds down to previous power of 2
    exports.prevPow2 = function(v) {
      v |= v >>> 1;
      v |= v >>> 2;
      v |= v >>> 4;
      v |= v >>> 8;
      v |= v >>> 16;
      return v - (v>>>1);
    }
    
    //Computes parity of word
    exports.parity = function(v) {
      v ^= v >>> 16;
      v ^= v >>> 8;
      v ^= v >>> 4;
      v &= 0xf;
      return (0x6996 >>> v) & 1;
    }
    
    var REVERSE_TABLE = new Array(256);
    
    (function(tab) {
      for(var i=0; i<256; ++i) {
        var v = i, r = i, s = 7;
        for (v >>>= 1; v; v >>>= 1) {
          r <<= 1;
          r |= v & 1;
          --s;
        }
        tab[i] = (r << s) & 0xff;
      }
    })(REVERSE_TABLE);
    
    //Reverse bits in a 32 bit word
    exports.reverse = function(v) {
      return  (REVERSE_TABLE[ v         & 0xff] << 24) |
              (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
              (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
               REVERSE_TABLE[(v >>> 24) & 0xff];
    }
    
    //Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
    exports.interleave2 = function(x, y) {
      x &= 0xFFFF;
      x = (x | (x << 8)) & 0x00FF00FF;
      x = (x | (x << 4)) & 0x0F0F0F0F;
      x = (x | (x << 2)) & 0x33333333;
      x = (x | (x << 1)) & 0x55555555;
    
      y &= 0xFFFF;
      y = (y | (y << 8)) & 0x00FF00FF;
      y = (y | (y << 4)) & 0x0F0F0F0F;
      y = (y | (y << 2)) & 0x33333333;
      y = (y | (y << 1)) & 0x55555555;
    
      return x | (y << 1);
    }
    
    //Extracts the nth interleaved component
    exports.deinterleave2 = function(v, n) {
      v = (v >>> n) & 0x55555555;
      v = (v | (v >>> 1))  & 0x33333333;
      v = (v | (v >>> 2))  & 0x0F0F0F0F;
      v = (v | (v >>> 4))  & 0x00FF00FF;
      v = (v | (v >>> 16)) & 0x000FFFF;
      return (v << 16) >> 16;
    }
    
    
    //Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
    exports.interleave3 = function(x, y, z) {
      x &= 0x3FF;
      x  = (x | (x<<16)) & 4278190335;
      x  = (x | (x<<8))  & 251719695;
      x  = (x | (x<<4))  & 3272356035;
      x  = (x | (x<<2))  & 1227133513;
    
      y &= 0x3FF;
      y  = (y | (y<<16)) & 4278190335;
      y  = (y | (y<<8))  & 251719695;
      y  = (y | (y<<4))  & 3272356035;
      y  = (y | (y<<2))  & 1227133513;
      x |= (y << 1);
      
      z &= 0x3FF;
      z  = (z | (z<<16)) & 4278190335;
      z  = (z | (z<<8))  & 251719695;
      z  = (z | (z<<4))  & 3272356035;
      z  = (z | (z<<2))  & 1227133513;
      
      return x | (z << 2);
    }
    
    //Extracts nth interleaved component of a 3-tuple
    exports.deinterleave3 = function(v, n) {
      v = (v >>> n)       & 1227133513;
      v = (v | (v>>>2))   & 3272356035;
      v = (v | (v>>>4))   & 251719695;
      v = (v | (v>>>8))   & 4278190335;
      v = (v | (v>>>16))  & 0x3FF;
      return (v<<22)>>22;
    }
    
    //Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
    exports.nextCombination = function(v) {
      var t = v | (v - 1);
      return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
    }
    
    
    },{}],2:[function(require,module,exports){
    (function (global){(function (){
    /*! https://mths.be/punycode v1.4.1 by @mathias */
    ;(function(root) {
    
        /** Detect free variables */
        var freeExports = typeof exports == 'object' && exports &&
            !exports.nodeType && exports;
        var freeModule = typeof module == 'object' && module &&
            !module.nodeType && module;
        var freeGlobal = typeof global == 'object' && global;
        if (
            freeGlobal.global === freeGlobal ||
            freeGlobal.window === freeGlobal ||
            freeGlobal.self === freeGlobal
        ) {
            root = freeGlobal;
        }
    
        /**
         * The `punycode` object.
         * @name punycode
         * @type Object
         */
        var punycode,
    
        /** Highest positive signed 32-bit float value */
        maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
    
        /** Bootstring parameters */
        base = 36,
        tMin = 1,
        tMax = 26,
        skew = 38,
        damp = 700,
        initialBias = 72,
        initialN = 128, // 0x80
        delimiter = '-', // '\x2D'
    
        /** Regular expressions */
        regexPunycode = /^xn--/,
        regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
        regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
    
        /** Error messages */
        errors = {
            'overflow': 'Overflow: input needs wider integers to process',
            'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
            'invalid-input': 'Invalid input'
        },
    
        /** Convenience shortcuts */
        baseMinusTMin = base - tMin,
        floor = Math.floor,
        stringFromCharCode = String.fromCharCode,
    
        /** Temporary variable */
        key;
    
        /*--------------------------------------------------------------------------*/
    
        /**
         * A generic error utility function.
         * @private
         * @param {String} type The error type.
         * @returns {Error} Throws a `RangeError` with the applicable error message.
         */
        function error(type) {
            throw new RangeError(errors[type]);
        }
    
        /**
         * A generic `Array#map` utility function.
         * @private
         * @param {Array} array The array to iterate over.
         * @param {Function} callback The function that gets called for every array
         * item.
         * @returns {Array} A new array of values returned by the callback function.
         */
        function map(array, fn) {
            var length = array.length;
            var result = [];
            while (length--) {
                result[length] = fn(array[length]);
            }
            return result;
        }
    
        /**
         * A simple `Array#map`-like wrapper to work with domain name strings or email
         * addresses.
         * @private
         * @param {String} domain The domain name or email address.
         * @param {Function} callback The function that gets called for every
         * character.
         * @returns {Array} A new string of characters returned by the callback
         * function.
         */
        function mapDomain(string, fn) {
            var parts = string.split('@');
            var result = '';
            if (parts.length > 1) {
                // In email addresses, only the domain name should be punycoded. Leave
                // the local part (i.e. everything up to `@`) intact.
                result = parts[0] + '@';
                string = parts[1];
            }
            // Avoid `split(regex)` for IE8 compatibility. See #17.
            string = string.replace(regexSeparators, '\x2E');
            var labels = string.split('.');
            var encoded = map(labels, fn).join('.');
            return result + encoded;
        }
    
        /**
         * Creates an array containing the numeric code points of each Unicode
         * character in the string. While JavaScript uses UCS-2 internally,
         * this function will convert a pair of surrogate halves (each of which
         * UCS-2 exposes as separate characters) into a single code point,
         * matching UTF-16.
         * @see `punycode.ucs2.encode`
         * @see <https://mathiasbynens.be/notes/javascript-encoding>
         * @memberOf punycode.ucs2
         * @name decode
         * @param {String} string The Unicode input string (UCS-2).
         * @returns {Array} The new array of code points.
         */
        function ucs2decode(string) {
            var output = [],
                counter = 0,
                length = string.length,
                value,
                extra;
            while (counter < length) {
                value = string.charCodeAt(counter++);
                if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                    // high surrogate, and there is a next character
                    extra = string.charCodeAt(counter++);
                    if ((extra & 0xFC00) == 0xDC00) { // low surrogate
                        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                    } else {
                        // unmatched surrogate; only append this code unit, in case the next
                        // code unit is the high surrogate of a surrogate pair
                        output.push(value);
                        counter--;
                    }
                } else {
                    output.push(value);
                }
            }
            return output;
        }
    
        /**
         * Creates a string based on an array of numeric code points.
         * @see `punycode.ucs2.decode`
         * @memberOf punycode.ucs2
         * @name encode
         * @param {Array} codePoints The array of numeric code points.
         * @returns {String} The new Unicode string (UCS-2).
         */
        function ucs2encode(array) {
            return map(array, function(value) {
                var output = '';
                if (value > 0xFFFF) {
                    value -= 0x10000;
                    output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                    value = 0xDC00 | value & 0x3FF;
                }
                output += stringFromCharCode(value);
                return output;
            }).join('');
        }
    
        /**
         * Converts a basic code point into a digit/integer.
         * @see `digitToBasic()`
         * @private
         * @param {Number} codePoint The basic numeric code point value.
         * @returns {Number} The numeric value of a basic code point (for use in
         * representing integers) in the range `0` to `base - 1`, or `base` if
         * the code point does not represent a value.
         */
        function basicToDigit(codePoint) {
            if (codePoint - 48 < 10) {
                return codePoint - 22;
            }
            if (codePoint - 65 < 26) {
                return codePoint - 65;
            }
            if (codePoint - 97 < 26) {
                return codePoint - 97;
            }
            return base;
        }
    
        /**
         * Converts a digit/integer into a basic code point.
         * @see `basicToDigit()`
         * @private
         * @param {Number} digit The numeric value of a basic code point.
         * @returns {Number} The basic code point whose value (when used for
         * representing integers) is `digit`, which needs to be in the range
         * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
         * used; else, the lowercase form is used. The behavior is undefined
         * if `flag` is non-zero and `digit` has no uppercase form.
         */
        function digitToBasic(digit, flag) {
            //  0..25 map to ASCII a..z or A..Z
            // 26..35 map to ASCII 0..9
            return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
        }
    
        /**
         * Bias adaptation function as per section 3.4 of RFC 3492.
         * https://tools.ietf.org/html/rfc3492#section-3.4
         * @private
         */
        function adapt(delta, numPoints, firstTime) {
            var k = 0;
            delta = firstTime ? floor(delta / damp) : delta >> 1;
            delta += floor(delta / numPoints);
            for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
                delta = floor(delta / baseMinusTMin);
            }
            return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
        }
    
        /**
         * Converts a Punycode string of ASCII-only symbols to a string of Unicode
         * symbols.
         * @memberOf punycode
         * @param {String} input The Punycode string of ASCII-only symbols.
         * @returns {String} The resulting string of Unicode symbols.
         */
        function decode(input) {
            // Don't use UCS-2
            var output = [],
                inputLength = input.length,
                out,
                i = 0,
                n = initialN,
                bias = initialBias,
                basic,
                j,
                index,
                oldi,
                w,
                k,
                digit,
                t,
                /** Cached calculation results */
                baseMinusT;
    
            // Handle the basic code points: let `basic` be the number of input code
            // points before the last delimiter, or `0` if there is none, then copy
            // the first basic code points to the output.
    
            basic = input.lastIndexOf(delimiter);
            if (basic < 0) {
                basic = 0;
            }
    
            for (j = 0; j < basic; ++j) {
                // if it's not a basic code point
                if (input.charCodeAt(j) >= 0x80) {
                    error('not-basic');
                }
                output.push(input.charCodeAt(j));
            }
    
            // Main decoding loop: start just after the last delimiter if any basic code
            // points were copied; start at the beginning otherwise.
    
            for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
    
                // `index` is the index of the next character to be consumed.
                // Decode a generalized variable-length integer into `delta`,
                // which gets added to `i`. The overflow checking is easier
                // if we increase `i` as we go, then subtract off its starting
                // value at the end to obtain `delta`.
                for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
    
                    if (index >= inputLength) {
                        error('invalid-input');
                    }
    
                    digit = basicToDigit(input.charCodeAt(index++));
    
                    if (digit >= base || digit > floor((maxInt - i) / w)) {
                        error('overflow');
                    }
    
                    i += digit * w;
                    t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
    
                    if (digit < t) {
                        break;
                    }
    
                    baseMinusT = base - t;
                    if (w > floor(maxInt / baseMinusT)) {
                        error('overflow');
                    }
    
                    w *= baseMinusT;
    
                }
    
                out = output.length + 1;
                bias = adapt(i - oldi, out, oldi == 0);
    
                // `i` was supposed to wrap around from `out` to `0`,
                // incrementing `n` each time, so we'll fix that now:
                if (floor(i / out) > maxInt - n) {
                    error('overflow');
                }
    
                n += floor(i / out);
                i %= out;
    
                // Insert `n` at position `i` of the output
                output.splice(i++, 0, n);
    
            }
    
            return ucs2encode(output);
        }
    
        /**
         * Converts a string of Unicode symbols (e.g. a domain name label) to a
         * Punycode string of ASCII-only symbols.
         * @memberOf punycode
         * @param {String} input The string of Unicode symbols.
         * @returns {String} The resulting Punycode string of ASCII-only symbols.
         */
        function encode(input) {
            var n,
                delta,
                handledCPCount,
                basicLength,
                bias,
                j,
                m,
                q,
                k,
                t,
                currentValue,
                output = [],
                /** `inputLength` will hold the number of code points in `input`. */
                inputLength,
                /** Cached calculation results */
                handledCPCountPlusOne,
                baseMinusT,
                qMinusT;
    
            // Convert the input in UCS-2 to Unicode
            input = ucs2decode(input);
    
            // Cache the length
            inputLength = input.length;
    
            // Initialize the state
            n = initialN;
            delta = 0;
            bias = initialBias;
    
            // Handle the basic code points
            for (j = 0; j < inputLength; ++j) {
                currentValue = input[j];
                if (currentValue < 0x80) {
                    output.push(stringFromCharCode(currentValue));
                }
            }
    
            handledCPCount = basicLength = output.length;
    
            // `handledCPCount` is the number of code points that have been handled;
            // `basicLength` is the number of basic code points.
    
            // Finish the basic string - if it is not empty - with a delimiter
            if (basicLength) {
                output.push(delimiter);
            }
    
            // Main encoding loop:
            while (handledCPCount < inputLength) {
    
                // All non-basic code points < n have been handled already. Find the next
                // larger one:
                for (m = maxInt, j = 0; j < inputLength; ++j) {
                    currentValue = input[j];
                    if (currentValue >= n && currentValue < m) {
                        m = currentValue;
                    }
                }
    
                // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                // but guard against overflow
                handledCPCountPlusOne = handledCPCount + 1;
                if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
                    error('overflow');
                }
    
                delta += (m - n) * handledCPCountPlusOne;
                n = m;
    
                for (j = 0; j < inputLength; ++j) {
                    currentValue = input[j];
    
                    if (currentValue < n && ++delta > maxInt) {
                        error('overflow');
                    }
    
                    if (currentValue == n) {
                        // Represent delta as a generalized variable-length integer
                        for (q = delta, k = base; /* no condition */; k += base) {
                            t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
                            if (q < t) {
                                break;
                            }
                            qMinusT = q - t;
                            baseMinusT = base - t;
                            output.push(
                                stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
                            );
                            q = floor(qMinusT / baseMinusT);
                        }
    
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
    
                ++delta;
                ++n;
    
            }
            return output.join('');
        }
    
        /**
         * Converts a Punycode string representing a domain name or an email address
         * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
         * it doesn't matter if you call it on a string that has already been
         * converted to Unicode.
         * @memberOf punycode
         * @param {String} input The Punycoded domain name or email address to
         * convert to Unicode.
         * @returns {String} The Unicode representation of the given Punycode
         * string.
         */
        function toUnicode(input) {
            return mapDomain(input, function(string) {
                return regexPunycode.test(string)
                    ? decode(string.slice(4).toLowerCase())
                    : string;
            });
        }
    
        /**
         * Converts a Unicode string representing a domain name or an email address to
         * Punycode. Only the non-ASCII parts of the domain name will be converted,
         * i.e. it doesn't matter if you call it with a domain that's already in
         * ASCII.
         * @memberOf punycode
         * @param {String} input The domain name or email address to convert, as a
         * Unicode string.
         * @returns {String} The Punycode representation of the given domain name or
         * email address.
         */
        function toASCII(input) {
            return mapDomain(input, function(string) {
                return regexNonASCII.test(string)
                    ? 'xn--' + encode(string)
                    : string;
            });
        }
    
        /*--------------------------------------------------------------------------*/
    
        /** Define the public API */
        punycode = {
            /**
             * A string representing the current Punycode.js version number.
             * @memberOf punycode
             * @type String
             */
            'version': '1.4.1',
            /**
             * An object of methods to convert from JavaScript's internal character
             * representation (UCS-2) to Unicode code points, and back.
             * @see <https://mathiasbynens.be/notes/javascript-encoding>
             * @memberOf punycode
             * @type Object
             */
            'ucs2': {
                'decode': ucs2decode,
                'encode': ucs2encode
            },
            'decode': decode,
            'encode': encode,
            'toASCII': toASCII,
            'toUnicode': toUnicode
        };
    
        /** Expose `punycode` */
        // Some AMD build optimizers, like r.js, check for specific condition patterns
        // like the following:
        if (
            typeof define == 'function' &&
            typeof define.amd == 'object' &&
            define.amd
        ) {
            define('punycode', function() {
                return punycode;
            });
        } else if (freeExports && freeModule) {
            if (module.exports == freeExports) {
                // in Node.js, io.js, or RingoJS v0.8.0+
                freeModule.exports = punycode;
            } else {
                // in Narwhal or RingoJS v0.7.0-
                for (key in punycode) {
                    punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                }
            }
        } else {
            // in Rhino or a web browser
            root.punycode = punycode;
        }
    
    }(this));
    
    }).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    
    },{}],3:[function(require,module,exports){
    'use strict';
    
    module.exports = earcut;
    module.exports.default = earcut;
    
    function earcut(data, holeIndices, dim) {
    
        dim = dim || 2;
    
        var hasHoles = holeIndices && holeIndices.length,
            outerLen = hasHoles ? holeIndices[0] * dim : data.length,
            outerNode = linkedList(data, 0, outerLen, dim, true),
            triangles = [];
    
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    
        var minX, minY, maxX, maxY, x, y, invSize;
    
        if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
    
            for (var i = dim; i < outerLen; i += dim) {
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
    
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
    
        earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    
        return triangles;
    }
    
    // create a circular doubly linked list from polygon points in the specified winding order
    function linkedList(data, start, end, dim, clockwise) {
        var i, last;
    
        if (clockwise === (signedArea(data, start, end, dim) > 0)) {
            for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
        } else {
            for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
        }
    
        if (last && equals(last, last.next)) {
            removeNode(last);
            last = last.next;
        }
    
        return last;
    }
    
    // eliminate colinear or duplicate points
    function filterPoints(start, end) {
        if (!start) return start;
        if (!end) end = start;
    
        var p = start,
            again;
        do {
            again = false;
    
            if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
                removeNode(p);
                p = end = p.prev;
                if (p === p.next) break;
                again = true;
    
            } else {
                p = p.next;
            }
        } while (again || p !== end);
    
        return end;
    }
    
    // main ear slicing loop which triangulates a polygon (given as a linked list)
    function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
        if (!ear) return;
    
        // interlink polygon nodes in z-order
        if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    
        var stop = ear,
            prev, next;
    
        // iterate through ears, slicing them one by one
        while (ear.prev !== ear.next) {
            prev = ear.prev;
            next = ear.next;
    
            if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
                // cut off the triangle
                triangles.push(prev.i / dim);
                triangles.push(ear.i / dim);
                triangles.push(next.i / dim);
    
                removeNode(ear);
    
                // skipping the next vertex leads to less sliver triangles
                ear = next.next;
                stop = next.next;
    
                continue;
            }
    
            ear = next;
    
            // if we looped through the whole remaining polygon and can't find any more ears
            if (ear === stop) {
                // try filtering points and slicing again
                if (!pass) {
                    earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
    
                // if this didn't work, try curing all small self-intersections locally
                } else if (pass === 1) {
                    ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                    earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
    
                // as a last resort, try splitting the remaining polygon into two
                } else if (pass === 2) {
                    splitEarcut(ear, triangles, dim, minX, minY, invSize);
                }
    
                break;
            }
        }
    }
    
    // check whether a polygon node forms a valid ear with adjacent nodes
    function isEar(ear) {
        var a = ear.prev,
            b = ear,
            c = ear.next;
    
        if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    
        // now make sure we don't have other points inside the potential ear
        var p = ear.next.next;
    
        while (p !== ear.prev) {
            if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0) return false;
            p = p.next;
        }
    
        return true;
    }
    
    function isEarHashed(ear, minX, minY, invSize) {
        var a = ear.prev,
            b = ear,
            c = ear.next;
    
        if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    
        // triangle bbox; min & max are calculated like this for speed
        var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
            minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
            maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
            maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
    
        // z-order range for the current triangle bbox;
        var minZ = zOrder(minTX, minTY, minX, minY, invSize),
            maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
    
        var p = ear.prevZ,
            n = ear.nextZ;
    
        // look for points inside the triangle in both directions
        while (p && p.z >= minZ && n && n.z <= maxZ) {
            if (p !== ear.prev && p !== ear.next &&
                pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0) return false;
            p = p.prevZ;
    
            if (n !== ear.prev && n !== ear.next &&
                pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
                area(n.prev, n, n.next) >= 0) return false;
            n = n.nextZ;
        }
    
        // look for remaining points in decreasing z-order
        while (p && p.z >= minZ) {
            if (p !== ear.prev && p !== ear.next &&
                pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
                area(p.prev, p, p.next) >= 0) return false;
            p = p.prevZ;
        }
    
        // look for remaining points in increasing z-order
        while (n && n.z <= maxZ) {
            if (n !== ear.prev && n !== ear.next &&
                pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
                area(n.prev, n, n.next) >= 0) return false;
            n = n.nextZ;
        }
    
        return true;
    }
    
    // go through all polygon nodes and cure small local self-intersections
    function cureLocalIntersections(start, triangles, dim) {
        var p = start;
        do {
            var a = p.prev,
                b = p.next.next;
    
            if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
    
                triangles.push(a.i / dim);
                triangles.push(p.i / dim);
                triangles.push(b.i / dim);
    
                // remove two nodes involved
                removeNode(p);
                removeNode(p.next);
    
                p = start = b;
            }
            p = p.next;
        } while (p !== start);
    
        return filterPoints(p);
    }
    
    // try splitting polygon into two and triangulate them independently
    function splitEarcut(start, triangles, dim, minX, minY, invSize) {
        // look for a valid diagonal that divides the polygon into two
        var a = start;
        do {
            var b = a.next.next;
            while (b !== a.prev) {
                if (a.i !== b.i && isValidDiagonal(a, b)) {
                    // split the polygon in two by the diagonal
                    var c = splitPolygon(a, b);
    
                    // filter colinear points around the cuts
                    a = filterPoints(a, a.next);
                    c = filterPoints(c, c.next);
    
                    // run earcut on each half
                    earcutLinked(a, triangles, dim, minX, minY, invSize);
                    earcutLinked(c, triangles, dim, minX, minY, invSize);
                    return;
                }
                b = b.next;
            }
            a = a.next;
        } while (a !== start);
    }
    
    // link every hole into the outer loop, producing a single-ring polygon without holes
    function eliminateHoles(data, holeIndices, outerNode, dim) {
        var queue = [],
            i, len, start, end, list;
    
        for (i = 0, len = holeIndices.length; i < len; i++) {
            start = holeIndices[i] * dim;
            end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            list = linkedList(data, start, end, dim, false);
            if (list === list.next) list.steiner = true;
            queue.push(getLeftmost(list));
        }
    
        queue.sort(compareX);
    
        // process holes from left to right
        for (i = 0; i < queue.length; i++) {
            eliminateHole(queue[i], outerNode);
            outerNode = filterPoints(outerNode, outerNode.next);
        }
    
        return outerNode;
    }
    
    function compareX(a, b) {
        return a.x - b.x;
    }
    
    // find a bridge between vertices that connects hole with an outer ring and and link it
    function eliminateHole(hole, outerNode) {
        outerNode = findHoleBridge(hole, outerNode);
        if (outerNode) {
            var b = splitPolygon(outerNode, hole);
    
            // filter collinear points around the cuts
            filterPoints(outerNode, outerNode.next);
            filterPoints(b, b.next);
        }
    }
    
    // David Eberly's algorithm for finding a bridge between hole and outer polygon
    function findHoleBridge(hole, outerNode) {
        var p = outerNode,
            hx = hole.x,
            hy = hole.y,
            qx = -Infinity,
            m;
    
        // find a segment intersected by a ray from the hole's leftmost point to the left;
        // segment's endpoint with lesser x will be potential connection point
        do {
            if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
                var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
                if (x <= hx && x > qx) {
                    qx = x;
                    if (x === hx) {
                        if (hy === p.y) return p;
                        if (hy === p.next.y) return p.next;
                    }
                    m = p.x < p.next.x ? p : p.next;
                }
            }
            p = p.next;
        } while (p !== outerNode);
    
        if (!m) return null;
    
        if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    
        // look for points inside the triangle of hole point, segment intersection and endpoint;
        // if there are no points found, we have a valid connection;
        // otherwise choose the point of the minimum angle with the ray as connection point
    
        var stop = m,
            mx = m.x,
            my = m.y,
            tanMin = Infinity,
            tan;
    
        p = m;
    
        do {
            if (hx >= p.x && p.x >= mx && hx !== p.x &&
                    pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
    
                tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
    
                if (locallyInside(p, hole) &&
                    (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                    m = p;
                    tanMin = tan;
                }
            }
    
            p = p.next;
        } while (p !== stop);
    
        return m;
    }
    
    // whether sector in vertex m contains sector in vertex p in the same coordinates
    function sectorContainsSector(m, p) {
        return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
    }
    
    // interlink polygon nodes in z-order
    function indexCurve(start, minX, minY, invSize) {
        var p = start;
        do {
            if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
            p.prevZ = p.prev;
            p.nextZ = p.next;
            p = p.next;
        } while (p !== start);
    
        p.prevZ.nextZ = null;
        p.prevZ = null;
    
        sortLinked(p);
    }
    
    // Simon Tatham's linked list merge sort algorithm
    // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
    function sortLinked(list) {
        var i, p, q, e, tail, numMerges, pSize, qSize,
            inSize = 1;
    
        do {
            p = list;
            list = null;
            tail = null;
            numMerges = 0;
    
            while (p) {
                numMerges++;
                q = p;
                pSize = 0;
                for (i = 0; i < inSize; i++) {
                    pSize++;
                    q = q.nextZ;
                    if (!q) break;
                }
                qSize = inSize;
    
                while (pSize > 0 || (qSize > 0 && q)) {
    
                    if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                        e = p;
                        p = p.nextZ;
                        pSize--;
                    } else {
                        e = q;
                        q = q.nextZ;
                        qSize--;
                    }
    
                    if (tail) tail.nextZ = e;
                    else list = e;
    
                    e.prevZ = tail;
                    tail = e;
                }
    
                p = q;
            }
    
            tail.nextZ = null;
            inSize *= 2;
    
        } while (numMerges > 1);
    
        return list;
    }
    
    // z-order of a point given coords and inverse of the longer side of data bbox
    function zOrder(x, y, minX, minY, invSize) {
        // coords are transformed into non-negative 15-bit integer range
        x = 32767 * (x - minX) * invSize;
        y = 32767 * (y - minY) * invSize;
    
        x = (x | (x << 8)) & 0x00FF00FF;
        x = (x | (x << 4)) & 0x0F0F0F0F;
        x = (x | (x << 2)) & 0x33333333;
        x = (x | (x << 1)) & 0x55555555;
    
        y = (y | (y << 8)) & 0x00FF00FF;
        y = (y | (y << 4)) & 0x0F0F0F0F;
        y = (y | (y << 2)) & 0x33333333;
        y = (y | (y << 1)) & 0x55555555;
    
        return x | (y << 1);
    }
    
    // find the leftmost node of a polygon ring
    function getLeftmost(start) {
        var p = start,
            leftmost = start;
        do {
            if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
            p = p.next;
        } while (p !== start);
    
        return leftmost;
    }
    
    // check if a point lies within a convex triangle
    function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
        return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
               (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
               (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
    }
    
    // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
    function isValidDiagonal(a, b) {
        return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
               (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
                (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
                equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
    }
    
    // signed area of a triangle
    function area(p, q, r) {
        return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
    }
    
    // check if two points are equal
    function equals(p1, p2) {
        return p1.x === p2.x && p1.y === p2.y;
    }
    
    // check if two segments intersect
    function intersects(p1, q1, p2, q2) {
        var o1 = sign(area(p1, q1, p2));
        var o2 = sign(area(p1, q1, q2));
        var o3 = sign(area(p2, q2, p1));
        var o4 = sign(area(p2, q2, q1));
    
        if (o1 !== o2 && o3 !== o4) return true; // general case
    
        if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
        if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
        if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
        if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    
        return false;
    }
    
    // for collinear points p, q, r, check if point q lies on segment pr
    function onSegment(p, q, r) {
        return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
    }
    
    function sign(num) {
        return num > 0 ? 1 : num < 0 ? -1 : 0;
    }
    
    // check if a polygon diagonal intersects any polygon segments
    function intersectsPolygon(a, b) {
        var p = a;
        do {
            if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                    intersects(p, p.next, a, b)) return true;
            p = p.next;
        } while (p !== a);
    
        return false;
    }
    
    // check if a polygon diagonal is locally inside the polygon
    function locallyInside(a, b) {
        return area(a.prev, a, a.next) < 0 ?
            area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
            area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
    }
    
    // check if the middle point of a polygon diagonal is inside the polygon
    function middleInside(a, b) {
        var p = a,
            inside = false,
            px = (a.x + b.x) / 2,
            py = (a.y + b.y) / 2;
        do {
            if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                    (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
                inside = !inside;
            p = p.next;
        } while (p !== a);
    
        return inside;
    }
    
    // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
    // if one belongs to the outer ring and another to a hole, it merges it into a single ring
    function splitPolygon(a, b) {
        var a2 = new Node(a.i, a.x, a.y),
            b2 = new Node(b.i, b.x, b.y),
            an = a.next,
            bp = b.prev;
    
        a.next = b;
        b.prev = a;
    
        a2.next = an;
        an.prev = a2;
    
        b2.next = a2;
        a2.prev = b2;
    
        bp.next = b2;
        b2.prev = bp;
    
        return b2;
    }
    
    // create a node and optionally link it with previous one (in a circular doubly linked list)
    function insertNode(i, x, y, last) {
        var p = new Node(i, x, y);
    
        if (!last) {
            p.prev = p;
            p.next = p;
    
        } else {
            p.next = last.next;
            p.prev = last;
            last.next.prev = p;
            last.next = p;
        }
        return p;
    }
    
    function removeNode(p) {
        p.next.prev = p.prev;
        p.prev.next = p.next;
    
        if (p.prevZ) p.prevZ.nextZ = p.nextZ;
        if (p.nextZ) p.nextZ.prevZ = p.prevZ;
    }
    
    function Node(i, x, y) {
        // vertex index in coordinates array
        this.i = i;
    
        // vertex coordinates
        this.x = x;
        this.y = y;
    
        // previous and next vertex nodes in a polygon ring
        this.prev = null;
        this.next = null;
    
        // z-order curve value
        this.z = null;
    
        // previous and next nodes in z-order
        this.prevZ = null;
        this.nextZ = null;
    
        // indicates whether this is a steiner point
        this.steiner = false;
    }
    
    // return a percentage difference between the polygon area and its triangulation area;
    // used to verify correctness of triangulation
    earcut.deviation = function (data, holeIndices, dim, triangles) {
        var hasHoles = holeIndices && holeIndices.length;
        var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    
        var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
        if (hasHoles) {
            for (var i = 0, len = holeIndices.length; i < len; i++) {
                var start = holeIndices[i] * dim;
                var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
                polygonArea -= Math.abs(signedArea(data, start, end, dim));
            }
        }
    
        var trianglesArea = 0;
        for (i = 0; i < triangles.length; i += 3) {
            var a = triangles[i] * dim;
            var b = triangles[i + 1] * dim;
            var c = triangles[i + 2] * dim;
            trianglesArea += Math.abs(
                (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
                (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
        }
    
        return polygonArea === 0 && trianglesArea === 0 ? 0 :
            Math.abs((trianglesArea - polygonArea) / polygonArea);
    };
    
    function signedArea(data, start, end, dim) {
        var sum = 0;
        for (var i = start, j = end - dim; i < end; i += dim) {
            sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
            j = i;
        }
        return sum;
    }
    
    // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
    earcut.flatten = function (data) {
        var dim = data[0][0].length,
            result = {vertices: [], holes: [], dimensions: dim},
            holeIndex = 0;
    
        for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].length; j++) {
                for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
            }
            if (i > 0) {
                holeIndex += data[i - 1].length;
                result.holes.push(holeIndex);
            }
        }
        return result;
    };
    
    },{}],4:[function(require,module,exports){
    'use strict';
    
    var has = Object.prototype.hasOwnProperty
      , prefix = '~';
    
    /**
     * Constructor to create a storage for our `EE` objects.
     * An `Events` instance is a plain object whose properties are event names.
     *
     * @constructor
     * @api private
     */
    function Events() {}
    
    //
    // We try to not inherit from `Object.prototype`. In some engines creating an
    // instance in this way is faster than calling `Object.create(null)` directly.
    // If `Object.create(null)` is not supported we prefix the event names with a
    // character to make sure that the built-in object properties are not
    // overridden or used as an attack vector.
    //
    if (Object.create) {
      Events.prototype = Object.create(null);
    
      //
      // This hack is needed because the `__proto__` property is still inherited in
      // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
      //
      if (!new Events().__proto__) prefix = false;
    }
    
    /**
     * Representation of a single event listener.
     *
     * @param {Function} fn The listener function.
     * @param {Mixed} context The context to invoke the listener with.
     * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
     * @constructor
     * @api private
     */
    function EE(fn, context, once) {
      this.fn = fn;
      this.context = context;
      this.once = once || false;
    }
    
    /**
     * Minimal `EventEmitter` interface that is molded against the Node.js
     * `EventEmitter` interface.
     *
     * @constructor
     * @api public
     */
    function EventEmitter() {
      this._events = new Events();
      this._eventsCount = 0;
    }
    
    /**
     * Return an array listing the events for which the emitter has registered
     * listeners.
     *
     * @returns {Array}
     * @api public
     */
    EventEmitter.prototype.eventNames = function eventNames() {
      var names = []
        , events
        , name;
    
      if (this._eventsCount === 0) return names;
    
      for (name in (events = this._events)) {
        if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
      }
    
      if (Object.getOwnPropertySymbols) {
        return names.concat(Object.getOwnPropertySymbols(events));
      }
    
      return names;
    };
    
    /**
     * Return the listeners registered for a given event.
     *
     * @param {String|Symbol} event The event name.
     * @param {Boolean} exists Only check if there are listeners.
     * @returns {Array|Boolean}
     * @api public
     */
    EventEmitter.prototype.listeners = function listeners(event, exists) {
      var evt = prefix ? prefix + event : event
        , available = this._events[evt];
    
      if (exists) return !!available;
      if (!available) return [];
      if (available.fn) return [available.fn];
    
      for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
        ee[i] = available[i].fn;
      }
    
      return ee;
    };
    
    /**
     * Calls each of the listeners registered for a given event.
     *
     * @param {String|Symbol} event The event name.
     * @returns {Boolean} `true` if the event had listeners, else `false`.
     * @api public
     */
    EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
      var evt = prefix ? prefix + event : event;
    
      if (!this._events[evt]) return false;
    
      var listeners = this._events[evt]
        , len = arguments.length
        , args
        , i;
    
      if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
    
        switch (len) {
          case 1: return listeners.fn.call(listeners.context), true;
          case 2: return listeners.fn.call(listeners.context, a1), true;
          case 3: return listeners.fn.call(listeners.context, a1, a2), true;
          case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
          case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
          case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
    
        for (i = 1, args = new Array(len -1); i < len; i++) {
          args[i - 1] = arguments[i];
        }
    
        listeners.fn.apply(listeners.context, args);
      } else {
        var length = listeners.length
          , j;
    
        for (i = 0; i < length; i++) {
          if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
    
          switch (len) {
            case 1: listeners[i].fn.call(listeners[i].context); break;
            case 2: listeners[i].fn.call(listeners[i].context, a1); break;
            case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
            case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
            default:
              if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
                args[j - 1] = arguments[j];
              }
    
              listeners[i].fn.apply(listeners[i].context, args);
          }
        }
      }
    
      return true;
    };
    
    /**
     * Add a listener for a given event.
     *
     * @param {String|Symbol} event The event name.
     * @param {Function} fn The listener function.
     * @param {Mixed} [context=this] The context to invoke the listener with.
     * @returns {EventEmitter} `this`.
     * @api public
     */
    EventEmitter.prototype.on = function on(event, fn, context) {
      var listener = new EE(fn, context || this)
        , evt = prefix ? prefix + event : event;
    
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
    
      return this;
    };
    
    /**
     * Add a one-time listener for a given event.
     *
     * @param {String|Symbol} event The event name.
     * @param {Function} fn The listener function.
     * @param {Mixed} [context=this] The context to invoke the listener with.
     * @returns {EventEmitter} `this`.
     * @api public
     */
    EventEmitter.prototype.once = function once(event, fn, context) {
      var listener = new EE(fn, context || this, true)
        , evt = prefix ? prefix + event : event;
    
      if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
      else if (!this._events[evt].fn) this._events[evt].push(listener);
      else this._events[evt] = [this._events[evt], listener];
    
      return this;
    };
    
    /**
     * Remove the listeners of a given event.
     *
     * @param {String|Symbol} event The event name.
     * @param {Function} fn Only remove the listeners that match this function.
     * @param {Mixed} context Only remove the listeners that have this context.
     * @param {Boolean} once Only remove one-time listeners.
     * @returns {EventEmitter} `this`.
     * @api public
     */
    EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
      var evt = prefix ? prefix + event : event;
    
      if (!this._events[evt]) return this;
      if (!fn) {
        if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
        return this;
      }
    
      var listeners = this._events[evt];
    
      if (listeners.fn) {
        if (
             listeners.fn === fn
          && (!once || listeners.once)
          && (!context || listeners.context === context)
        ) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        for (var i = 0, events = [], length = listeners.length; i < length; i++) {
          if (
               listeners[i].fn !== fn
            || (once && !listeners[i].once)
            || (context && listeners[i].context !== context)
          ) {
            events.push(listeners[i]);
          }
        }
    
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else if (--this._eventsCount === 0) this._events = new Events();
        else delete this._events[evt];
      }
    
      return this;
    };
    
    /**
     * Remove all listeners, or those of the specified event.
     *
     * @param {String|Symbol} [event] The event name.
     * @returns {EventEmitter} `this`.
     * @api public
     */
    EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
      var evt;
    
      if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) {
          if (--this._eventsCount === 0) this._events = new Events();
          else delete this._events[evt];
        }
      } else {
        this._events = new Events();
        this._eventsCount = 0;
      }
    
      return this;
    };
    
    //
    // Alias methods names because people roll like that.
    //
    EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    
    //
    // This function doesn't apply anymore.
    //
    EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
      return this;
    };
    
    //
    // Expose the prefix.
    //
    EventEmitter.prefixed = prefix;
    
    //
    // Allow `EventEmitter` to be imported as module namespace.
    //
    EventEmitter.EventEmitter = EventEmitter;
    
    //
    // Expose the module.
    //
    if ('undefined' !== typeof module) {
      module.exports = EventEmitter;
    }
    
    },{}],5:[function(require,module,exports){
    /**
     * isMobile.js v0.4.1
     *
     * A simple library to detect Apple phones and tablets,
     * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
     * and any kind of seven inch device, via user agent sniffing.
     *
     * @author: Kai Mallea (kmallea@gmail.com)
     *
     * @license: http://creativecommons.org/publicdomain/zero/1.0/
     */
    (function (global) {
    
        var apple_phone         = /iPhone/i,
            apple_ipod          = /iPod/i,
            apple_tablet        = /iPad/i,
            android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
            android_tablet      = /Android/i,
            amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
            amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
            windows_phone       = /Windows Phone/i,
            windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
            other_blackberry    = /BlackBerry/i,
            other_blackberry_10 = /BB10/i,
            other_opera         = /Opera Mini/i,
            other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
            other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
            seven_inch = new RegExp(
                '(?:' +         // Non-capturing group
    
                'Nexus 7' +     // Nexus 7
    
                '|' +           // OR
    
                'BNTV250' +     // B&N Nook Tablet 7 inch
    
                '|' +           // OR
    
                'Kindle Fire' + // Kindle Fire
    
                '|' +           // OR
    
                'Silk' +        // Kindle Fire, Silk Accelerated
    
                '|' +           // OR
    
                'GT-P1000' +    // Galaxy Tab 7 inch
    
                ')',            // End non-capturing group
    
                'i');           // Case-insensitive matching
    
        var match = function(regex, userAgent) {
            return regex.test(userAgent);
        };
    
        var IsMobileClass = function(userAgent) {
            var ua = userAgent || navigator.userAgent;
    
            // Facebook mobile app's integrated browser adds a bunch of strings that
            // match everything. Strip it out if it exists.
            var tmp = ua.split('[FBAN');
            if (typeof tmp[1] !== 'undefined') {
                ua = tmp[0];
            }
    
            // Twitter mobile app's integrated browser on iPad adds a "Twitter for
            // iPhone" string. Same probable happens on other tablet platforms.
            // This will confuse detection so strip it out if it exists.
            tmp = ua.split('Twitter');
            if (typeof tmp[1] !== 'undefined') {
                ua = tmp[0];
            }
    
            this.apple = {
                phone:  match(apple_phone, ua),
                ipod:   match(apple_ipod, ua),
                tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
                device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
            };
            this.amazon = {
                phone:  match(amazon_phone, ua),
                tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
                device: match(amazon_phone, ua) || match(amazon_tablet, ua)
            };
            this.android = {
                phone:  match(amazon_phone, ua) || match(android_phone, ua),
                tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
                device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
            };
            this.windows = {
                phone:  match(windows_phone, ua),
                tablet: match(windows_tablet, ua),
                device: match(windows_phone, ua) || match(windows_tablet, ua)
            };
            this.other = {
                blackberry:   match(other_blackberry, ua),
                blackberry10: match(other_blackberry_10, ua),
                opera:        match(other_opera, ua),
                firefox:      match(other_firefox, ua),
                chrome:       match(other_chrome, ua),
                device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
            };
            this.seven_inch = match(seven_inch, ua);
            this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;
    
            // excludes 'other' devices and ipods, targeting touchscreen phones
            this.phone = this.apple.phone || this.android.phone || this.windows.phone;
    
            // excludes 7 inch devices, classifying as phone or tablet is left to the user
            this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;
    
            if (typeof window === 'undefined') {
                return this;
            }
        };
    
        var instantiate = function() {
            var IM = new IsMobileClass();
            IM.Class = IsMobileClass;
            return IM;
        };
    
        if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
            //node
            module.exports = IsMobileClass;
        } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
            //browserify
            module.exports = instantiate();
        } else if (typeof define === 'function' && define.amd) {
            //AMD
            define('isMobile', [], global.isMobile = instantiate());
        } else {
            global.isMobile = instantiate();
        }
    
    })(this);
    
    },{}],6:[function(require,module,exports){
    'use strict';
    
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    
    var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
    
    var MiniSignalBinding = (function () {
      function MiniSignalBinding(fn, once, thisArg) {
        if (once === undefined) once = false;
    
        _classCallCheck(this, MiniSignalBinding);
    
        this._fn = fn;
        this._once = once;
        this._thisArg = thisArg;
        this._next = this._prev = this._owner = null;
      }
    
      _createClass(MiniSignalBinding, [{
        key: 'detach',
        value: function detach() {
          if (this._owner === null) return false;
          this._owner.detach(this);
          return true;
        }
      }]);
    
      return MiniSignalBinding;
    })();
    
    function _addMiniSignalBinding(self, node) {
      if (!self._head) {
        self._head = node;
        self._tail = node;
      } else {
        self._tail._next = node;
        node._prev = self._tail;
        self._tail = node;
      }
    
      node._owner = self;
    
      return node;
    }
    
    var MiniSignal = (function () {
      function MiniSignal() {
        _classCallCheck(this, MiniSignal);
    
        this._head = this._tail = undefined;
      }
    
      _createClass(MiniSignal, [{
        key: 'handlers',
        value: function handlers() {
          var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
    
          var node = this._head;
    
          if (exists) return !!node;
    
          var ee = [];
    
          while (node) {
            ee.push(node);
            node = node._next;
          }
    
          return ee;
        }
      }, {
        key: 'has',
        value: function has(node) {
          if (!(node instanceof MiniSignalBinding)) {
            throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
          }
    
          return node._owner === this;
        }
      }, {
        key: 'dispatch',
        value: function dispatch() {
          var node = this._head;
    
          if (!node) return false;
    
          while (node) {
            if (node._once) this.detach(node);
            node._fn.apply(node._thisArg, arguments);
            node = node._next;
          }
    
          return true;
        }
      }, {
        key: 'add',
        value: function add(fn) {
          var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
    
          if (typeof fn !== 'function') {
            throw new Error('MiniSignal#add(): First arg must be a Function.');
          }
          return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
        }
      }, {
        key: 'once',
        value: function once(fn) {
          var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
    
          if (typeof fn !== 'function') {
            throw new Error('MiniSignal#once(): First arg must be a Function.');
          }
          return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
        }
      }, {
        key: 'detach',
        value: function detach(node) {
          if (!(node instanceof MiniSignalBinding)) {
            throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
          }
          if (node._owner !== this) return this;
    
          if (node._prev) node._prev._next = node._next;
          if (node._next) node._next._prev = node._prev;
    
          if (node === this._head) {
            this._head = node._next;
            if (node._next === null) {
              this._tail = null;
            }
          } else if (node === this._tail) {
            this._tail = node._prev;
            this._tail._next = null;
          }
    
          node._owner = null;
          return this;
        }
      }, {
        key: 'detachAll',
        value: function detachAll() {
          var node = this._head;
          if (!node) return this;
    
          this._head = this._tail = null;
    
          while (node) {
            node._owner = null;
            node = node._next;
          }
          return this;
        }
      }]);
    
      return MiniSignal;
    })();
    
    MiniSignal.MiniSignalBinding = MiniSignalBinding;
    
    exports['default'] = MiniSignal;
    module.exports = exports['default'];
    
    },{}],7:[function(require,module,exports){
    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    
    'use strict';
    /* eslint-disable no-unused-vars */
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    
    function toObject(val) {
        if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
        }
    
        return Object(val);
    }
    
    function shouldUseNative() {
        try {
            if (!Object.assign) {
                return false;
            }
    
            // Detect buggy property enumeration order in older V8 versions.
    
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118
            var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
            test1[5] = 'de';
            if (Object.getOwnPropertyNames(test1)[0] === '5') {
                return false;
            }
    
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test2 = {};
            for (var i = 0; i < 10; i++) {
                test2['_' + String.fromCharCode(i)] = i;
            }
            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
                return test2[n];
            });
            if (order2.join('') !== '0123456789') {
                return false;
            }
    
            // https://bugs.chromium.org/p/v8/issues/detail?id=3056
            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
                test3[letter] = letter;
            });
            if (Object.keys(Object.assign({}, test3)).join('') !==
                    'abcdefghijklmnopqrst') {
                return false;
            }
    
            return true;
        } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
        }
    }
    
    module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;
    
        for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);
    
            for (var key in from) {
                if (hasOwnProperty.call(from, key)) {
                    to[key] = from[key];
                }
            }
    
            if (getOwnPropertySymbols) {
                symbols = getOwnPropertySymbols(from);
                for (var i = 0; i < symbols.length; i++) {
                    if (propIsEnumerable.call(from, symbols[i])) {
                        to[symbols[i]] = from[symbols[i]];
                    }
                }
            }
        }
    
        return to;
    };
    
    },{}],8:[function(require,module,exports){
    'use strict'
    
    function parseURI (str, opts) {
      if (!str) return undefined
    
      opts = opts || {}
    
      var o = {
        key: [
          'source',
          'protocol',
          'authority',
          'userInfo',
          'user',
          'password',
          'host',
          'port',
          'relative',
          'path',
          'directory',
          'file',
          'query',
          'anchor'
        ],
        q: {
          name: 'queryKey',
          parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        },
        parser: {
          strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
          loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }
      }
    
      var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
      var uri = {}
      var i = 14
    
      while (i--) uri[o.key[i]] = m[i] || ''
    
      uri[o.q.name] = {}
      uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
        if ($1) uri[o.q.name][$1] = $2
      })
    
      return uri
    }
    
    module.exports = parseURI
    
    },{}],9:[function(require,module,exports){
    (function (process){(function (){
    // .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
    // backported and transplited with Babel, with backwards-compat fixes
    
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    
    // resolves . and .. elements in a path array with directory names there
    // must be no slashes, empty elements, or device names (c:\) in the array
    // (so also no leading and trailing slashes - it does not distinguish
    // relative and absolute paths)
    function normalizeArray(parts, allowAboveRoot) {
      // if the path tries to go above the root, `up` ends up > 0
      var up = 0;
      for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
          parts.splice(i, 1);
        } else if (last === '..') {
          parts.splice(i, 1);
          up++;
        } else if (up) {
          parts.splice(i, 1);
          up--;
        }
      }
    
      // if the path is allowed to go above the root, restore leading ..s
      if (allowAboveRoot) {
        for (; up--; up) {
          parts.unshift('..');
        }
      }
    
      return parts;
    }
    
    // path.resolve([from ...], to)
    // posix version
    exports.resolve = function() {
      var resolvedPath = '',
          resolvedAbsolute = false;
    
      for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = (i >= 0) ? arguments[i] : process.cwd();
    
        // Skip empty and invalid entries
        if (typeof path !== 'string') {
          throw new TypeError('Arguments to path.resolve must be strings');
        } else if (!path) {
          continue;
        }
    
        resolvedPath = path + '/' + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
      }
    
      // At this point the path should be resolved to a full absolute path, but
      // handle relative paths to be safe (might happen when process.cwd() fails)
    
      // Normalize the path
      resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
        return !!p;
      }), !resolvedAbsolute).join('/');
    
      return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
    };
    
    // path.normalize(path)
    // posix version
    exports.normalize = function(path) {
      var isAbsolute = exports.isAbsolute(path),
          trailingSlash = substr(path, -1) === '/';
    
      // Normalize the path
      path = normalizeArray(filter(path.split('/'), function(p) {
        return !!p;
      }), !isAbsolute).join('/');
    
      if (!path && !isAbsolute) {
        path = '.';
      }
      if (path && trailingSlash) {
        path += '/';
      }
    
      return (isAbsolute ? '/' : '') + path;
    };
    
    // posix version
    exports.isAbsolute = function(path) {
      return path.charAt(0) === '/';
    };
    
    // posix version
    exports.join = function() {
      var paths = Array.prototype.slice.call(arguments, 0);
      return exports.normalize(filter(paths, function(p, index) {
        if (typeof p !== 'string') {
          throw new TypeError('Arguments to path.join must be strings');
        }
        return p;
      }).join('/'));
    };
    
    
    // path.relative(from, to)
    // posix version
    exports.relative = function(from, to) {
      from = exports.resolve(from).substr(1);
      to = exports.resolve(to).substr(1);
    
      function trim(arr) {
        var start = 0;
        for (; start < arr.length; start++) {
          if (arr[start] !== '') break;
        }
    
        var end = arr.length - 1;
        for (; end >= 0; end--) {
          if (arr[end] !== '') break;
        }
    
        if (start > end) return [];
        return arr.slice(start, end - start + 1);
      }
    
      var fromParts = trim(from.split('/'));
      var toParts = trim(to.split('/'));
    
      var length = Math.min(fromParts.length, toParts.length);
      var samePartsLength = length;
      for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
          samePartsLength = i;
          break;
        }
      }
    
      var outputParts = [];
      for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
      }
    
      outputParts = outputParts.concat(toParts.slice(samePartsLength));
    
      return outputParts.join('/');
    };
    
    exports.sep = '/';
    exports.delimiter = ':';
    
    exports.dirname = function (path) {
      if (typeof path !== 'string') path = path + '';
      if (path.length === 0) return '.';
      var code = path.charCodeAt(0);
      var hasRoot = code === 47 /*/*/;
      var end = -1;
      var matchedSlash = true;
      for (var i = path.length - 1; i >= 1; --i) {
        code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            if (!matchedSlash) {
              end = i;
              break;
            }
          } else {
          // We saw the first non-path separator
          matchedSlash = false;
        }
      }
    
      if (end === -1) return hasRoot ? '/' : '.';
      if (hasRoot && end === 1) {
        // return '//';
        // Backwards-compat fix:
        return '/';
      }
      return path.slice(0, end);
    };
    
    function basename(path) {
      if (typeof path !== 'string') path = path + '';
    
      var start = 0;
      var end = -1;
      var matchedSlash = true;
      var i;
    
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }
    
      if (end === -1) return '';
      return path.slice(start, end);
    }
    
    // Uses a mixed approach for backwards-compatibility, as ext behavior changed
    // in new Node.js versions, so only basename() above is backported here
    exports.basename = function (path, ext) {
      var f = basename(path);
      if (ext && f.substr(-1 * ext.length) === ext) {
        f = f.substr(0, f.length - ext.length);
      }
      return f;
    };
    
    exports.extname = function (path) {
      if (typeof path !== 'string') path = path + '';
      var startDot = -1;
      var startPart = 0;
      var end = -1;
      var matchedSlash = true;
      // Track the state of characters (if any) we see before our first dot and
      // after any path separator we find
      var preDotState = 0;
      for (var i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              startPart = i + 1;
              break;
            }
            continue;
          }
        if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // extension
          matchedSlash = false;
          end = i + 1;
        }
        if (code === 46 /*.*/) {
            // If this is our first dot, mark it as the start of our extension
            if (startDot === -1)
              startDot = i;
            else if (preDotState !== 1)
              preDotState = 1;
        } else if (startDot !== -1) {
          // We saw a non-dot and non-path separator before our dot, so we should
          // have a good chance at having a non-empty extension
          preDotState = -1;
        }
      }
    
      if (startDot === -1 || end === -1 ||
          // We saw a non-dot character immediately before the dot
          preDotState === 0 ||
          // The (right-most) trimmed path component is exactly '..'
          preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
        return '';
      }
      return path.slice(startDot, end);
    };
    
    function filter (xs, f) {
        if (xs.filter) return xs.filter(f);
        var res = [];
        for (var i = 0; i < xs.length; i++) {
            if (f(xs[i], i, xs)) res.push(xs[i]);
        }
        return res;
    }
    
    // String.prototype.substr - negative index don't work in IE8
    var substr = 'ab'.substr(-1) === 'b'
        ? function (str, start, len) { return str.substr(start, len) }
        : function (str, start, len) {
            if (start < 0) start = str.length + start;
            return str.substr(start, len);
        }
    ;
    
    }).call(this)}).call(this,require('_process'))
    
    },{"_process":27}],10:[function(require,module,exports){
    var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);
    
    /**
     * Helper class to create a webGL buffer
     *
     * @class
     * @memberof PIXI.glCore
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
     * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
     * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
     */
    var Buffer = function(gl, type, data, drawType)
    {
    
        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        /**
         * The WebGL buffer, created upon instantiation
         *
         * @member {WebGLBuffer}
         */
        this.buffer = gl.createBuffer();
    
        /**
         * The type of the buffer
         *
         * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
         */
        this.type = type || gl.ARRAY_BUFFER;
    
        /**
         * The draw type of the buffer
         *
         * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
         */
        this.drawType = drawType || gl.STATIC_DRAW;
    
        /**
         * The data in the buffer, as a typed array
         *
         * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
         */
        this.data = EMPTY_ARRAY_BUFFER;
    
        if(data)
        {
            this.upload(data);
        }
    
        this._updateID = 0;
    };
    
    /**
     * Uploads the buffer to the GPU
     * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
     * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
     * @param dontBind {Boolean} whether to bind the buffer before uploading it
     */
    Buffer.prototype.upload = function(data, offset, dontBind)
    {
        // todo - needed?
        if(!dontBind) this.bind();
    
        var gl = this.gl;
    
        data = data || this.data;
        offset = offset || 0;
    
        if(this.data.byteLength >= data.byteLength)
        {
            gl.bufferSubData(this.type, offset, data);
        }
        else
        {
            gl.bufferData(this.type, data, this.drawType);
        }
    
        this.data = data;
    };
    /**
     * Binds the buffer
     *
     */
    Buffer.prototype.bind = function()
    {
        var gl = this.gl;
        gl.bindBuffer(this.type, this.buffer);
    };
    
    Buffer.createVertexBuffer = function(gl, data, drawType)
    {
        return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
    };
    
    Buffer.createIndexBuffer = function(gl, data, drawType)
    {
        return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
    };
    
    Buffer.create = function(gl, type, data, drawType)
    {
        return new Buffer(gl, type, data, drawType);
    };
    
    /**
     * Destroys the buffer
     *
     */
    Buffer.prototype.destroy = function(){
        this.gl.deleteBuffer(this.buffer);
    };
    
    module.exports = Buffer;
    
    },{}],11:[function(require,module,exports){
    
    var Texture = require('./GLTexture');
    
    /**
     * Helper class to create a webGL Framebuffer
     *
     * @class
     * @memberof PIXI.glCore
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param width {Number} the width of the drawing area of the frame buffer
     * @param height {Number} the height of the drawing area of the frame buffer
     */
    var Framebuffer = function(gl, width, height)
    {
        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        /**
         * The frame buffer
         *
         * @member {WebGLFramebuffer}
         */
        this.framebuffer = gl.createFramebuffer();
    
        /**
         * The stencil buffer
         *
         * @member {WebGLRenderbuffer}
         */
        this.stencil = null;
    
        /**
         * The stencil buffer
         *
         * @member {PIXI.glCore.GLTexture}
         */
        this.texture = null;
    
        /**
         * The width of the drawing area of the buffer
         *
         * @member {Number}
         */
        this.width = width || 100;
        /**
         * The height of the drawing area of the buffer
         *
         * @member {Number}
         */
        this.height = height || 100;
    };
    
    /**
     * Adds a texture to the frame buffer
     * @param texture {PIXI.glCore.GLTexture}
     */
    Framebuffer.prototype.enableTexture = function(texture)
    {
        var gl = this.gl;
    
        this.texture = texture || new Texture(gl);
    
        this.texture.bind();
    
        //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    
        this.bind();
    
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
    };
    
    /**
     * Initialises the stencil buffer
     */
    Framebuffer.prototype.enableStencil = function()
    {
        if(this.stencil)return;
    
        var gl = this.gl;
    
        this.stencil = gl.createRenderbuffer();
    
        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
    
        // TODO.. this is depth AND stencil?
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.width  , this.height );
    
    
    };
    
    /**
     * Erases the drawing area and fills it with a colour
     * @param  r {Number} the red value of the clearing colour
     * @param  g {Number} the green value of the clearing colour
     * @param  b {Number} the blue value of the clearing colour
     * @param  a {Number} the alpha value of the clearing colour
     */
    Framebuffer.prototype.clear = function( r, g, b, a )
    {
        this.bind();
    
        var gl = this.gl;
    
        gl.clearColor(r, g, b, a);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    };
    
    /**
     * Binds the frame buffer to the WebGL context
     */
    Framebuffer.prototype.bind = function()
    {
        var gl = this.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer );
    };
    
    /**
     * Unbinds the frame buffer to the WebGL context
     */
    Framebuffer.prototype.unbind = function()
    {
        var gl = this.gl;
        gl.bindFramebuffer(gl.FRAMEBUFFER, null );
    };
    /**
     * Resizes the drawing area of the buffer to the given width and height
     * @param  width  {Number} the new width
     * @param  height {Number} the new height
     */
    Framebuffer.prototype.resize = function(width, height)
    {
        var gl = this.gl;
    
        this.width = width;
        this.height = height;
    
        if ( this.texture )
        {
            this.texture.uploadData(null, width, height);
        }
    
        if ( this.stencil )
        {
            // update the stencil buffer width and height
            gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
            gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
        }
    };
    
    /**
     * Destroys this buffer
     */
    Framebuffer.prototype.destroy = function()
    {
        var gl = this.gl;
    
        //TODO
        if(this.texture)
        {
            this.texture.destroy();
        }
    
        gl.deleteFramebuffer(this.framebuffer);
    
        this.gl = null;
    
        this.stencil = null;
        this.texture = null;
    };
    
    /**
     * Creates a frame buffer with a texture containing the given data
     * @static
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param width {Number} the width of the drawing area of the frame buffer
     * @param height {Number} the height of the drawing area of the frame buffer
     * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
     */
    Framebuffer.createRGBA = function(gl, width, height, data)
    {
        var texture = Texture.fromData(gl, null, width, height);
        texture.enableNearestScaling();
        texture.enableWrapClamp();
    
        //now create the framebuffer object and attach the texture to it.
        var fbo = new Framebuffer(gl, width, height);
        fbo.enableTexture(texture);
        //fbo.enableStencil(); // get this back on soon!
    
        //fbo.enableStencil(); // get this back on soon!
    
        fbo.unbind();
    
        return fbo;
    };
    
    /**
     * Creates a frame buffer with a texture containing the given data
     * @static
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param width {Number} the width of the drawing area of the frame buffer
     * @param height {Number} the height of the drawing area of the frame buffer
     * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
     */
    Framebuffer.createFloat32 = function(gl, width, height, data)
    {
        // create a new texture..
        var texture = new Texture.fromData(gl, data, width, height);
        texture.enableNearestScaling();
        texture.enableWrapClamp();
    
        //now create the framebuffer object and attach the texture to it.
        var fbo = new Framebuffer(gl, width, height);
        fbo.enableTexture(texture);
    
        fbo.unbind();
    
        return fbo;
    };
    
    module.exports = Framebuffer;
    
    },{"./GLTexture":13}],12:[function(require,module,exports){
    
    var compileProgram = require('./shader/compileProgram'),
        extractAttributes = require('./shader/extractAttributes'),
        extractUniforms = require('./shader/extractUniforms'),
        setPrecision = require('./shader/setPrecision'),
        generateUniformAccessObject = require('./shader/generateUniformAccessObject');
    
    /**
     * Helper class to create a webGL Shader
     *
     * @class
     * @memberof PIXI.glCore
     * @param gl {WebGLRenderingContext}
     * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
     * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
     * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
     * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
     */
    var Shader = function(gl, vertexSrc, fragmentSrc, precision, attributeLocations)
    {
        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        if(precision)
        {
            vertexSrc = setPrecision(vertexSrc, precision);
            fragmentSrc = setPrecision(fragmentSrc, precision);
        }
    
        /**
         * The shader program
         *
         * @member {WebGLProgram}
         */
        // First compile the program..
        this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);
    
        /**
         * The attributes of the shader as an object containing the following properties
         * {
         * 	type,
         * 	size,
         * 	location,
         * 	pointer
         * }
         * @member {Object}
         */
        // next extract the attributes
        this.attributes = extractAttributes(gl, this.program);
    
        this.uniformData = extractUniforms(gl, this.program);
    
        /**
         * The uniforms of the shader as an object containing the following properties
         * {
         * 	gl,
         * 	data
         * }
         * @member {Object}
         */
        this.uniforms = generateUniformAccessObject( gl, this.uniformData );
    
    };
    /**
     * Uses this shader
     * 
     * @return {PIXI.glCore.GLShader} Returns itself.
     */
    Shader.prototype.bind = function()
    {
        this.gl.useProgram(this.program);
        return this;
    };
    
    /**
     * Destroys this shader
     * TODO
     */
    Shader.prototype.destroy = function()
    {
        this.attributes = null;
        this.uniformData = null;
        this.uniforms = null;
    
        var gl = this.gl;
        gl.deleteProgram(this.program);
    };
    
    
    module.exports = Shader;
    
    },{"./shader/compileProgram":18,"./shader/extractAttributes":20,"./shader/extractUniforms":21,"./shader/generateUniformAccessObject":22,"./shader/setPrecision":26}],13:[function(require,module,exports){
    
    /**
     * Helper class to create a WebGL Texture
     *
     * @class
     * @memberof PIXI.glCore
     * @param gl {WebGLRenderingContext} The current WebGL context
     * @param width {number} the width of the texture
     * @param height {number} the height of the texture
     * @param format {number} the pixel format of the texture. defaults to gl.RGBA
     * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
     */
    var Texture = function(gl, width, height, format, type)
    {
        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
    
        /**
         * The WebGL texture
         *
         * @member {WebGLTexture}
         */
        this.texture = gl.createTexture();
    
        /**
         * If mipmapping was used for this texture, enable and disable with enableMipmap()
         *
         * @member {Boolean}
         */
        // some settings..
        this.mipmap = false;
    
    
        /**
         * Set to true to enable pre-multiplied alpha
         *
         * @member {Boolean}
         */
        this.premultiplyAlpha = false;
    
        /**
         * The width of texture
         *
         * @member {Number}
         */
        this.width = width || -1;
        /**
         * The height of texture
         *
         * @member {Number}
         */
        this.height = height || -1;
    
        /**
         * The pixel format of the texture. defaults to gl.RGBA
         *
         * @member {Number}
         */
        this.format = format || gl.RGBA;
    
        /**
         * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
         *
         * @member {Number}
         */
        this.type = type || gl.UNSIGNED_BYTE;
    
    
    };
    
    /**
     * Uploads this texture to the GPU
     * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
     */
    Texture.prototype.upload = function(source)
    {
        this.bind();
    
        var gl = this.gl;
    
    
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
    
        var newWidth = source.videoWidth || source.width;
        var newHeight = source.videoHeight || source.height;
    
        if(newHeight !== this.height || newWidth !== this.width)
        {
            gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
        }
        else
        {
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
        }
    
        // if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
        this.width = newWidth;
        this.height = newHeight;
    
    };
    
    var FLOATING_POINT_AVAILABLE = false;
    
    /**
     * Use a data source and uploads this texture to the GPU
     * @param data {TypedArray} the data to upload to the texture
     * @param width {number} the new width of the texture
     * @param height {number} the new height of the texture
     */
    Texture.prototype.uploadData = function(data, width, height)
    {
        this.bind();
    
        var gl = this.gl;
    
    
        if(data instanceof Float32Array)
        {
            if(!FLOATING_POINT_AVAILABLE)
            {
                var ext = gl.getExtension("OES_texture_float");
    
                if(ext)
                {
                    FLOATING_POINT_AVAILABLE = true;
                }
                else
                {
                    throw new Error('floating point textures not available');
                }
            }
    
            this.type = gl.FLOAT;
        }
        else
        {
            // TODO support for other types
            this.type = this.type || gl.UNSIGNED_BYTE;
        }
    
        // what type of data?
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
    
    
        if(width !== this.width || height !== this.height)
        {
            gl.texImage2D(gl.TEXTURE_2D, 0, this.format,  width, height, 0, this.format, this.type, data || null);
        }
        else
        {
            gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
        }
    
        this.width = width;
        this.height = height;
    
    
    //	texSubImage2D
    };
    
    /**
     * Binds the texture
     * @param  location
     */
    Texture.prototype.bind = function(location)
    {
        var gl = this.gl;
    
        if(location !== undefined)
        {
            gl.activeTexture(gl.TEXTURE0 + location);
        }
    
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
    };
    
    /**
     * Unbinds the texture
     */
    Texture.prototype.unbind = function()
    {
        var gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, null);
    };
    
    /**
     * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
     */
    Texture.prototype.minFilter = function( linear )
    {
        var gl = this.gl;
    
        this.bind();
    
        if(this.mipmap)
        {
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
        }
        else
        {
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
        }
    };
    
    /**
     * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
     */
    Texture.prototype.magFilter = function( linear )
    {
        var gl = this.gl;
    
        this.bind();
    
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
    };
    
    /**
     * Enables mipmapping
     */
    Texture.prototype.enableMipmap = function()
    {
        var gl = this.gl;
    
        this.bind();
    
        this.mipmap = true;
    
        gl.generateMipmap(gl.TEXTURE_2D);
    };
    
    /**
     * Enables linear filtering
     */
    Texture.prototype.enableLinearScaling = function()
    {
        this.minFilter(true);
        this.magFilter(true);
    };
    
    /**
     * Enables nearest neighbour interpolation
     */
    Texture.prototype.enableNearestScaling = function()
    {
        this.minFilter(false);
        this.magFilter(false);
    };
    
    /**
     * Enables clamping on the texture so WebGL will not repeat it
     */
    Texture.prototype.enableWrapClamp = function()
    {
        var gl = this.gl;
    
        this.bind();
    
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    };
    
    /**
     * Enable tiling on the texture
     */
    Texture.prototype.enableWrapRepeat = function()
    {
        var gl = this.gl;
    
        this.bind();
    
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
    };
    
    Texture.prototype.enableWrapMirrorRepeat = function()
    {
        var gl = this.gl;
    
        this.bind();
    
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
    };
    
    
    /**
     * Destroys this texture
     */
    Texture.prototype.destroy = function()
    {
        var gl = this.gl;
        //TODO
        gl.deleteTexture(this.texture);
    };
    
    /**
     * @static
     * @param gl {WebGLRenderingContext} The current WebGL context
     * @param source {HTMLImageElement|ImageData} the source image of the texture
     * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
     */
    Texture.fromSource = function(gl, source, premultiplyAlpha)
    {
        var texture = new Texture(gl);
        texture.premultiplyAlpha = premultiplyAlpha || false;
        texture.upload(source);
    
        return texture;
    };
    
    /**
     * @static
     * @param gl {WebGLRenderingContext} The current WebGL context
     * @param data {TypedArray} the data to upload to the texture
     * @param width {number} the new width of the texture
     * @param height {number} the new height of the texture
     */
    Texture.fromData = function(gl, data, width, height)
    {
        //console.log(data, width, height);
        var texture = new Texture(gl);
        texture.uploadData(data, width, height);
    
        return texture;
    };
    
    
    module.exports = Texture;
    
    },{}],14:[function(require,module,exports){
    
    // state object//
    var setVertexAttribArrays = require( './setVertexAttribArrays' );
    
    /**
     * Helper class to work with WebGL VertexArrayObjects (vaos)
     * Only works if WebGL extensions are enabled (they usually are)
     *
     * @class
     * @memberof PIXI.glCore
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     */
    function VertexArrayObject(gl, state)
    {
        this.nativeVaoExtension = null;
    
        if(!VertexArrayObject.FORCE_NATIVE)
        {
            this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') ||
                                      gl.getExtension('MOZ_OES_vertex_array_object') ||
                                      gl.getExtension('WEBKIT_OES_vertex_array_object');
        }
    
        this.nativeState = state;
    
        if(this.nativeVaoExtension)
        {
            this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();
    
            var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    
            // VAO - overwrite the state..
            this.nativeState = {
                tempAttribState: new Array(maxAttribs),
                attribState: new Array(maxAttribs)
            };
        }
    
        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        /**
         * An array of attributes
         *
         * @member {Array}
         */
        this.attributes = [];
    
        /**
         * @member {PIXI.glCore.GLBuffer}
         */
        this.indexBuffer = null;
    
        /**
         * A boolean flag
         *
         * @member {Boolean}
         */
        this.dirty = false;
    }
    
    VertexArrayObject.prototype.constructor = VertexArrayObject;
    module.exports = VertexArrayObject;
    
    /**
    * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
    * If you find on older devices that things have gone a bit weird then set this to true.
    */
    /**
     * Lets the VAO know if you should use the WebGL extension or the native methods.
     * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
     * If you find on older devices that things have gone a bit weird then set this to true.
     * @static
     * @property {Boolean} FORCE_NATIVE
     */
    VertexArrayObject.FORCE_NATIVE = false;
    
    /**
     * Binds the buffer
     */
    VertexArrayObject.prototype.bind = function()
    {
        if(this.nativeVao)
        {
            this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
    
            if(this.dirty)
            {
                this.dirty = false;
                this.activate();
                return this;
            }
            if (this.indexBuffer)
            {
                this.indexBuffer.bind();
            }
        }
        else
        {
            this.activate();
        }
    
        return this;
    };
    
    /**
     * Unbinds the buffer
     */
    VertexArrayObject.prototype.unbind = function()
    {
        if(this.nativeVao)
        {
            this.nativeVaoExtension.bindVertexArrayOES(null);
        }
    
        return this;
    };
    
    /**
     * Uses this vao
     */
    VertexArrayObject.prototype.activate = function()
    {
    
        var gl = this.gl;
        var lastBuffer = null;
    
        for (var i = 0; i < this.attributes.length; i++)
        {
            var attrib = this.attributes[i];
    
            if(lastBuffer !== attrib.buffer)
            {
                attrib.buffer.bind();
                lastBuffer = attrib.buffer;
            }
    
            gl.vertexAttribPointer(attrib.attribute.location,
                                   attrib.attribute.size,
                                   attrib.type || gl.FLOAT,
                                   attrib.normalized || false,
                                   attrib.stride || 0,
                                   attrib.start || 0);
        }
    
        setVertexAttribArrays(gl, this.attributes, this.nativeState);
    
        if(this.indexBuffer)
        {
            this.indexBuffer.bind();
        }
    
        return this;
    };
    
    /**
     *
     * @param buffer     {PIXI.gl.GLBuffer}
     * @param attribute  {*}
     * @param type       {String}
     * @param normalized {Boolean}
     * @param stride     {Number}
     * @param start      {Number}
     */
    VertexArrayObject.prototype.addAttribute = function(buffer, attribute, type, normalized, stride, start)
    {
        this.attributes.push({
            buffer:     buffer,
            attribute:  attribute,
    
            location:   attribute.location,
            type:       type || this.gl.FLOAT,
            normalized: normalized || false,
            stride:     stride || 0,
            start:      start || 0
        });
    
        this.dirty = true;
    
        return this;
    };
    
    /**
     *
     * @param buffer   {PIXI.gl.GLBuffer}
     */
    VertexArrayObject.prototype.addIndex = function(buffer/*, options*/)
    {
        this.indexBuffer = buffer;
    
        this.dirty = true;
    
        return this;
    };
    
    /**
     * Unbinds this vao and disables it
     */
    VertexArrayObject.prototype.clear = function()
    {
        // var gl = this.gl;
    
        // TODO - should this function unbind after clear?
        // for now, no but lets see what happens in the real world!
        if(this.nativeVao)
        {
            this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
        }
    
        this.attributes.length = 0;
        this.indexBuffer = null;
    
        return this;
    };
    
    /**
     * @param type  {Number}
     * @param size  {Number}
     * @param start {Number}
     */
    VertexArrayObject.prototype.draw = function(type, size, start)
    {
        var gl = this.gl;
    
        if(this.indexBuffer)
        {
            gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2 );
        }
        else
        {
            // TODO need a better way to calculate size..
            gl.drawArrays(type, start, size || this.getSize());
        }
    
        return this;
    };
    
    /**
     * Destroy this vao
     */
    VertexArrayObject.prototype.destroy = function()
    {
        // lose references
        this.gl = null;
        this.indexBuffer = null;
        this.attributes = null;
        this.nativeState = null;
    
        if(this.nativeVao)
        {
            this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
        }
    
        this.nativeVaoExtension = null;
        this.nativeVao = null;
    };
    
    VertexArrayObject.prototype.getSize = function()
    {
        var attrib = this.attributes[0];
        return attrib.buffer.data.length / (( attrib.stride/4 ) || attrib.attribute.size);
    };
    
    },{"./setVertexAttribArrays":17}],15:[function(require,module,exports){
    
    /**
     * Helper class to create a webGL Context
     *
     * @class
     * @memberof PIXI.glCore
     * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
     * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
     *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
     * @return {WebGLRenderingContext} the WebGL context
     */
    var createContext = function(canvas, options)
    {
        var gl = canvas.getContext('webgl', options) || 
             canvas.getContext('experimental-webgl', options);
    
        if (!gl)
        {
            // fail, not able to get a context
            throw new Error('This browser does not support webGL. Try using the canvas renderer');
        }
    
        return gl;
    };
    
    module.exports = createContext;
    
    },{}],16:[function(require,module,exports){
    var gl = {
        createContext:          require('./createContext'),
        setVertexAttribArrays:  require('./setVertexAttribArrays'),
        GLBuffer:               require('./GLBuffer'),
        GLFramebuffer:          require('./GLFramebuffer'),
        GLShader:               require('./GLShader'),
        GLTexture:              require('./GLTexture'),
        VertexArrayObject:      require('./VertexArrayObject'),
        shader:                 require('./shader')
    };
    
    // Export for Node-compatible environments
    if (typeof module !== 'undefined' && module.exports)
    {
        // Export the module
        module.exports = gl;
    }
    
    // Add to the browser window pixi.gl
    if (typeof window !== 'undefined')
    {
        // add the window object
        window.PIXI = window.PIXI || {};
        window.PIXI.glCore = gl;
    }
    
    },{"./GLBuffer":10,"./GLFramebuffer":11,"./GLShader":12,"./GLTexture":13,"./VertexArrayObject":14,"./createContext":15,"./setVertexAttribArrays":17,"./shader":23}],17:[function(require,module,exports){
    // var GL_MAP = {};
    
    /**
     * @param gl {WebGLRenderingContext} The current WebGL context
     * @param attribs {*}
     * @param state {*}
     */
    var setVertexAttribArrays = function (gl, attribs, state)
    {
        var i;
        if(state)
        {
            var tempAttribState = state.tempAttribState,
                attribState = state.attribState;
    
            for (i = 0; i < tempAttribState.length; i++)
            {
                tempAttribState[i] = false;
            }
    
            // set the new attribs
            for (i = 0; i < attribs.length; i++)
            {
                tempAttribState[attribs[i].attribute.location] = true;
            }
    
            for (i = 0; i < attribState.length; i++)
            {
                if (attribState[i] !== tempAttribState[i])
                {
                    attribState[i] = tempAttribState[i];
    
                    if (state.attribState[i])
                    {
                        gl.enableVertexAttribArray(i);
                    }
                    else
                    {
                        gl.disableVertexAttribArray(i);
                    }
                }
            }
    
        }
        else
        {
            for (i = 0; i < attribs.length; i++)
            {
                var attrib = attribs[i];
                gl.enableVertexAttribArray(attrib.attribute.location);
            }
        }
    };
    
    module.exports = setVertexAttribArrays;
    
    },{}],18:[function(require,module,exports){
    
    /**
     * @class
     * @memberof PIXI.glCore.shader
     * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
     * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
     * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
     * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
     * @return {WebGLProgram} the shader program
     */
    var compileProgram = function(gl, vertexSrc, fragmentSrc, attributeLocations)
    {
        var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
        var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
    
        var program = gl.createProgram();
    
        gl.attachShader(program, glVertShader);
        gl.attachShader(program, glFragShader);
    
        // optionally, set the attributes manually for the program rather than letting WebGL decide..
        if(attributeLocations)
        {
            for(var i in attributeLocations)
            {
                gl.bindAttribLocation(program, attributeLocations[i], i);
            }
        }
    
    
        gl.linkProgram(program);
    
        // if linking fails, then log and cleanup
        if (!gl.getProgramParameter(program, gl.LINK_STATUS))
        {
            console.error('Pixi.js Error: Could not initialize shader.');
            console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
            console.error('gl.getError()', gl.getError());
    
            // if there is a program info log, log it
            if (gl.getProgramInfoLog(program) !== '')
            {
                console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
            }
    
            gl.deleteProgram(program);
            program = null;
        }
    
        // clean up some shaders
        gl.deleteShader(glVertShader);
        gl.deleteShader(glFragShader);
    
        return program;
    };
    
    /**
     * @private
     * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
     * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
     * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
     * @return {WebGLShader} the shader
     */
    var compileShader = function (gl, type, src)
    {
        var shader = gl.createShader(type);
    
        gl.shaderSource(shader, src);
        gl.compileShader(shader);
    
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
        {
            console.log(gl.getShaderInfoLog(shader));
            return null;
        }
    
        return shader;
    };
    
    module.exports = compileProgram;
    
    },{}],19:[function(require,module,exports){
    /**
     * @class
     * @memberof PIXI.glCore.shader
     * @param type {String} Type of value
     * @param size {Number}
     */
    var defaultValue = function(type, size) 
    {
        switch (type)
        {
            case 'float':
                return 0;
    
            case 'vec2': 
                return new Float32Array(2 * size);
    
            case 'vec3':
                return new Float32Array(3 * size);
    
            case 'vec4':     
                return new Float32Array(4 * size);
                
            case 'int':
            case 'sampler2D':
                return 0;
    
            case 'ivec2':   
                return new Int32Array(2 * size);
    
            case 'ivec3':
                return new Int32Array(3 * size);
    
            case 'ivec4': 
                return new Int32Array(4 * size);
    
            case 'bool':     
                return false;
    
            case 'bvec2':
    
                return booleanArray( 2 * size);
    
            case 'bvec3':
                return booleanArray(3 * size);
    
            case 'bvec4':
                return booleanArray(4 * size);
    
            case 'mat2':
                return new Float32Array([1, 0,
                                         0, 1]);
    
            case 'mat3': 
                return new Float32Array([1, 0, 0,
                                         0, 1, 0,
                                         0, 0, 1]);
    
            case 'mat4':
                return new Float32Array([1, 0, 0, 0,
                                         0, 1, 0, 0,
                                         0, 0, 1, 0,
                                         0, 0, 0, 1]);
        }
    };
    
    var booleanArray = function(size)
    {
        var array = new Array(size);
    
        for (var i = 0; i < array.length; i++) 
        {
            array[i] = false;
        }
    
        return array;
    };
    
    module.exports = defaultValue;
    
    },{}],20:[function(require,module,exports){
    
    var mapType = require('./mapType');
    var mapSize = require('./mapSize');
    
    /**
     * Extracts the attributes
     * @class
     * @memberof PIXI.glCore.shader
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param program {WebGLProgram} The shader program to get the attributes from
     * @return attributes {Object}
     */
    var extractAttributes = function(gl, program)
    {
        var attributes = {};
    
        var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    
        for (var i = 0; i < totalAttributes; i++)
        {
            var attribData = gl.getActiveAttrib(program, i);
            var type = mapType(gl, attribData.type);
    
            attributes[attribData.name] = {
                type:type,
                size:mapSize(type),
                location:gl.getAttribLocation(program, attribData.name),
                //TODO - make an attribute object
                pointer: pointer
            };
        }
    
        return attributes;
    };
    
    var pointer = function(type, normalized, stride, start){
        // console.log(this.location)
        gl.vertexAttribPointer(this.location,this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
    };
    
    module.exports = extractAttributes;
    
    },{"./mapSize":24,"./mapType":25}],21:[function(require,module,exports){
    var mapType = require('./mapType');
    var defaultValue = require('./defaultValue');
    
    /**
     * Extracts the uniforms
     * @class
     * @memberof PIXI.glCore.shader
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param program {WebGLProgram} The shader program to get the uniforms from
     * @return uniforms {Object}
     */
    var extractUniforms = function(gl, program)
    {
        var uniforms = {};
    
        var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
    
        for (var i = 0; i < totalUniforms; i++)
        {
            var uniformData = gl.getActiveUniform(program, i);
            var name = uniformData.name.replace(/\[.*?\]/, "");
            var type = mapType(gl, uniformData.type );
    
            uniforms[name] = {
                type:type,
                size:uniformData.size,
                location:gl.getUniformLocation(program, name),
                value:defaultValue(type, uniformData.size)
            };
        }
    
        return uniforms;
    };
    
    module.exports = extractUniforms;
    
    },{"./defaultValue":19,"./mapType":25}],22:[function(require,module,exports){
    /**
     * Extracts the attributes
     * @class
     * @memberof PIXI.glCore.shader
     * @param gl {WebGLRenderingContext} The current WebGL rendering context
     * @param uniforms {Array} @mat ?
     * @return attributes {Object}
     */
    var generateUniformAccessObject = function(gl, uniformData)
    {
        // this is the object we will be sending back.
        // an object hierachy will be created for structs
        var uniforms = {data:{}};
    
        uniforms.gl = gl;
    
        var uniformKeys= Object.keys(uniformData);
    
        for (var i = 0; i < uniformKeys.length; i++)
        {
            var fullName = uniformKeys[i];
    
            var nameTokens = fullName.split('.');
            var name = nameTokens[nameTokens.length - 1];
    
    
            var uniformGroup = getUniformGroup(nameTokens, uniforms);
    
            var uniform =  uniformData[fullName];
            uniformGroup.data[name] = uniform;
    
            uniformGroup.gl = gl;
    
            Object.defineProperty(uniformGroup, name, {
                get: generateGetter(name),
                set: generateSetter(name, uniform)
            });
        }
    
        return uniforms;
    };
    
    var generateGetter = function(name)
    {
        return function() {
            return this.data[name].value;
        };
    };
    
    var GLSL_SINGLE_SETTERS = {
        float: function setSingleFloat(gl, location, value) { gl.uniform1f(location, value); },
        vec2: function setSingleVec2(gl, location, value) { gl.uniform2f(location, value[0], value[1]); },
        vec3: function setSingleVec3(gl, location, value) { gl.uniform3f(location, value[0], value[1], value[2]); },
        vec4: function setSingleVec4(gl, location, value) { gl.uniform4f(location, value[0], value[1], value[2], value[3]); },
    
        int: function setSingleInt(gl, location, value) { gl.uniform1i(location, value); },
        ivec2: function setSingleIvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
        ivec3: function setSingleIvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
        ivec4: function setSingleIvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
    
        bool: function setSingleBool(gl, location, value) { gl.uniform1i(location, value); },
        bvec2: function setSingleBvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
        bvec3: function setSingleBvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
        bvec4: function setSingleBvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },
    
        mat2: function setSingleMat2(gl, location, value) { gl.uniformMatrix2fv(location, false, value); },
        mat3: function setSingleMat3(gl, location, value) { gl.uniformMatrix3fv(location, false, value); },
        mat4: function setSingleMat4(gl, location, value) { gl.uniformMatrix4fv(location, false, value); },
    
        sampler2D: function setSingleSampler2D(gl, location, value) { gl.uniform1i(location, value); },
    };
    
    var GLSL_ARRAY_SETTERS = {
        float: function setFloatArray(gl, location, value) { gl.uniform1fv(location, value); },
        vec2: function setVec2Array(gl, location, value) { gl.uniform2fv(location, value); },
        vec3: function setVec3Array(gl, location, value) { gl.uniform3fv(location, value); },
        vec4: function setVec4Array(gl, location, value) { gl.uniform4fv(location, value); },
        int: function setIntArray(gl, location, value) { gl.uniform1iv(location, value); },
        ivec2: function setIvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
        ivec3: function setIvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
        ivec4: function setIvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
        bool: function setBoolArray(gl, location, value) { gl.uniform1iv(location, value); },
        bvec2: function setBvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
        bvec3: function setBvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
        bvec4: function setBvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
        sampler2D: function setSampler2DArray(gl, location, value) { gl.uniform1iv(location, value); },
    };
    
    function generateSetter(name, uniform)
    {
        return function(value) {
            this.data[name].value = value;
            var location = this.data[name].location;
            if (uniform.size === 1)
            {
                GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
            }
            else
            {
                // glslSetArray(gl, location, type, value) {
                GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
            }
        };
    }
    
    function getUniformGroup(nameTokens, uniform)
    {
        var cur = uniform;
    
        for (var i = 0; i < nameTokens.length - 1; i++)
        {
            var o = cur[nameTokens[i]] || {data:{}};
            cur[nameTokens[i]] = o;
            cur = o;
        }
    
        return cur;
    }
    
    
    module.exports = generateUniformAccessObject;
    
    },{}],23:[function(require,module,exports){
    module.exports = {
        compileProgram: require('./compileProgram'),
        defaultValue: require('./defaultValue'),
        extractAttributes: require('./extractAttributes'),
        extractUniforms: require('./extractUniforms'),
        generateUniformAccessObject: require('./generateUniformAccessObject'),
        setPrecision: require('./setPrecision'),
        mapSize: require('./mapSize'),
        mapType: require('./mapType')
    };
    },{"./compileProgram":18,"./defaultValue":19,"./extractAttributes":20,"./extractUniforms":21,"./generateUniformAccessObject":22,"./mapSize":24,"./mapType":25,"./setPrecision":26}],24:[function(require,module,exports){
    /**
     * @class
     * @memberof PIXI.glCore.shader
     * @param type {String}
     * @return {Number}
     */
    var mapSize = function(type) 
    { 
        return GLSL_TO_SIZE[type];
    };
    
    
    var GLSL_TO_SIZE = {
        'float':    1,
        'vec2':     2,
        'vec3':     3,
        'vec4':     4,
    
        'int':      1,
        'ivec2':    2,
        'ivec3':    3,
        'ivec4':    4,
    
        'bool':     1,
        'bvec2':    2,
        'bvec3':    3,
        'bvec4':    4,
    
        'mat2':     4,
        'mat3':     9,
        'mat4':     16,
    
        'sampler2D':  1
    };
    
    module.exports = mapSize;
    
    },{}],25:[function(require,module,exports){
    
    
    var mapType = function(gl, type) 
    {
        if(!GL_TABLE) 
        {
            var typeNames = Object.keys(GL_TO_GLSL_TYPES);
    
            GL_TABLE = {};
    
            for(var i = 0; i < typeNames.length; ++i) 
            {
                var tn = typeNames[i];
                GL_TABLE[ gl[tn] ] = GL_TO_GLSL_TYPES[tn];
            }
        }
    
      return GL_TABLE[type];
    };
    
    var GL_TABLE = null;
    
    var GL_TO_GLSL_TYPES = {
      'FLOAT':       'float',
      'FLOAT_VEC2':  'vec2',
      'FLOAT_VEC3':  'vec3',
      'FLOAT_VEC4':  'vec4',
    
      'INT':         'int',
      'INT_VEC2':    'ivec2',
      'INT_VEC3':    'ivec3',
      'INT_VEC4':    'ivec4',
      
      'BOOL':        'bool',
      'BOOL_VEC2':   'bvec2',
      'BOOL_VEC3':   'bvec3',
      'BOOL_VEC4':   'bvec4',
      
      'FLOAT_MAT2':  'mat2',
      'FLOAT_MAT3':  'mat3',
      'FLOAT_MAT4':  'mat4',
      
      'SAMPLER_2D':  'sampler2D'  
    };
    
    module.exports = mapType;
    
    },{}],26:[function(require,module,exports){
    /**
     * Sets the float precision on the shader. If the precision is already present this function will do nothing
     * @param {string} src       the shader source
     * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
     *
     * @return {string} modified shader source
     */
    var setPrecision = function(src, precision)
    {
        if(src.substring(0, 9) !== 'precision')
        {
            return 'precision ' + precision + ' float;\n' + src;
        }
    
        return src;
    };
    
    module.exports = setPrecision;
    
    },{}],27:[function(require,module,exports){
    // shim for using process in browser
    var process = module.exports = {};
    
    // cached from whatever global is present so that test runners that stub it
    // don't break things.  But we need to wrap it in a try catch in case it is
    // wrapped in strict mode code which doesn't define any globals.  It's inside a
    // function because try/catches deoptimize in certain engines.
    
    var cachedSetTimeout;
    var cachedClearTimeout;
    
    function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
    }
    function defaultClearTimeout () {
        throw new Error('clearTimeout has not been defined');
    }
    (function () {
        try {
            if (typeof setTimeout === 'function') {
                cachedSetTimeout = setTimeout;
            } else {
                cachedSetTimeout = defaultSetTimout;
            }
        } catch (e) {
            cachedSetTimeout = defaultSetTimout;
        }
        try {
            if (typeof clearTimeout === 'function') {
                cachedClearTimeout = clearTimeout;
            } else {
                cachedClearTimeout = defaultClearTimeout;
            }
        } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
        }
    } ())
    function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
        }
        // if setTimeout wasn't available but was latter defined
        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
        } catch(e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
                return cachedSetTimeout.call(null, fun, 0);
            } catch(e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
                return cachedSetTimeout.call(this, fun, 0);
            }
        }
    
    
    }
    function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
        }
        // if clearTimeout wasn't available but was latter defined
        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
        }
        try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
        } catch (e){
            try {
                // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
                return cachedClearTimeout.call(null, marker);
            } catch (e){
                // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
                // Some versions of I.E. have different rules for clearTimeout vs setTimeout
                return cachedClearTimeout.call(this, marker);
            }
        }
    
    
    
    }
    var queue = [];
    var draining = false;
    var currentQueue;
    var queueIndex = -1;
    
    function cleanUpNextTick() {
        if (!draining || !currentQueue) {
            return;
        }
        draining = false;
        if (currentQueue.length) {
            queue = currentQueue.concat(queue);
        } else {
            queueIndex = -1;
        }
        if (queue.length) {
            drainQueue();
        }
    }
    
    function drainQueue() {
        if (draining) {
            return;
        }
        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
    
        var len = queue.length;
        while(len) {
            currentQueue = queue;
            queue = [];
            while (++queueIndex < len) {
                if (currentQueue) {
                    currentQueue[queueIndex].run();
                }
            }
            queueIndex = -1;
            len = queue.length;
        }
        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
    }
    
    process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);
        if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
                args[i - 1] = arguments[i];
            }
        }
        queue.push(new Item(fun, args));
        if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
        }
    };
    
    // v8 likes predictible objects
    function Item(fun, array) {
        this.fun = fun;
        this.array = array;
    }
    Item.prototype.run = function () {
        this.fun.apply(null, this.array);
    };
    process.title = 'browser';
    process.browser = true;
    process.env = {};
    process.argv = [];
    process.version = ''; // empty string to avoid regexp issues
    process.versions = {};
    
    function noop() {}
    
    process.on = noop;
    process.addListener = noop;
    process.once = noop;
    process.off = noop;
    process.removeListener = noop;
    process.removeAllListeners = noop;
    process.emit = noop;
    process.prependListener = noop;
    process.prependOnceListener = noop;
    
    process.listeners = function (name) { return [] }
    
    process.binding = function (name) {
        throw new Error('process.binding is not supported');
    };
    
    process.cwd = function () { return '/' };
    process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
    };
    process.umask = function() { return 0; };
    
    },{}],28:[function(require,module,exports){
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    
    'use strict';
    
    // If obj.hasOwnProperty has been overridden, then calling
    // obj.hasOwnProperty(prop) will break.
    // See: https://github.com/joyent/node/issues/1707
    function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    
    module.exports = function(qs, sep, eq, options) {
      sep = sep || '&';
      eq = eq || '=';
      var obj = {};
    
      if (typeof qs !== 'string' || qs.length === 0) {
        return obj;
      }
    
      var regexp = /\+/g;
      qs = qs.split(sep);
    
      var maxKeys = 1000;
      if (options && typeof options.maxKeys === 'number') {
        maxKeys = options.maxKeys;
      }
    
      var len = qs.length;
      // maxKeys <= 0 means that we should not limit keys count
      if (maxKeys > 0 && len > maxKeys) {
        len = maxKeys;
      }
    
      for (var i = 0; i < len; ++i) {
        var x = qs[i].replace(regexp, '%20'),
            idx = x.indexOf(eq),
            kstr, vstr, k, v;
    
        if (idx >= 0) {
          kstr = x.substr(0, idx);
          vstr = x.substr(idx + 1);
        } else {
          kstr = x;
          vstr = '';
        }
    
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
    
        if (!hasOwnProperty(obj, k)) {
          obj[k] = v;
        } else if (isArray(obj[k])) {
          obj[k].push(v);
        } else {
          obj[k] = [obj[k], v];
        }
      }
    
      return obj;
    };
    
    var isArray = Array.isArray || function (xs) {
      return Object.prototype.toString.call(xs) === '[object Array]';
    };
    
    },{}],29:[function(require,module,exports){
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    
    'use strict';
    
    var stringifyPrimitive = function(v) {
      switch (typeof v) {
        case 'string':
          return v;
    
        case 'boolean':
          return v ? 'true' : 'false';
    
        case 'number':
          return isFinite(v) ? v : '';
    
        default:
          return '';
      }
    };
    
    module.exports = function(obj, sep, eq, name) {
      sep = sep || '&';
      eq = eq || '=';
      if (obj === null) {
        obj = undefined;
      }
    
      if (typeof obj === 'object') {
        return map(objectKeys(obj), function(k) {
          var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
          if (isArray(obj[k])) {
            return map(obj[k], function(v) {
              return ks + encodeURIComponent(stringifyPrimitive(v));
            }).join(sep);
          } else {
            return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
          }
        }).join(sep);
    
      }
    
      if (!name) return '';
      return encodeURIComponent(stringifyPrimitive(name)) + eq +
             encodeURIComponent(stringifyPrimitive(obj));
    };
    
    var isArray = Array.isArray || function (xs) {
      return Object.prototype.toString.call(xs) === '[object Array]';
    };
    
    function map (xs, f) {
      if (xs.map) return xs.map(f);
      var res = [];
      for (var i = 0; i < xs.length; i++) {
        res.push(f(xs[i], i));
      }
      return res;
    }
    
    var objectKeys = Object.keys || function (obj) {
      var res = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
      }
      return res;
    };
    
    },{}],30:[function(require,module,exports){
    'use strict';
    
    exports.decode = exports.parse = require('./decode');
    exports.encode = exports.stringify = require('./encode');
    
    },{"./decode":28,"./encode":29}],31:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.Loader = undefined;
    
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _miniSignals = require('mini-signals');
    
    var _miniSignals2 = _interopRequireDefault(_miniSignals);
    
    var _parseUri = require('parse-uri');
    
    var _parseUri2 = _interopRequireDefault(_parseUri);
    
    var _async = require('./async');
    
    var async = _interopRequireWildcard(_async);
    
    var _Resource = require('./Resource');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    // some constants
    var MAX_PROGRESS = 100;
    var rgxExtractUrlHash = /(#[\w-]+)?$/;
    
    /**
     * Manages the state and loading of multiple resources to load.
     *
     * @class
     */
    
    var Loader = exports.Loader = function () {
        /**
         * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
         * @param {number} [concurrency=10] - The number of resources to load concurrently.
         */
        function Loader() {
            var _this = this;
    
            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
            var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    
            _classCallCheck(this, Loader);
    
            /**
             * The base url for all resources loaded by this loader.
             *
             * @member {string}
             */
            this.baseUrl = baseUrl;
    
            /**
             * The progress percent of the loader going through the queue.
             *
             * @member {number}
             */
            this.progress = 0;
    
            /**
             * Loading state of the loader, true if it is currently loading resources.
             *
             * @member {boolean}
             */
            this.loading = false;
    
            /**
             * A querystring to append to every URL added to the loader.
             *
             * This should be a valid query string *without* the question-mark (`?`). The loader will
             * also *not* escape values for you. Make sure to escape your parameters with
             * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
             *
             * @example
             * const loader = new Loader();
             *
             * loader.defaultQueryString = 'user=me&password=secret';
             *
             * // This will request 'image.png?user=me&password=secret'
             * loader.add('image.png').load();
             *
             * loader.reset();
             *
             * // This will request 'image.png?v=1&user=me&password=secret'
             * loader.add('iamge.png?v=1').load();
             *
             * @member {string}
             */
            this.defaultQueryString = '';
    
            /**
             * The middleware to run before loading each resource.
             *
             * @private
             * @member {function[]}
             */
            this._beforeMiddleware = [];
    
            /**
             * The middleware to run after loading each resource.
             *
             * @private
             * @member {function[]}
             */
            this._afterMiddleware = [];
    
            /**
             * The tracks the resources we are currently completing parsing for.
             *
             * @private
             * @member {Resource[]}
             */
            this._resourcesParsing = [];
    
            /**
             * The `_loadResource` function bound with this object context.
             *
             * @private
             * @member {function}
             * @param {Resource} r - The resource to load
             * @param {Function} d - The dequeue function
             * @return {undefined}
             */
            this._boundLoadResource = function (r, d) {
                return _this._loadResource(r, d);
            };
    
            /**
             * The resources waiting to be loaded.
             *
             * @private
             * @member {Resource[]}
             */
            this._queue = async.queue(this._boundLoadResource, concurrency);
    
            this._queue.pause();
    
            /**
             * All the resources for this loader keyed by name.
             *
             * @member {object<string, Resource>}
             */
            this.resources = {};
    
            /**
             * Dispatched once per loaded or errored resource.
             *
             * The callback looks like {@link Loader.OnProgressSignal}.
             *
             * @member {Signal<Loader.OnProgressSignal>}
             */
            this.onProgress = new _miniSignals2.default();
    
            /**
             * Dispatched once per errored resource.
             *
             * The callback looks like {@link Loader.OnErrorSignal}.
             *
             * @member {Signal<Loader.OnErrorSignal>}
             */
            this.onError = new _miniSignals2.default();
    
            /**
             * Dispatched once per loaded resource.
             *
             * The callback looks like {@link Loader.OnLoadSignal}.
             *
             * @member {Signal<Loader.OnLoadSignal>}
             */
            this.onLoad = new _miniSignals2.default();
    
            /**
             * Dispatched when the loader begins to process the queue.
             *
             * The callback looks like {@link Loader.OnStartSignal}.
             *
             * @member {Signal<Loader.OnStartSignal>}
             */
            this.onStart = new _miniSignals2.default();
    
            /**
             * Dispatched when the queued resources all load.
             *
             * The callback looks like {@link Loader.OnCompleteSignal}.
             *
             * @member {Signal<Loader.OnCompleteSignal>}
             */
            this.onComplete = new _miniSignals2.default();
    
            // Add default before middleware
            for (var i = 0; i < Loader._defaultBeforeMiddleware.length; ++i) {
                this.pre(Loader._defaultBeforeMiddleware[i]);
            }
    
            // Add default after middleware
            for (var _i = 0; _i < Loader._defaultAfterMiddleware.length; ++_i) {
                this.use(Loader._defaultAfterMiddleware[_i]);
            }
        }
    
        /**
         * When the progress changes the loader and resource are disaptched.
         *
         * @memberof Loader
         * @callback OnProgressSignal
         * @param {Loader} loader - The loader the progress is advancing on.
         * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
         */
    
        /**
         * When an error occurrs the loader and resource are disaptched.
         *
         * @memberof Loader
         * @callback OnErrorSignal
         * @param {Loader} loader - The loader the error happened in.
         * @param {Resource} resource - The resource that caused the error.
         */
    
        /**
         * When a load completes the loader and resource are disaptched.
         *
         * @memberof Loader
         * @callback OnLoadSignal
         * @param {Loader} loader - The loader that laoded the resource.
         * @param {Resource} resource - The resource that has completed loading.
         */
    
        /**
         * When the loader starts loading resources it dispatches this callback.
         *
         * @memberof Loader
         * @callback OnStartSignal
         * @param {Loader} loader - The loader that has started loading resources.
         */
    
        /**
         * When the loader completes loading resources it dispatches this callback.
         *
         * @memberof Loader
         * @callback OnCompleteSignal
         * @param {Loader} loader - The loader that has finished loading resources.
         */
    
        /**
         * Options for a call to `.add()`.
         *
         * @see Loader#add
         *
         * @typedef {object} IAddOptions
         * @property {string} [name] - The name of the resource to load, if not passed the url is used.
         * @property {string} [key] - Alias for `name`.
         * @property {string} [url] - The url for this resource, relative to the baseUrl of this loader.
         * @property {string|boolean} [crossOrigin] - Is this request cross-origin? Default is to
         *      determine automatically.
         * @property {number} [timeout=0] - A timeout in milliseconds for the load. If the load takes
         *      longer than this time it is cancelled and the load is considered a failure. If this value is
         *      set to `0` then there is no explicit timeout.
         * @property {Resource.LOAD_TYPE} [loadType=Resource.LOAD_TYPE.XHR] - How should this resource
         *      be loaded?
         * @property {Resource.XHR_RESPONSE_TYPE} [xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
         *      should the data being loaded be interpreted when using XHR?
         * @property {Resource.OnCompleteSignal} [onComplete] - Callback to add an an onComplete signal istener.
         * @property {Resource.OnCompleteSignal} [callback] - Alias for `onComplete`.
         * @property {Resource.IMetadata} [metadata] - Extra configuration for middleware and the Resource object.
         */
    
        /* eslint-disable require-jsdoc,valid-jsdoc */
        /**
         * Adds a resource (or multiple resources) to the loader queue.
         *
         * This function can take a wide variety of different parameters. The only thing that is always
         * required the url to load. All the following will work:
         *
         * ```js
         * loader
         *     // normal param syntax
         *     .add('key', 'http://...', function () {})
         *     .add('http://...', function () {})
         *     .add('http://...')
         *
         *     // object syntax
         *     .add({
         *         name: 'key2',
         *         url: 'http://...'
         *     }, function () {})
         *     .add({
         *         url: 'http://...'
         *     }, function () {})
         *     .add({
         *         name: 'key3',
         *         url: 'http://...'
         *         onComplete: function () {}
         *     })
         *     .add({
         *         url: 'https://...',
         *         onComplete: function () {},
         *         crossOrigin: true
         *     })
         *
         *     // you can also pass an array of objects or urls or both
         *     .add([
         *         { name: 'key4', url: 'http://...', onComplete: function () {} },
         *         { url: 'http://...', onComplete: function () {} },
         *         'http://...'
         *     ])
         *
         *     // and you can use both params and options
         *     .add('key', 'http://...', { crossOrigin: true }, function () {})
         *     .add('http://...', { crossOrigin: true }, function () {});
         * ```
         *
         * @function
         * @variation 1
         * @param {string} name - The name of the resource to load.
         * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
         * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
         * @return {this} Returns itself.
         */ /**
            * @function
            * @variation 2
            * @param {string} name - The name of the resource to load.
            * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
            * @param {IAddOptions} [options] - The options for the load.
            * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
            * @return {this} Returns itself.
            */ /**
               * @function
               * @variation 3
               * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
               * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
               * @return {this} Returns itself.
               */ /**
                  * @function
                  * @variation 4
                  * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
                  * @param {IAddOptions} [options] - The options for the load.
                  * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                  * @return {this} Returns itself.
                  */ /**
                     * @function
                     * @variation 5
                     * @param {IAddOptions} options - The options for the load. This object must contain a `url` property.
                     * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                     * @return {this} Returns itself.
                     */ /**
                        * @function
                        * @variation 6
                        * @param {Array<IAddOptions|string>} resources - An array of resources to load, where each is
                        *      either an object with the options or a string url. If you pass an object, it must contain a `url` property.
                        * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                        * @return {this} Returns itself.
                        */
    
    
        Loader.prototype.add = function add(name, url, options, cb) {
            // special case of an array of objects or urls
            if (Array.isArray(name)) {
                for (var i = 0; i < name.length; ++i) {
                    this.add(name[i]);
                }
    
                return this;
            }
    
            // if an object is passed instead of params
            if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
                cb = url || name.callback || name.onComplete;
                options = name;
                url = name.url;
                name = name.name || name.key || name.url;
            }
    
            // case where no name is passed shift all args over by one.
            if (typeof url !== 'string') {
                cb = options;
                options = url;
                url = name;
            }
    
            // now that we shifted make sure we have a proper url.
            if (typeof url !== 'string') {
                throw new Error('No url passed to add resource to loader.');
            }
    
            // options are optional so people might pass a function and no options
            if (typeof options === 'function') {
                cb = options;
                options = null;
            }
    
            // if loading already you can only add resources that have a parent.
            if (this.loading && (!options || !options.parentResource)) {
                throw new Error('Cannot add resources while the loader is running.');
            }
    
            // check if resource already exists.
            if (this.resources[name]) {
                throw new Error('Resource named "' + name + '" already exists.');
            }
    
            // add base url if this isn't an absolute url
            url = this._prepareUrl(url);
    
            // create the store the resource
            this.resources[name] = new _Resource.Resource(name, url, options);
    
            if (typeof cb === 'function') {
                this.resources[name].onAfterMiddleware.once(cb);
            }
    
            // if actively loading, make sure to adjust progress chunks for that parent and its children
            if (this.loading) {
                var parent = options.parentResource;
                var incompleteChildren = [];
    
                for (var _i2 = 0; _i2 < parent.children.length; ++_i2) {
                    if (!parent.children[_i2].isComplete) {
                        incompleteChildren.push(parent.children[_i2]);
                    }
                }
    
                var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
                var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child
    
                parent.children.push(this.resources[name]);
                parent.progressChunk = eachChunk;
    
                for (var _i3 = 0; _i3 < incompleteChildren.length; ++_i3) {
                    incompleteChildren[_i3].progressChunk = eachChunk;
                }
    
                this.resources[name].progressChunk = eachChunk;
            }
    
            // add the resource to the queue
            this._queue.push(this.resources[name]);
    
            return this;
        };
        /* eslint-enable require-jsdoc,valid-jsdoc */
    
        /**
         * Sets up a middleware function that will run *before* the
         * resource is loaded.
         *
         * @param {function} fn - The middleware function to register.
         * @return {this} Returns itself.
         */
    
    
        Loader.prototype.pre = function pre(fn) {
            this._beforeMiddleware.push(fn);
    
            return this;
        };
    
        /**
         * Sets up a middleware function that will run *after* the
         * resource is loaded.
         *
         * @param {function} fn - The middleware function to register.
         * @return {this} Returns itself.
         */
    
    
        Loader.prototype.use = function use(fn) {
            this._afterMiddleware.push(fn);
    
            return this;
        };
    
        /**
         * Resets the queue of the loader to prepare for a new load.
         *
         * @return {this} Returns itself.
         */
    
    
        Loader.prototype.reset = function reset() {
            this.progress = 0;
            this.loading = false;
    
            this._queue.kill();
            this._queue.pause();
    
            // abort all resource loads
            for (var k in this.resources) {
                var res = this.resources[k];
    
                if (res._onLoadBinding) {
                    res._onLoadBinding.detach();
                }
    
                if (res.isLoading) {
                    res.abort();
                }
            }
    
            this.resources = {};
    
            return this;
        };
    
        /**
         * Starts loading the queued resources.
         *
         * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
         * @return {this} Returns itself.
         */
    
    
        Loader.prototype.load = function load(cb) {
            // register complete callback if they pass one
            if (typeof cb === 'function') {
                this.onComplete.once(cb);
            }
    
            // if the queue has already started we are done here
            if (this.loading) {
                return this;
            }
    
            if (this._queue.idle()) {
                this._onStart();
                this._onComplete();
            } else {
                // distribute progress chunks
                var numTasks = this._queue._tasks.length;
                var chunk = MAX_PROGRESS / numTasks;
    
                for (var i = 0; i < this._queue._tasks.length; ++i) {
                    this._queue._tasks[i].data.progressChunk = chunk;
                }
    
                // notify we are starting
                this._onStart();
    
                // start loading
                this._queue.resume();
            }
    
            return this;
        };
    
        /**
         * The number of resources to load concurrently.
         *
         * @member {number}
         * @default 10
         */
    
    
        /**
         * Prepares a url for usage based on the configuration of this object
         *
         * @private
         * @param {string} url - The url to prepare.
         * @return {string} The prepared url.
         */
        Loader.prototype._prepareUrl = function _prepareUrl(url) {
            var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
            var result = void 0;
    
            // absolute url, just use it as is.
            if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
                result = url;
            }
            // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
            else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
                    result = this.baseUrl + '/' + url;
                } else {
                    result = this.baseUrl + url;
                }
    
            // if we need to add a default querystring, there is a bit more work
            if (this.defaultQueryString) {
                var hash = rgxExtractUrlHash.exec(result)[0];
    
                result = result.substr(0, result.length - hash.length);
    
                if (result.indexOf('?') !== -1) {
                    result += '&' + this.defaultQueryString;
                } else {
                    result += '?' + this.defaultQueryString;
                }
    
                result += hash;
            }
    
            return result;
        };
    
        /**
         * Loads a single resource.
         *
         * @private
         * @param {Resource} resource - The resource to load.
         * @param {function} dequeue - The function to call when we need to dequeue this item.
         */
    
    
        Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
            var _this2 = this;
    
            resource._dequeue = dequeue;
    
            // run before middleware
            async.eachSeries(this._beforeMiddleware, function (fn, next) {
                fn.call(_this2, resource, function () {
                    // if the before middleware marks the resource as complete,
                    // break and don't process any more before middleware
                    next(resource.isComplete ? {} : null);
                });
            }, function () {
                if (resource.isComplete) {
                    _this2._onLoad(resource);
                } else {
                    resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
                    resource.load();
                }
            }, true);
        };
    
        /**
         * Called once loading has started.
         *
         * @private
         */
    
    
        Loader.prototype._onStart = function _onStart() {
            this.progress = 0;
            this.loading = true;
            this.onStart.dispatch(this);
        };
    
        /**
         * Called once each resource has loaded.
         *
         * @private
         */
    
    
        Loader.prototype._onComplete = function _onComplete() {
            this.progress = MAX_PROGRESS;
            this.loading = false;
            this.onComplete.dispatch(this, this.resources);
        };
    
        /**
         * Called each time a resources is loaded.
         *
         * @private
         * @param {Resource} resource - The resource that was loaded
         */
    
    
        Loader.prototype._onLoad = function _onLoad(resource) {
            var _this3 = this;
    
            resource._onLoadBinding = null;
    
            // remove this resource from the async queue, and add it to our list of resources that are being parsed
            this._resourcesParsing.push(resource);
            resource._dequeue();
    
            // run all the after middleware for this resource
            async.eachSeries(this._afterMiddleware, function (fn, next) {
                fn.call(_this3, resource, next);
            }, function () {
                resource.onAfterMiddleware.dispatch(resource);
    
                _this3.progress = Math.min(MAX_PROGRESS, _this3.progress + resource.progressChunk);
                _this3.onProgress.dispatch(_this3, resource);
    
                if (resource.error) {
                    _this3.onError.dispatch(resource.error, _this3, resource);
                } else {
                    _this3.onLoad.dispatch(_this3, resource);
                }
    
                _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);
    
                // do completion check
                if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
                    _this3._onComplete();
                }
            }, true);
        };
    
        _createClass(Loader, [{
            key: 'concurrency',
            get: function get() {
                return this._queue.concurrency;
            }
            // eslint-disable-next-line require-jsdoc
            ,
            set: function set(concurrency) {
                this._queue.concurrency = concurrency;
            }
        }]);
    
        return Loader;
    }();
    
    /**
     * A default array of middleware to run before loading each resource.
     * Each of these middlewares are added to any new Loader instances when they are created.
     *
     * @private
     * @member {function[]}
     */
    
    
    Loader._defaultBeforeMiddleware = [];
    
    /**
     * A default array of middleware to run after loading each resource.
     * Each of these middlewares are added to any new Loader instances when they are created.
     *
     * @private
     * @member {function[]}
     */
    Loader._defaultAfterMiddleware = [];
    
    /**
     * Sets up a middleware function that will run *before* the
     * resource is loaded.
     *
     * @static
     * @param {function} fn - The middleware function to register.
     * @return {Loader} Returns itself.
     */
    Loader.pre = function LoaderPreStatic(fn) {
        Loader._defaultBeforeMiddleware.push(fn);
    
        return Loader;
    };
    
    /**
     * Sets up a middleware function that will run *after* the
     * resource is loaded.
     *
     * @static
     * @param {function} fn - The middleware function to register.
     * @return {Loader} Returns itself.
     */
    Loader.use = function LoaderUseStatic(fn) {
        Loader._defaultAfterMiddleware.push(fn);
    
        return Loader;
    };
    
    },{"./Resource":32,"./async":33,"mini-signals":6,"parse-uri":8}],32:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.Resource = undefined;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _parseUri = require('parse-uri');
    
    var _parseUri2 = _interopRequireDefault(_parseUri);
    
    var _miniSignals = require('mini-signals');
    
    var _miniSignals2 = _interopRequireDefault(_miniSignals);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    // tests if CORS is supported in XHR, if not we need to use XDR
    var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
    var tempAnchor = null;
    
    // some status constants
    var STATUS_NONE = 0;
    var STATUS_OK = 200;
    var STATUS_EMPTY = 204;
    var STATUS_IE_BUG_EMPTY = 1223;
    var STATUS_TYPE_OK = 2;
    
    // noop
    function _noop() {} /* empty */
    
    /**
     * Manages the state and loading of a resource and all child resources.
     *
     * @class
     */
    
    var Resource = exports.Resource = function () {
        /**
         * Sets the load type to be used for a specific extension.
         *
         * @static
         * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
         * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
         */
        Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
            setExtMap(Resource._loadTypeMap, extname, loadType);
        };
    
        /**
         * Sets the load type to be used for a specific extension.
         *
         * @static
         * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
         * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
         */
    
    
        Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
            setExtMap(Resource._xhrTypeMap, extname, xhrType);
        };
    
        /**
         * @param {string} name - The name of the resource to load.
         * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
         *      an array of sources.
         * @param {object} [options] - The options for the load.
         * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
         *      determine automatically.
         * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
         *      longer than this time it is cancelled and the load is considered a failure. If this value is
         *      set to `0` then there is no explicit timeout.
         * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
         *      be loaded?
         * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
         *      should the data being loaded be interpreted when using XHR?
         * @param {Resource.IMetadata} [options.metadata] - Extra configuration for middleware and the Resource object.
         */
    
    
        function Resource(name, url, options) {
            _classCallCheck(this, Resource);
    
            if (typeof name !== 'string' || typeof url !== 'string') {
                throw new Error('Both name and url are required for constructing a resource.');
            }
    
            options = options || {};
    
            /**
             * The state flags of this resource.
             *
             * @private
             * @member {number}
             */
            this._flags = 0;
    
            // set data url flag, needs to be set early for some _determineX checks to work.
            this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);
    
            /**
             * The name of this resource.
             *
             * @readonly
             * @member {string}
             */
            this.name = name;
    
            /**
             * The url used to load this resource.
             *
             * @readonly
             * @member {string}
             */
            this.url = url;
    
            /**
             * The extension used to load this resource.
             *
             * @readonly
             * @member {string}
             */
            this.extension = this._getExtension();
    
            /**
             * The data that was loaded by the resource.
             *
             * @member {any}
             */
            this.data = null;
    
            /**
             * Is this request cross-origin? If unset, determined automatically.
             *
             * @member {string}
             */
            this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;
    
            /**
             * A timeout in milliseconds for the load. If the load takes longer than this time
             * it is cancelled and the load is considered a failure. If this value is set to `0`
             * then there is no explicit timeout.
             *
             * @member {number}
             */
            this.timeout = options.timeout || 0;
    
            /**
             * The method of loading to use for this resource.
             *
             * @member {Resource.LOAD_TYPE}
             */
            this.loadType = options.loadType || this._determineLoadType();
    
            /**
             * The type used to load the resource via XHR. If unset, determined automatically.
             *
             * @member {string}
             */
            this.xhrType = options.xhrType;
    
            /**
             * Extra info for middleware, and controlling specifics about how the resource loads.
             *
             * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
             * Meaning it will modify it as it sees fit.
             *
             * @member {Resource.IMetadata}
             */
            this.metadata = options.metadata || {};
    
            /**
             * The error that occurred while loading (if any).
             *
             * @readonly
             * @member {Error}
             */
            this.error = null;
    
            /**
             * The XHR object that was used to load this resource. This is only set
             * when `loadType` is `Resource.LOAD_TYPE.XHR`.
             *
             * @readonly
             * @member {XMLHttpRequest}
             */
            this.xhr = null;
    
            /**
             * The child resources this resource owns.
             *
             * @readonly
             * @member {Resource[]}
             */
            this.children = [];
    
            /**
             * The resource type.
             *
             * @readonly
             * @member {Resource.TYPE}
             */
            this.type = Resource.TYPE.UNKNOWN;
    
            /**
             * The progress chunk owned by this resource.
             *
             * @readonly
             * @member {number}
             */
            this.progressChunk = 0;
    
            /**
             * The `dequeue` method that will be used a storage place for the async queue dequeue method
             * used privately by the loader.
             *
             * @private
             * @member {function}
             */
            this._dequeue = _noop;
    
            /**
             * Used a storage place for the on load binding used privately by the loader.
             *
             * @private
             * @member {function}
             */
            this._onLoadBinding = null;
    
            /**
             * The timer for element loads to check if they timeout.
             *
             * @private
             * @member {number}
             */
            this._elementTimer = 0;
    
            /**
             * The `complete` function bound to this resource's context.
             *
             * @private
             * @member {function}
             */
            this._boundComplete = this.complete.bind(this);
    
            /**
             * The `_onError` function bound to this resource's context.
             *
             * @private
             * @member {function}
             */
            this._boundOnError = this._onError.bind(this);
    
            /**
             * The `_onProgress` function bound to this resource's context.
             *
             * @private
             * @member {function}
             */
            this._boundOnProgress = this._onProgress.bind(this);
    
            /**
             * The `_onTimeout` function bound to this resource's context.
             *
             * @private
             * @member {function}
             */
            this._boundOnTimeout = this._onTimeout.bind(this);
    
            // xhr callbacks
            this._boundXhrOnError = this._xhrOnError.bind(this);
            this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
            this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
            this._boundXhrOnLoad = this._xhrOnLoad.bind(this);
    
            /**
             * Dispatched when the resource beings to load.
             *
             * The callback looks like {@link Resource.OnStartSignal}.
             *
             * @member {Signal<Resource.OnStartSignal>}
             */
            this.onStart = new _miniSignals2.default();
    
            /**
             * Dispatched each time progress of this resource load updates.
             * Not all resources types and loader systems can support this event
             * so sometimes it may not be available. If the resource
             * is being loaded on a modern browser, using XHR, and the remote server
             * properly sets Content-Length headers, then this will be available.
             *
             * The callback looks like {@link Resource.OnProgressSignal}.
             *
             * @member {Signal<Resource.OnProgressSignal>}
             */
            this.onProgress = new _miniSignals2.default();
    
            /**
             * Dispatched once this resource has loaded, if there was an error it will
             * be in the `error` property.
             *
             * The callback looks like {@link Resource.OnCompleteSignal}.
             *
             * @member {Signal<Resource.OnCompleteSignal>}
             */
            this.onComplete = new _miniSignals2.default();
    
            /**
             * Dispatched after this resource has had all the *after* middleware run on it.
             *
             * The callback looks like {@link Resource.OnCompleteSignal}.
             *
             * @member {Signal<Resource.OnCompleteSignal>}
             */
            this.onAfterMiddleware = new _miniSignals2.default();
        }
    
        /**
         * When the resource starts to load.
         *
         * @memberof Resource
         * @callback OnStartSignal
         * @param {Resource} resource - The resource that the event happened on.
         */
    
        /**
         * When the resource reports loading progress.
         *
         * @memberof Resource
         * @callback OnProgressSignal
         * @param {Resource} resource - The resource that the event happened on.
         * @param {number} percentage - The progress of the load in the range [0, 1].
         */
    
        /**
         * When the resource finishes loading.
         *
         * @memberof Resource
         * @callback OnCompleteSignal
         * @param {Resource} resource - The resource that the event happened on.
         */
    
        /**
         * @memberof Resource
         * @typedef {object} IMetadata
         * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
         *      element to use for loading, instead of creating one.
         * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
         *      is useful if you want to pass in a `loadElement` that you already added load sources to.
         * @property {string|string[]} [mimeType] - The mime type to use for the source element
         *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
         *      where each index is the mime type to use for the corresponding url index.
         */
    
        /**
         * Stores whether or not this url is a data url.
         *
         * @readonly
         * @member {boolean}
         */
    
    
        /**
         * Marks the resource as complete.
         *
         */
        Resource.prototype.complete = function complete() {
            this._clearEvents();
            this._finish();
        };
    
        /**
         * Aborts the loading of this resource, with an optional message.
         *
         * @param {string} message - The message to use for the error
         */
    
    
        Resource.prototype.abort = function abort(message) {
            // abort can be called multiple times, ignore subsequent calls.
            if (this.error) {
                return;
            }
    
            // store error
            this.error = new Error(message);
    
            // clear events before calling aborts
            this._clearEvents();
    
            // abort the actual loading
            if (this.xhr) {
                this.xhr.abort();
            } else if (this.xdr) {
                this.xdr.abort();
            } else if (this.data) {
                // single source
                if (this.data.src) {
                    this.data.src = Resource.EMPTY_GIF;
                }
                // multi-source
                else {
                        while (this.data.firstChild) {
                            this.data.removeChild(this.data.firstChild);
                        }
                    }
            }
    
            // done now.
            this._finish();
        };
    
        /**
         * Kicks off loading of this resource. This method is asynchronous.
         *
         * @param {Resource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
         */
    
    
        Resource.prototype.load = function load(cb) {
            var _this = this;
    
            if (this.isLoading) {
                return;
            }
    
            if (this.isComplete) {
                if (cb) {
                    setTimeout(function () {
                        return cb(_this);
                    }, 1);
                }
    
                return;
            } else if (cb) {
                this.onComplete.once(cb);
            }
    
            this._setFlag(Resource.STATUS_FLAGS.LOADING, true);
    
            this.onStart.dispatch(this);
    
            // if unset, determine the value
            if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
                this.crossOrigin = this._determineCrossOrigin(this.url);
            }
    
            switch (this.loadType) {
                case Resource.LOAD_TYPE.IMAGE:
                    this.type = Resource.TYPE.IMAGE;
                    this._loadElement('image');
                    break;
    
                case Resource.LOAD_TYPE.AUDIO:
                    this.type = Resource.TYPE.AUDIO;
                    this._loadSourceElement('audio');
                    break;
    
                case Resource.LOAD_TYPE.VIDEO:
                    this.type = Resource.TYPE.VIDEO;
                    this._loadSourceElement('video');
                    break;
    
                case Resource.LOAD_TYPE.XHR:
                /* falls through */
                default:
                    if (useXdr && this.crossOrigin) {
                        this._loadXdr();
                    } else {
                        this._loadXhr();
                    }
                    break;
            }
        };
    
        /**
         * Checks if the flag is set.
         *
         * @private
         * @param {number} flag - The flag to check.
         * @return {boolean} True if the flag is set.
         */
    
    
        Resource.prototype._hasFlag = function _hasFlag(flag) {
            return (this._flags & flag) !== 0;
        };
    
        /**
         * (Un)Sets the flag.
         *
         * @private
         * @param {number} flag - The flag to (un)set.
         * @param {boolean} value - Whether to set or (un)set the flag.
         */
    
    
        Resource.prototype._setFlag = function _setFlag(flag, value) {
            this._flags = value ? this._flags | flag : this._flags & ~flag;
        };
    
        /**
         * Clears all the events from the underlying loading source.
         *
         * @private
         */
    
    
        Resource.prototype._clearEvents = function _clearEvents() {
            clearTimeout(this._elementTimer);
    
            if (this.data && this.data.removeEventListener) {
                this.data.removeEventListener('error', this._boundOnError, false);
                this.data.removeEventListener('load', this._boundComplete, false);
                this.data.removeEventListener('progress', this._boundOnProgress, false);
                this.data.removeEventListener('canplaythrough', this._boundComplete, false);
            }
    
            if (this.xhr) {
                if (this.xhr.removeEventListener) {
                    this.xhr.removeEventListener('error', this._boundXhrOnError, false);
                    this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
                    this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
                    this.xhr.removeEventListener('progress', this._boundOnProgress, false);
                    this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
                } else {
                    this.xhr.onerror = null;
                    this.xhr.ontimeout = null;
                    this.xhr.onprogress = null;
                    this.xhr.onload = null;
                }
            }
        };
    
        /**
         * Finalizes the load.
         *
         * @private
         */
    
    
        Resource.prototype._finish = function _finish() {
            if (this.isComplete) {
                throw new Error('Complete called again for an already completed resource.');
            }
    
            this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
            this._setFlag(Resource.STATUS_FLAGS.LOADING, false);
    
            this.onComplete.dispatch(this);
        };
    
        /**
         * Loads this resources using an element that has a single source,
         * like an HTMLImageElement.
         *
         * @private
         * @param {string} type - The type of element to use.
         */
    
    
        Resource.prototype._loadElement = function _loadElement(type) {
            if (this.metadata.loadElement) {
                this.data = this.metadata.loadElement;
            } else if (type === 'image' && typeof window.Image !== 'undefined') {
                this.data = new Image();
            } else {
                this.data = document.createElement(type);
            }
    
            if (this.crossOrigin) {
                this.data.crossOrigin = this.crossOrigin;
            }
    
            if (!this.metadata.skipSource) {
                this.data.src = this.url;
            }
    
            this.data.addEventListener('error', this._boundOnError, false);
            this.data.addEventListener('load', this._boundComplete, false);
            this.data.addEventListener('progress', this._boundOnProgress, false);
    
            if (this.timeout) {
                this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
            }
        };
    
        /**
         * Loads this resources using an element that has multiple sources,
         * like an HTMLAudioElement or HTMLVideoElement.
         *
         * @private
         * @param {string} type - The type of element to use.
         */
    
    
        Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
            if (this.metadata.loadElement) {
                this.data = this.metadata.loadElement;
            } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
                this.data = new Audio();
            } else {
                this.data = document.createElement(type);
            }
    
            if (this.data === null) {
                this.abort('Unsupported element: ' + type);
    
                return;
            }
    
            if (this.crossOrigin) {
                this.data.crossOrigin = this.crossOrigin;
            }
    
            if (!this.metadata.skipSource) {
                // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
                if (navigator.isCocoonJS) {
                    this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
                } else if (Array.isArray(this.url)) {
                    var mimeTypes = this.metadata.mimeType;
    
                    for (var i = 0; i < this.url.length; ++i) {
                        this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
                    }
                } else {
                    var _mimeTypes = this.metadata.mimeType;
    
                    this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
                }
            }
    
            this.data.addEventListener('error', this._boundOnError, false);
            this.data.addEventListener('load', this._boundComplete, false);
            this.data.addEventListener('progress', this._boundOnProgress, false);
            this.data.addEventListener('canplaythrough', this._boundComplete, false);
    
            this.data.load();
    
            if (this.timeout) {
                this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
            }
        };
    
        /**
         * Loads this resources using an XMLHttpRequest.
         *
         * @private
         */
    
    
        Resource.prototype._loadXhr = function _loadXhr() {
            // if unset, determine the value
            if (typeof this.xhrType !== 'string') {
                this.xhrType = this._determineXhrType();
            }
    
            var xhr = this.xhr = new XMLHttpRequest();
    
            // set the request type and url
            xhr.open('GET', this.url, true);
    
            xhr.timeout = this.timeout;
    
            // load json as text and parse it ourselves. We do this because some browsers
            // *cough* safari *cough* can't deal with it.
            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
                xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
            } else {
                xhr.responseType = this.xhrType;
            }
    
            xhr.addEventListener('error', this._boundXhrOnError, false);
            xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
            xhr.addEventListener('abort', this._boundXhrOnAbort, false);
            xhr.addEventListener('progress', this._boundOnProgress, false);
            xhr.addEventListener('load', this._boundXhrOnLoad, false);
    
            xhr.send();
        };
    
        /**
         * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
         *
         * @private
         */
    
    
        Resource.prototype._loadXdr = function _loadXdr() {
            // if unset, determine the value
            if (typeof this.xhrType !== 'string') {
                this.xhrType = this._determineXhrType();
            }
    
            var xdr = this.xhr = new XDomainRequest(); // eslint-disable-line no-undef
    
            // XDomainRequest has a few quirks. Occasionally it will abort requests
            // A way to avoid this is to make sure ALL callbacks are set even if not used
            // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
            xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9
    
            xdr.onerror = this._boundXhrOnError;
            xdr.ontimeout = this._boundXhrOnTimeout;
            xdr.onprogress = this._boundOnProgress;
            xdr.onload = this._boundXhrOnLoad;
    
            xdr.open('GET', this.url, true);
    
            // Note: The xdr.send() call is wrapped in a timeout to prevent an
            // issue with the interface where some requests are lost if multiple
            // XDomainRequests are being sent at the same time.
            // Some info here: https://github.com/photonstorm/phaser/issues/1248
            setTimeout(function () {
                return xdr.send();
            }, 1);
        };
    
        /**
         * Creates a source used in loading via an element.
         *
         * @private
         * @param {string} type - The element type (video or audio).
         * @param {string} url - The source URL to load from.
         * @param {string} [mime] - The mime type of the video
         * @return {HTMLSourceElement} The source element.
         */
    
    
        Resource.prototype._createSource = function _createSource(type, url, mime) {
            if (!mime) {
                mime = type + '/' + this._getExtension(url);
            }
    
            var source = document.createElement('source');
    
            source.src = url;
            source.type = mime;
    
            return source;
        };
    
        /**
         * Called if a load errors out.
         *
         * @param {Event} event - The error event from the element that emits it.
         * @private
         */
    
    
        Resource.prototype._onError = function _onError(event) {
            this.abort('Failed to load element using: ' + event.target.nodeName);
        };
    
        /**
         * Called if a load progress event fires for an element or xhr/xdr.
         *
         * @private
         * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
         */
    
    
        Resource.prototype._onProgress = function _onProgress(event) {
            if (event && event.lengthComputable) {
                this.onProgress.dispatch(this, event.loaded / event.total);
            }
        };
    
        /**
         * Called if a timeout event fires for an element.
         *
         * @private
         */
    
    
        Resource.prototype._onTimeout = function _onTimeout() {
            this.abort('Load timed out.');
        };
    
        /**
         * Called if an error event fires for xhr/xdr.
         *
         * @private
         */
    
    
        Resource.prototype._xhrOnError = function _xhrOnError() {
            var xhr = this.xhr;
    
            this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
        };
    
        /**
         * Called if an error event fires for xhr/xdr.
         *
         * @private
         */
    
    
        Resource.prototype._xhrOnTimeout = function _xhrOnTimeout() {
            var xhr = this.xhr;
    
            this.abort(reqType(xhr) + ' Request timed out.');
        };
    
        /**
         * Called if an abort event fires for xhr/xdr.
         *
         * @private
         */
    
    
        Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
            var xhr = this.xhr;
    
            this.abort(reqType(xhr) + ' Request was aborted by the user.');
        };
    
        /**
         * Called when data successfully loads from an xhr/xdr request.
         *
         * @private
         * @param {XMLHttpRequestLoadEvent|Event} event - Load event
         */
    
    
        Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
            var xhr = this.xhr;
            var text = '';
            var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.
    
            // responseText is accessible only if responseType is '' or 'text' and on older browsers
            if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
                text = xhr.responseText;
            }
    
            // status can be 0 when using the `file://` protocol so we also check if a response is set.
            // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
            if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
                status = STATUS_OK;
            }
            // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
            else if (status === STATUS_IE_BUG_EMPTY) {
                    status = STATUS_EMPTY;
                }
    
            var statusType = status / 100 | 0;
    
            if (statusType === STATUS_TYPE_OK) {
                // if text, just return it
                if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
                    this.data = text;
                    this.type = Resource.TYPE.TEXT;
                }
                // if json, parse into json object
                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
                        try {
                            this.data = JSON.parse(text);
                            this.type = Resource.TYPE.JSON;
                        } catch (e) {
                            this.abort('Error trying to parse loaded json: ' + e);
    
                            return;
                        }
                    }
                    // if xml, parse into an xml document or div element
                    else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
                            try {
                                if (window.DOMParser) {
                                    var domparser = new DOMParser();
    
                                    this.data = domparser.parseFromString(text, 'text/xml');
                                } else {
                                    var div = document.createElement('div');
    
                                    div.innerHTML = text;
    
                                    this.data = div;
                                }
    
                                this.type = Resource.TYPE.XML;
                            } catch (e) {
                                this.abort('Error trying to parse loaded xml: ' + e);
    
                                return;
                            }
                        }
                        // other types just return the response
                        else {
                                this.data = xhr.response || text;
                            }
            } else {
                this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);
    
                return;
            }
    
            this.complete();
        };
    
        /**
         * Sets the `crossOrigin` property for this resource based on if the url
         * for this resource is cross-origin. If crossOrigin was manually set, this
         * function does nothing.
         *
         * @private
         * @param {string} url - The url to test.
         * @param {object} [loc=window.location] - The location object to test against.
         * @return {string} The crossOrigin value to use (or empty string for none).
         */
    
    
        Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
            // data: and javascript: urls are considered same-origin
            if (url.indexOf('data:') === 0) {
                return '';
            }
    
            // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
            // origin designed not to match window.location.origin, and will always require
            // crossOrigin requests regardless of whether the location matches.
            if (window.origin !== window.location.origin) {
                return 'anonymous';
            }
    
            // default is window.location
            loc = loc || window.location;
    
            if (!tempAnchor) {
                tempAnchor = document.createElement('a');
            }
    
            // let the browser determine the full href for the url of this resource and then
            // parse with the node url lib, we can't use the properties of the anchor element
            // because they don't work in IE9 :(
            tempAnchor.href = url;
            url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });
    
            var samePort = !url.port && loc.port === '' || url.port === loc.port;
            var protocol = url.protocol ? url.protocol + ':' : '';
    
            // if cross origin
            if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
                return 'anonymous';
            }
    
            return '';
        };
    
        /**
         * Determines the responseType of an XHR request based on the extension of the
         * resource being loaded.
         *
         * @private
         * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
         */
    
    
        Resource.prototype._determineXhrType = function _determineXhrType() {
            return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
        };
    
        /**
         * Determines the loadType of a resource based on the extension of the
         * resource being loaded.
         *
         * @private
         * @return {Resource.LOAD_TYPE} The loadType to use.
         */
    
    
        Resource.prototype._determineLoadType = function _determineLoadType() {
            return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
        };
    
        /**
         * Extracts the extension (sans '.') of the file being loaded by the resource.
         *
         * @private
         * @return {string} The extension.
         */
    
    
        Resource.prototype._getExtension = function _getExtension() {
            var url = this.url;
            var ext = '';
    
            if (this.isDataUrl) {
                var slashIndex = url.indexOf('/');
    
                ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
            } else {
                var queryStart = url.indexOf('?');
                var hashStart = url.indexOf('#');
                var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);
    
                url = url.substring(0, index);
                ext = url.substring(url.lastIndexOf('.') + 1);
            }
    
            return ext.toLowerCase();
        };
    
        /**
         * Determines the mime type of an XHR request based on the responseType of
         * resource being loaded.
         *
         * @private
         * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
         * @return {string} The mime type to use.
         */
    
    
        Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
            switch (type) {
                case Resource.XHR_RESPONSE_TYPE.BUFFER:
                    return 'application/octet-binary';
    
                case Resource.XHR_RESPONSE_TYPE.BLOB:
                    return 'application/blob';
    
                case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
                    return 'application/xml';
    
                case Resource.XHR_RESPONSE_TYPE.JSON:
                    return 'application/json';
    
                case Resource.XHR_RESPONSE_TYPE.DEFAULT:
                case Resource.XHR_RESPONSE_TYPE.TEXT:
                /* falls through */
                default:
                    return 'text/plain';
            }
        };
    
        _createClass(Resource, [{
            key: 'isDataUrl',
            get: function get() {
                return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
            }
    
            /**
             * Describes if this resource has finished loading. Is true when the resource has completely
             * loaded.
             *
             * @readonly
             * @member {boolean}
             */
    
        }, {
            key: 'isComplete',
            get: function get() {
                return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
            }
    
            /**
             * Describes if this resource is currently loading. Is true when the resource starts loading,
             * and is false again when complete.
             *
             * @readonly
             * @member {boolean}
             */
    
        }, {
            key: 'isLoading',
            get: function get() {
                return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
            }
        }]);
    
        return Resource;
    }();
    
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     */
    
    
    Resource.STATUS_FLAGS = {
        NONE: 0,
        DATA_URL: 1 << 0,
        COMPLETE: 1 << 1,
        LOADING: 1 << 2
    };
    
    /**
     * The types of resources a resource could represent.
     *
     * @static
     * @readonly
     * @enum {number}
     */
    Resource.TYPE = {
        UNKNOWN: 0,
        JSON: 1,
        XML: 2,
        IMAGE: 3,
        AUDIO: 4,
        VIDEO: 5,
        TEXT: 6
    };
    
    /**
     * The types of loading a resource can use.
     *
     * @static
     * @readonly
     * @enum {number}
     */
    Resource.LOAD_TYPE = {
        /** Uses XMLHttpRequest to load the resource. */
        XHR: 1,
        /** Uses an `Image` object to load the resource. */
        IMAGE: 2,
        /** Uses an `Audio` object to load the resource. */
        AUDIO: 3,
        /** Uses a `Video` object to load the resource. */
        VIDEO: 4
    };
    
    /**
     * The XHR ready states, used internally.
     *
     * @static
     * @readonly
     * @enum {string}
     */
    Resource.XHR_RESPONSE_TYPE = {
        /** string */
        DEFAULT: 'text',
        /** ArrayBuffer */
        BUFFER: 'arraybuffer',
        /** Blob */
        BLOB: 'blob',
        /** Document */
        DOCUMENT: 'document',
        /** Object */
        JSON: 'json',
        /** String */
        TEXT: 'text'
    };
    
    Resource._loadTypeMap = {
        // images
        gif: Resource.LOAD_TYPE.IMAGE,
        png: Resource.LOAD_TYPE.IMAGE,
        bmp: Resource.LOAD_TYPE.IMAGE,
        jpg: Resource.LOAD_TYPE.IMAGE,
        jpeg: Resource.LOAD_TYPE.IMAGE,
        tif: Resource.LOAD_TYPE.IMAGE,
        tiff: Resource.LOAD_TYPE.IMAGE,
        webp: Resource.LOAD_TYPE.IMAGE,
        tga: Resource.LOAD_TYPE.IMAGE,
        svg: Resource.LOAD_TYPE.IMAGE,
        'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls
    
        // audio
        mp3: Resource.LOAD_TYPE.AUDIO,
        ogg: Resource.LOAD_TYPE.AUDIO,
        wav: Resource.LOAD_TYPE.AUDIO,
    
        // videos
        mp4: Resource.LOAD_TYPE.VIDEO,
        webm: Resource.LOAD_TYPE.VIDEO
    };
    
    Resource._xhrTypeMap = {
        // xml
        xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
        html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
        htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
        xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
        tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
        svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    
        // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
        // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
        // this should probably be fine.
        tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    
        // images
        gif: Resource.XHR_RESPONSE_TYPE.BLOB,
        png: Resource.XHR_RESPONSE_TYPE.BLOB,
        bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
        jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
        jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
        tif: Resource.XHR_RESPONSE_TYPE.BLOB,
        tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
        webp: Resource.XHR_RESPONSE_TYPE.BLOB,
        tga: Resource.XHR_RESPONSE_TYPE.BLOB,
    
        // json
        json: Resource.XHR_RESPONSE_TYPE.JSON,
    
        // text
        text: Resource.XHR_RESPONSE_TYPE.TEXT,
        txt: Resource.XHR_RESPONSE_TYPE.TEXT,
    
        // fonts
        ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
        otf: Resource.XHR_RESPONSE_TYPE.BUFFER
    };
    
    // We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
    Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    
    /**
     * Quick helper to set a value on one of the extension maps. Ensures there is no
     * dot at the start of the extension.
     *
     * @ignore
     * @param {object} map - The map to set on.
     * @param {string} extname - The extension (or key) to set.
     * @param {number} val - The value to set.
     */
    function setExtMap(map, extname, val) {
        if (extname && extname.indexOf('.') === 0) {
            extname = extname.substring(1);
        }
    
        if (!extname) {
            return;
        }
    
        map[extname] = val;
    }
    
    /**
     * Quick helper to get string xhr type.
     *
     * @ignore
     * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
     * @return {string} The type.
     */
    function reqType(xhr) {
        return xhr.toString().replace('object ', '');
    }
    
    // Backwards compat
    if (typeof module !== 'undefined') {
        module.exports.default = Resource; // eslint-disable-line no-undef
    }
    
    },{"mini-signals":6,"parse-uri":8}],33:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.eachSeries = eachSeries;
    exports.queue = queue;
    /**
     * Smaller version of the async library constructs.
     *
     * @namespace async
     */
    
    /**
     * Noop function
     *
     * @ignore
     * @function
     * @memberof async
     */
    function _noop() {} /* empty */
    
    /**
     * Iterates an array in series.
     *
     * @memberof async
     * @param {Array.<*>} array - Array to iterate.
     * @param {function} iterator - Function to call for each element.
     * @param {function} callback - Function to call when done, or on error.
     * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
     */
    function eachSeries(array, iterator, callback, deferNext) {
        var i = 0;
        var len = array.length;
    
        (function next(err) {
            if (err || i === len) {
                if (callback) {
                    callback(err);
                }
    
                return;
            }
    
            if (deferNext) {
                setTimeout(function () {
                    iterator(array[i++], next);
                }, 1);
            } else {
                iterator(array[i++], next);
            }
        })();
    }
    
    /**
     * Ensures a function is only called once.
     *
     * @ignore
     * @memberof async
     * @param {function} fn - The function to wrap.
     * @return {function} The wrapping function.
     */
    function onlyOnce(fn) {
        return function onceWrapper() {
            if (fn === null) {
                throw new Error('Callback was already called.');
            }
    
            var callFn = fn;
    
            fn = null;
            callFn.apply(this, arguments);
        };
    }
    
    /**
     * Async queue implementation,
     *
     * @memberof async
     * @param {function} worker - The worker function to call for each task.
     * @param {number} concurrency - How many workers to run in parrallel.
     * @return {*} The async queue object.
     */
    function queue(worker, concurrency) {
        if (concurrency == null) {
            // eslint-disable-line no-eq-null,eqeqeq
            concurrency = 1;
        } else if (concurrency === 0) {
            throw new Error('Concurrency must not be zero');
        }
    
        var workers = 0;
        var q = {
            _tasks: [],
            concurrency: concurrency,
            saturated: _noop,
            unsaturated: _noop,
            buffer: concurrency / 4,
            empty: _noop,
            drain: _noop,
            error: _noop,
            started: false,
            paused: false,
            push: function push(data, callback) {
                _insert(data, false, callback);
            },
            kill: function kill() {
                workers = 0;
                q.drain = _noop;
                q.started = false;
                q._tasks = [];
            },
            unshift: function unshift(data, callback) {
                _insert(data, true, callback);
            },
            process: function process() {
                while (!q.paused && workers < q.concurrency && q._tasks.length) {
                    var task = q._tasks.shift();
    
                    if (q._tasks.length === 0) {
                        q.empty();
                    }
    
                    workers += 1;
    
                    if (workers === q.concurrency) {
                        q.saturated();
                    }
    
                    worker(task.data, onlyOnce(_next(task)));
                }
            },
            length: function length() {
                return q._tasks.length;
            },
            running: function running() {
                return workers;
            },
            idle: function idle() {
                return q._tasks.length + workers === 0;
            },
            pause: function pause() {
                if (q.paused === true) {
                    return;
                }
    
                q.paused = true;
            },
            resume: function resume() {
                if (q.paused === false) {
                    return;
                }
    
                q.paused = false;
    
                // Need to call q.process once per concurrent
                // worker to preserve full concurrency after pause
                for (var w = 1; w <= q.concurrency; w++) {
                    q.process();
                }
            }
        };
    
        function _insert(data, insertAtFront, callback) {
            if (callback != null && typeof callback !== 'function') {
                // eslint-disable-line no-eq-null,eqeqeq
                throw new Error('task callback must be a function');
            }
    
            q.started = true;
    
            if (data == null && q.idle()) {
                // eslint-disable-line no-eq-null,eqeqeq
                // call drain immediately if there are no tasks
                setTimeout(function () {
                    return q.drain();
                }, 1);
    
                return;
            }
    
            var item = {
                data: data,
                callback: typeof callback === 'function' ? callback : _noop
            };
    
            if (insertAtFront) {
                q._tasks.unshift(item);
            } else {
                q._tasks.push(item);
            }
    
            setTimeout(function () {
                return q.process();
            }, 1);
        }
    
        function _next(task) {
            return function next() {
                workers -= 1;
    
                task.callback.apply(task, arguments);
    
                if (arguments[0] != null) {
                    // eslint-disable-line no-eq-null,eqeqeq
                    q.error(arguments[0], task.data);
                }
    
                if (workers <= q.concurrency - q.buffer) {
                    q.unsaturated();
                }
    
                if (q.idle()) {
                    q.drain();
                }
    
                q.process();
            };
        }
    
        return q;
    }
    
    },{}],34:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.encodeBinary = encodeBinary;
    var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    
    /**
     * Encodes binary into base64.
     *
     * @param {string} input The input data to encode.
     * @returns {string} The encoded base64 string
     */
    function encodeBinary(input) {
        var output = '';
        var inx = 0;
    
        while (inx < input.length) {
            // Fill byte buffer array
            var bytebuffer = [0, 0, 0];
            var encodedCharIndexes = [0, 0, 0, 0];
    
            for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
                if (inx < input.length) {
                    // throw away high-order byte, as documented at:
                    // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
                    bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
                } else {
                    bytebuffer[jnx] = 0;
                }
            }
    
            // Get each encoded character, 6 bits at a time
            // index 1: first 6 bits
            encodedCharIndexes[0] = bytebuffer[0] >> 2;
    
            // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
            encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;
    
            // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
            encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;
    
            // index 3: forth 6 bits (6 least significant bits from input byte 3)
            encodedCharIndexes[3] = bytebuffer[2] & 0x3f;
    
            // Determine whether padding happened, and adjust accordingly
            var paddingBytes = inx - (input.length - 1);
    
            switch (paddingBytes) {
                case 2:
                    // Set last 2 characters to padding char
                    encodedCharIndexes[3] = 64;
                    encodedCharIndexes[2] = 64;
                    break;
    
                case 1:
                    // Set last character to padding char
                    encodedCharIndexes[3] = 64;
                    break;
    
                default:
                    break; // No padding - proceed
            }
    
            // Now we will grab each appropriate character out of our keystring
            // based on our index array and append it to the output string
            for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
                output += _keyStr.charAt(encodedCharIndexes[_jnx]);
            }
        }
    
        return output;
    }
    
    // Backwards compat
    if (typeof module !== 'undefined') {
        module.exports.default = encodeBinary; // eslint-disable-line no-undef
    }
    
    },{}],35:[function(require,module,exports){
    'use strict';
    
    // import Loader from './Loader';
    // import Resource from './Resource';
    // import * as async from './async';
    // import * as b64 from './b64';
    
    /* eslint-disable no-undef */
    
    var Loader = require('./Loader').Loader;
    var Resource = require('./Resource').Resource;
    var async = require('./async');
    var b64 = require('./b64');
    
    /**
     *
     * @static
     * @memberof Loader
     * @member {Class<Resource>}
     */
    Loader.Resource = Resource;
    
    /**
     *
     * @static
     * @memberof Loader
     * @member {Class<async>}
     */
    Loader.async = async;
    
    /**
     *
     * @static
     * @memberof Loader
     * @member {Class<encodeBinary>}
     */
    Loader.encodeBinary = b64;
    
    /**
     *
     * @deprecated
     * @see Loader.encodeBinary
     *
     * @static
     * @memberof Loader
     * @member {Class<encodeBinary>}
     */
    Loader.base64 = b64;
    
    // export manually, and also as default
    module.exports = Loader;
    
    // default & named export
    module.exports.Loader = Loader;
    module.exports.default = Loader;
    
    },{"./Loader":31,"./Resource":32,"./async":33,"./b64":34}],36:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.blobMiddlewareFactory = blobMiddlewareFactory;
    
    var _Resource = require('../../Resource');
    
    var _b = require('../../b64');
    
    var Url = window.URL || window.webkitURL;
    
    // a middleware for transforming XHR loaded Blobs into more useful objects
    function blobMiddlewareFactory() {
        return function blobMiddleware(resource, next) {
            if (!resource.data) {
                next();
    
                return;
            }
    
            // if this was an XHR load of a blob
            if (resource.xhr && resource.xhrType === _Resource.Resource.XHR_RESPONSE_TYPE.BLOB) {
                // if there is no blob support we probably got a binary string back
                if (!window.Blob || typeof resource.data === 'string') {
                    var type = resource.xhr.getResponseHeader('content-type');
    
                    // this is an image, convert the binary string into a data url
                    if (type && type.indexOf('image') === 0) {
                        resource.data = new Image();
                        resource.data.src = 'data:' + type + ';base64,' + (0, _b.encodeBinary)(resource.xhr.responseText);
    
                        resource.type = _Resource.Resource.TYPE.IMAGE;
    
                        // wait until the image loads and then callback
                        resource.data.onload = function () {
                            resource.data.onload = null;
    
                            next();
                        };
    
                        // next will be called on load
                        return;
                    }
                }
                // if content type says this is an image, then we should transform the blob into an Image object
                else if (resource.data.type.indexOf('image') === 0) {
                        var src = Url.createObjectURL(resource.data);
    
                        resource.blob = resource.data;
                        resource.data = new Image();
                        resource.data.src = src;
    
                        resource.type = _Resource.Resource.TYPE.IMAGE;
    
                        // cleanup the no longer used blob after the image loads
                        // TODO: Is this correct? Will the image be invalid after revoking?
                        resource.data.onload = function () {
                            Url.revokeObjectURL(src);
                            resource.data.onload = null;
    
                            next();
                        };
    
                        // next will be called on load.
                        return;
                    }
            }
    
            next();
        };
    }
    
    },{"../../Resource":32,"../../b64":34}],37:[function(require,module,exports){
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    
    'use strict';
    
    var punycode = require('punycode');
    var util = require('./util');
    
    exports.parse = urlParse;
    exports.resolve = urlResolve;
    exports.resolveObject = urlResolveObject;
    exports.format = urlFormat;
    
    exports.Url = Url;
    
    function Url() {
      this.protocol = null;
      this.slashes = null;
      this.auth = null;
      this.host = null;
      this.port = null;
      this.hostname = null;
      this.hash = null;
      this.search = null;
      this.query = null;
      this.pathname = null;
      this.path = null;
      this.href = null;
    }
    
    // Reference: RFC 3986, RFC 1808, RFC 2396
    
    // define these here so at least they only have to be
    // compiled once on the first module load.
    var protocolPattern = /^([a-z0-9.+-]+:)/i,
        portPattern = /:[0-9]*$/,
    
        // Special case for a simple path URL
        simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
    
        // RFC 2396: characters reserved for delimiting URLs.
        // We actually just auto-escape these.
        delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],
    
        // RFC 2396: characters not allowed for various reasons.
        unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),
    
        // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
        autoEscape = ['\''].concat(unwise),
        // Characters that are never ever allowed in a hostname.
        // Note that any invalid chars are also handled, but these
        // are the ones that are *expected* to be seen, so we fast-path
        // them.
        nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
        hostEndingChars = ['/', '?', '#'],
        hostnameMaxLen = 255,
        hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
        hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        // protocols that can allow "unsafe" and "unwise" chars.
        unsafeProtocol = {
          'javascript': true,
          'javascript:': true
        },
        // protocols that never have a hostname.
        hostlessProtocol = {
          'javascript': true,
          'javascript:': true
        },
        // protocols that always contain a // bit.
        slashedProtocol = {
          'http': true,
          'https': true,
          'ftp': true,
          'gopher': true,
          'file': true,
          'http:': true,
          'https:': true,
          'ftp:': true,
          'gopher:': true,
          'file:': true
        },
        querystring = require('querystring');
    
    function urlParse(url, parseQueryString, slashesDenoteHost) {
      if (url && util.isObject(url) && url instanceof Url) return url;
    
      var u = new Url;
      u.parse(url, parseQueryString, slashesDenoteHost);
      return u;
    }
    
    Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
      if (!util.isString(url)) {
        throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
      }
    
      // Copy chrome, IE, opera backslash-handling behavior.
      // Back slashes before the query string get converted to forward slashes
      // See: https://code.google.com/p/chromium/issues/detail?id=25916
      var queryIndex = url.indexOf('?'),
          splitter =
              (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
          uSplit = url.split(splitter),
          slashRegex = /\\/g;
      uSplit[0] = uSplit[0].replace(slashRegex, '/');
      url = uSplit.join(splitter);
    
      var rest = url;
    
      // trim before proceeding.
      // This is to support parse stuff like "  http://foo.com  \n"
      rest = rest.trim();
    
      if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
          this.path = rest;
          this.href = rest;
          this.pathname = simplePath[1];
          if (simplePath[2]) {
            this.search = simplePath[2];
            if (parseQueryString) {
              this.query = querystring.parse(this.search.substr(1));
            } else {
              this.query = this.search.substr(1);
            }
          } else if (parseQueryString) {
            this.search = '';
            this.query = {};
          }
          return this;
        }
      }
    
      var proto = protocolPattern.exec(rest);
      if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
      }
    
      // figure out if it's got a host
      // user@server is *always* interpreted as a hostname, and url
      // resolution will treat //foo/bar as host=foo,path=bar because that's
      // how the browser resolves relative URLs.
      if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
          rest = rest.substr(2);
          this.slashes = true;
        }
      }
    
      if (!hostlessProtocol[proto] &&
          (slashes || (proto && !slashedProtocol[proto]))) {
    
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
    
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
    
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for (var i = 0; i < hostEndingChars.length; i++) {
          var hec = rest.indexOf(hostEndingChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
            hostEnd = hec;
        }
    
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) {
          // atSign can be anywhere.
          atSign = rest.lastIndexOf('@');
        } else {
          // atSign must be in auth portion.
          // http://a@b/c@d => host:b auth:a path:/c@d
          atSign = rest.lastIndexOf('@', hostEnd);
        }
    
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
          auth = rest.slice(0, atSign);
          rest = rest.slice(atSign + 1);
          this.auth = decodeURIComponent(auth);
        }
    
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for (var i = 0; i < nonHostChars.length; i++) {
          var hec = rest.indexOf(nonHostChars[i]);
          if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
            hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1)
          hostEnd = rest.length;
    
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
    
        // pull out port.
        this.parseHost();
    
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
    
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' &&
            this.hostname[this.hostname.length - 1] === ']';
    
        // validate a little.
        if (!ipv6Hostname) {
          var hostparts = this.hostname.split(/\./);
          for (var i = 0, l = hostparts.length; i < l; i++) {
            var part = hostparts[i];
            if (!part) continue;
            if (!part.match(hostnamePartPattern)) {
              var newpart = '';
              for (var j = 0, k = part.length; j < k; j++) {
                if (part.charCodeAt(j) > 127) {
                  // we replace non-ASCII char with a temporary placeholder
                  // we need this to make sure size of hostname is not
                  // broken by replacing non-ASCII by nothing
                  newpart += 'x';
                } else {
                  newpart += part[j];
                }
              }
              // we test again with ASCII char only
              if (!newpart.match(hostnamePartPattern)) {
                var validParts = hostparts.slice(0, i);
                var notHost = hostparts.slice(i + 1);
                var bit = part.match(hostnamePartStart);
                if (bit) {
                  validParts.push(bit[1]);
                  notHost.unshift(bit[2]);
                }
                if (notHost.length) {
                  rest = '/' + notHost.join('.') + rest;
                }
                this.hostname = validParts.join('.');
                break;
              }
            }
          }
        }
    
        if (this.hostname.length > hostnameMaxLen) {
          this.hostname = '';
        } else {
          // hostnames are always lower case.
          this.hostname = this.hostname.toLowerCase();
        }
    
        if (!ipv6Hostname) {
          // IDNA Support: Returns a punycoded representation of "domain".
          // It only converts parts of the domain name that
          // have non-ASCII characters, i.e. it doesn't matter if
          // you call it with a domain that already is ASCII-only.
          this.hostname = punycode.toASCII(this.hostname);
        }
    
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
    
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
          this.hostname = this.hostname.substr(1, this.hostname.length - 2);
          if (rest[0] !== '/') {
            rest = '/' + rest;
          }
        }
      }
    
      // now rest is set to the post-host stuff.
      // chop off any delim chars.
      if (!unsafeProtocol[lowerProto]) {
    
        // First, make 100% sure that any "autoEscape" chars get
        // escaped, even if encodeURIComponent doesn't think they
        // need to be.
        for (var i = 0, l = autoEscape.length; i < l; i++) {
          var ae = autoEscape[i];
          if (rest.indexOf(ae) === -1)
            continue;
          var esc = encodeURIComponent(ae);
          if (esc === ae) {
            esc = escape(ae);
          }
          rest = rest.split(ae).join(esc);
        }
      }
    
    
      // chop off from the tail first.
      var hash = rest.indexOf('#');
      if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
      }
      var qm = rest.indexOf('?');
      if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) {
          this.query = querystring.parse(this.query);
        }
        rest = rest.slice(0, qm);
      } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
      }
      if (rest) this.pathname = rest;
      if (slashedProtocol[lowerProto] &&
          this.hostname && !this.pathname) {
        this.pathname = '/';
      }
    
      //to support http.request
      if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
      }
    
      // finally, reconstruct the href based on what has been validated.
      this.href = this.format();
      return this;
    };
    
    // format a parsed object into a url string
    function urlFormat(obj) {
      // ensure it's an object, and not a string url.
      // If it's an obj, this is a no-op.
      // this way, you can call url_format() on strings
      // to clean up potentially wonky urls.
      if (util.isString(obj)) obj = urlParse(obj);
      if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
      return obj.format();
    }
    
    Url.prototype.format = function() {
      var auth = this.auth || '';
      if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
      }
    
      var protocol = this.protocol || '',
          pathname = this.pathname || '',
          hash = this.hash || '',
          host = false,
          query = '';
    
      if (this.host) {
        host = auth + this.host;
      } else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ?
            this.hostname :
            '[' + this.hostname + ']');
        if (this.port) {
          host += ':' + this.port;
        }
      }
    
      if (this.query &&
          util.isObject(this.query) &&
          Object.keys(this.query).length) {
        query = querystring.stringify(this.query);
      }
    
      var search = this.search || (query && ('?' + query)) || '';
    
      if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    
      // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
      // unless they had them to begin with.
      if (this.slashes ||
          (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
      } else if (!host) {
        host = '';
      }
    
      if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
      if (search && search.charAt(0) !== '?') search = '?' + search;
    
      pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
      });
      search = search.replace('#', '%23');
    
      return protocol + host + pathname + search + hash;
    };
    
    function urlResolve(source, relative) {
      return urlParse(source, false, true).resolve(relative);
    }
    
    Url.prototype.resolve = function(relative) {
      return this.resolveObject(urlParse(relative, false, true)).format();
    };
    
    function urlResolveObject(source, relative) {
      if (!source) return relative;
      return urlParse(source, false, true).resolveObject(relative);
    }
    
    Url.prototype.resolveObject = function(relative) {
      if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
      }
    
      var result = new Url();
      var tkeys = Object.keys(this);
      for (var tk = 0; tk < tkeys.length; tk++) {
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
      }
    
      // hash is always overridden, no matter what.
      // even href="" will remove it.
      result.hash = relative.hash;
    
      // if the relative url is empty, then there's nothing left to do here.
      if (relative.href === '') {
        result.href = result.format();
        return result;
      }
    
      // hrefs like //foo/bar always cut to the protocol.
      if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for (var rk = 0; rk < rkeys.length; rk++) {
          var rkey = rkeys[rk];
          if (rkey !== 'protocol')
            result[rkey] = relative[rkey];
        }
    
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] &&
            result.hostname && !result.pathname) {
          result.path = result.pathname = '/';
        }
    
        result.href = result.format();
        return result;
      }
    
      if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
          var keys = Object.keys(relative);
          for (var v = 0; v < keys.length; v++) {
            var k = keys[v];
            result[k] = relative[k];
          }
          result.href = result.format();
          return result;
        }
    
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
          var relPath = (relative.pathname || '').split('/');
          while (relPath.length && !(relative.host = relPath.shift()));
          if (!relative.host) relative.host = '';
          if (!relative.hostname) relative.hostname = '';
          if (relPath[0] !== '') relPath.unshift('');
          if (relPath.length < 2) relPath.unshift('');
          result.pathname = relPath.join('/');
        } else {
          result.pathname = relative.pathname;
        }
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
          var p = result.pathname || '';
          var s = result.search || '';
          result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
      }
    
      var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
          isRelAbs = (
              relative.host ||
              relative.pathname && relative.pathname.charAt(0) === '/'
          ),
          mustEndAbs = (isRelAbs || isSourceAbs ||
                        (result.host && relative.pathname)),
          removeAllDots = mustEndAbs,
          srcPath = result.pathname && result.pathname.split('/') || [],
          relPath = relative.pathname && relative.pathname.split('/') || [],
          psychotic = result.protocol && !slashedProtocol[result.protocol];
    
      // if the url is a non-slashed url, then relative
      // links like ../.. should be able
      // to crawl up to the hostname, as well.  This is strange.
      // result.protocol has already been set by now.
      // Later on, put the first path part into the host field.
      if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
          if (srcPath[0] === '') srcPath[0] = result.host;
          else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
          relative.hostname = null;
          relative.port = null;
          if (relative.host) {
            if (relPath[0] === '') relPath[0] = relative.host;
            else relPath.unshift(relative.host);
          }
          relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
      }
    
      if (isRelAbs) {
        // it's absolute.
        result.host = (relative.host || relative.host === '') ?
                      relative.host : result.host;
        result.hostname = (relative.hostname || relative.hostname === '') ?
                          relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
        // fall through to the dot-handling below.
      } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
      } else if (!util.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
          result.hostname = result.host = srcPath.shift();
          //occationaly the auth can get stuck only in host
          //this especially happens in cases like
          //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
          var authInHost = result.host && result.host.indexOf('@') > 0 ?
                           result.host.split('@') : false;
          if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
          }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
          result.path = (result.pathname ? result.pathname : '') +
                        (result.search ? result.search : '');
        }
        result.href = result.format();
        return result;
      }
    
      if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) {
          result.path = '/' + result.search;
        } else {
          result.path = null;
        }
        result.href = result.format();
        return result;
      }
    
      // if a url ENDs in . or .., then it must get a trailing slash.
      // however, if it ends in anything else non-slashy,
      // then it must NOT get a trailing slash.
      var last = srcPath.slice(-1)[0];
      var hasTrailingSlash = (
          (result.host || relative.host || srcPath.length > 1) &&
          (last === '.' || last === '..') || last === '');
    
      // strip single dots, resolve double dots to parent dir
      // if the path tries to go above the root, `up` ends up > 0
      var up = 0;
      for (var i = srcPath.length; i >= 0; i--) {
        last = srcPath[i];
        if (last === '.') {
          srcPath.splice(i, 1);
        } else if (last === '..') {
          srcPath.splice(i, 1);
          up++;
        } else if (up) {
          srcPath.splice(i, 1);
          up--;
        }
      }
    
      // if the path is allowed to go above the root, restore leading ..s
      if (!mustEndAbs && !removeAllDots) {
        for (; up--; up) {
          srcPath.unshift('..');
        }
      }
    
      if (mustEndAbs && srcPath[0] !== '' &&
          (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
        srcPath.unshift('');
      }
    
      if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
        srcPath.push('');
      }
    
      var isAbsolute = srcPath[0] === '' ||
          (srcPath[0] && srcPath[0].charAt(0) === '/');
    
      // put the host back
      if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' :
                                        srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ?
                         result.host.split('@') : false;
        if (authInHost) {
          result.auth = authInHost.shift();
          result.host = result.hostname = authInHost.shift();
        }
      }
    
      mustEndAbs = mustEndAbs || (result.host && srcPath.length);
    
      if (mustEndAbs && !isAbsolute) {
        srcPath.unshift('');
      }
    
      if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
      } else {
        result.pathname = srcPath.join('/');
      }
    
      //to support request.http
      if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
        result.path = (result.pathname ? result.pathname : '') +
                      (result.search ? result.search : '');
      }
      result.auth = relative.auth || result.auth;
      result.slashes = result.slashes || relative.slashes;
      result.href = result.format();
      return result;
    };
    
    Url.prototype.parseHost = function() {
      var host = this.host;
      var port = portPattern.exec(host);
      if (port) {
        port = port[0];
        if (port !== ':') {
          this.port = port.substr(1);
        }
        host = host.substr(0, host.length - port.length);
      }
      if (host) this.hostname = host;
    };
    
    },{"./util":38,"punycode":2,"querystring":30}],38:[function(require,module,exports){
    'use strict';
    
    module.exports = {
      isString: function(arg) {
        return typeof(arg) === 'string';
      },
      isObject: function(arg) {
        return typeof(arg) === 'object' && arg !== null;
      },
      isNull: function(arg) {
        return arg === null;
      },
      isNullOrUndefined: function(arg) {
        return arg == null;
      }
    };
    
    },{}],39:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _ismobilejs = require('ismobilejs');
    
    var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
    
    var _accessibleTarget = require('./accessibleTarget');
    
    var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    // add some extra variables to the container..
    core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);
    
    var KEY_CODE_TAB = 9;
    
    var DIV_TOUCH_SIZE = 100;
    var DIV_TOUCH_POS_X = 0;
    var DIV_TOUCH_POS_Y = 0;
    var DIV_TOUCH_ZINDEX = 2;
    
    var DIV_HOOK_SIZE = 1;
    var DIV_HOOK_POS_X = -1000;
    var DIV_HOOK_POS_Y = -1000;
    var DIV_HOOK_ZINDEX = 2;
    
    /**
     * The Accessibility manager reacreates the ability to tab and and have content read by screen
     * readers. This is very important as it can possibly help people with disabilities access pixi
     * content.
     *
     * Much like interaction any DisplayObject can be made accessible. This manager will map the
     * events as if the mouse was being used, minimizing the efferot required to implement.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
     *
     * @class
     * @memberof PIXI.accessibility
     */
    
    var AccessibilityManager = function () {
        /**
         * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
         */
        function AccessibilityManager(renderer) {
            _classCallCheck(this, AccessibilityManager);
    
            if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
                this.createTouchHook();
            }
    
            // first we create a div that will sit over the pixi element. This is where the div overlays will go.
            var div = document.createElement('div');
    
            div.style.width = DIV_TOUCH_SIZE + 'px';
            div.style.height = DIV_TOUCH_SIZE + 'px';
            div.style.position = 'absolute';
            div.style.top = DIV_TOUCH_POS_X + 'px';
            div.style.left = DIV_TOUCH_POS_Y + 'px';
            div.style.zIndex = DIV_TOUCH_ZINDEX;
    
            /**
             * This is the dom element that will sit over the pixi element. This is where the div overlays will go.
             *
             * @type {HTMLElement}
             * @private
             */
            this.div = div;
    
            /**
             * A simple pool for storing divs.
             *
             * @type {*}
             * @private
             */
            this.pool = [];
    
            /**
             * This is a tick used to check if an object is no longer being rendered.
             *
             * @type {Number}
             * @private
             */
            this.renderId = 0;
    
            /**
             * Setting this to true will visually show the divs
             *
             * @type {boolean}
             */
            this.debug = false;
    
            /**
             * The renderer this accessibility manager works for.
             *
             * @member {PIXI.SystemRenderer}
             */
            this.renderer = renderer;
    
            /**
             * The array of currently active accessible items.
             *
             * @member {Array<*>}
             * @private
             */
            this.children = [];
    
            /**
             * pre-bind the functions
             *
             * @private
             */
            this._onKeyDown = this._onKeyDown.bind(this);
            this._onMouseMove = this._onMouseMove.bind(this);
    
            /**
             * stores the state of the manager. If there are no accessible objects or the mouse is moving the will be false.
             *
             * @member {Array<*>}
             * @private
             */
            this.isActive = false;
            this.isMobileAccessabillity = false;
    
            // let listen for tab.. once pressed we can fire up and show the accessibility layer
            window.addEventListener('keydown', this._onKeyDown, false);
        }
    
        /**
         * Creates the touch hooks.
         *
         */
    
    
        AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
            var _this = this;
    
            var hookDiv = document.createElement('button');
    
            hookDiv.style.width = DIV_HOOK_SIZE + 'px';
            hookDiv.style.height = DIV_HOOK_SIZE + 'px';
            hookDiv.style.position = 'absolute';
            hookDiv.style.top = DIV_HOOK_POS_X + 'px';
            hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
            hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
            hookDiv.style.backgroundColor = '#FF0000';
            hookDiv.title = 'HOOK DIV';
    
            hookDiv.addEventListener('focus', function () {
                _this.isMobileAccessabillity = true;
                _this.activate();
                document.body.removeChild(hookDiv);
            });
    
            document.body.appendChild(hookDiv);
        };
    
        /**
         * Activating will cause the Accessibility layer to be shown. This is called when a user
         * preses the tab key
         *
         * @private
         */
    
    
        AccessibilityManager.prototype.activate = function activate() {
            if (this.isActive) {
                return;
            }
    
            this.isActive = true;
    
            window.document.addEventListener('mousemove', this._onMouseMove, true);
            window.removeEventListener('keydown', this._onKeyDown, false);
    
            this.renderer.on('postrender', this.update, this);
    
            if (this.renderer.view.parentNode) {
                this.renderer.view.parentNode.appendChild(this.div);
            }
        };
    
        /**
         * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
         * the mouse
         *
         * @private
         */
    
    
        AccessibilityManager.prototype.deactivate = function deactivate() {
            if (!this.isActive || this.isMobileAccessabillity) {
                return;
            }
    
            this.isActive = false;
    
            window.document.removeEventListener('mousemove', this._onMouseMove);
            window.addEventListener('keydown', this._onKeyDown, false);
    
            this.renderer.off('postrender', this.update);
    
            if (this.div.parentNode) {
                this.div.parentNode.removeChild(this.div);
            }
        };
    
        /**
         * This recursive function will run throught he scene graph and add any new accessible objects to the DOM layer.
         *
         * @private
         * @param {PIXI.Container} displayObject - The DisplayObject to check.
         */
    
    
        AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
            if (!displayObject.visible) {
                return;
            }
    
            if (displayObject.accessible && displayObject.interactive) {
                if (!displayObject._accessibleActive) {
                    this.addChild(displayObject);
                }
    
                displayObject.renderId = this.renderId;
            }
    
            var children = displayObject.children;
    
            for (var i = children.length - 1; i >= 0; i--) {
                this.updateAccessibleObjects(children[i]);
            }
        };
    
        /**
         * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
         *
         * @private
         */
    
    
        AccessibilityManager.prototype.update = function update() {
            if (!this.renderer.renderingToScreen) {
                return;
            }
    
            // update children...
            this.updateAccessibleObjects(this.renderer._lastObjectRendered);
    
            var rect = this.renderer.view.getBoundingClientRect();
            var sx = rect.width / this.renderer.width;
            var sy = rect.height / this.renderer.height;
    
            var div = this.div;
    
            div.style.left = rect.left + 'px';
            div.style.top = rect.top + 'px';
            div.style.width = this.renderer.width + 'px';
            div.style.height = this.renderer.height + 'px';
    
            for (var i = 0; i < this.children.length; i++) {
                var child = this.children[i];
    
                if (child.renderId !== this.renderId) {
                    child._accessibleActive = false;
    
                    core.utils.removeItems(this.children, i, 1);
                    this.div.removeChild(child._accessibleDiv);
                    this.pool.push(child._accessibleDiv);
                    child._accessibleDiv = null;
    
                    i--;
    
                    if (this.children.length === 0) {
                        this.deactivate();
                    }
                } else {
                    // map div to display..
                    div = child._accessibleDiv;
                    var hitArea = child.hitArea;
                    var wt = child.worldTransform;
    
                    if (child.hitArea) {
                        div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
                        div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';
    
                        div.style.width = hitArea.width * wt.a * sx + 'px';
                        div.style.height = hitArea.height * wt.d * sy + 'px';
                    } else {
                        hitArea = child.getBounds();
    
                        this.capHitArea(hitArea);
    
                        div.style.left = hitArea.x * sx + 'px';
                        div.style.top = hitArea.y * sy + 'px';
    
                        div.style.width = hitArea.width * sx + 'px';
                        div.style.height = hitArea.height * sy + 'px';
                    }
                }
            }
    
            // increment the render id..
            this.renderId++;
        };
    
        /**
         * TODO: docs.
         *
         * @param {Rectangle} hitArea - TODO docs
         */
    
    
        AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
            if (hitArea.x < 0) {
                hitArea.width += hitArea.x;
                hitArea.x = 0;
            }
    
            if (hitArea.y < 0) {
                hitArea.height += hitArea.y;
                hitArea.y = 0;
            }
    
            if (hitArea.x + hitArea.width > this.renderer.width) {
                hitArea.width = this.renderer.width - hitArea.x;
            }
    
            if (hitArea.y + hitArea.height > this.renderer.height) {
                hitArea.height = this.renderer.height - hitArea.y;
            }
        };
    
        /**
         * Adds a DisplayObject to the accessibility manager
         *
         * @private
         * @param {DisplayObject} displayObject - The child to make accessible.
         */
    
    
        AccessibilityManager.prototype.addChild = function addChild(displayObject) {
            //    this.activate();
    
            var div = this.pool.pop();
    
            if (!div) {
                div = document.createElement('button');
    
                div.style.width = DIV_TOUCH_SIZE + 'px';
                div.style.height = DIV_TOUCH_SIZE + 'px';
                div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
                div.style.position = 'absolute';
                div.style.zIndex = DIV_TOUCH_ZINDEX;
                div.style.borderStyle = 'none';
    
                div.addEventListener('click', this._onClick.bind(this));
                div.addEventListener('focus', this._onFocus.bind(this));
                div.addEventListener('focusout', this._onFocusOut.bind(this));
            }
    
            if (displayObject.accessibleTitle) {
                div.title = displayObject.accessibleTitle;
            } else if (!displayObject.accessibleTitle && !displayObject.accessibleHint) {
                div.title = 'displayObject ' + this.tabIndex;
            }
    
            if (displayObject.accessibleHint) {
                div.setAttribute('aria-label', displayObject.accessibleHint);
            }
    
            //
    
            displayObject._accessibleActive = true;
            displayObject._accessibleDiv = div;
            div.displayObject = displayObject;
    
            this.children.push(displayObject);
            this.div.appendChild(displayObject._accessibleDiv);
            displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
        };
    
        /**
         * Maps the div button press to pixi's InteractionManager (click)
         *
         * @private
         * @param {MouseEvent} e - The click event.
         */
    
    
        AccessibilityManager.prototype._onClick = function _onClick(e) {
            var interactionManager = this.renderer.plugins.interaction;
    
            interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
        };
    
        /**
         * Maps the div focus events to pixis InteractionManager (mouseover)
         *
         * @private
         * @param {FocusEvent} e - The focus event.
         */
    
    
        AccessibilityManager.prototype._onFocus = function _onFocus(e) {
            var interactionManager = this.renderer.plugins.interaction;
    
            interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
        };
    
        /**
         * Maps the div focus events to pixis InteractionManager (mouseout)
         *
         * @private
         * @param {FocusEvent} e - The focusout event.
         */
    
    
        AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
            var interactionManager = this.renderer.plugins.interaction;
    
            interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
        };
    
        /**
         * Is called when a key is pressed
         *
         * @private
         * @param {KeyboardEvent} e - The keydown event.
         */
    
    
        AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
            if (e.keyCode !== KEY_CODE_TAB) {
                return;
            }
    
            this.activate();
        };
    
        /**
         * Is called when the mouse moves across the renderer element
         *
         * @private
         */
    
    
        AccessibilityManager.prototype._onMouseMove = function _onMouseMove() {
            this.deactivate();
        };
    
        /**
         * Destroys the accessibility manager
         *
         */
    
    
        AccessibilityManager.prototype.destroy = function destroy() {
            this.div = null;
    
            for (var i = 0; i < this.children.length; i++) {
                this.children[i].div = null;
            }
    
            window.document.removeEventListener('mousemove', this._onMouseMove);
            window.removeEventListener('keydown', this._onKeyDown);
    
            this.pool = null;
            this.children = null;
            this.renderer = null;
        };
    
        return AccessibilityManager;
    }();
    
    exports.default = AccessibilityManager;
    
    
    core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
    core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
    
    },{"../core":64,"./accessibleTarget":40,"ismobilejs":5}],40:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    /**
     * Default property values of accessible objects
     * used by {@link PIXI.accessibility.AccessibilityManager}.
     *
     * @function accessibleTarget
     * @memberof PIXI.accessibility
     * @example
     *      function MyObject() {}
     *
     *      Object.assign(
     *          MyObject.prototype,
     *          PIXI.accessibility.accessibleTarget
     *      );
     */
    exports.default = {
      /**
       *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
       *   shadow div with attributes set
       *
       * @member {boolean}
       */
      accessible: false,
    
      /**
       * Sets the title attribute of the shadow div
       * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
       *
       * @member {string}
       */
      accessibleTitle: null,
    
      /**
       * Sets the aria-label attribute of the shadow div
       *
       * @member {string}
       */
      accessibleHint: null,
    
      /**
       * @todo Needs docs.
       */
      tabIndex: 0,
    
      /**
       * @todo Needs docs.
       */
      _accessibleActive: false,
    
      /**
       * @todo Needs docs.
       */
      _accessibleDiv: false
    };
    
    },{}],41:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _accessibleTarget = require('./accessibleTarget');
    
    Object.defineProperty(exports, 'accessibleTarget', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_accessibleTarget).default;
      }
    });
    
    var _AccessibilityManager = require('./AccessibilityManager');
    
    Object.defineProperty(exports, 'AccessibilityManager', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_AccessibilityManager).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./AccessibilityManager":39,"./accessibleTarget":40}],42:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _autoDetectRenderer = require('./autoDetectRenderer');
    
    var _Container = require('./display/Container');
    
    var _Container2 = _interopRequireDefault(_Container);
    
    var _ticker = require('./ticker');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Convenience class to create a new PIXI application.
     * This class automatically creates the renderer, ticker
     * and root container.
     *
     * @example
     * // Create the application
     * const app = new PIXI.Application();
     *
     * // Add the view to the DOM
     * document.body.appendChild(app.view);
     *
     * // ex, add display objects
     * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
     *
     * @class
     * @memberof PIXI
     */
    var Application = function () {
      /**
       * @param {number} [width=800] - the width of the renderers view
       * @param {number} [height=600] - the height of the renderers view
       * @param {object} [options] - The optional renderer parameters
       * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
       * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
       * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
       * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
       *      need to call toDataUrl on the webgl context
       * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
       * @param {boolean} [noWebGL=false] - prevents selection of WebGL renderer, even if such is present
       * @param {boolean} [options.legacy=false] - If true Pixi will aim to ensure compatibility
       * with older / less advanced devices. If you experience unexplained flickering try setting this to true.
       * @param {boolean} [useSharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
       */
      function Application(width, height, options, noWebGL) {
        var useSharedTicker = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    
        _classCallCheck(this, Application);
    
        /**
         * WebGL renderer if available, otherwise CanvasRenderer
         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
         */
        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(width, height, options, noWebGL);
    
        /**
         * The root display container that's rendered.
         * @member {PIXI.Container}
         */
        this.stage = new _Container2.default();
    
        /**
         * Internal reference to the ticker
         * @member {PIXI.ticker.Ticker}
         * @private
         */
        this._ticker = null;
    
        /**
         * Ticker for doing render updates.
         * @member {PIXI.ticker.Ticker}
         * @default PIXI.ticker.shared
         */
        this.ticker = useSharedTicker ? _ticker.shared : new _ticker.Ticker();
    
        // Start the rendering
        this.start();
      }
    
      /**
       * Render the current stage.
       */
      Application.prototype.render = function render() {
        this.renderer.render(this.stage);
      };
    
      /**
       * Convenience method for stopping the render.
       */
    
    
      Application.prototype.stop = function stop() {
        this._ticker.stop();
      };
    
      /**
       * Convenience method for starting the render.
       */
    
    
      Application.prototype.start = function start() {
        this._ticker.start();
      };
    
      /**
       * Reference to the renderer's canvas element.
       * @member {HTMLCanvasElement}
       * @readonly
       */
    
    
      /**
       * Destroy and don't use after this.
       * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
       */
      Application.prototype.destroy = function destroy(removeView) {
        this.stop();
        this.ticker = null;
    
        this.stage.destroy();
        this.stage = null;
    
        this.renderer.destroy(removeView);
        this.renderer = null;
      };
    
      _createClass(Application, [{
        key: 'ticker',
        set: function set(ticker) // eslint-disable-line require-jsdoc
        {
          if (this._ticker) {
            this._ticker.remove(this.render, this);
          }
          this._ticker = ticker;
          if (ticker) {
            ticker.add(this.render, this);
          }
        },
        get: function get() // eslint-disable-line require-jsdoc
        {
          return this._ticker;
        }
      }, {
        key: 'view',
        get: function get() {
          return this.renderer.view;
        }
    
        /**
         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
         * @member {PIXI.Rectangle}
         * @readonly
         */
    
      }, {
        key: 'screen',
        get: function get() {
          return this.renderer.screen;
        }
      }]);
    
      return Application;
    }();
    
    exports.default = Application;
    
    },{"./autoDetectRenderer":44,"./display/Container":47,"./ticker":117}],43:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _settings = require('./settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    function checkPrecision(src, def) {
        if (src instanceof Array) {
            if (src[0].substring(0, 9) !== 'precision') {
                var copy = src.slice(0);
    
                copy.unshift('precision ' + def + ' float;');
    
                return copy;
            }
        } else if (src.substring(0, 9) !== 'precision') {
            return 'precision ' + def + ' float;\n' + src;
        }
    
        return src;
    }
    
    /**
     * Wrapper class, webGL Shader for Pixi.
     * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
     *
     * @class
     * @extends GLShader
     * @memberof PIXI
     */
    
    var Shader = function (_GLShader) {
        _inherits(Shader, _GLShader);
    
        /**
         *
         * @param {WebGLRenderingContext} gl - The current WebGL rendering context
         * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
         * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
         */
        function Shader(gl, vertexSrc, fragmentSrc) {
            _classCallCheck(this, Shader);
    
            return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, _settings2.default.PRECISION_FRAGMENT)));
        }
    
        return Shader;
    }(_pixiGlCore.GLShader);
    
    exports.default = Shader;
    
    },{"./settings":100,"pixi-gl-core":16}],44:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.autoDetectRenderer = autoDetectRenderer;
    
    var _utils = require('./utils');
    
    var utils = _interopRequireWildcard(_utils);
    
    var _CanvasRenderer = require('./renderers/canvas/CanvasRenderer');
    
    var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
    
    var _WebGLRenderer = require('./renderers/webgl/WebGLRenderer');
    
    var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    /**
     * This helper function will automatically detect which renderer you should be using.
     * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
     * the browser then this function will return a canvas renderer
     *
     * @memberof PIXI
     * @function autoDetectRenderer
     * @param {number} [width=800] - the width of the renderers view
     * @param {number} [height=600] - the height of the renderers view
     * @param {object} [options] - The optional renderer parameters
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
     *      need to call toDataUrl on the webgl context
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
     * @param {boolean} [noWebGL=false] - prevents selection of WebGL renderer, even if such is present
     * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
     */
    function autoDetectRenderer() {
        var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 800;
        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 600;
        var options = arguments[2];
        var noWebGL = arguments[3];
    
        if (!noWebGL && utils.isWebGLSupported()) {
            return new _WebGLRenderer2.default(width, height, options);
        }
    
        return new _CanvasRenderer2.default(width, height, options);
    }
    
    },{"./renderers/canvas/CanvasRenderer":76,"./renderers/webgl/WebGLRenderer":83,"./utils":121}],45:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    /**
     * String of the current PIXI version.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @name VERSION
     * @type {string}
     */
    var VERSION = exports.VERSION = '4.4.5';
    
    /**
     * Two Pi.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @type {number}
     */
    var PI_2 = exports.PI_2 = Math.PI * 2;
    
    /**
     * Conversion factor for converting radians to degrees.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @type {number}
     */
    var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;
    
    /**
     * Conversion factor for converting degrees to radians.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @type {number}
     */
    var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;
    
    /**
     * Constant to identify the Renderer Type.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @name RENDERER_TYPE
     * @type {object}
     * @property {number} UNKNOWN - Unknown render type.
     * @property {number} WEBGL - WebGL render type.
     * @property {number} CANVAS - Canvas render type.
     */
    var RENDERER_TYPE = exports.RENDERER_TYPE = {
      UNKNOWN: 0,
      WEBGL: 1,
      CANVAS: 2
    };
    
    /**
     * Various blend modes supported by PIXI.
     *
     * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
     * Anything else will silently act like NORMAL.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @name BLEND_MODES
     * @type {object}
     * @property {number} NORMAL
     * @property {number} ADD
     * @property {number} MULTIPLY
     * @property {number} SCREEN
     * @property {number} OVERLAY
     * @property {number} DARKEN
     * @property {number} LIGHTEN
     * @property {number} COLOR_DODGE
     * @property {number} COLOR_BURN
     * @property {number} HARD_LIGHT
     * @property {number} SOFT_LIGHT
     * @property {number} DIFFERENCE
     * @property {number} EXCLUSION
     * @property {number} HUE
     * @property {number} SATURATION
     * @property {number} COLOR
     * @property {number} LUMINOSITY
     */
    var BLEND_MODES = exports.BLEND_MODES = {
      NORMAL: 0,
      ADD: 1,
      MULTIPLY: 2,
      SCREEN: 3,
      OVERLAY: 4,
      DARKEN: 5,
      LIGHTEN: 6,
      COLOR_DODGE: 7,
      COLOR_BURN: 8,
      HARD_LIGHT: 9,
      SOFT_LIGHT: 10,
      DIFFERENCE: 11,
      EXCLUSION: 12,
      HUE: 13,
      SATURATION: 14,
      COLOR: 15,
      LUMINOSITY: 16
    };
    
    /**
     * Various webgl draw modes. These can be used to specify which GL drawMode to use
     * under certain situations and renderers.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @name DRAW_MODES
     * @type {object}
     * @property {number} POINTS
     * @property {number} LINES
     * @property {number} LINE_LOOP
     * @property {number} LINE_STRIP
     * @property {number} TRIANGLES
     * @property {number} TRIANGLE_STRIP
     * @property {number} TRIANGLE_FAN
     */
    var DRAW_MODES = exports.DRAW_MODES = {
      POINTS: 0,
      LINES: 1,
      LINE_LOOP: 2,
      LINE_STRIP: 3,
      TRIANGLES: 4,
      TRIANGLE_STRIP: 5,
      TRIANGLE_FAN: 6
    };
    
    /**
     * The scale modes that are supported by pixi.
     *
     * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
     * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @name SCALE_MODES
     * @type {object}
     * @property {number} LINEAR Smooth scaling
     * @property {number} NEAREST Pixelating scaling
     */
    var SCALE_MODES = exports.SCALE_MODES = {
      LINEAR: 0,
      NEAREST: 1
    };
    
    /**
     * The wrap modes that are supported by pixi.
     *
     * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wraping mode of future operations.
     * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
     * If the texture is non power of two then clamp will be used regardless as webGL can
     * only use REPEAT if the texture is po2.
     *
     * This property only affects WebGL.
     *
     * @static
     * @constant
     * @name WRAP_MODES
     * @memberof PIXI
     * @type {object}
     * @property {number} CLAMP - The textures uvs are clamped
     * @property {number} REPEAT - The texture uvs tile and repeat
     * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
     */
    var WRAP_MODES = exports.WRAP_MODES = {
      CLAMP: 0,
      REPEAT: 1,
      MIRRORED_REPEAT: 2
    };
    
    /**
     * The gc modes that are supported by pixi.
     *
     * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for pixi textures is AUTO
     * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
     * used for a specified period of time they will be removed from the GPU. They will of course
     * be uploaded again when they are required. This is a silent behind the scenes process that
     * should ensure that the GPU does not  get filled up.
     *
     * Handy for mobile devices!
     * This property only affects WebGL.
     *
     * @static
     * @constant
     * @name GC_MODES
     * @memberof PIXI
     * @type {object}
     * @property {number} AUTO - Garbage collection will happen periodically automatically
     * @property {number} MANUAL - Garbage collection will need to be called manually
     */
    var GC_MODES = exports.GC_MODES = {
      AUTO: 0,
      MANUAL: 1
    };
    
    /**
     * Regexp for image type by extension.
     *
     * @static
     * @constant
     * @memberof PIXI
     * @type {RegExp|string}
     * @example `image.png`
     */
    var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;
    
    /**
     * Regexp for data URI.
     * Based on: {@link https://github.com/ragingwind/data-uri-regex}
     *
     * @static
     * @constant
     * @name DATA_URI
     * @memberof PIXI
     * @type {RegExp|string}
     * @example data:image/png;base64
     */
    var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;(charset=[\w-]+|base64))?,(.*)/i;
    
    /**
     * Regexp for SVG size.
     *
     * @static
     * @constant
     * @name SVG_SIZE
     * @memberof PIXI
     * @type {RegExp|string}
     * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
     */
    var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len
    
    /**
     * Constants that identify shapes, mainly to prevent `instanceof` calls.
     *
     * @static
     * @constant
     * @name SHAPES
     * @memberof PIXI
     * @type {object}
     * @property {number} POLY Polygon
     * @property {number} RECT Rectangle
     * @property {number} CIRC Circle
     * @property {number} ELIP Ellipse
     * @property {number} RREC Rounded Rectangle
     */
    var SHAPES = exports.SHAPES = {
      POLY: 0,
      RECT: 1,
      CIRC: 2,
      ELIP: 3,
      RREC: 4
    };
    
    /**
     * Constants that specify float precision in shaders.
     *
     * @static
     * @constant
     * @name PRECISION
     * @memberof PIXI
     * @type {object}
     * @property {string} LOW='lowp'
     * @property {string} MEDIUM='mediump'
     * @property {string} HIGH='highp'
     */
    var PRECISION = exports.PRECISION = {
      LOW: 'lowp',
      MEDIUM: 'mediump',
      HIGH: 'highp'
    };
    
    /**
     * Constants that specify the transform type.
     *
     * @static
     * @constant
     * @name TRANSFORM_MODE
     * @memberof PIXI
     * @type {object}
     * @property {number} STATIC
     * @property {number} DYNAMIC
     */
    var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
      STATIC: 0,
      DYNAMIC: 1
    };
    
    /**
     * Constants that define the type of gradient on text.
     *
     * @static
     * @constant
     * @name TEXT_GRADIENT
     * @memberof PIXI
     * @type {object}
     * @property {number} LINEAR_VERTICAL Vertical gradient
     * @property {number} LINEAR_HORIZONTAL Linear gradient
     */
    var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
      LINEAR_VERTICAL: 0,
      LINEAR_HORIZONTAL: 1
    };
    
    },{}],46:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _math = require('../math');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * 'Builder' pattern for bounds rectangles
     * Axis-Aligned Bounding Box
     * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
     *
     * @class
     * @memberof PIXI
     */
    var Bounds = function () {
        /**
         *
         */
        function Bounds() {
            _classCallCheck(this, Bounds);
    
            /**
             * @member {number}
             * @default 0
             */
            this.minX = Infinity;
    
            /**
             * @member {number}
             * @default 0
             */
            this.minY = Infinity;
    
            /**
             * @member {number}
             * @default 0
             */
            this.maxX = -Infinity;
    
            /**
             * @member {number}
             * @default 0
             */
            this.maxY = -Infinity;
    
            this.rect = null;
        }
    
        /**
         * Checks if bounds are empty.
         *
         * @return {boolean} True if empty.
         */
    
    
        Bounds.prototype.isEmpty = function isEmpty() {
            return this.minX > this.maxX || this.minY > this.maxY;
        };
    
        /**
         * Clears the bounds and resets.
         *
         */
    
    
        Bounds.prototype.clear = function clear() {
            this.updateID++;
    
            this.minX = Infinity;
            this.minY = Infinity;
            this.maxX = -Infinity;
            this.maxY = -Infinity;
        };
    
        /**
         * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
         * It is not guaranteed that it will return tempRect
         *
         * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
         * @returns {PIXI.Rectangle} A rectangle of the bounds
         */
    
    
        Bounds.prototype.getRectangle = function getRectangle(rect) {
            if (this.minX > this.maxX || this.minY > this.maxY) {
                return _math.Rectangle.EMPTY;
            }
    
            rect = rect || new _math.Rectangle(0, 0, 1, 1);
    
            rect.x = this.minX;
            rect.y = this.minY;
            rect.width = this.maxX - this.minX;
            rect.height = this.maxY - this.minY;
    
            return rect;
        };
    
        /**
         * This function should be inlined when its possible.
         *
         * @param {PIXI.Point} point - The point to add.
         */
    
    
        Bounds.prototype.addPoint = function addPoint(point) {
            this.minX = Math.min(this.minX, point.x);
            this.maxX = Math.max(this.maxX, point.x);
            this.minY = Math.min(this.minY, point.y);
            this.maxY = Math.max(this.maxY, point.y);
        };
    
        /**
         * Adds a quad, not transformed
         *
         * @param {Float32Array} vertices - The verts to add.
         */
    
    
        Bounds.prototype.addQuad = function addQuad(vertices) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
    
            var x = vertices[0];
            var y = vertices[1];
    
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = vertices[2];
            y = vertices[3];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = vertices[4];
            y = vertices[5];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = vertices[6];
            y = vertices[7];
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            this.minX = minX;
            this.minY = minY;
            this.maxX = maxX;
            this.maxY = maxY;
        };
    
        /**
         * Adds sprite frame, transformed.
         *
         * @param {PIXI.TransformBase} transform - TODO
         * @param {number} x0 - TODO
         * @param {number} y0 - TODO
         * @param {number} x1 - TODO
         * @param {number} y1 - TODO
         */
    
    
        Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
            var matrix = transform.worldTransform;
            var a = matrix.a;
            var b = matrix.b;
            var c = matrix.c;
            var d = matrix.d;
            var tx = matrix.tx;
            var ty = matrix.ty;
    
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
    
            var x = a * x0 + c * y0 + tx;
            var y = b * x0 + d * y0 + ty;
    
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = a * x1 + c * y0 + tx;
            y = b * x1 + d * y0 + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = a * x0 + c * y1 + tx;
            y = b * x0 + d * y1 + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            x = a * x1 + c * y1 + tx;
            y = b * x1 + d * y1 + ty;
            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
    
            this.minX = minX;
            this.minY = minY;
            this.maxX = maxX;
            this.maxY = maxY;
        };
    
        /**
         * Add an array of vertices
         *
         * @param {PIXI.TransformBase} transform - TODO
         * @param {Float32Array} vertices - TODO
         * @param {number} beginOffset - TODO
         * @param {number} endOffset - TODO
         */
    
    
        Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
            var matrix = transform.worldTransform;
            var a = matrix.a;
            var b = matrix.b;
            var c = matrix.c;
            var d = matrix.d;
            var tx = matrix.tx;
            var ty = matrix.ty;
    
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
    
            for (var i = beginOffset; i < endOffset; i += 2) {
                var rawX = vertices[i];
                var rawY = vertices[i + 1];
                var x = a * rawX + c * rawY + tx;
                var y = d * rawY + b * rawX + ty;
    
                minX = x < minX ? x : minX;
                minY = y < minY ? y : minY;
                maxX = x > maxX ? x : maxX;
                maxY = y > maxY ? y : maxY;
            }
    
            this.minX = minX;
            this.minY = minY;
            this.maxX = maxX;
            this.maxY = maxY;
        };
    
        /**
         * Adds other Bounds
         *
         * @param {PIXI.Bounds} bounds - TODO
         */
    
    
        Bounds.prototype.addBounds = function addBounds(bounds) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;
    
            this.minX = bounds.minX < minX ? bounds.minX : minX;
            this.minY = bounds.minY < minY ? bounds.minY : minY;
            this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
            this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
        };
    
        /**
         * Adds other Bounds, masked with Bounds
         *
         * @param {PIXI.Bounds} bounds - TODO
         * @param {PIXI.Bounds} mask - TODO
         */
    
    
        Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
            var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
            var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
            var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
            var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;
    
            if (_minX <= _maxX && _minY <= _maxY) {
                var minX = this.minX;
                var minY = this.minY;
                var maxX = this.maxX;
                var maxY = this.maxY;
    
                this.minX = _minX < minX ? _minX : minX;
                this.minY = _minY < minY ? _minY : minY;
                this.maxX = _maxX > maxX ? _maxX : maxX;
                this.maxY = _maxY > maxY ? _maxY : maxY;
            }
        };
    
        /**
         * Adds other Bounds, masked with Rectangle
         *
         * @param {PIXI.Bounds} bounds - TODO
         * @param {PIXI.Rectangle} area - TODO
         */
    
    
        Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
            var _minX = bounds.minX > area.x ? bounds.minX : area.x;
            var _minY = bounds.minY > area.y ? bounds.minY : area.y;
            var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
            var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;
    
            if (_minX <= _maxX && _minY <= _maxY) {
                var minX = this.minX;
                var minY = this.minY;
                var maxX = this.maxX;
                var maxY = this.maxY;
    
                this.minX = _minX < minX ? _minX : minX;
                this.minY = _minY < minY ? _minY : minY;
                this.maxX = _maxX > maxX ? _maxX : maxX;
                this.maxY = _maxY > maxY ? _maxY : maxY;
            }
        };
    
        return Bounds;
    }();
    
    exports.default = Bounds;
    
    },{"../math":69}],47:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _utils = require('../utils');
    
    var _DisplayObject2 = require('./DisplayObject');
    
    var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A Container represents a collection of display objects.
     * It is the base class of all display objects that act as a container for other objects.
     *
     *```js
     * let container = new PIXI.Container();
     * container.addChild(sprite);
     * ```
     *
     * @class
     * @extends PIXI.DisplayObject
     * @memberof PIXI
     */
    var Container = function (_DisplayObject) {
        _inherits(Container, _DisplayObject);
    
        /**
         *
         */
        function Container() {
            _classCallCheck(this, Container);
    
            /**
             * The array of children of this container.
             *
             * @member {PIXI.DisplayObject[]}
             * @readonly
             */
            var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));
    
            _this.children = [];
            return _this;
        }
    
        /**
         * Overridable method that can be used by Container subclasses whenever the children array is modified
         *
         * @private
         */
    
    
        Container.prototype.onChildrenChange = function onChildrenChange() {}
        /* empty */
    
    
        /**
         * Adds one or more children to the container.
         *
         * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
         *
         * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
         * @return {PIXI.DisplayObject} The first child that was added.
         */
        ;
    
        Container.prototype.addChild = function addChild(child) {
            var argumentsLength = arguments.length;
    
            // if there is only one argument we can bypass looping through the them
            if (argumentsLength > 1) {
                // loop through the arguments property and add all children
                // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
                for (var i = 0; i < argumentsLength; i++) {
                    this.addChild(arguments[i]);
                }
            } else {
                // if the child has a parent then lets remove it as Pixi objects can only exist in one place
                if (child.parent) {
                    child.parent.removeChild(child);
                }
    
                child.parent = this;
                // ensure child transform will be recalculated
                child.transform._parentID = -1;
    
                this.children.push(child);
    
                // ensure bounds will be recalculated
                this._boundsID++;
    
                // TODO - lets either do all callbacks or all events.. not both!
                this.onChildrenChange(this.children.length - 1);
                child.emit('added', this);
            }
    
            return child;
        };
    
        /**
         * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
         *
         * @param {PIXI.DisplayObject} child - The child to add
         * @param {number} index - The index to place the child in
         * @return {PIXI.DisplayObject} The child that was added.
         */
    
    
        Container.prototype.addChildAt = function addChildAt(child, index) {
            if (index < 0 || index > this.children.length) {
                throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
            }
    
            if (child.parent) {
                child.parent.removeChild(child);
            }
    
            child.parent = this;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
    
            this.children.splice(index, 0, child);
    
            // ensure bounds will be recalculated
            this._boundsID++;
    
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('added', this);
    
            return child;
        };
    
        /**
         * Swaps the position of 2 Display Objects within this container.
         *
         * @param {PIXI.DisplayObject} child - First display object to swap
         * @param {PIXI.DisplayObject} child2 - Second display object to swap
         */
    
    
        Container.prototype.swapChildren = function swapChildren(child, child2) {
            if (child === child2) {
                return;
            }
    
            var index1 = this.getChildIndex(child);
            var index2 = this.getChildIndex(child2);
    
            this.children[index1] = child2;
            this.children[index2] = child;
            this.onChildrenChange(index1 < index2 ? index1 : index2);
        };
    
        /**
         * Returns the index position of a child DisplayObject instance
         *
         * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
         * @return {number} The index position of the child display object to identify
         */
    
    
        Container.prototype.getChildIndex = function getChildIndex(child) {
            var index = this.children.indexOf(child);
    
            if (index === -1) {
                throw new Error('The supplied DisplayObject must be a child of the caller');
            }
    
            return index;
        };
    
        /**
         * Changes the position of an existing child in the display object container
         *
         * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
         * @param {number} index - The resulting index number for the child display object
         */
    
    
        Container.prototype.setChildIndex = function setChildIndex(child, index) {
            if (index < 0 || index >= this.children.length) {
                throw new Error('The supplied index is out of bounds');
            }
    
            var currentIndex = this.getChildIndex(child);
    
            (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
            this.children.splice(index, 0, child); // add at new position
    
            this.onChildrenChange(index);
        };
    
        /**
         * Returns the child at the specified index
         *
         * @param {number} index - The index to get the child at
         * @return {PIXI.DisplayObject} The child at the given index, if any.
         */
    
    
        Container.prototype.getChildAt = function getChildAt(index) {
            if (index < 0 || index >= this.children.length) {
                throw new Error('getChildAt: Index (' + index + ') does not exist.');
            }
    
            return this.children[index];
        };
    
        /**
         * Removes one or more children from the container.
         *
         * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
         * @return {PIXI.DisplayObject} The first child that was removed.
         */
    
    
        Container.prototype.removeChild = function removeChild(child) {
            var argumentsLength = arguments.length;
    
            // if there is only one argument we can bypass looping through the them
            if (argumentsLength > 1) {
                // loop through the arguments property and add all children
                // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
                for (var i = 0; i < argumentsLength; i++) {
                    this.removeChild(arguments[i]);
                }
            } else {
                var index = this.children.indexOf(child);
    
                if (index === -1) return null;
    
                child.parent = null;
                // ensure child transform will be recalculated
                child.transform._parentID = -1;
                (0, _utils.removeItems)(this.children, index, 1);
    
                // ensure bounds will be recalculated
                this._boundsID++;
    
                // TODO - lets either do all callbacks or all events.. not both!
                this.onChildrenChange(index);
                child.emit('removed', this);
            }
    
            return child;
        };
    
        /**
         * Removes a child from the specified index position.
         *
         * @param {number} index - The index to get the child from
         * @return {PIXI.DisplayObject} The child that was removed.
         */
    
    
        Container.prototype.removeChildAt = function removeChildAt(index) {
            var child = this.getChildAt(index);
    
            // ensure child transform will be recalculated..
            child.parent = null;
            child.transform._parentID = -1;
            (0, _utils.removeItems)(this.children, index, 1);
    
            // ensure bounds will be recalculated
            this._boundsID++;
    
            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('removed', this);
    
            return child;
        };
    
        /**
         * Removes all children from this container that are within the begin and end indexes.
         *
         * @param {number} [beginIndex=0] - The beginning position.
         * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
         * @returns {DisplayObject[]} List of removed children
         */
    
    
        Container.prototype.removeChildren = function removeChildren() {
            var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var endIndex = arguments[1];
    
            var begin = beginIndex;
            var end = typeof endIndex === 'number' ? endIndex : this.children.length;
            var range = end - begin;
            var removed = void 0;
    
            if (range > 0 && range <= end) {
                removed = this.children.splice(begin, range);
    
                for (var i = 0; i < removed.length; ++i) {
                    removed[i].parent = null;
                    if (removed[i].transform) {
                        removed[i].transform._parentID = -1;
                    }
                }
    
                this._boundsID++;
    
                this.onChildrenChange(beginIndex);
    
                for (var _i = 0; _i < removed.length; ++_i) {
                    removed[_i].emit('removed', this);
                }
    
                return removed;
            } else if (range === 0 && this.children.length === 0) {
                return [];
            }
    
            throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
        };
    
        /**
         * Updates the transform on all children of this container for rendering
         */
    
    
        Container.prototype.updateTransform = function updateTransform() {
            this._boundsID++;
    
            this.transform.updateTransform(this.parent.transform);
    
            // TODO: check render flags, how to process stuff here
            this.worldAlpha = this.alpha * this.parent.worldAlpha;
    
            for (var i = 0, j = this.children.length; i < j; ++i) {
                var child = this.children[i];
    
                if (child.visible) {
                    child.updateTransform();
                }
            }
        };
    
        /**
         * Recalculates the bounds of the container.
         *
         */
    
    
        Container.prototype.calculateBounds = function calculateBounds() {
            this._bounds.clear();
    
            this._calculateBounds();
    
            for (var i = 0; i < this.children.length; i++) {
                var child = this.children[i];
    
                if (!child.visible || !child.renderable) {
                    continue;
                }
    
                child.calculateBounds();
    
                // TODO: filter+mask, need to mask both somehow
                if (child._mask) {
                    child._mask.calculateBounds();
                    this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
                } else if (child.filterArea) {
                    this._bounds.addBoundsArea(child._bounds, child.filterArea);
                } else {
                    this._bounds.addBounds(child._bounds);
                }
            }
    
            this._lastBoundsID = this._boundsID;
        };
    
        /**
         * Recalculates the bounds of the object. Override this to
         * calculate the bounds of the specific object (not including children).
         *
         */
    
    
        Container.prototype._calculateBounds = function _calculateBounds() {}
        // FILL IN//
    
    
        /**
         * Renders the object using the WebGL renderer
         *
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
        ;
    
        Container.prototype.renderWebGL = function renderWebGL(renderer) {
            // if the object is not visible or the alpha is 0 then no need to render this element
            if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
                return;
            }
    
            // do a quick check to see if this element has a mask or a filter.
            if (this._mask || this._filters) {
                this.renderAdvancedWebGL(renderer);
            } else {
                this._renderWebGL(renderer);
    
                // simple render children!
                for (var i = 0, j = this.children.length; i < j; ++i) {
                    this.children[i].renderWebGL(renderer);
                }
            }
        };
    
        /**
         * Render the object using the WebGL renderer and advanced features.
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
            renderer.flush();
    
            var filters = this._filters;
            var mask = this._mask;
    
            // push filter first as we need to ensure the stencil buffer is correct for any masking
            if (filters) {
                if (!this._enabledFilters) {
                    this._enabledFilters = [];
                }
    
                this._enabledFilters.length = 0;
    
                for (var i = 0; i < filters.length; i++) {
                    if (filters[i].enabled) {
                        this._enabledFilters.push(filters[i]);
                    }
                }
    
                if (this._enabledFilters.length) {
                    renderer.filterManager.pushFilter(this, this._enabledFilters);
                }
            }
    
            if (mask) {
                renderer.maskManager.pushMask(this, this._mask);
            }
    
            // add this object to the batch, only rendered if it has a texture.
            this._renderWebGL(renderer);
    
            // now loop through the children and make sure they get rendered
            for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
                this.children[_i2].renderWebGL(renderer);
            }
    
            renderer.flush();
    
            if (mask) {
                renderer.maskManager.popMask(this, this._mask);
            }
    
            if (filters && this._enabledFilters && this._enabledFilters.length) {
                renderer.filterManager.popFilter();
            }
        };
    
        /**
         * To be overridden by the subclasses.
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
        {}
        // this is where content itself gets rendered...
    
    
        /**
         * To be overridden by the subclass
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - The renderer
         */
        ;
    
        Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
        {}
        // this is where content itself gets rendered...
    
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @param {PIXI.CanvasRenderer} renderer - The renderer
         */
        ;
    
        Container.prototype.renderCanvas = function renderCanvas(renderer) {
            // if not visible or the alpha is 0 then no need to render this
            if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
                return;
            }
    
            if (this._mask) {
                renderer.maskManager.pushMask(this._mask);
            }
    
            this._renderCanvas(renderer);
            for (var i = 0, j = this.children.length; i < j; ++i) {
                this.children[i].renderCanvas(renderer);
            }
    
            if (this._mask) {
                renderer.maskManager.popMask(renderer);
            }
        };
    
        /**
         * Removes all internal references and listeners as well as removes children from the display list.
         * Do not use a Container after calling `destroy`.
         *
         * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
         *  have been set to that value
         * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
         *  method called as well. 'options' will be passed on to those calls.
         * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the texture of the child sprite
         * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the base texture of the child sprite
         */
    
    
        Container.prototype.destroy = function destroy(options) {
            _DisplayObject.prototype.destroy.call(this);
    
            var destroyChildren = typeof options === 'boolean' ? options : options && options.children;
    
            var oldChildren = this.removeChildren(0, this.children.length);
    
            if (destroyChildren) {
                for (var i = 0; i < oldChildren.length; ++i) {
                    oldChildren[i].destroy(options);
                }
            }
        };
    
        /**
         * The width of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */
    
    
        _createClass(Container, [{
            key: 'width',
            get: function get() {
                return this.scale.x * this.getLocalBounds().width;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                var width = this.getLocalBounds().width;
    
                if (width !== 0) {
                    this.scale.x = value / width;
                } else {
                    this.scale.x = 1;
                }
    
                this._width = value;
            }
    
            /**
             * The height of the Container, setting this will actually modify the scale to achieve the value set
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                return this.scale.y * this.getLocalBounds().height;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                var height = this.getLocalBounds().height;
    
                if (height !== 0) {
                    this.scale.y = value / height;
                } else {
                    this.scale.y = 1;
                }
    
                this._height = value;
            }
        }]);
    
        return Container;
    }(_DisplayObject3.default);
    
    // performance increase to avoid using call.. (10x faster)
    
    
    exports.default = Container;
    Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
    
    },{"../utils":121,"./DisplayObject":48}],48:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _const = require('../const');
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _TransformStatic = require('./TransformStatic');
    
    var _TransformStatic2 = _interopRequireDefault(_TransformStatic);
    
    var _Transform = require('./Transform');
    
    var _Transform2 = _interopRequireDefault(_Transform);
    
    var _Bounds = require('./Bounds');
    
    var _Bounds2 = _interopRequireDefault(_Bounds);
    
    var _math = require('../math');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    // _tempDisplayObjectParent = new DisplayObject();
    
    /**
     * The base class for all objects that are rendered on the screen.
     * This is an abstract class and should not be used on its own rather it should be extended.
     *
     * @class
     * @extends EventEmitter
     * @mixes PIXI.interaction.interactiveTarget
     * @memberof PIXI
     */
    var DisplayObject = function (_EventEmitter) {
        _inherits(DisplayObject, _EventEmitter);
    
        /**
         *
         */
        function DisplayObject() {
            _classCallCheck(this, DisplayObject);
    
            var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
    
            var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;
    
            _this.tempDisplayObjectParent = null;
    
            // TODO: need to create Transform from factory
            /**
             * World transform and local transform of this object.
             * This will become read-only later, please do not assign anything there unless you know what are you doing
             *
             * @member {PIXI.TransformBase}
             */
            _this.transform = new TransformClass();
    
            /**
             * The opacity of the object.
             *
             * @member {number}
             */
            _this.alpha = 1;
    
            /**
             * The visibility of the object. If false the object will not be drawn, and
             * the updateTransform function will not be called.
             *
             * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
             *
             * @member {boolean}
             */
            _this.visible = true;
    
            /**
             * Can this object be rendered, if false the object will not be drawn but the updateTransform
             * methods will still be called.
             *
             * Only affects recursive calls from parent. You can ask for bounds manually
             *
             * @member {boolean}
             */
            _this.renderable = true;
    
            /**
             * The display object container that contains this display object.
             *
             * @member {PIXI.Container}
             * @readonly
             */
            _this.parent = null;
    
            /**
             * The multiplied alpha of the displayObject
             *
             * @member {number}
             * @readonly
             */
            _this.worldAlpha = 1;
    
            /**
             * The area the filter is applied to. This is used as more of an optimisation
             * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
             *
             * Also works as an interaction mask
             *
             * @member {PIXI.Rectangle}
             */
            _this.filterArea = null;
    
            _this._filters = null;
            _this._enabledFilters = null;
    
            /**
             * The bounds object, this is used to calculate and store the bounds of the displayObject
             *
             * @member {PIXI.Rectangle}
             * @private
             */
            _this._bounds = new _Bounds2.default();
            _this._boundsID = 0;
            _this._lastBoundsID = -1;
            _this._boundsRect = null;
            _this._localBoundsRect = null;
    
            /**
             * The original, cached mask of the object
             *
             * @member {PIXI.Graphics|PIXI.Sprite}
             * @private
             */
            _this._mask = null;
    
            /**
             * If the object has been destroyed via destroy(). If true, it should not be used.
             *
             * @member {boolean}
             * @private
             * @readonly
             */
            _this._destroyed = false;
            return _this;
        }
    
        /**
         * @private
         * @member {PIXI.DisplayObject}
         */
    
    
        /**
         * Updates the object transform for rendering
         *
         * TODO - Optimization pass!
         */
        DisplayObject.prototype.updateTransform = function updateTransform() {
            this.transform.updateTransform(this.parent.transform);
            // multiply the alphas..
            this.worldAlpha = this.alpha * this.parent.worldAlpha;
    
            this._bounds.updateID++;
        };
    
        /**
         * recursively updates transform of all objects from the root to this one
         * internal function for toLocal()
         */
    
    
        DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
            if (this.parent) {
                this.parent._recursivePostUpdateTransform();
                this.transform.updateTransform(this.parent.transform);
            } else {
                this.transform.updateTransform(this._tempDisplayObjectParent.transform);
            }
        };
    
        /**
         * Retrieves the bounds of the displayObject as a rectangle object.
         *
         * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
         *  being updated. This means the calculation returned MAY be out of date BUT will give you a
         *  nice performance boost
         * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
         * @return {PIXI.Rectangle} the rectangular bounding area
         */
    
    
        DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
            if (!skipUpdate) {
                if (!this.parent) {
                    this.parent = this._tempDisplayObjectParent;
                    this.updateTransform();
                    this.parent = null;
                } else {
                    this._recursivePostUpdateTransform();
                    this.updateTransform();
                }
            }
    
            if (this._boundsID !== this._lastBoundsID) {
                this.calculateBounds();
            }
    
            if (!rect) {
                if (!this._boundsRect) {
                    this._boundsRect = new _math.Rectangle();
                }
    
                rect = this._boundsRect;
            }
    
            return this._bounds.getRectangle(rect);
        };
    
        /**
         * Retrieves the local bounds of the displayObject as a rectangle object
         *
         * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
         * @return {PIXI.Rectangle} the rectangular bounding area
         */
    
    
        DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
            var transformRef = this.transform;
            var parentRef = this.parent;
    
            this.parent = null;
            this.transform = this._tempDisplayObjectParent.transform;
    
            if (!rect) {
                if (!this._localBoundsRect) {
                    this._localBoundsRect = new _math.Rectangle();
                }
    
                rect = this._localBoundsRect;
            }
    
            var bounds = this.getBounds(false, rect);
    
            this.parent = parentRef;
            this.transform = transformRef;
    
            return bounds;
        };
    
        /**
         * Calculates the global position of the display object
         *
         * @param {PIXI.Point} position - The world origin to calculate from
         * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
         *  (otherwise will create a new Point)
         * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
         * @return {PIXI.Point} A point object representing the position of this object
         */
    
    
        DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
            var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    
            if (!skipUpdate) {
                this._recursivePostUpdateTransform();
    
                // this parent check is for just in case the item is a root object.
                // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
                // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
                if (!this.parent) {
                    this.parent = this._tempDisplayObjectParent;
                    this.displayObjectUpdateTransform();
                    this.parent = null;
                } else {
                    this.displayObjectUpdateTransform();
                }
            }
    
            // don't need to update the lot
            return this.worldTransform.apply(position, point);
        };
    
        /**
         * Calculates the local position of the display object relative to another point
         *
         * @param {PIXI.Point} position - The world origin to calculate from
         * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
         * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
         *  (otherwise will create a new Point)
         * @param {boolean} [skipUpdate=false] - Should we skip the update transform
         * @return {PIXI.Point} A point object representing the position of this object
         */
    
    
        DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
            if (from) {
                position = from.toGlobal(position, point, skipUpdate);
            }
    
            if (!skipUpdate) {
                this._recursivePostUpdateTransform();
    
                // this parent check is for just in case the item is a root object.
                // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
                // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
                if (!this.parent) {
                    this.parent = this._tempDisplayObjectParent;
                    this.displayObjectUpdateTransform();
                    this.parent = null;
                } else {
                    this.displayObjectUpdateTransform();
                }
            }
    
            // simply apply the matrix..
            return this.worldTransform.applyInverse(position, point);
        };
    
        /**
         * Renders the object using the WebGL renderer
         *
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
        {}
        // OVERWRITE;
    
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @param {PIXI.CanvasRenderer} renderer - The renderer
         */
        ;
    
        DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
        {}
        // OVERWRITE;
    
    
        /**
         * Set the parent Container of this DisplayObject
         *
         * @param {PIXI.Container} container - The Container to add this DisplayObject to
         * @return {PIXI.Container} The Container that this DisplayObject was added to
         */
        ;
    
        DisplayObject.prototype.setParent = function setParent(container) {
            if (!container || !container.addChild) {
                throw new Error('setParent: Argument must be a Container');
            }
    
            container.addChild(this);
    
            return container;
        };
    
        /**
         * Convenience function to set the position, scale, skew and pivot at once.
         *
         * @param {number} [x=0] - The X position
         * @param {number} [y=0] - The Y position
         * @param {number} [scaleX=1] - The X scale value
         * @param {number} [scaleY=1] - The Y scale value
         * @param {number} [rotation=0] - The rotation
         * @param {number} [skewX=0] - The X skew value
         * @param {number} [skewY=0] - The Y skew value
         * @param {number} [pivotX=0] - The X pivot value
         * @param {number} [pivotY=0] - The Y pivot value
         * @return {PIXI.DisplayObject} The DisplayObject instance
         */
    
    
        DisplayObject.prototype.setTransform = function setTransform() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
            var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
            var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
            var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
            var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
            var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    
            this.position.x = x;
            this.position.y = y;
            this.scale.x = !scaleX ? 1 : scaleX;
            this.scale.y = !scaleY ? 1 : scaleY;
            this.rotation = rotation;
            this.skew.x = skewX;
            this.skew.y = skewY;
            this.pivot.x = pivotX;
            this.pivot.y = pivotY;
    
            return this;
        };
    
        /**
         * Base destroy method for generic display objects. This will automatically
         * remove the display object from its parent Container as well as remove
         * all current event listeners and internal references. Do not use a DisplayObject
         * after calling `destroy`.
         *
         */
    
    
        DisplayObject.prototype.destroy = function destroy() {
            this.removeAllListeners();
            if (this.parent) {
                this.parent.removeChild(this);
            }
            this.transform = null;
    
            this.parent = null;
    
            this._bounds = null;
            this._currentBounds = null;
            this._mask = null;
    
            this.filterArea = null;
    
            this.interactive = false;
            this.interactiveChildren = false;
    
            this._destroyed = true;
        };
    
        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         * An alias to position.x
         *
         * @member {number}
         */
    
    
        _createClass(DisplayObject, [{
            key: '_tempDisplayObjectParent',
            get: function get() {
                if (this.tempDisplayObjectParent === null) {
                    this.tempDisplayObjectParent = new DisplayObject();
                }
    
                return this.tempDisplayObjectParent;
            }
        }, {
            key: 'x',
            get: function get() {
                return this.position.x;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.position.x = value;
            }
    
            /**
             * The position of the displayObject on the y axis relative to the local coordinates of the parent.
             * An alias to position.y
             *
             * @member {number}
             */
    
        }, {
            key: 'y',
            get: function get() {
                return this.position.y;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.position.y = value;
            }
    
            /**
             * Current transform of the object based on world (parent) factors
             *
             * @member {PIXI.Matrix}
             * @readonly
             */
    
        }, {
            key: 'worldTransform',
            get: function get() {
                return this.transform.worldTransform;
            }
    
            /**
             * Current transform of the object based on local factors: position, scale, other stuff
             *
             * @member {PIXI.Matrix}
             * @readonly
             */
    
        }, {
            key: 'localTransform',
            get: function get() {
                return this.transform.localTransform;
            }
    
            /**
             * The coordinate of the object relative to the local coordinates of the parent.
             * Assignment by value since pixi-v4.
             *
             * @member {PIXI.Point|PIXI.ObservablePoint}
             */
    
        }, {
            key: 'position',
            get: function get() {
                return this.transform.position;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.position.copy(value);
            }
    
            /**
             * The scale factor of the object.
             * Assignment by value since pixi-v4.
             *
             * @member {PIXI.Point|PIXI.ObservablePoint}
             */
    
        }, {
            key: 'scale',
            get: function get() {
                return this.transform.scale;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.scale.copy(value);
            }
    
            /**
             * The pivot point of the displayObject that it rotates around
             * Assignment by value since pixi-v4.
             *
             * @member {PIXI.Point|PIXI.ObservablePoint}
             */
    
        }, {
            key: 'pivot',
            get: function get() {
                return this.transform.pivot;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.pivot.copy(value);
            }
    
            /**
             * The skew factor for the object in radians.
             * Assignment by value since pixi-v4.
             *
             * @member {PIXI.ObservablePoint}
             */
    
        }, {
            key: 'skew',
            get: function get() {
                return this.transform.skew;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.skew.copy(value);
            }
    
            /**
             * The rotation of the object in radians.
             *
             * @member {number}
             */
    
        }, {
            key: 'rotation',
            get: function get() {
                return this.transform.rotation;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.transform.rotation = value;
            }
    
            /**
             * Indicates if the object is globally visible.
             *
             * @member {boolean}
             * @readonly
             */
    
        }, {
            key: 'worldVisible',
            get: function get() {
                var item = this;
    
                do {
                    if (!item.visible) {
                        return false;
                    }
    
                    item = item.parent;
                } while (item);
    
                return true;
            }
    
            /**
             * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
             * object to the shape of the mask applied to it. In PIXI a regular mask must be a
             * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
             * utilises shape clipping. To remove a mask, set this property to null.
             *
             * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
             *
             * @member {PIXI.Graphics|PIXI.Sprite}
             */
    
        }, {
            key: 'mask',
            get: function get() {
                return this._mask;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (this._mask) {
                    this._mask.renderable = true;
                }
    
                this._mask = value;
    
                if (this._mask) {
                    this._mask.renderable = false;
                }
            }
    
            /**
             * Sets the filters for the displayObject.
             * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
             * To remove filters simply set this property to 'null'
             *
             * @member {PIXI.Filter[]}
             */
    
        }, {
            key: 'filters',
            get: function get() {
                return this._filters && this._filters.slice();
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._filters = value && value.slice();
            }
        }]);
    
        return DisplayObject;
    }(_eventemitter2.default);
    
    // performance increase to avoid using call.. (10x faster)
    
    
    exports.default = DisplayObject;
    DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
    
    },{"../const":45,"../math":69,"../settings":100,"./Bounds":46,"./Transform":49,"./TransformStatic":51,"eventemitter3":4}],49:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _math = require('../math');
    
    var _TransformBase2 = require('./TransformBase');
    
    var _TransformBase3 = _interopRequireDefault(_TransformBase2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * Generic class to deal with traditional 2D matrix transforms
     * local transformation is calculated from position,scale,skew and rotation
     *
     * @class
     * @extends PIXI.TransformBase
     * @memberof PIXI
     */
    var Transform = function (_TransformBase) {
      _inherits(Transform, _TransformBase);
    
      /**
       *
       */
      function Transform() {
        _classCallCheck(this, Transform);
    
        /**
        * The coordinate of the object relative to the local coordinates of the parent.
        *
        * @member {PIXI.Point}
        */
        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
    
        _this.position = new _math.Point(0, 0);
    
        /**
         * The scale factor of the object.
         *
         * @member {PIXI.Point}
         */
        _this.scale = new _math.Point(1, 1);
    
        /**
         * The skew amount, on the x and y axis.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
    
        /**
         * The pivot point of the displayObject that it rotates around
         *
         * @member {PIXI.Point}
         */
        _this.pivot = new _math.Point(0, 0);
    
        /**
         * The rotation value of the object, in radians
         *
         * @member {Number}
         * @private
         */
        _this._rotation = 0;
    
        _this._cx = 1; // cos rotation + skewY;
        _this._sx = 0; // sin rotation + skewY;
        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
        return _this;
      }
    
      /**
       * Updates the skew values when the skew or rotation changes.
       *
       * @private
       */
    
    
      Transform.prototype.updateSkew = function updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew._y);
        this._sx = Math.sin(this._rotation + this.skew._y);
        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
      };
    
      /**
       * Updates only local matrix
       */
    
    
      Transform.prototype.updateLocalTransform = function updateLocalTransform() {
        var lt = this.localTransform;
    
        lt.a = this._cx * this.scale.x;
        lt.b = this._sx * this.scale.x;
        lt.c = this._cy * this.scale.y;
        lt.d = this._sy * this.scale.y;
    
        lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
        lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
      };
    
      /**
       * Updates the values of the object and applies the parent's transform.
       *
       * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
       */
    
    
      Transform.prototype.updateTransform = function updateTransform(parentTransform) {
        var lt = this.localTransform;
    
        lt.a = this._cx * this.scale.x;
        lt.b = this._sx * this.scale.x;
        lt.c = this._cy * this.scale.y;
        lt.d = this._sy * this.scale.y;
    
        lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
        lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
    
        // concat the parent matrix with the objects transform.
        var pt = parentTransform.worldTransform;
        var wt = this.worldTransform;
    
        wt.a = lt.a * pt.a + lt.b * pt.c;
        wt.b = lt.a * pt.b + lt.b * pt.d;
        wt.c = lt.c * pt.a + lt.d * pt.c;
        wt.d = lt.c * pt.b + lt.d * pt.d;
        wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
        wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
    
        this._worldID++;
      };
    
      /**
       * Decomposes a matrix and sets the transforms properties based on it.
       *
       * @param {PIXI.Matrix} matrix - The matrix to decompose
       */
    
    
      Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
        matrix.decompose(this);
      };
    
      /**
       * The rotation of the object in radians.
       *
       * @member {number}
       */
    
    
      _createClass(Transform, [{
        key: 'rotation',
        get: function get() {
          return this._rotation;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
          this._rotation = value;
          this.updateSkew();
        }
      }]);
    
      return Transform;
    }(_TransformBase3.default);
    
    exports.default = Transform;
    
    },{"../math":69,"./TransformBase":50}],50:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _math = require('../math');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Generic class to deal with traditional 2D matrix transforms
     *
     * @class
     * @memberof PIXI
     */
    var TransformBase = function () {
      /**
       *
       */
      function TransformBase() {
        _classCallCheck(this, TransformBase);
    
        /**
         * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
         *
         * @member {PIXI.Matrix}
         */
        this.worldTransform = new _math.Matrix();
    
        /**
         * The local matrix transform
         *
         * @member {PIXI.Matrix}
         */
        this.localTransform = new _math.Matrix();
    
        this._worldID = 0;
        this._parentID = 0;
      }
    
      /**
       * TransformBase does not have decomposition, so this function wont do anything
       */
    
    
      TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
      // empty
    
    
      /**
       * Updates the values of the object and applies the parent's transform.
       *
       * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
       */
      ;
    
      TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
        var pt = parentTransform.worldTransform;
        var wt = this.worldTransform;
        var lt = this.localTransform;
    
        // concat the parent matrix with the objects transform.
        wt.a = lt.a * pt.a + lt.b * pt.c;
        wt.b = lt.a * pt.b + lt.b * pt.d;
        wt.c = lt.c * pt.a + lt.d * pt.c;
        wt.d = lt.c * pt.b + lt.d * pt.d;
        wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
        wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
    
        this._worldID++;
      };
    
      return TransformBase;
    }();
    
    /**
     * Updates the values of the object and applies the parent's transform.
     * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
     *
     */
    
    
    exports.default = TransformBase;
    TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;
    
    TransformBase.IDENTITY = new TransformBase();
    
    },{"../math":69}],51:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _math = require('../math');
    
    var _TransformBase2 = require('./TransformBase');
    
    var _TransformBase3 = _interopRequireDefault(_TransformBase2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * Transform that takes care about its versions
     *
     * @class
     * @extends PIXI.TransformBase
     * @memberof PIXI
     */
    var TransformStatic = function (_TransformBase) {
        _inherits(TransformStatic, _TransformBase);
    
        /**
         *
         */
        function TransformStatic() {
            _classCallCheck(this, TransformStatic);
    
            /**
            * The coordinate of the object relative to the local coordinates of the parent.
            *
            * @member {PIXI.ObservablePoint}
            */
            var _this = _possibleConstructorReturn(this, _TransformBase.call(this));
    
            _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
    
            /**
             * The scale factor of the object.
             *
             * @member {PIXI.ObservablePoint}
             */
            _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);
    
            /**
             * The pivot point of the displayObject that it rotates around
             *
             * @member {PIXI.ObservablePoint}
             */
            _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);
    
            /**
             * The skew amount, on the x and y axis.
             *
             * @member {PIXI.ObservablePoint}
             */
            _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);
    
            _this._rotation = 0;
    
            _this._cx = 1; // cos rotation + skewY;
            _this._sx = 0; // sin rotation + skewY;
            _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
            _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
    
            _this._localID = 0;
            _this._currentLocalID = 0;
            return _this;
        }
    
        /**
         * Called when a value changes.
         *
         * @private
         */
    
    
        TransformStatic.prototype.onChange = function onChange() {
            this._localID++;
        };
    
        /**
         * Called when skew or rotation changes
         *
         * @private
         */
    
    
        TransformStatic.prototype.updateSkew = function updateSkew() {
            this._cx = Math.cos(this._rotation + this.skew._y);
            this._sx = Math.sin(this._rotation + this.skew._y);
            this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
            this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
    
            this._localID++;
        };
    
        /**
         * Updates only local matrix
         */
    
    
        TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
            var lt = this.localTransform;
    
            if (this._localID !== this._currentLocalID) {
                // get the matrix values of the displayobject based on its transform properties..
                lt.a = this._cx * this.scale._x;
                lt.b = this._sx * this.scale._x;
                lt.c = this._cy * this.scale._y;
                lt.d = this._sy * this.scale._y;
    
                lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
                lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
                this._currentLocalID = this._localID;
    
                // force an update..
                this._parentID = -1;
            }
        };
    
        /**
         * Updates the values of the object and applies the parent's transform.
         *
         * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
         */
    
    
        TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
            var lt = this.localTransform;
    
            if (this._localID !== this._currentLocalID) {
                // get the matrix values of the displayobject based on its transform properties..
                lt.a = this._cx * this.scale._x;
                lt.b = this._sx * this.scale._x;
                lt.c = this._cy * this.scale._y;
                lt.d = this._sy * this.scale._y;
    
                lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
                lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
                this._currentLocalID = this._localID;
    
                // force an update..
                this._parentID = -1;
            }
    
            if (this._parentID !== parentTransform._worldID) {
                // concat the parent matrix with the objects transform.
                var pt = parentTransform.worldTransform;
                var wt = this.worldTransform;
    
                wt.a = lt.a * pt.a + lt.b * pt.c;
                wt.b = lt.a * pt.b + lt.b * pt.d;
                wt.c = lt.c * pt.a + lt.d * pt.c;
                wt.d = lt.c * pt.b + lt.d * pt.d;
                wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
                wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
    
                this._parentID = parentTransform._worldID;
    
                // update the id of the transform..
                this._worldID++;
            }
        };
    
        /**
         * Decomposes a matrix and sets the transforms properties based on it.
         *
         * @param {PIXI.Matrix} matrix - The matrix to decompose
         */
    
    
        TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
            matrix.decompose(this);
            this._localID++;
        };
    
        /**
         * The rotation of the object in radians.
         *
         * @member {number}
         */
    
    
        _createClass(TransformStatic, [{
            key: 'rotation',
            get: function get() {
                return this._rotation;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._rotation = value;
                this.updateSkew();
            }
        }]);
    
        return TransformStatic;
    }(_TransformBase3.default);
    
    exports.default = TransformStatic;
    
    },{"../math":69,"./TransformBase":50}],52:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Container2 = require('../display/Container');
    
    var _Container3 = _interopRequireDefault(_Container2);
    
    var _RenderTexture = require('../textures/RenderTexture');
    
    var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
    
    var _Texture = require('../textures/Texture');
    
    var _Texture2 = _interopRequireDefault(_Texture);
    
    var _GraphicsData = require('./GraphicsData');
    
    var _GraphicsData2 = _interopRequireDefault(_GraphicsData);
    
    var _Sprite = require('../sprites/Sprite');
    
    var _Sprite2 = _interopRequireDefault(_Sprite);
    
    var _math = require('../math');
    
    var _utils = require('../utils');
    
    var _const = require('../const');
    
    var _Bounds = require('../display/Bounds');
    
    var _Bounds2 = _interopRequireDefault(_Bounds);
    
    var _bezierCurveTo2 = require('./utils/bezierCurveTo');
    
    var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);
    
    var _CanvasRenderer = require('../renderers/canvas/CanvasRenderer');
    
    var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var canvasRenderer = void 0;
    var tempMatrix = new _math.Matrix();
    var tempPoint = new _math.Point();
    var tempColor1 = new Float32Array(4);
    var tempColor2 = new Float32Array(4);
    
    /**
     * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
     * rectangles to the display, and to color and fill them.
     *
     * @class
     * @extends PIXI.Container
     * @memberof PIXI
     */
    
    var Graphics = function (_Container) {
        _inherits(Graphics, _Container);
    
        /**
         *
         * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
         */
        function Graphics() {
            var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    
            _classCallCheck(this, Graphics);
    
            /**
             * The alpha value used when filling the Graphics object.
             *
             * @member {number}
             * @default 1
             */
            var _this = _possibleConstructorReturn(this, _Container.call(this));
    
            _this.fillAlpha = 1;
    
            /**
             * The width (thickness) of any lines drawn.
             *
             * @member {number}
             * @default 0
             */
            _this.lineWidth = 0;
    
            /**
             * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
             *
             * @member {boolean}
             */
            _this.nativeLines = nativeLines;
    
            /**
             * The color of any lines drawn.
             *
             * @member {string}
             * @default 0
             */
            _this.lineColor = 0;
    
            /**
             * Graphics data
             *
             * @member {PIXI.GraphicsData[]}
             * @private
             */
            _this.graphicsData = [];
    
            /**
             * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
             * reset the tint.
             *
             * @member {number}
             * @default 0xFFFFFF
             */
            _this.tint = 0xFFFFFF;
    
            /**
             * The previous tint applied to the graphic shape. Used to compare to the current tint and
             * check if theres change.
             *
             * @member {number}
             * @private
             * @default 0xFFFFFF
             */
            _this._prevTint = 0xFFFFFF;
    
            /**
             * The blend mode to be applied to the graphic shape. Apply a value of
             * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
             *
             * @member {number}
             * @default PIXI.BLEND_MODES.NORMAL;
             * @see PIXI.BLEND_MODES
             */
            _this.blendMode = _const.BLEND_MODES.NORMAL;
    
            /**
             * Current path
             *
             * @member {PIXI.GraphicsData}
             * @private
             */
            _this.currentPath = null;
    
            /**
             * Array containing some WebGL-related properties used by the WebGL renderer.
             *
             * @member {object<number, object>}
             * @private
             */
            // TODO - _webgl should use a prototype object, not a random undocumented object...
            _this._webGL = {};
    
            /**
             * Whether this shape is being used as a mask.
             *
             * @member {boolean}
             */
            _this.isMask = false;
    
            /**
             * The bounds' padding used for bounds calculation.
             *
             * @member {number}
             */
            _this.boundsPadding = 0;
    
            /**
             * A cache of the local bounds to prevent recalculation.
             *
             * @member {PIXI.Rectangle}
             * @private
             */
            _this._localBounds = new _Bounds2.default();
    
            /**
             * Used to detect if the graphics object has changed. If this is set to true then the graphics
             * object will be recalculated.
             *
             * @member {boolean}
             * @private
             */
            _this.dirty = 0;
    
            /**
             * Used to detect if we need to do a fast rect check using the id compare method
             * @type {Number}
             */
            _this.fastRectDirty = -1;
    
            /**
             * Used to detect if we clear the graphics webGL data
             * @type {Number}
             */
            _this.clearDirty = 0;
    
            /**
             * Used to detect if we we need to recalculate local bounds
             * @type {Number}
             */
            _this.boundsDirty = -1;
    
            /**
             * Used to detect if the cached sprite object needs to be updated.
             *
             * @member {boolean}
             * @private
             */
            _this.cachedSpriteDirty = false;
    
            _this._spriteRect = null;
            _this._fastRect = false;
    
            /**
             * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
             * This is useful if your graphics element does not change often, as it will speed up the rendering
             * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
             * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
             * you are constantly redrawing the graphics element.
             *
             * @name cacheAsBitmap
             * @member {boolean}
             * @memberof PIXI.Graphics#
             * @default false
             */
            return _this;
        }
    
        /**
         * Creates a new Graphics object with the same values as this one.
         * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
         *
         * @return {PIXI.Graphics} A clone of the graphics object
         */
    
    
        Graphics.prototype.clone = function clone() {
            var clone = new Graphics();
    
            clone.renderable = this.renderable;
            clone.fillAlpha = this.fillAlpha;
            clone.lineWidth = this.lineWidth;
            clone.lineColor = this.lineColor;
            clone.tint = this.tint;
            clone.blendMode = this.blendMode;
            clone.isMask = this.isMask;
            clone.boundsPadding = this.boundsPadding;
            clone.dirty = 0;
            clone.cachedSpriteDirty = this.cachedSpriteDirty;
    
            // copy graphics data
            for (var i = 0; i < this.graphicsData.length; ++i) {
                clone.graphicsData.push(this.graphicsData[i].clone());
            }
    
            clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];
    
            clone.updateLocalBounds();
    
            return clone;
        };
    
        /**
         * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
         * method or the drawCircle() method.
         *
         * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
         * @param {number} [color=0] - color of the line to draw, will update the objects stored style
         * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.lineStyle = function lineStyle() {
            var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    
            this.lineWidth = lineWidth;
            this.lineColor = color;
            this.lineAlpha = alpha;
    
            if (this.currentPath) {
                if (this.currentPath.shape.points.length) {
                    // halfway through a line? start a new one!
                    var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));
    
                    shape.closed = false;
    
                    this.drawShape(shape);
                } else {
                    // otherwise its empty so lets just set the line properties
                    this.currentPath.lineWidth = this.lineWidth;
                    this.currentPath.lineColor = this.lineColor;
                    this.currentPath.lineAlpha = this.lineAlpha;
                }
            }
    
            return this;
        };
    
        /**
         * Moves the current drawing position to x, y.
         *
         * @param {number} x - the X coordinate to move to
         * @param {number} y - the Y coordinate to move to
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.moveTo = function moveTo(x, y) {
            var shape = new _math.Polygon([x, y]);
    
            shape.closed = false;
            this.drawShape(shape);
    
            return this;
        };
    
        /**
         * Draws a line using the current line style from the current drawing position to (x, y);
         * The current drawing position is then set to (x, y).
         *
         * @param {number} x - the X coordinate to draw to
         * @param {number} y - the Y coordinate to draw to
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.lineTo = function lineTo(x, y) {
            this.currentPath.shape.points.push(x, y);
            this.dirty++;
    
            return this;
        };
    
        /**
         * Calculate the points for a quadratic bezier curve and then draws it.
         * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
         *
         * @param {number} cpX - Control point x
         * @param {number} cpY - Control point y
         * @param {number} toX - Destination point x
         * @param {number} toY - Destination point y
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
            if (this.currentPath) {
                if (this.currentPath.shape.points.length === 0) {
                    this.currentPath.shape.points = [0, 0];
                }
            } else {
                this.moveTo(0, 0);
            }
    
            var n = 20;
            var points = this.currentPath.shape.points;
            var xa = 0;
            var ya = 0;
    
            if (points.length === 0) {
                this.moveTo(0, 0);
            }
    
            var fromX = points[points.length - 2];
            var fromY = points[points.length - 1];
    
            for (var i = 1; i <= n; ++i) {
                var j = i / n;
    
                xa = fromX + (cpX - fromX) * j;
                ya = fromY + (cpY - fromY) * j;
    
                points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
            }
    
            this.dirty++;
    
            return this;
        };
    
        /**
         * Calculate the points for a bezier curve and then draws it.
         *
         * @param {number} cpX - Control point x
         * @param {number} cpY - Control point y
         * @param {number} cpX2 - Second Control point x
         * @param {number} cpY2 - Second Control point y
         * @param {number} toX - Destination point x
         * @param {number} toY - Destination point y
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
            if (this.currentPath) {
                if (this.currentPath.shape.points.length === 0) {
                    this.currentPath.shape.points = [0, 0];
                }
            } else {
                this.moveTo(0, 0);
            }
    
            var points = this.currentPath.shape.points;
    
            var fromX = points[points.length - 2];
            var fromY = points[points.length - 1];
    
            points.length -= 2;
    
            (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, points);
    
            this.dirty++;
    
            return this;
        };
    
        /**
         * The arcTo() method creates an arc/curve between two tangents on the canvas.
         *
         * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
         *
         * @param {number} x1 - The x-coordinate of the beginning of the arc
         * @param {number} y1 - The y-coordinate of the beginning of the arc
         * @param {number} x2 - The x-coordinate of the end of the arc
         * @param {number} y2 - The y-coordinate of the end of the arc
         * @param {number} radius - The radius of the arc
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
            if (this.currentPath) {
                if (this.currentPath.shape.points.length === 0) {
                    this.currentPath.shape.points.push(x1, y1);
                }
            } else {
                this.moveTo(x1, y1);
            }
    
            var points = this.currentPath.shape.points;
            var fromX = points[points.length - 2];
            var fromY = points[points.length - 1];
            var a1 = fromY - y1;
            var b1 = fromX - x1;
            var a2 = y2 - y1;
            var b2 = x2 - x1;
            var mm = Math.abs(a1 * b2 - b1 * a2);
    
            if (mm < 1.0e-8 || radius === 0) {
                if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
                    points.push(x1, y1);
                }
            } else {
                var dd = a1 * a1 + b1 * b1;
                var cc = a2 * a2 + b2 * b2;
                var tt = a1 * a2 + b1 * b2;
                var k1 = radius * Math.sqrt(dd) / mm;
                var k2 = radius * Math.sqrt(cc) / mm;
                var j1 = k1 * tt / dd;
                var j2 = k2 * tt / cc;
                var cx = k1 * b2 + k2 * b1;
                var cy = k1 * a2 + k2 * a1;
                var px = b1 * (k2 + j1);
                var py = a1 * (k2 + j1);
                var qx = b2 * (k1 + j2);
                var qy = a2 * (k1 + j2);
                var startAngle = Math.atan2(py - cy, px - cx);
                var endAngle = Math.atan2(qy - cy, qx - cx);
    
                this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
            }
    
            this.dirty++;
    
            return this;
        };
    
        /**
         * The arc method creates an arc/curve (used to create circles, or parts of circles).
         *
         * @param {number} cx - The x-coordinate of the center of the circle
         * @param {number} cy - The y-coordinate of the center of the circle
         * @param {number} radius - The radius of the circle
         * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
         *  of the arc's circle)
         * @param {number} endAngle - The ending angle, in radians
         * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
         *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
         *  indicates counter-clockwise.
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
            var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    
            if (startAngle === endAngle) {
                return this;
            }
    
            if (!anticlockwise && endAngle <= startAngle) {
                endAngle += Math.PI * 2;
            } else if (anticlockwise && startAngle <= endAngle) {
                startAngle += Math.PI * 2;
            }
    
            var sweep = endAngle - startAngle;
            var segs = Math.ceil(Math.abs(sweep) / (Math.PI * 2)) * 40;
    
            if (sweep === 0) {
                return this;
            }
    
            var startX = cx + Math.cos(startAngle) * radius;
            var startY = cy + Math.sin(startAngle) * radius;
    
            // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
            var points = this.currentPath ? this.currentPath.shape.points : null;
    
            if (points) {
                if (points[points.length - 2] !== startX || points[points.length - 1] !== startY) {
                    points.push(startX, startY);
                }
            } else {
                this.moveTo(startX, startY);
                points = this.currentPath.shape.points;
            }
    
            var theta = sweep / (segs * 2);
            var theta2 = theta * 2;
    
            var cTheta = Math.cos(theta);
            var sTheta = Math.sin(theta);
    
            var segMinus = segs - 1;
    
            var remainder = segMinus % 1 / segMinus;
    
            for (var i = 0; i <= segMinus; ++i) {
                var real = i + remainder * i;
    
                var angle = theta + startAngle + theta2 * real;
    
                var c = Math.cos(angle);
                var s = -Math.sin(angle);
    
                points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
            }
    
            this.dirty++;
    
            return this;
        };
    
        /**
         * Specifies a simple one-color fill that subsequent calls to other Graphics methods
         * (such as lineTo() or drawCircle()) use when drawing.
         *
         * @param {number} [color=0] - the color of the fill
         * @param {number} [alpha=1] - the alpha of the fill
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.beginFill = function beginFill() {
            var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    
            this.filling = true;
            this.fillColor = color;
            this.fillAlpha = alpha;
    
            if (this.currentPath) {
                if (this.currentPath.shape.points.length <= 2) {
                    this.currentPath.fill = this.filling;
                    this.currentPath.fillColor = this.fillColor;
                    this.currentPath.fillAlpha = this.fillAlpha;
                }
            }
    
            return this;
        };
    
        /**
         * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
         *
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.endFill = function endFill() {
            this.filling = false;
            this.fillColor = null;
            this.fillAlpha = 1;
    
            return this;
        };
    
        /**
         *
         * @param {number} x - The X coord of the top-left of the rectangle
         * @param {number} y - The Y coord of the top-left of the rectangle
         * @param {number} width - The width of the rectangle
         * @param {number} height - The height of the rectangle
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
            this.drawShape(new _math.Rectangle(x, y, width, height));
    
            return this;
        };
    
        /**
         *
         * @param {number} x - The X coord of the top-left of the rectangle
         * @param {number} y - The Y coord of the top-left of the rectangle
         * @param {number} width - The width of the rectangle
         * @param {number} height - The height of the rectangle
         * @param {number} radius - Radius of the rectangle corners
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
            this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));
    
            return this;
        };
    
        /**
         * Draws a circle.
         *
         * @param {number} x - The X coordinate of the center of the circle
         * @param {number} y - The Y coordinate of the center of the circle
         * @param {number} radius - The radius of the circle
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
            this.drawShape(new _math.Circle(x, y, radius));
    
            return this;
        };
    
        /**
         * Draws an ellipse.
         *
         * @param {number} x - The X coordinate of the center of the ellipse
         * @param {number} y - The Y coordinate of the center of the ellipse
         * @param {number} width - The half width of the ellipse
         * @param {number} height - The half height of the ellipse
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
            this.drawShape(new _math.Ellipse(x, y, width, height));
    
            return this;
        };
    
        /**
         * Draws a polygon using the given path.
         *
         * @param {number[]|PIXI.Point[]} path - The path data used to construct the polygon.
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.drawPolygon = function drawPolygon(path) {
            // prevents an argument assignment deopt
            // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
            var points = path;
    
            var closed = true;
    
            if (points instanceof _math.Polygon) {
                closed = points.closed;
                points = points.points;
            }
    
            if (!Array.isArray(points)) {
                // prevents an argument leak deopt
                // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
                points = new Array(arguments.length);
    
                for (var i = 0; i < points.length; ++i) {
                    points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
                }
            }
    
            var shape = new _math.Polygon(points);
    
            shape.closed = closed;
    
            this.drawShape(shape);
    
            return this;
        };
    
        /**
         * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
         *
         * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
         */
    
    
        Graphics.prototype.clear = function clear() {
            if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
                this.lineWidth = 0;
                this.filling = false;
    
                this.boundsDirty = -1;
                this.dirty++;
                this.clearDirty++;
                this.graphicsData.length = 0;
            }
    
            this.currentPath = null;
            this._spriteRect = null;
    
            return this;
        };
    
        /**
         * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
         * masked with gl.scissor.
         *
         * @returns {boolean} True if only 1 rect.
         */
    
    
        Graphics.prototype.isFastRect = function isFastRect() {
            return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
        };
    
        /**
         * Renders the object using the WebGL renderer
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
            // if the sprite is not visible or the alpha is 0 then no need to render this element
            if (this.dirty !== this.fastRectDirty) {
                this.fastRectDirty = this.dirty;
                this._fastRect = this.isFastRect();
            }
    
            // TODO this check can be moved to dirty?
            if (this._fastRect) {
                this._renderSpriteRect(renderer);
            } else {
                renderer.setObjectRenderer(renderer.plugins.graphics);
                renderer.plugins.graphics.render(this);
            }
        };
    
        /**
         * Renders a sprite rectangle.
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
            var rect = this.graphicsData[0].shape;
    
            if (!this._spriteRect) {
                this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
            }
    
            var sprite = this._spriteRect;
    
            if (this.tint === 0xffffff) {
                sprite.tint = this.graphicsData[0].fillColor;
            } else {
                var t1 = tempColor1;
                var t2 = tempColor2;
    
                (0, _utils.hex2rgb)(this.graphicsData[0].fillColor, t1);
                (0, _utils.hex2rgb)(this.tint, t2);
    
                t1[0] *= t2[0];
                t1[1] *= t2[1];
                t1[2] *= t2[2];
    
                sprite.tint = (0, _utils.rgb2hex)(t1);
            }
            sprite.alpha = this.graphicsData[0].fillAlpha;
            sprite.worldAlpha = this.worldAlpha * sprite.alpha;
            sprite.blendMode = this.blendMode;
    
            sprite.texture._frame.width = rect.width;
            sprite.texture._frame.height = rect.height;
    
            sprite.transform.worldTransform = this.transform.worldTransform;
    
            sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
            sprite._onAnchorUpdate();
    
            sprite._renderWebGL(renderer);
        };
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - The renderer
         */
    
    
        Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
            if (this.isMask === true) {
                return;
            }
    
            renderer.plugins.graphics.render(this);
        };
    
        /**
         * Retrieves the bounds of the graphic shape as a rectangle object
         *
         * @private
         */
    
    
        Graphics.prototype._calculateBounds = function _calculateBounds() {
            if (this.boundsDirty !== this.dirty) {
                this.boundsDirty = this.dirty;
                this.updateLocalBounds();
    
                this.cachedSpriteDirty = true;
            }
    
            var lb = this._localBounds;
    
            this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
        };
    
        /**
         * Tests if a point is inside this graphics object
         *
         * @param {PIXI.Point} point - the point to test
         * @return {boolean} the result of the test
         */
    
    
        Graphics.prototype.containsPoint = function containsPoint(point) {
            this.worldTransform.applyInverse(point, tempPoint);
    
            var graphicsData = this.graphicsData;
    
            for (var i = 0; i < graphicsData.length; ++i) {
                var data = graphicsData[i];
    
                if (!data.fill) {
                    continue;
                }
    
                // only deal with fills..
                if (data.shape) {
                    if (data.shape.contains(tempPoint.x, tempPoint.y)) {
                        return true;
                    }
                }
            }
    
            return false;
        };
    
        /**
         * Update the bounds of the object
         *
         */
    
    
        Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
            var minX = Infinity;
            var maxX = -Infinity;
    
            var minY = Infinity;
            var maxY = -Infinity;
    
            if (this.graphicsData.length) {
                var shape = 0;
                var x = 0;
                var y = 0;
                var w = 0;
                var h = 0;
    
                for (var i = 0; i < this.graphicsData.length; i++) {
                    var data = this.graphicsData[i];
                    var type = data.type;
                    var lineWidth = data.lineWidth;
    
                    shape = data.shape;
    
                    if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
                        x = shape.x - lineWidth / 2;
                        y = shape.y - lineWidth / 2;
                        w = shape.width + lineWidth;
                        h = shape.height + lineWidth;
    
                        minX = x < minX ? x : minX;
                        maxX = x + w > maxX ? x + w : maxX;
    
                        minY = y < minY ? y : minY;
                        maxY = y + h > maxY ? y + h : maxY;
                    } else if (type === _const.SHAPES.CIRC) {
                        x = shape.x;
                        y = shape.y;
                        w = shape.radius + lineWidth / 2;
                        h = shape.radius + lineWidth / 2;
    
                        minX = x - w < minX ? x - w : minX;
                        maxX = x + w > maxX ? x + w : maxX;
    
                        minY = y - h < minY ? y - h : minY;
                        maxY = y + h > maxY ? y + h : maxY;
                    } else if (type === _const.SHAPES.ELIP) {
                        x = shape.x;
                        y = shape.y;
                        w = shape.width + lineWidth / 2;
                        h = shape.height + lineWidth / 2;
    
                        minX = x - w < minX ? x - w : minX;
                        maxX = x + w > maxX ? x + w : maxX;
    
                        minY = y - h < minY ? y - h : minY;
                        maxY = y + h > maxY ? y + h : maxY;
                    } else {
                        // POLY
                        var points = shape.points;
                        var x2 = 0;
                        var y2 = 0;
                        var dx = 0;
                        var dy = 0;
                        var rw = 0;
                        var rh = 0;
                        var cx = 0;
                        var cy = 0;
    
                        for (var j = 0; j + 2 < points.length; j += 2) {
                            x = points[j];
                            y = points[j + 1];
                            x2 = points[j + 2];
                            y2 = points[j + 3];
                            dx = Math.abs(x2 - x);
                            dy = Math.abs(y2 - y);
                            h = lineWidth;
                            w = Math.sqrt(dx * dx + dy * dy);
    
                            if (w < 1e-9) {
                                continue;
                            }
    
                            rw = (h / w * dy + dx) / 2;
                            rh = (h / w * dx + dy) / 2;
                            cx = (x2 + x) / 2;
                            cy = (y2 + y) / 2;
    
                            minX = cx - rw < minX ? cx - rw : minX;
                            maxX = cx + rw > maxX ? cx + rw : maxX;
    
                            minY = cy - rh < minY ? cy - rh : minY;
                            maxY = cy + rh > maxY ? cy + rh : maxY;
                        }
                    }
                }
            } else {
                minX = 0;
                maxX = 0;
                minY = 0;
                maxY = 0;
            }
    
            var padding = this.boundsPadding;
    
            this._localBounds.minX = minX - padding;
            this._localBounds.maxX = maxX + padding * 2;
    
            this._localBounds.minY = minY - padding;
            this._localBounds.maxY = maxY + padding * 2;
        };
    
        /**
         * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
         *
         * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
         * @return {PIXI.GraphicsData} The generated GraphicsData object.
         */
    
    
        Graphics.prototype.drawShape = function drawShape(shape) {
            if (this.currentPath) {
                // check current path!
                if (this.currentPath.shape.points.length <= 2) {
                    this.graphicsData.pop();
                }
            }
    
            this.currentPath = null;
    
            var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape);
    
            this.graphicsData.push(data);
    
            if (data.type === _const.SHAPES.POLY) {
                data.shape.closed = data.shape.closed || this.filling;
                this.currentPath = data;
            }
    
            this.dirty++;
    
            return data;
        };
    
        /**
         * Generates a canvas texture.
         *
         * @param {number} scaleMode - The scale mode of the texture.
         * @param {number} resolution - The resolution of the texture.
         * @return {PIXI.Texture} The new texture.
         */
    
    
        Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
            var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    
            var bounds = this.getLocalBounds();
    
            var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);
    
            if (!canvasRenderer) {
                canvasRenderer = new _CanvasRenderer2.default();
            }
    
            this.transform.updateLocalTransform();
            this.transform.localTransform.copy(tempMatrix);
    
            tempMatrix.invert();
    
            tempMatrix.tx -= bounds.x;
            tempMatrix.ty -= bounds.y;
    
            canvasRenderer.render(this, canvasBuffer, true, tempMatrix);
    
            var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode);
    
            texture.baseTexture.resolution = resolution;
            texture.baseTexture.update();
    
            return texture;
        };
    
        /**
         * Closes the current path.
         *
         * @return {PIXI.Graphics} Returns itself.
         */
    
    
        Graphics.prototype.closePath = function closePath() {
            // ok so close path assumes next one is a hole!
            var currentPath = this.currentPath;
    
            if (currentPath && currentPath.shape) {
                currentPath.shape.close();
            }
    
            return this;
        };
    
        /**
         * Adds a hole in the current path.
         *
         * @return {PIXI.Graphics} Returns itself.
         */
    
    
        Graphics.prototype.addHole = function addHole() {
            // this is a hole!
            var hole = this.graphicsData.pop();
    
            this.currentPath = this.graphicsData[this.graphicsData.length - 1];
    
            this.currentPath.addHole(hole.shape);
            this.currentPath = null;
    
            return this;
        };
    
        /**
         * Destroys the Graphics object.
         *
         * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
         *  options have been set to that value
         * @param {boolean} [options.children=false] - if set to true, all the children will have
         *  their destroy method called as well. 'options' will be passed on to those calls.
         * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the texture of the child sprite
         * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the base texture of the child sprite
         */
    
    
        Graphics.prototype.destroy = function destroy(options) {
            _Container.prototype.destroy.call(this, options);
    
            // destroy each of the GraphicsData objects
            for (var i = 0; i < this.graphicsData.length; ++i) {
                this.graphicsData[i].destroy();
            }
    
            // for each webgl data entry, destroy the WebGLGraphicsData
            for (var id in this._webgl) {
                for (var j = 0; j < this._webgl[id].data.length; ++j) {
                    this._webgl[id].data[j].destroy();
                }
            }
    
            if (this._spriteRect) {
                this._spriteRect.destroy();
            }
    
            this.graphicsData = null;
    
            this.currentPath = null;
            this._webgl = null;
            this._localBounds = null;
        };
    
        return Graphics;
    }(_Container3.default);
    
    exports.default = Graphics;
    
    
    Graphics._SPRITE_TEXTURE = null;
    
    },{"../const":45,"../display/Bounds":46,"../display/Container":47,"../math":69,"../renderers/canvas/CanvasRenderer":76,"../sprites/Sprite":101,"../textures/RenderTexture":111,"../textures/Texture":113,"../utils":121,"./GraphicsData":53,"./utils/bezierCurveTo":55}],53:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * A GraphicsData object.
     *
     * @class
     * @memberof PIXI
     */
    var GraphicsData = function () {
      /**
       *
       * @param {number} lineWidth - the width of the line to draw
       * @param {number} lineColor - the color of the line to draw
       * @param {number} lineAlpha - the alpha of the line to draw
       * @param {number} fillColor - the color of the fill
       * @param {number} fillAlpha - the alpha of the fill
       * @param {boolean} fill - whether or not the shape is filled with a colour
       * @param {boolean} nativeLines - the method for drawing lines
       * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
       */
      function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape) {
        _classCallCheck(this, GraphicsData);
    
        /**
         * @member {number} the width of the line to draw
         */
        this.lineWidth = lineWidth;
        /**
         * @member {boolean} if true the liens will be draw using LINES instead of TRIANGLE_STRIP
         */
        this.nativeLines = nativeLines;
    
        /**
         * @member {number} the color of the line to draw
         */
        this.lineColor = lineColor;
    
        /**
         * @member {number} the alpha of the line to draw
         */
        this.lineAlpha = lineAlpha;
    
        /**
         * @member {number} cached tint of the line to draw
         */
        this._lineTint = lineColor;
    
        /**
         * @member {number} the color of the fill
         */
        this.fillColor = fillColor;
    
        /**
         * @member {number} the alpha of the fill
         */
        this.fillAlpha = fillAlpha;
    
        /**
         * @member {number} cached tint of the fill
         */
        this._fillTint = fillColor;
    
        /**
         * @member {boolean} whether or not the shape is filled with a colour
         */
        this.fill = fill;
    
        this.holes = [];
    
        /**
         * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} The shape object to draw.
         */
        this.shape = shape;
    
        /**
         * @member {number} The type of the shape, see the Const.Shapes file for all the existing types,
         */
        this.type = shape.type;
      }
    
      /**
       * Creates a new GraphicsData object with the same values as this one.
       *
       * @return {PIXI.GraphicsData} Cloned GraphicsData object
       */
    
    
      GraphicsData.prototype.clone = function clone() {
        return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape);
      };
    
      /**
       * Adds a hole to the shape.
       *
       * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
       */
    
    
      GraphicsData.prototype.addHole = function addHole(shape) {
        this.holes.push(shape);
      };
    
      /**
       * Destroys the Graphics data.
       */
    
    
      GraphicsData.prototype.destroy = function destroy() {
        this.shape = null;
        this.holes = null;
      };
    
      return GraphicsData;
    }();
    
    exports.default = GraphicsData;
    
    },{}],54:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _CanvasRenderer = require('../../renderers/canvas/CanvasRenderer');
    
    var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
    
    var _const = require('../../const');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @author Mat Groves
     *
     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
     * for creating the original pixi version!
     * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
     * now share 4 bytes on the vertex buffer
     *
     * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
     * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
     */
    
    /**
     * Renderer dedicated to drawing and batching graphics objects.
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var CanvasGraphicsRenderer = function () {
        /**
         * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
         */
        function CanvasGraphicsRenderer(renderer) {
            _classCallCheck(this, CanvasGraphicsRenderer);
    
            this.renderer = renderer;
        }
    
        /**
         * Renders a Graphics object to a canvas.
         *
         * @param {PIXI.Graphics} graphics - the actual graphics object to render
         */
    
    
        CanvasGraphicsRenderer.prototype.render = function render(graphics) {
            var renderer = this.renderer;
            var context = renderer.context;
            var worldAlpha = graphics.worldAlpha;
            var transform = graphics.transform.worldTransform;
            var resolution = renderer.resolution;
    
            // if the tint has changed, set the graphics object to dirty.
            if (this._prevTint !== this.tint) {
                this.dirty = true;
            }
    
            context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
    
            if (graphics.dirty) {
                this.updateGraphicsTint(graphics);
                graphics.dirty = false;
            }
    
            renderer.setBlendMode(graphics.blendMode);
    
            for (var i = 0; i < graphics.graphicsData.length; i++) {
                var data = graphics.graphicsData[i];
                var shape = data.shape;
    
                var fillColor = data._fillTint;
                var lineColor = data._lineTint;
    
                context.lineWidth = data.lineWidth;
    
                if (data.type === _const.SHAPES.POLY) {
                    context.beginPath();
    
                    this.renderPolygon(shape.points, shape.closed, context);
    
                    for (var j = 0; j < data.holes.length; j++) {
                        this.renderPolygon(data.holes[j].points, true, context);
                    }
    
                    if (data.fill) {
                        context.globalAlpha = data.fillAlpha * worldAlpha;
                        context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                        context.fill();
                    }
                    if (data.lineWidth) {
                        context.globalAlpha = data.lineAlpha * worldAlpha;
                        context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                        context.stroke();
                    }
                } else if (data.type === _const.SHAPES.RECT) {
                    if (data.fillColor || data.fillColor === 0) {
                        context.globalAlpha = data.fillAlpha * worldAlpha;
                        context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                        context.fillRect(shape.x, shape.y, shape.width, shape.height);
                    }
                    if (data.lineWidth) {
                        context.globalAlpha = data.lineAlpha * worldAlpha;
                        context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                        context.strokeRect(shape.x, shape.y, shape.width, shape.height);
                    }
                } else if (data.type === _const.SHAPES.CIRC) {
                    // TODO - need to be Undefined!
                    context.beginPath();
                    context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                    context.closePath();
    
                    if (data.fill) {
                        context.globalAlpha = data.fillAlpha * worldAlpha;
                        context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                        context.fill();
                    }
                    if (data.lineWidth) {
                        context.globalAlpha = data.lineAlpha * worldAlpha;
                        context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                        context.stroke();
                    }
                } else if (data.type === _const.SHAPES.ELIP) {
                    // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
    
                    var w = shape.width * 2;
                    var h = shape.height * 2;
    
                    var x = shape.x - w / 2;
                    var y = shape.y - h / 2;
    
                    context.beginPath();
    
                    var kappa = 0.5522848;
                    var ox = w / 2 * kappa; // control point offset horizontal
                    var oy = h / 2 * kappa; // control point offset vertical
                    var xe = x + w; // x-end
                    var ye = y + h; // y-end
                    var xm = x + w / 2; // x-middle
                    var ym = y + h / 2; // y-middle
    
                    context.moveTo(x, ym);
                    context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                    context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                    context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                    context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
    
                    context.closePath();
    
                    if (data.fill) {
                        context.globalAlpha = data.fillAlpha * worldAlpha;
                        context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                        context.fill();
                    }
                    if (data.lineWidth) {
                        context.globalAlpha = data.lineAlpha * worldAlpha;
                        context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                        context.stroke();
                    }
                } else if (data.type === _const.SHAPES.RREC) {
                    var rx = shape.x;
                    var ry = shape.y;
                    var width = shape.width;
                    var height = shape.height;
                    var radius = shape.radius;
    
                    var maxRadius = Math.min(width, height) / 2 | 0;
    
                    radius = radius > maxRadius ? maxRadius : radius;
    
                    context.beginPath();
                    context.moveTo(rx, ry + radius);
                    context.lineTo(rx, ry + height - radius);
                    context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                    context.lineTo(rx + width - radius, ry + height);
                    context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                    context.lineTo(rx + width, ry + radius);
                    context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                    context.lineTo(rx + radius, ry);
                    context.quadraticCurveTo(rx, ry, rx, ry + radius);
                    context.closePath();
    
                    if (data.fillColor || data.fillColor === 0) {
                        context.globalAlpha = data.fillAlpha * worldAlpha;
                        context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                        context.fill();
                    }
    
                    if (data.lineWidth) {
                        context.globalAlpha = data.lineAlpha * worldAlpha;
                        context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                        context.stroke();
                    }
                }
            }
        };
    
        /**
         * Updates the tint of a graphics object
         *
         * @private
         * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
         */
    
    
        CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
            graphics._prevTint = graphics.tint;
    
            var tintR = (graphics.tint >> 16 & 0xFF) / 255;
            var tintG = (graphics.tint >> 8 & 0xFF) / 255;
            var tintB = (graphics.tint & 0xFF) / 255;
    
            for (var i = 0; i < graphics.graphicsData.length; ++i) {
                var data = graphics.graphicsData[i];
    
                var fillColor = data.fillColor | 0;
                var lineColor = data.lineColor | 0;
    
                // super inline cos im an optimization NAZI :)
                data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;
    
                data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
            }
        };
    
        /**
         * Renders a polygon.
         *
         * @param {PIXI.Point[]} points - The points to render
         * @param {boolean} close - Should the polygon be closed
         * @param {CanvasRenderingContext2D} context - The rendering context to use
         */
    
    
        CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
            context.moveTo(points[0], points[1]);
    
            for (var j = 1; j < points.length / 2; ++j) {
                context.lineTo(points[j * 2], points[j * 2 + 1]);
            }
    
            if (close) {
                context.closePath();
            }
        };
    
        /**
         * destroy graphics object
         *
         */
    
    
        CanvasGraphicsRenderer.prototype.destroy = function destroy() {
            this.renderer = null;
        };
    
        return CanvasGraphicsRenderer;
    }();
    
    exports.default = CanvasGraphicsRenderer;
    
    
    _CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
    
    },{"../../const":45,"../../renderers/canvas/CanvasRenderer":76}],55:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    exports.default = bezierCurveTo;
    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @param {number} fromX - Starting point x
     * @param {number} fromY - Starting point y
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} [path=[]] - Path array to push points into
     * @return {number[]} Array of points of the curve
     */
    function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        var path = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
    
        var n = 20;
        var dt = 0;
        var dt2 = 0;
        var dt3 = 0;
        var t2 = 0;
        var t3 = 0;
    
        path.push(fromX, fromY);
    
        for (var i = 1, j = 0; i <= n; ++i) {
            j = i / n;
    
            dt = 1 - j;
            dt2 = dt * dt;
            dt3 = dt2 * dt;
    
            t2 = j * j;
            t3 = t2 * j;
    
            path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
        }
    
        return path;
    }
    
    },{}],56:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _utils = require('../../utils');
    
    var _const = require('../../const');
    
    var _ObjectRenderer2 = require('../../renderers/webgl/utils/ObjectRenderer');
    
    var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
    
    var _WebGLRenderer = require('../../renderers/webgl/WebGLRenderer');
    
    var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
    
    var _WebGLGraphicsData = require('./WebGLGraphicsData');
    
    var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);
    
    var _PrimitiveShader = require('./shaders/PrimitiveShader');
    
    var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);
    
    var _buildPoly = require('./utils/buildPoly');
    
    var _buildPoly2 = _interopRequireDefault(_buildPoly);
    
    var _buildRectangle = require('./utils/buildRectangle');
    
    var _buildRectangle2 = _interopRequireDefault(_buildRectangle);
    
    var _buildRoundedRectangle = require('./utils/buildRoundedRectangle');
    
    var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);
    
    var _buildCircle = require('./utils/buildCircle');
    
    var _buildCircle2 = _interopRequireDefault(_buildCircle);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * Renders the graphics object.
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.ObjectRenderer
     */
    var GraphicsRenderer = function (_ObjectRenderer) {
        _inherits(GraphicsRenderer, _ObjectRenderer);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
         */
        function GraphicsRenderer(renderer) {
            _classCallCheck(this, GraphicsRenderer);
    
            var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
    
            _this.graphicsDataPool = [];
    
            _this.primitiveShader = null;
    
            _this.gl = renderer.gl;
    
            // easy access!
            _this.CONTEXT_UID = 0;
            return _this;
        }
    
        /**
         * Called when there is a WebGL context change
         *
         * @private
         *
         */
    
    
        GraphicsRenderer.prototype.onContextChange = function onContextChange() {
            this.gl = this.renderer.gl;
            this.CONTEXT_UID = this.renderer.CONTEXT_UID;
            this.primitiveShader = new _PrimitiveShader2.default(this.gl);
        };
    
        /**
         * Destroys this renderer.
         *
         */
    
    
        GraphicsRenderer.prototype.destroy = function destroy() {
            _ObjectRenderer3.default.prototype.destroy.call(this);
    
            for (var i = 0; i < this.graphicsDataPool.length; ++i) {
                this.graphicsDataPool[i].destroy();
            }
    
            this.graphicsDataPool = null;
        };
    
        /**
         * Renders a graphics object.
         *
         * @param {PIXI.Graphics} graphics - The graphics object to render.
         */
    
    
        GraphicsRenderer.prototype.render = function render(graphics) {
            var renderer = this.renderer;
            var gl = renderer.gl;
    
            var webGLData = void 0;
            var webGL = graphics._webGL[this.CONTEXT_UID];
    
            if (!webGL || graphics.dirty !== webGL.dirty) {
                this.updateGraphics(graphics);
    
                webGL = graphics._webGL[this.CONTEXT_UID];
            }
    
            // This  could be speeded up for sure!
            var shader = this.primitiveShader;
    
            renderer.bindShader(shader);
            renderer.state.setBlendMode(graphics.blendMode);
    
            for (var i = 0, n = webGL.data.length; i < n; i++) {
                webGLData = webGL.data[i];
                var shaderTemp = webGLData.shader;
    
                renderer.bindShader(shaderTemp);
                shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
                shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
                shaderTemp.uniforms.alpha = graphics.worldAlpha;
    
                renderer.bindVao(webGLData.vao);
    
                if (graphics.nativeLines) {
                    gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
                } else {
                    webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
                }
            }
        };
    
        /**
         * Updates the graphics object
         *
         * @private
         * @param {PIXI.Graphics} graphics - The graphics object to update
         */
    
    
        GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
            var gl = this.renderer.gl;
    
            // get the contexts graphics object
            var webGL = graphics._webGL[this.CONTEXT_UID];
    
            // if the graphics object does not exist in the webGL context time to create it!
            if (!webGL) {
                webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
            }
    
            // flag the graphics as not dirty as we are about to update it...
            webGL.dirty = graphics.dirty;
    
            // if the user cleared the graphics object we will need to clear every object
            if (graphics.clearDirty !== webGL.clearDirty) {
                webGL.clearDirty = graphics.clearDirty;
    
                // loop through and return all the webGLDatas to the object pool so than can be reused later on
                for (var i = 0; i < webGL.data.length; i++) {
                    this.graphicsDataPool.push(webGL.data[i]);
                }
    
                // clear the array and reset the index..
                webGL.data.length = 0;
                webGL.lastIndex = 0;
            }
    
            var webGLData = void 0;
    
            // loop through the graphics datas and construct each one..
            // if the object is a complex fill then the new stencil buffer technique will be used
            // other wise graphics objects will be pushed into a batch..
            for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
                var data = graphics.graphicsData[_i];
    
                // TODO - this can be simplified
                webGLData = this.getWebGLData(webGL, 0);
    
                if (data.type === _const.SHAPES.POLY) {
                    (0, _buildPoly2.default)(data, webGLData);
                }
                if (data.type === _const.SHAPES.RECT) {
                    (0, _buildRectangle2.default)(data, webGLData);
                } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
                    (0, _buildCircle2.default)(data, webGLData);
                } else if (data.type === _const.SHAPES.RREC) {
                    (0, _buildRoundedRectangle2.default)(data, webGLData);
                }
    
                webGL.lastIndex++;
            }
    
            this.renderer.bindVao(null);
    
            // upload all the dirty data...
            for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
                webGLData = webGL.data[_i2];
    
                if (webGLData.dirty) {
                    webGLData.upload();
                }
            }
        };
    
        /**
         *
         * @private
         * @param {WebGLRenderingContext} gl - the current WebGL drawing context
         * @param {number} type - TODO @Alvin
         * @return {*} TODO
         */
    
    
        GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type) {
            var webGLData = gl.data[gl.data.length - 1];
    
            if (!webGLData || webGLData.points.length > 320000) {
                webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
    
                webGLData.reset(type);
                gl.data.push(webGLData);
            }
    
            webGLData.dirty = true;
    
            return webGLData;
        };
    
        return GraphicsRenderer;
    }(_ObjectRenderer3.default);
    
    exports.default = GraphicsRenderer;
    
    
    _WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
    
    },{"../../const":45,"../../renderers/webgl/WebGLRenderer":83,"../../renderers/webgl/utils/ObjectRenderer":93,"../../utils":121,"./WebGLGraphicsData":57,"./shaders/PrimitiveShader":58,"./utils/buildCircle":59,"./utils/buildPoly":61,"./utils/buildRectangle":62,"./utils/buildRoundedRectangle":63}],57:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * An object containing WebGL specific properties to be used by the WebGL renderer
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var WebGLGraphicsData = function () {
      /**
       * @param {WebGLRenderingContext} gl - The current WebGL drawing context
       * @param {PIXI.Shader} shader - The shader
       * @param {object} attribsState - The state for the VAO
       */
      function WebGLGraphicsData(gl, shader, attribsState) {
        _classCallCheck(this, WebGLGraphicsData);
    
        /**
         * The current WebGL drawing context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        // TODO does this need to be split before uploading??
        /**
         * An array of color components (r,g,b)
         * @member {number[]}
         */
        this.color = [0, 0, 0]; // color split!
    
        /**
         * An array of points to draw
         * @member {PIXI.Point[]}
         */
        this.points = [];
    
        /**
         * The indices of the vertices
         * @member {number[]}
         */
        this.indices = [];
        /**
         * The main buffer
         * @member {WebGLBuffer}
         */
        this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);
    
        /**
         * The index buffer
         * @member {WebGLBuffer}
         */
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);
    
        /**
         * Whether this graphics is dirty or not
         * @member {boolean}
         */
        this.dirty = true;
    
        this.glPoints = null;
        this.glIndices = null;
    
        /**
         *
         * @member {PIXI.Shader}
         */
        this.shader = shader;
    
        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
      }
    
      /**
       * Resets the vertices and the indices
       */
    
    
      WebGLGraphicsData.prototype.reset = function reset() {
        this.points.length = 0;
        this.indices.length = 0;
      };
    
      /**
       * Binds the buffers and uploads the data
       */
    
    
      WebGLGraphicsData.prototype.upload = function upload() {
        this.glPoints = new Float32Array(this.points);
        this.buffer.upload(this.glPoints);
    
        this.glIndices = new Uint16Array(this.indices);
        this.indexBuffer.upload(this.glIndices);
    
        this.dirty = false;
      };
    
      /**
       * Empties all the data
       */
    
    
      WebGLGraphicsData.prototype.destroy = function destroy() {
        this.color = null;
        this.points = null;
        this.indices = null;
    
        this.vao.destroy();
        this.buffer.destroy();
        this.indexBuffer.destroy();
    
        this.gl = null;
    
        this.buffer = null;
        this.indexBuffer = null;
    
        this.glPoints = null;
        this.glIndices = null;
      };
    
      return WebGLGraphicsData;
    }();
    
    exports.default = WebGLGraphicsData;
    
    },{"pixi-gl-core":16}],58:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Shader2 = require('../../../Shader');
    
    var _Shader3 = _interopRequireDefault(_Shader2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.Shader
     */
    var PrimitiveShader = function (_Shader) {
        _inherits(PrimitiveShader, _Shader);
    
        /**
         * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
         */
        function PrimitiveShader(gl) {
            _classCallCheck(this, PrimitiveShader);
    
            return _possibleConstructorReturn(this, _Shader.call(this, gl,
            // vertex shader
            ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
            // fragment shader
            ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
        }
    
        return PrimitiveShader;
    }(_Shader3.default);
    
    exports.default = PrimitiveShader;
    
    },{"../../../Shader":43}],59:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = buildCircle;
    
    var _buildLine = require('./buildLine');
    
    var _buildLine2 = _interopRequireDefault(_buildLine);
    
    var _const = require('../../../const');
    
    var _utils = require('../../../utils');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Builds a circle to draw
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildCircle(graphicsData, webGLData) {
        // need to convert points to a nice regular data
        var circleData = graphicsData.shape;
        var x = circleData.x;
        var y = circleData.y;
        var width = void 0;
        var height = void 0;
    
        // TODO - bit hacky??
        if (graphicsData.type === _const.SHAPES.CIRC) {
            width = circleData.radius;
            height = circleData.radius;
        } else {
            width = circleData.width;
            height = circleData.height;
        }
    
        if (width === 0 || height === 0) {
            return;
        }
    
        var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));
    
        var seg = Math.PI * 2 / totalSegs;
    
        if (graphicsData.fill) {
            var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
            var alpha = graphicsData.fillAlpha;
    
            var r = color[0] * alpha;
            var g = color[1] * alpha;
            var b = color[2] * alpha;
    
            var verts = webGLData.points;
            var indices = webGLData.indices;
    
            var vecPos = verts.length / 6;
    
            indices.push(vecPos);
    
            for (var i = 0; i < totalSegs + 1; i++) {
                verts.push(x, y, r, g, b, alpha);
    
                verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);
    
                indices.push(vecPos++, vecPos++);
            }
    
            indices.push(vecPos - 1);
        }
    
        if (graphicsData.lineWidth) {
            var tempPoints = graphicsData.points;
    
            graphicsData.points = [];
    
            for (var _i = 0; _i < totalSegs + 1; _i++) {
                graphicsData.points.push(x + Math.sin(seg * _i) * width, y + Math.cos(seg * _i) * height);
            }
    
            (0, _buildLine2.default)(graphicsData, webGLData);
    
            graphicsData.points = tempPoints;
        }
    }
    
    },{"../../../const":45,"../../../utils":121,"./buildLine":60}],60:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    exports.default = function (graphicsData, webGLData) {
        if (graphicsData.nativeLines) {
            buildNativeLine(graphicsData, webGLData);
        } else {
            buildLine(graphicsData, webGLData);
        }
    };
    
    var _math = require('../../../math');
    
    var _utils = require('../../../utils');
    
    /**
     * Builds a line to draw using the poligon method.
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildLine(graphicsData, webGLData) {
        // TODO OPTIMISE!
        var points = graphicsData.points;
    
        if (points.length === 0) {
            return;
        }
        // if the line width is an odd number add 0.5 to align to a whole pixel
        // commenting this out fixes #711 and #1620
        // if (graphicsData.lineWidth%2)
        // {
        //     for (i = 0; i < points.length; i++)
        //     {
        //         points[i] += 0.5;
        //     }
        // }
    
        // get first and last point.. figure out the middle!
        var firstPoint = new _math.Point(points[0], points[1]);
        var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
    
        // if the first point is the last point - gonna have issues :)
        if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
            // need to clone as we are going to slightly modify the shape..
            points = points.slice();
    
            points.pop();
            points.pop();
    
            lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);
    
            var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
            var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;
    
            points.unshift(midPointX, midPointY);
            points.push(midPointX, midPointY);
        }
    
        var verts = webGLData.points;
        var indices = webGLData.indices;
        var length = points.length / 2;
        var indexCount = points.length;
        var indexStart = verts.length / 6;
    
        // DRAW the Line
        var width = graphicsData.lineWidth / 2;
    
        // sort color
        var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
        var alpha = graphicsData.lineAlpha;
        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;
    
        var p1x = points[0];
        var p1y = points[1];
        var p2x = points[2];
        var p2y = points[3];
        var p3x = 0;
        var p3y = 0;
    
        var perpx = -(p1y - p2y);
        var perpy = p1x - p2x;
        var perp2x = 0;
        var perp2y = 0;
        var perp3x = 0;
        var perp3y = 0;
    
        var dist = Math.sqrt(perpx * perpx + perpy * perpy);
    
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;
    
        // start
        verts.push(p1x - perpx, p1y - perpy, r, g, b, alpha);
    
        verts.push(p1x + perpx, p1y + perpy, r, g, b, alpha);
    
        for (var i = 1; i < length - 1; ++i) {
            p1x = points[(i - 1) * 2];
            p1y = points[(i - 1) * 2 + 1];
    
            p2x = points[i * 2];
            p2y = points[i * 2 + 1];
    
            p3x = points[(i + 1) * 2];
            p3y = points[(i + 1) * 2 + 1];
    
            perpx = -(p1y - p2y);
            perpy = p1x - p2x;
    
            dist = Math.sqrt(perpx * perpx + perpy * perpy);
            perpx /= dist;
            perpy /= dist;
            perpx *= width;
            perpy *= width;
    
            perp2x = -(p2y - p3y);
            perp2y = p2x - p3x;
    
            dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
            perp2x /= dist;
            perp2y /= dist;
            perp2x *= width;
            perp2y *= width;
    
            var a1 = -perpy + p1y - (-perpy + p2y);
            var b1 = -perpx + p2x - (-perpx + p1x);
            var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
            var a2 = -perp2y + p3y - (-perp2y + p2y);
            var b2 = -perp2x + p2x - (-perp2x + p3x);
            var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);
    
            var denom = a1 * b2 - a2 * b1;
    
            if (Math.abs(denom) < 0.1) {
                denom += 10.1;
                verts.push(p2x - perpx, p2y - perpy, r, g, b, alpha);
    
                verts.push(p2x + perpx, p2y + perpy, r, g, b, alpha);
    
                continue;
            }
    
            var px = (b1 * c2 - b2 * c1) / denom;
            var py = (a2 * c1 - a1 * c2) / denom;
            var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);
    
            if (pdist > 196 * width * width) {
                perp3x = perpx - perp2x;
                perp3y = perpy - perp2y;
    
                dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
                perp3x /= dist;
                perp3y /= dist;
                perp3x *= width;
                perp3y *= width;
    
                verts.push(p2x - perp3x, p2y - perp3y);
                verts.push(r, g, b, alpha);
    
                verts.push(p2x + perp3x, p2y + perp3y);
                verts.push(r, g, b, alpha);
    
                verts.push(p2x - perp3x, p2y - perp3y);
                verts.push(r, g, b, alpha);
    
                indexCount++;
            } else {
                verts.push(px, py);
                verts.push(r, g, b, alpha);
    
                verts.push(p2x - (px - p2x), p2y - (py - p2y));
                verts.push(r, g, b, alpha);
            }
        }
    
        p1x = points[(length - 2) * 2];
        p1y = points[(length - 2) * 2 + 1];
    
        p2x = points[(length - 1) * 2];
        p2y = points[(length - 1) * 2 + 1];
    
        perpx = -(p1y - p2y);
        perpy = p1x - p2x;
    
        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;
    
        verts.push(p2x - perpx, p2y - perpy);
        verts.push(r, g, b, alpha);
    
        verts.push(p2x + perpx, p2y + perpy);
        verts.push(r, g, b, alpha);
    
        indices.push(indexStart);
    
        for (var _i = 0; _i < indexCount; ++_i) {
            indices.push(indexStart++);
        }
    
        indices.push(indexStart - 1);
    }
    
    /**
     * Builds a line to draw using the gl.drawArrays(gl.LINES) method
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    
    
    /**
     * Builds a line to draw
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildNativeLine(graphicsData, webGLData) {
        var i = 0;
        var points = graphicsData.points;
    
        if (points.length === 0) return;
    
        var verts = webGLData.points;
        var length = points.length / 2;
    
        // sort color
        var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
        var alpha = graphicsData.lineAlpha;
        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;
    
        for (i = 1; i < length; i++) {
            var p1x = points[(i - 1) * 2];
            var p1y = points[(i - 1) * 2 + 1];
    
            var p2x = points[i * 2];
            var p2y = points[i * 2 + 1];
    
            verts.push(p1x, p1y);
            verts.push(r, g, b, alpha);
    
            verts.push(p2x, p2y);
            verts.push(r, g, b, alpha);
        }
    }
    
    },{"../../../math":69,"../../../utils":121}],61:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = buildPoly;
    
    var _buildLine = require('./buildLine');
    
    var _buildLine2 = _interopRequireDefault(_buildLine);
    
    var _utils = require('../../../utils');
    
    var _earcut = require('earcut');
    
    var _earcut2 = _interopRequireDefault(_earcut);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Builds a polygon to draw
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildPoly(graphicsData, webGLData) {
        graphicsData.points = graphicsData.shape.points.slice();
    
        var points = graphicsData.points;
    
        if (graphicsData.fill && points.length >= 6) {
            var holeArray = [];
            // Process holes..
            var holes = graphicsData.holes;
    
            for (var i = 0; i < holes.length; i++) {
                var hole = holes[i];
    
                holeArray.push(points.length / 2);
    
                points = points.concat(hole.points);
            }
    
            // get first and last point.. figure out the middle!
            var verts = webGLData.points;
            var indices = webGLData.indices;
    
            var length = points.length / 2;
    
            // sort color
            var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
            var alpha = graphicsData.fillAlpha;
            var r = color[0] * alpha;
            var g = color[1] * alpha;
            var b = color[2] * alpha;
    
            var triangles = (0, _earcut2.default)(points, holeArray, 2);
    
            if (!triangles) {
                return;
            }
    
            var vertPos = verts.length / 6;
    
            for (var _i = 0; _i < triangles.length; _i += 3) {
                indices.push(triangles[_i] + vertPos);
                indices.push(triangles[_i] + vertPos);
                indices.push(triangles[_i + 1] + vertPos);
                indices.push(triangles[_i + 2] + vertPos);
                indices.push(triangles[_i + 2] + vertPos);
            }
    
            for (var _i2 = 0; _i2 < length; _i2++) {
                verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
            }
        }
    
        if (graphicsData.lineWidth > 0) {
            (0, _buildLine2.default)(graphicsData, webGLData);
        }
    }
    
    },{"../../../utils":121,"./buildLine":60,"earcut":3}],62:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = buildRectangle;
    
    var _buildLine = require('./buildLine');
    
    var _buildLine2 = _interopRequireDefault(_buildLine);
    
    var _utils = require('../../../utils');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Builds a rectangle to draw
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildRectangle(graphicsData, webGLData) {
        // --- //
        // need to convert points to a nice regular data
        //
        var rectData = graphicsData.shape;
        var x = rectData.x;
        var y = rectData.y;
        var width = rectData.width;
        var height = rectData.height;
    
        if (graphicsData.fill) {
            var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
            var alpha = graphicsData.fillAlpha;
    
            var r = color[0] * alpha;
            var g = color[1] * alpha;
            var b = color[2] * alpha;
    
            var verts = webGLData.points;
            var indices = webGLData.indices;
    
            var vertPos = verts.length / 6;
    
            // start
            verts.push(x, y);
            verts.push(r, g, b, alpha);
    
            verts.push(x + width, y);
            verts.push(r, g, b, alpha);
    
            verts.push(x, y + height);
            verts.push(r, g, b, alpha);
    
            verts.push(x + width, y + height);
            verts.push(r, g, b, alpha);
    
            // insert 2 dead triangles..
            indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
        }
    
        if (graphicsData.lineWidth) {
            var tempPoints = graphicsData.points;
    
            graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];
    
            (0, _buildLine2.default)(graphicsData, webGLData);
    
            graphicsData.points = tempPoints;
        }
    }
    
    },{"../../../utils":121,"./buildLine":60}],63:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = buildRoundedRectangle;
    
    var _earcut = require('earcut');
    
    var _earcut2 = _interopRequireDefault(_earcut);
    
    var _buildLine = require('./buildLine');
    
    var _buildLine2 = _interopRequireDefault(_buildLine);
    
    var _utils = require('../../../utils');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Builds a rounded rectangle to draw
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
     * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
     */
    function buildRoundedRectangle(graphicsData, webGLData) {
        var rrectData = graphicsData.shape;
        var x = rrectData.x;
        var y = rrectData.y;
        var width = rrectData.width;
        var height = rrectData.height;
    
        var radius = rrectData.radius;
    
        var recPoints = [];
    
        recPoints.push(x, y + radius);
        quadraticBezierCurve(x, y + height - radius, x, y + height, x + radius, y + height, recPoints);
        quadraticBezierCurve(x + width - radius, y + height, x + width, y + height, x + width, y + height - radius, recPoints);
        quadraticBezierCurve(x + width, y + radius, x + width, y, x + width - radius, y, recPoints);
        quadraticBezierCurve(x + radius, y, x, y, x, y + radius + 0.0000000001, recPoints);
    
        // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
        // TODO - fix this properly, this is not very elegant.. but it works for now.
    
        if (graphicsData.fill) {
            var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
            var alpha = graphicsData.fillAlpha;
    
            var r = color[0] * alpha;
            var g = color[1] * alpha;
            var b = color[2] * alpha;
    
            var verts = webGLData.points;
            var indices = webGLData.indices;
    
            var vecPos = verts.length / 6;
    
            var triangles = (0, _earcut2.default)(recPoints, null, 2);
    
            for (var i = 0, j = triangles.length; i < j; i += 3) {
                indices.push(triangles[i] + vecPos);
                indices.push(triangles[i] + vecPos);
                indices.push(triangles[i + 1] + vecPos);
                indices.push(triangles[i + 2] + vecPos);
                indices.push(triangles[i + 2] + vecPos);
            }
    
            for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
                verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
            }
        }
    
        if (graphicsData.lineWidth) {
            var tempPoints = graphicsData.points;
    
            graphicsData.points = recPoints;
    
            (0, _buildLine2.default)(graphicsData, webGLData);
    
            graphicsData.points = tempPoints;
        }
    }
    
    /**
     * Calculate a single point for a quadratic bezier curve.
     * Utility function used by quadraticBezierCurve.
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {number} n1 - first number
     * @param {number} n2 - second number
     * @param {number} perc - percentage
     * @return {number} the result
     *
     */
    function getPt(n1, n2, perc) {
        var diff = n2 - n1;
    
        return n1 + diff * perc;
    }
    
    /**
     * Calculate the points for a quadratic bezier curve. (helper function..)
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * Ignored from docs since it is not directly exposed.
     *
     * @ignore
     * @private
     * @param {number} fromX - Origin point x
     * @param {number} fromY - Origin point x
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
     * @return {number[]} an array of points
     */
    function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
        var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
    
        var n = 20;
        var points = out;
    
        var xa = 0;
        var ya = 0;
        var xb = 0;
        var yb = 0;
        var x = 0;
        var y = 0;
    
        for (var i = 0, j = 0; i <= n; ++i) {
            j = i / n;
    
            // The Green Line
            xa = getPt(fromX, cpX, j);
            ya = getPt(fromY, cpY, j);
            xb = getPt(cpX, toX, j);
            yb = getPt(cpY, toY, j);
    
            // The Black Dot
            x = getPt(xa, xb, j);
            y = getPt(ya, yb, j);
    
            points.push(x, y);
        }
    
        return points;
    }
    
    },{"../../../utils":121,"./buildLine":60,"earcut":3}],64:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;
    
    var _const = require('./const');
    
    Object.keys(_const).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _const[key];
        }
      });
    });
    
    var _math = require('./math');
    
    Object.keys(_math).forEach(function (key) {
      if (key === "default" || key === "__esModule") return;
      Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
          return _math[key];
        }
      });
    });
    
    var _pixiGlCore = require('pixi-gl-core');
    
    Object.defineProperty(exports, 'glCore', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_pixiGlCore).default;
      }
    });
    
    var _Bounds = require('./display/Bounds');
    
    Object.defineProperty(exports, 'Bounds', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Bounds).default;
      }
    });
    
    var _DisplayObject = require('./display/DisplayObject');
    
    Object.defineProperty(exports, 'DisplayObject', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_DisplayObject).default;
      }
    });
    
    var _Container = require('./display/Container');
    
    Object.defineProperty(exports, 'Container', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Container).default;
      }
    });
    
    var _Transform = require('./display/Transform');
    
    Object.defineProperty(exports, 'Transform', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Transform).default;
      }
    });
    
    var _TransformStatic = require('./display/TransformStatic');
    
    Object.defineProperty(exports, 'TransformStatic', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TransformStatic).default;
      }
    });
    
    var _TransformBase = require('./display/TransformBase');
    
    Object.defineProperty(exports, 'TransformBase', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TransformBase).default;
      }
    });
    
    var _Sprite = require('./sprites/Sprite');
    
    Object.defineProperty(exports, 'Sprite', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Sprite).default;
      }
    });
    
    var _CanvasSpriteRenderer = require('./sprites/canvas/CanvasSpriteRenderer');
    
    Object.defineProperty(exports, 'CanvasSpriteRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasSpriteRenderer).default;
      }
    });
    
    var _CanvasTinter = require('./sprites/canvas/CanvasTinter');
    
    Object.defineProperty(exports, 'CanvasTinter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasTinter).default;
      }
    });
    
    var _SpriteRenderer = require('./sprites/webgl/SpriteRenderer');
    
    Object.defineProperty(exports, 'SpriteRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_SpriteRenderer).default;
      }
    });
    
    var _Text = require('./text/Text');
    
    Object.defineProperty(exports, 'Text', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Text).default;
      }
    });
    
    var _TextStyle = require('./text/TextStyle');
    
    Object.defineProperty(exports, 'TextStyle', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TextStyle).default;
      }
    });
    
    var _Graphics = require('./graphics/Graphics');
    
    Object.defineProperty(exports, 'Graphics', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Graphics).default;
      }
    });
    
    var _GraphicsData = require('./graphics/GraphicsData');
    
    Object.defineProperty(exports, 'GraphicsData', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_GraphicsData).default;
      }
    });
    
    var _GraphicsRenderer = require('./graphics/webgl/GraphicsRenderer');
    
    Object.defineProperty(exports, 'GraphicsRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_GraphicsRenderer).default;
      }
    });
    
    var _CanvasGraphicsRenderer = require('./graphics/canvas/CanvasGraphicsRenderer');
    
    Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasGraphicsRenderer).default;
      }
    });
    
    var _Spritesheet = require('./textures/Spritesheet');
    
    Object.defineProperty(exports, 'Spritesheet', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Spritesheet).default;
      }
    });
    
    var _Texture = require('./textures/Texture');
    
    Object.defineProperty(exports, 'Texture', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Texture).default;
      }
    });
    
    var _BaseTexture = require('./textures/BaseTexture');
    
    Object.defineProperty(exports, 'BaseTexture', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BaseTexture).default;
      }
    });
    
    var _RenderTexture = require('./textures/RenderTexture');
    
    Object.defineProperty(exports, 'RenderTexture', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_RenderTexture).default;
      }
    });
    
    var _BaseRenderTexture = require('./textures/BaseRenderTexture');
    
    Object.defineProperty(exports, 'BaseRenderTexture', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BaseRenderTexture).default;
      }
    });
    
    var _VideoBaseTexture = require('./textures/VideoBaseTexture');
    
    Object.defineProperty(exports, 'VideoBaseTexture', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_VideoBaseTexture).default;
      }
    });
    
    var _TextureUvs = require('./textures/TextureUvs');
    
    Object.defineProperty(exports, 'TextureUvs', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TextureUvs).default;
      }
    });
    
    var _CanvasRenderTarget = require('./renderers/canvas/utils/CanvasRenderTarget');
    
    Object.defineProperty(exports, 'CanvasRenderTarget', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasRenderTarget).default;
      }
    });
    
    var _Shader = require('./Shader');
    
    Object.defineProperty(exports, 'Shader', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Shader).default;
      }
    });
    
    var _WebGLManager = require('./renderers/webgl/managers/WebGLManager');
    
    Object.defineProperty(exports, 'WebGLManager', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_WebGLManager).default;
      }
    });
    
    var _ObjectRenderer = require('./renderers/webgl/utils/ObjectRenderer');
    
    Object.defineProperty(exports, 'ObjectRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ObjectRenderer).default;
      }
    });
    
    var _RenderTarget = require('./renderers/webgl/utils/RenderTarget');
    
    Object.defineProperty(exports, 'RenderTarget', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_RenderTarget).default;
      }
    });
    
    var _Quad = require('./renderers/webgl/utils/Quad');
    
    Object.defineProperty(exports, 'Quad', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Quad).default;
      }
    });
    
    var _SpriteMaskFilter = require('./renderers/webgl/filters/spriteMask/SpriteMaskFilter');
    
    Object.defineProperty(exports, 'SpriteMaskFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_SpriteMaskFilter).default;
      }
    });
    
    var _Filter = require('./renderers/webgl/filters/Filter');
    
    Object.defineProperty(exports, 'Filter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Filter).default;
      }
    });
    
    var _Application = require('./Application');
    
    Object.defineProperty(exports, 'Application', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Application).default;
      }
    });
    
    var _autoDetectRenderer = require('./autoDetectRenderer');
    
    Object.defineProperty(exports, 'autoDetectRenderer', {
      enumerable: true,
      get: function get() {
        return _autoDetectRenderer.autoDetectRenderer;
      }
    });
    
    var _utils = require('./utils');
    
    var utils = _interopRequireWildcard(_utils);
    
    var _ticker = require('./ticker');
    
    var ticker = _interopRequireWildcard(_ticker);
    
    var _settings = require('./settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _CanvasRenderer = require('./renderers/canvas/CanvasRenderer');
    
    var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
    
    var _WebGLRenderer = require('./renderers/webgl/WebGLRenderer');
    
    var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    exports.settings = _settings2.default;
    exports.utils = utils;
    exports.ticker = ticker;
    exports.CanvasRenderer = _CanvasRenderer2.default;
    exports.WebGLRenderer = _WebGLRenderer2.default; /**
                                                      * @namespace PIXI
                                                      */
    
    },{"./Application":42,"./Shader":43,"./autoDetectRenderer":44,"./const":45,"./display/Bounds":46,"./display/Container":47,"./display/DisplayObject":48,"./display/Transform":49,"./display/TransformBase":50,"./display/TransformStatic":51,"./graphics/Graphics":52,"./graphics/GraphicsData":53,"./graphics/canvas/CanvasGraphicsRenderer":54,"./graphics/webgl/GraphicsRenderer":56,"./math":69,"./renderers/canvas/CanvasRenderer":76,"./renderers/canvas/utils/CanvasRenderTarget":78,"./renderers/webgl/WebGLRenderer":83,"./renderers/webgl/filters/Filter":85,"./renderers/webgl/filters/spriteMask/SpriteMaskFilter":88,"./renderers/webgl/managers/WebGLManager":92,"./renderers/webgl/utils/ObjectRenderer":93,"./renderers/webgl/utils/Quad":94,"./renderers/webgl/utils/RenderTarget":95,"./settings":100,"./sprites/Sprite":101,"./sprites/canvas/CanvasSpriteRenderer":102,"./sprites/canvas/CanvasTinter":103,"./sprites/webgl/SpriteRenderer":105,"./text/Text":107,"./text/TextStyle":108,"./textures/BaseRenderTexture":109,"./textures/BaseTexture":110,"./textures/RenderTexture":111,"./textures/Spritesheet":112,"./textures/Texture":113,"./textures/TextureUvs":114,"./textures/VideoBaseTexture":115,"./ticker":117,"./utils":121,"pixi-gl-core":16}],65:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Matrix = require('./Matrix');
    
    var _Matrix2 = _interopRequireDefault(_Matrix);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16
    
    var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
    var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
    var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
    var tempMatrices = [];
    
    var mul = [];
    
    function signum(x) {
        if (x < 0) {
            return -1;
        }
        if (x > 0) {
            return 1;
        }
    
        return 0;
    }
    
    function init() {
        for (var i = 0; i < 16; i++) {
            var row = [];
    
            mul.push(row);
    
            for (var j = 0; j < 16; j++) {
                var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
                var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
                var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
                var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);
    
                for (var k = 0; k < 16; k++) {
                    if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
                        row.push(k);
                        break;
                    }
                }
            }
        }
    
        for (var _i = 0; _i < 16; _i++) {
            var mat = new _Matrix2.default();
    
            mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
            tempMatrices.push(mat);
        }
    }
    
    init();
    
    /**
     * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
     * D8 is the same but with diagonals. Used for texture rotations.
     *
     * Vector xX(i), xY(i) is U-axis of sprite with rotation i
     * Vector yY(i), yY(i) is V-axis of sprite with rotation i
     * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
     * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
     * This is the small part of gameofbombs.com portal system. It works.
     *
     * @author Ivan @ivanpopelyshev
     * @class
     * @memberof PIXI
     */
    var GroupD8 = {
        E: 0,
        SE: 1,
        S: 2,
        SW: 3,
        W: 4,
        NW: 5,
        N: 6,
        NE: 7,
        MIRROR_VERTICAL: 8,
        MIRROR_HORIZONTAL: 12,
        uX: function uX(ind) {
            return ux[ind];
        },
        uY: function uY(ind) {
            return uy[ind];
        },
        vX: function vX(ind) {
            return vx[ind];
        },
        vY: function vY(ind) {
            return vy[ind];
        },
        inv: function inv(rotation) {
            if (rotation & 8) {
                return rotation & 15;
            }
    
            return -rotation & 7;
        },
        add: function add(rotationSecond, rotationFirst) {
            return mul[rotationSecond][rotationFirst];
        },
        sub: function sub(rotationSecond, rotationFirst) {
            return mul[rotationSecond][GroupD8.inv(rotationFirst)];
        },
    
        /**
         * Adds 180 degrees to rotation. Commutative operation.
         *
         * @memberof PIXI.GroupD8
         * @param {number} rotation - The number to rotate.
         * @returns {number} rotated number
         */
        rotate180: function rotate180(rotation) {
            return rotation ^ 4;
        },
    
        /**
         * I dont know why sometimes width and heights needs to be swapped. We'll fix it later.
         *
         * @memberof PIXI.GroupD8
         * @param {number} rotation - The number to check.
         * @returns {boolean} Whether or not the width/height should be swapped.
         */
        isSwapWidthHeight: function isSwapWidthHeight(rotation) {
            return (rotation & 3) === 2;
        },
    
        /**
         * @memberof PIXI.GroupD8
         * @param {number} dx - TODO
         * @param {number} dy - TODO
         *
         * @return {number} TODO
         */
        byDirection: function byDirection(dx, dy) {
            if (Math.abs(dx) * 2 <= Math.abs(dy)) {
                if (dy >= 0) {
                    return GroupD8.S;
                }
    
                return GroupD8.N;
            } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
                if (dx > 0) {
                    return GroupD8.E;
                }
    
                return GroupD8.W;
            } else if (dy > 0) {
                if (dx > 0) {
                    return GroupD8.SE;
                }
    
                return GroupD8.SW;
            } else if (dx > 0) {
                return GroupD8.NE;
            }
    
            return GroupD8.NW;
        },
    
        /**
         * Helps sprite to compensate texture packer rotation.
         *
         * @memberof PIXI.GroupD8
         * @param {PIXI.Matrix} matrix - sprite world matrix
         * @param {number} rotation - The rotation factor to use.
         * @param {number} tx - sprite anchoring
         * @param {number} ty - sprite anchoring
         */
        matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
            var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    
            // Packer used "rotation", we use "inv(rotation)"
            var mat = tempMatrices[GroupD8.inv(rotation)];
    
            mat.tx = tx;
            mat.ty = ty;
            matrix.append(mat);
        }
    };
    
    exports.default = GroupD8;
    
    },{"./Matrix":66}],66:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _Point = require('./Point');
    
    var _Point2 = _interopRequireDefault(_Point);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The pixi Matrix class as an object, which makes it a lot faster,
     * here is a representation of it :
     * | a | b | tx|
     * | c | d | ty|
     * | 0 | 0 | 1 |
     *
     * @class
     * @memberof PIXI
     */
    var Matrix = function () {
        /**
         * @param {number} [a=1] - x scale
         * @param {number} [b=0] - y skew
         * @param {number} [c=0] - x skew
         * @param {number} [d=1] - y scale
         * @param {number} [tx=0] - x translation
         * @param {number} [ty=0] - y translation
         */
        function Matrix() {
            var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
            var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
            var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    
            _classCallCheck(this, Matrix);
    
            /**
             * @member {number}
             * @default 1
             */
            this.a = a;
    
            /**
             * @member {number}
             * @default 0
             */
            this.b = b;
    
            /**
             * @member {number}
             * @default 0
             */
            this.c = c;
    
            /**
             * @member {number}
             * @default 1
             */
            this.d = d;
    
            /**
             * @member {number}
             * @default 0
             */
            this.tx = tx;
    
            /**
             * @member {number}
             * @default 0
             */
            this.ty = ty;
    
            this.array = null;
        }
    
        /**
         * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
         *
         * a = array[0]
         * b = array[1]
         * c = array[3]
         * d = array[4]
         * tx = array[2]
         * ty = array[5]
         *
         * @param {number[]} array - The array that the matrix will be populated from.
         */
    
    
        Matrix.prototype.fromArray = function fromArray(array) {
            this.a = array[0];
            this.b = array[1];
            this.c = array[3];
            this.d = array[4];
            this.tx = array[2];
            this.ty = array[5];
        };
    
        /**
         * sets the matrix properties
         *
         * @param {number} a - Matrix component
         * @param {number} b - Matrix component
         * @param {number} c - Matrix component
         * @param {number} d - Matrix component
         * @param {number} tx - Matrix component
         * @param {number} ty - Matrix component
         *
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
            this.a = a;
            this.b = b;
            this.c = c;
            this.d = d;
            this.tx = tx;
            this.ty = ty;
    
            return this;
        };
    
        /**
         * Creates an array from the current Matrix object.
         *
         * @param {boolean} transpose - Whether we need to transpose the matrix or not
         * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
         * @return {number[]} the newly created array which contains the matrix
         */
    
    
        Matrix.prototype.toArray = function toArray(transpose, out) {
            if (!this.array) {
                this.array = new Float32Array(9);
            }
    
            var array = out || this.array;
    
            if (transpose) {
                array[0] = this.a;
                array[1] = this.b;
                array[2] = 0;
                array[3] = this.c;
                array[4] = this.d;
                array[5] = 0;
                array[6] = this.tx;
                array[7] = this.ty;
                array[8] = 1;
            } else {
                array[0] = this.a;
                array[1] = this.c;
                array[2] = this.tx;
                array[3] = this.b;
                array[4] = this.d;
                array[5] = this.ty;
                array[6] = 0;
                array[7] = 0;
                array[8] = 1;
            }
    
            return array;
        };
    
        /**
         * Get a new position with the current transformation applied.
         * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
         *
         * @param {PIXI.Point} pos - The origin
         * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
         * @return {PIXI.Point} The new point, transformed through this matrix
         */
    
    
        Matrix.prototype.apply = function apply(pos, newPos) {
            newPos = newPos || new _Point2.default();
    
            var x = pos.x;
            var y = pos.y;
    
            newPos.x = this.a * x + this.c * y + this.tx;
            newPos.y = this.b * x + this.d * y + this.ty;
    
            return newPos;
        };
    
        /**
         * Get a new position with the inverse of the current transformation applied.
         * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
         *
         * @param {PIXI.Point} pos - The origin
         * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
         * @return {PIXI.Point} The new point, inverse-transformed through this matrix
         */
    
    
        Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
            newPos = newPos || new _Point2.default();
    
            var id = 1 / (this.a * this.d + this.c * -this.b);
    
            var x = pos.x;
            var y = pos.y;
    
            newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
            newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
    
            return newPos;
        };
    
        /**
         * Translates the matrix on the x and y.
         *
         * @param {number} x How much to translate x by
         * @param {number} y How much to translate y by
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.translate = function translate(x, y) {
            this.tx += x;
            this.ty += y;
    
            return this;
        };
    
        /**
         * Applies a scale transformation to the matrix.
         *
         * @param {number} x The amount to scale horizontally
         * @param {number} y The amount to scale vertically
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.scale = function scale(x, y) {
            this.a *= x;
            this.d *= y;
            this.c *= x;
            this.b *= y;
            this.tx *= x;
            this.ty *= y;
    
            return this;
        };
    
        /**
         * Applies a rotation transformation to the matrix.
         *
         * @param {number} angle - The angle in radians.
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.rotate = function rotate(angle) {
            var cos = Math.cos(angle);
            var sin = Math.sin(angle);
    
            var a1 = this.a;
            var c1 = this.c;
            var tx1 = this.tx;
    
            this.a = a1 * cos - this.b * sin;
            this.b = a1 * sin + this.b * cos;
            this.c = c1 * cos - this.d * sin;
            this.d = c1 * sin + this.d * cos;
            this.tx = tx1 * cos - this.ty * sin;
            this.ty = tx1 * sin + this.ty * cos;
    
            return this;
        };
    
        /**
         * Appends the given Matrix to this Matrix.
         *
         * @param {PIXI.Matrix} matrix - The matrix to append.
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.append = function append(matrix) {
            var a1 = this.a;
            var b1 = this.b;
            var c1 = this.c;
            var d1 = this.d;
    
            this.a = matrix.a * a1 + matrix.b * c1;
            this.b = matrix.a * b1 + matrix.b * d1;
            this.c = matrix.c * a1 + matrix.d * c1;
            this.d = matrix.c * b1 + matrix.d * d1;
    
            this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
            this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
    
            return this;
        };
    
        /**
         * Sets the matrix based on all the available properties
         *
         * @param {number} x - Position on the x axis
         * @param {number} y - Position on the y axis
         * @param {number} pivotX - Pivot on the x axis
         * @param {number} pivotY - Pivot on the y axis
         * @param {number} scaleX - Scale on the x axis
         * @param {number} scaleY - Scale on the y axis
         * @param {number} rotation - Rotation in radians
         * @param {number} skewX - Skew on the x axis
         * @param {number} skewY - Skew on the y axis
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
            var sr = Math.sin(rotation);
            var cr = Math.cos(rotation);
            var cy = Math.cos(skewY);
            var sy = Math.sin(skewY);
            var nsx = -Math.sin(skewX);
            var cx = Math.cos(skewX);
    
            var a = cr * scaleX;
            var b = sr * scaleX;
            var c = -sr * scaleY;
            var d = cr * scaleY;
    
            this.a = cy * a + sy * c;
            this.b = cy * b + sy * d;
            this.c = nsx * a + cx * c;
            this.d = nsx * b + cx * d;
    
            this.tx = x + (pivotX * a + pivotY * c);
            this.ty = y + (pivotX * b + pivotY * d);
    
            return this;
        };
    
        /**
         * Prepends the given Matrix to this Matrix.
         *
         * @param {PIXI.Matrix} matrix - The matrix to prepend
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.prepend = function prepend(matrix) {
            var tx1 = this.tx;
    
            if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
                var a1 = this.a;
                var c1 = this.c;
    
                this.a = a1 * matrix.a + this.b * matrix.c;
                this.b = a1 * matrix.b + this.b * matrix.d;
                this.c = c1 * matrix.a + this.d * matrix.c;
                this.d = c1 * matrix.b + this.d * matrix.d;
            }
    
            this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
            this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
    
            return this;
        };
    
        /**
         * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
         *
         * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
         * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
         */
    
    
        Matrix.prototype.decompose = function decompose(transform) {
            // sort out rotation / skew..
            var a = this.a;
            var b = this.b;
            var c = this.c;
            var d = this.d;
    
            var skewX = -Math.atan2(-c, d);
            var skewY = Math.atan2(b, a);
    
            var delta = Math.abs(skewX + skewY);
    
            if (delta < 0.00001) {
                transform.rotation = skewY;
    
                if (a < 0 && d >= 0) {
                    transform.rotation += transform.rotation <= 0 ? Math.PI : -Math.PI;
                }
    
                transform.skew.x = transform.skew.y = 0;
            } else {
                transform.skew.x = skewX;
                transform.skew.y = skewY;
            }
    
            // next set scale
            transform.scale.x = Math.sqrt(a * a + b * b);
            transform.scale.y = Math.sqrt(c * c + d * d);
    
            // next set position
            transform.position.x = this.tx;
            transform.position.y = this.ty;
    
            return transform;
        };
    
        /**
         * Inverts this matrix
         *
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.invert = function invert() {
            var a1 = this.a;
            var b1 = this.b;
            var c1 = this.c;
            var d1 = this.d;
            var tx1 = this.tx;
            var n = a1 * d1 - b1 * c1;
    
            this.a = d1 / n;
            this.b = -b1 / n;
            this.c = -c1 / n;
            this.d = a1 / n;
            this.tx = (c1 * this.ty - d1 * tx1) / n;
            this.ty = -(a1 * this.ty - b1 * tx1) / n;
    
            return this;
        };
    
        /**
         * Resets this Matix to an identity (default) matrix.
         *
         * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.identity = function identity() {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.tx = 0;
            this.ty = 0;
    
            return this;
        };
    
        /**
         * Creates a new Matrix object with the same values as this one.
         *
         * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
         */
    
    
        Matrix.prototype.clone = function clone() {
            var matrix = new Matrix();
    
            matrix.a = this.a;
            matrix.b = this.b;
            matrix.c = this.c;
            matrix.d = this.d;
            matrix.tx = this.tx;
            matrix.ty = this.ty;
    
            return matrix;
        };
    
        /**
         * Changes the values of the given matrix to be the same as the ones in this matrix
         *
         * @param {PIXI.Matrix} matrix - The matrix to copy from.
         * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
         */
    
    
        Matrix.prototype.copy = function copy(matrix) {
            matrix.a = this.a;
            matrix.b = this.b;
            matrix.c = this.c;
            matrix.d = this.d;
            matrix.tx = this.tx;
            matrix.ty = this.ty;
    
            return matrix;
        };
    
        /**
         * A default (identity) matrix
         *
         * @static
         * @const
         */
    
    
        _createClass(Matrix, null, [{
            key: 'IDENTITY',
            get: function get() {
                return new Matrix();
            }
    
            /**
             * A temp matrix
             *
             * @static
             * @const
             */
    
        }, {
            key: 'TEMP_MATRIX',
            get: function get() {
                return new Matrix();
            }
        }]);
    
        return Matrix;
    }();
    
    exports.default = Matrix;
    
    },{"./Point":68}],67:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The Point object represents a location in a two-dimensional coordinate system, where x represents
     * the horizontal axis and y represents the vertical axis.
     * An observable point is a point that triggers a callback when the point's position is changed.
     *
     * @class
     * @memberof PIXI
     */
    var ObservablePoint = function () {
        /**
         * @param {Function} cb - callback when changed
         * @param {object} scope - owner of callback
         * @param {number} [x=0] - position of the point on the x axis
         * @param {number} [y=0] - position of the point on the y axis
         */
        function ObservablePoint(cb, scope) {
            var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    
            _classCallCheck(this, ObservablePoint);
    
            this._x = x;
            this._y = y;
    
            this.cb = cb;
            this.scope = scope;
        }
    
        /**
         * Sets the point to a new x and y position.
         * If y is omitted, both x and y will be set to x.
         *
         * @param {number} [x=0] - position of the point on the x axis
         * @param {number} [y=0] - position of the point on the y axis
         */
    
    
        ObservablePoint.prototype.set = function set(x, y) {
            var _x = x || 0;
            var _y = y || (y !== 0 ? _x : 0);
    
            if (this._x !== _x || this._y !== _y) {
                this._x = _x;
                this._y = _y;
                this.cb.call(this.scope);
            }
        };
    
        /**
         * Copies the data from another point
         *
         * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
         */
    
    
        ObservablePoint.prototype.copy = function copy(point) {
            if (this._x !== point.x || this._y !== point.y) {
                this._x = point.x;
                this._y = point.y;
                this.cb.call(this.scope);
            }
        };
    
        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         *
         * @member {number}
         */
    
    
        _createClass(ObservablePoint, [{
            key: "x",
            get: function get() {
                return this._x;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (this._x !== value) {
                    this._x = value;
                    this.cb.call(this.scope);
                }
            }
    
            /**
             * The position of the displayObject on the x axis relative to the local coordinates of the parent.
             *
             * @member {number}
             */
    
        }, {
            key: "y",
            get: function get() {
                return this._y;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (this._y !== value) {
                    this._y = value;
                    this.cb.call(this.scope);
                }
            }
        }]);
    
        return ObservablePoint;
    }();
    
    exports.default = ObservablePoint;
    
    },{}],68:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The Point object represents a location in a two-dimensional coordinate system, where x represents
     * the horizontal axis and y represents the vertical axis.
     *
     * @class
     * @memberof PIXI
     */
    var Point = function () {
      /**
       * @param {number} [x=0] - position of the point on the x axis
       * @param {number} [y=0] - position of the point on the y axis
       */
      function Point() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    
        _classCallCheck(this, Point);
    
        /**
         * @member {number}
         * @default 0
         */
        this.x = x;
    
        /**
         * @member {number}
         * @default 0
         */
        this.y = y;
      }
    
      /**
       * Creates a clone of this point
       *
       * @return {PIXI.Point} a copy of the point
       */
    
    
      Point.prototype.clone = function clone() {
        return new Point(this.x, this.y);
      };
    
      /**
       * Copies x and y from the given point
       *
       * @param {PIXI.Point} p - The point to copy.
       */
    
    
      Point.prototype.copy = function copy(p) {
        this.set(p.x, p.y);
      };
    
      /**
       * Returns true if the given point is equal to this point
       *
       * @param {PIXI.Point} p - The point to check
       * @returns {boolean} Whether the given point equal to this point
       */
    
    
      Point.prototype.equals = function equals(p) {
        return p.x === this.x && p.y === this.y;
      };
    
      /**
       * Sets the point to a new x and y position.
       * If y is omitted, both x and y will be set to x.
       *
       * @param {number} [x=0] - position of the point on the x axis
       * @param {number} [y=0] - position of the point on the y axis
       */
    
    
      Point.prototype.set = function set(x, y) {
        this.x = x || 0;
        this.y = y || (y !== 0 ? this.x : 0);
      };
    
      return Point;
    }();
    
    exports.default = Point;
    
    },{}],69:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Point = require('./Point');
    
    Object.defineProperty(exports, 'Point', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Point).default;
      }
    });
    
    var _ObservablePoint = require('./ObservablePoint');
    
    Object.defineProperty(exports, 'ObservablePoint', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ObservablePoint).default;
      }
    });
    
    var _Matrix = require('./Matrix');
    
    Object.defineProperty(exports, 'Matrix', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Matrix).default;
      }
    });
    
    var _GroupD = require('./GroupD8');
    
    Object.defineProperty(exports, 'GroupD8', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_GroupD).default;
      }
    });
    
    var _Circle = require('./shapes/Circle');
    
    Object.defineProperty(exports, 'Circle', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Circle).default;
      }
    });
    
    var _Ellipse = require('./shapes/Ellipse');
    
    Object.defineProperty(exports, 'Ellipse', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Ellipse).default;
      }
    });
    
    var _Polygon = require('./shapes/Polygon');
    
    Object.defineProperty(exports, 'Polygon', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Polygon).default;
      }
    });
    
    var _Rectangle = require('./shapes/Rectangle');
    
    Object.defineProperty(exports, 'Rectangle', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Rectangle).default;
      }
    });
    
    var _RoundedRectangle = require('./shapes/RoundedRectangle');
    
    Object.defineProperty(exports, 'RoundedRectangle', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_RoundedRectangle).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./GroupD8":65,"./Matrix":66,"./ObservablePoint":67,"./Point":68,"./shapes/Circle":70,"./shapes/Ellipse":71,"./shapes/Polygon":72,"./shapes/Rectangle":73,"./shapes/RoundedRectangle":74}],70:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Rectangle = require('./Rectangle');
    
    var _Rectangle2 = _interopRequireDefault(_Rectangle);
    
    var _const = require('../../const');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The Circle object can be used to specify a hit area for displayObjects
     *
     * @class
     * @memberof PIXI
     */
    var Circle = function () {
      /**
       * @param {number} [x=0] - The X coordinate of the center of this circle
       * @param {number} [y=0] - The Y coordinate of the center of this circle
       * @param {number} [radius=0] - The radius of the circle
       */
      function Circle() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    
        _classCallCheck(this, Circle);
    
        /**
         * @member {number}
         * @default 0
         */
        this.x = x;
    
        /**
         * @member {number}
         * @default 0
         */
        this.y = y;
    
        /**
         * @member {number}
         * @default 0
         */
        this.radius = radius;
    
        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readOnly
         * @default PIXI.SHAPES.CIRC
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.CIRC;
      }
    
      /**
       * Creates a clone of this Circle instance
       *
       * @return {PIXI.Circle} a copy of the Circle
       */
    
    
      Circle.prototype.clone = function clone() {
        return new Circle(this.x, this.y, this.radius);
      };
    
      /**
       * Checks whether the x and y coordinates given are contained within this circle
       *
       * @param {number} x - The X coordinate of the point to test
       * @param {number} y - The Y coordinate of the point to test
       * @return {boolean} Whether the x/y coordinates are within this Circle
       */
    
    
      Circle.prototype.contains = function contains(x, y) {
        if (this.radius <= 0) {
          return false;
        }
    
        var r2 = this.radius * this.radius;
        var dx = this.x - x;
        var dy = this.y - y;
    
        dx *= dx;
        dy *= dy;
    
        return dx + dy <= r2;
      };
    
      /**
      * Returns the framing rectangle of the circle as a Rectangle object
      *
      * @return {PIXI.Rectangle} the framing rectangle
      */
    
    
      Circle.prototype.getBounds = function getBounds() {
        return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
      };
    
      return Circle;
    }();
    
    exports.default = Circle;
    
    },{"../../const":45,"./Rectangle":73}],71:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Rectangle = require('./Rectangle');
    
    var _Rectangle2 = _interopRequireDefault(_Rectangle);
    
    var _const = require('../../const');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The Ellipse object can be used to specify a hit area for displayObjects
     *
     * @class
     * @memberof PIXI
     */
    var Ellipse = function () {
      /**
       * @param {number} [x=0] - The X coordinate of the center of this circle
       * @param {number} [y=0] - The Y coordinate of the center of this circle
       * @param {number} [width=0] - The half width of this ellipse
       * @param {number} [height=0] - The half height of this ellipse
       */
      function Ellipse() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    
        _classCallCheck(this, Ellipse);
    
        /**
         * @member {number}
         * @default 0
         */
        this.x = x;
    
        /**
         * @member {number}
         * @default 0
         */
        this.y = y;
    
        /**
         * @member {number}
         * @default 0
         */
        this.width = width;
    
        /**
         * @member {number}
         * @default 0
         */
        this.height = height;
    
        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readOnly
         * @default PIXI.SHAPES.ELIP
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.ELIP;
      }
    
      /**
       * Creates a clone of this Ellipse instance
       *
       * @return {PIXI.Ellipse} a copy of the ellipse
       */
    
    
      Ellipse.prototype.clone = function clone() {
        return new Ellipse(this.x, this.y, this.width, this.height);
      };
    
      /**
       * Checks whether the x and y coordinates given are contained within this ellipse
       *
       * @param {number} x - The X coordinate of the point to test
       * @param {number} y - The Y coordinate of the point to test
       * @return {boolean} Whether the x/y coords are within this ellipse
       */
    
    
      Ellipse.prototype.contains = function contains(x, y) {
        if (this.width <= 0 || this.height <= 0) {
          return false;
        }
    
        // normalize the coords to an ellipse with center 0,0
        var normx = (x - this.x) / this.width;
        var normy = (y - this.y) / this.height;
    
        normx *= normx;
        normy *= normy;
    
        return normx + normy <= 1;
      };
    
      /**
       * Returns the framing rectangle of the ellipse as a Rectangle object
       *
       * @return {PIXI.Rectangle} the framing rectangle
       */
    
    
      Ellipse.prototype.getBounds = function getBounds() {
        return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
      };
    
      return Ellipse;
    }();
    
    exports.default = Ellipse;
    
    },{"../../const":45,"./Rectangle":73}],72:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Point = require('../Point');
    
    var _Point2 = _interopRequireDefault(_Point);
    
    var _const = require('../../const');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @class
     * @memberof PIXI
     */
    var Polygon = function () {
        /**
         * @param {PIXI.Point[]|number[]} points - This can be an array of Points
         *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
         *  the arguments passed can be all the points of the polygon e.g.
         *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
         *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
         */
        function Polygon() {
            for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
                points[_key] = arguments[_key];
            }
    
            _classCallCheck(this, Polygon);
    
            if (Array.isArray(points[0])) {
                points = points[0];
            }
    
            // if this is an array of points, convert it to a flat array of numbers
            if (points[0] instanceof _Point2.default) {
                var p = [];
    
                for (var i = 0, il = points.length; i < il; i++) {
                    p.push(points[i].x, points[i].y);
                }
    
                points = p;
            }
    
            this.closed = true;
    
            /**
             * An array of the points of this polygon
             *
             * @member {number[]}
             */
            this.points = points;
    
            /**
             * The type of the object, mainly used to avoid `instanceof` checks
             *
             * @member {number}
             * @readOnly
             * @default PIXI.SHAPES.POLY
             * @see PIXI.SHAPES
             */
            this.type = _const.SHAPES.POLY;
        }
    
        /**
         * Creates a clone of this polygon
         *
         * @return {PIXI.Polygon} a copy of the polygon
         */
    
    
        Polygon.prototype.clone = function clone() {
            return new Polygon(this.points.slice());
        };
    
        /**
         * Closes the polygon, adding points if necessary.
         *
         */
    
    
        Polygon.prototype.close = function close() {
            var points = this.points;
    
            // close the poly if the value is true!
            if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
                points.push(points[0], points[1]);
            }
        };
    
        /**
         * Checks whether the x and y coordinates passed to this function are contained within this polygon
         *
         * @param {number} x - The X coordinate of the point to test
         * @param {number} y - The Y coordinate of the point to test
         * @return {boolean} Whether the x/y coordinates are within this polygon
         */
    
    
        Polygon.prototype.contains = function contains(x, y) {
            var inside = false;
    
            // use some raycasting to test hits
            // https://github.com/substack/point-in-polygon/blob/master/index.js
            var length = this.points.length / 2;
    
            for (var i = 0, j = length - 1; i < length; j = i++) {
                var xi = this.points[i * 2];
                var yi = this.points[i * 2 + 1];
                var xj = this.points[j * 2];
                var yj = this.points[j * 2 + 1];
                var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;
    
                if (intersect) {
                    inside = !inside;
                }
            }
    
            return inside;
        };
    
        return Polygon;
    }();
    
    exports.default = Polygon;
    
    },{"../../const":45,"../Point":68}],73:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _const = require('../../const');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Rectangle object is an area defined by its position, as indicated by its top-left corner
     * point (x, y) and by its width and its height.
     *
     * @class
     * @memberof PIXI
     */
    var Rectangle = function () {
        /**
         * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
         * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
         * @param {number} [width=0] - The overall width of this rectangle
         * @param {number} [height=0] - The overall height of this rectangle
         */
        function Rectangle() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    
            _classCallCheck(this, Rectangle);
    
            /**
             * @member {number}
             * @default 0
             */
            this.x = x;
    
            /**
             * @member {number}
             * @default 0
             */
            this.y = y;
    
            /**
             * @member {number}
             * @default 0
             */
            this.width = width;
    
            /**
             * @member {number}
             * @default 0
             */
            this.height = height;
    
            /**
             * The type of the object, mainly used to avoid `instanceof` checks
             *
             * @member {number}
             * @readOnly
             * @default PIXI.SHAPES.RECT
             * @see PIXI.SHAPES
             */
            this.type = _const.SHAPES.RECT;
        }
    
        /**
         * returns the left edge of the rectangle
         *
         * @member {number}
         */
    
    
        /**
         * Creates a clone of this Rectangle
         *
         * @return {PIXI.Rectangle} a copy of the rectangle
         */
        Rectangle.prototype.clone = function clone() {
            return new Rectangle(this.x, this.y, this.width, this.height);
        };
    
        /**
         * Copies another rectangle to this one.
         *
         * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
         * @return {PIXI.Rectangle} Returns itself.
         */
    
    
        Rectangle.prototype.copy = function copy(rectangle) {
            this.x = rectangle.x;
            this.y = rectangle.y;
            this.width = rectangle.width;
            this.height = rectangle.height;
    
            return this;
        };
    
        /**
         * Checks whether the x and y coordinates given are contained within this Rectangle
         *
         * @param {number} x - The X coordinate of the point to test
         * @param {number} y - The Y coordinate of the point to test
         * @return {boolean} Whether the x/y coordinates are within this Rectangle
         */
    
    
        Rectangle.prototype.contains = function contains(x, y) {
            if (this.width <= 0 || this.height <= 0) {
                return false;
            }
    
            if (x >= this.x && x < this.x + this.width) {
                if (y >= this.y && y < this.y + this.height) {
                    return true;
                }
            }
    
            return false;
        };
    
        /**
         * Pads the rectangle making it grow in all directions.
         *
         * @param {number} paddingX - The horizontal padding amount.
         * @param {number} paddingY - The vertical padding amount.
         */
    
    
        Rectangle.prototype.pad = function pad(paddingX, paddingY) {
            paddingX = paddingX || 0;
            paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);
    
            this.x -= paddingX;
            this.y -= paddingY;
    
            this.width += paddingX * 2;
            this.height += paddingY * 2;
        };
    
        /**
         * Fits this rectangle around the passed one.
         *
         * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
         */
    
    
        Rectangle.prototype.fit = function fit(rectangle) {
            if (this.x < rectangle.x) {
                this.width += this.x;
                if (this.width < 0) {
                    this.width = 0;
                }
    
                this.x = rectangle.x;
            }
    
            if (this.y < rectangle.y) {
                this.height += this.y;
                if (this.height < 0) {
                    this.height = 0;
                }
                this.y = rectangle.y;
            }
    
            if (this.x + this.width > rectangle.x + rectangle.width) {
                this.width = rectangle.width - this.x;
                if (this.width < 0) {
                    this.width = 0;
                }
            }
    
            if (this.y + this.height > rectangle.y + rectangle.height) {
                this.height = rectangle.height - this.y;
                if (this.height < 0) {
                    this.height = 0;
                }
            }
        };
    
        /**
         * Enlarges this rectangle to include the passed rectangle.
         *
         * @param {PIXI.Rectangle} rectangle - The rectangle to include.
         */
    
    
        Rectangle.prototype.enlarge = function enlarge(rectangle) {
            var x1 = Math.min(this.x, rectangle.x);
            var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
            var y1 = Math.min(this.y, rectangle.y);
            var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);
    
            this.x = x1;
            this.width = x2 - x1;
            this.y = y1;
            this.height = y2 - y1;
        };
    
        _createClass(Rectangle, [{
            key: 'left',
            get: function get() {
                return this.x;
            }
    
            /**
             * returns the right edge of the rectangle
             *
             * @member {number}
             */
    
        }, {
            key: 'right',
            get: function get() {
                return this.x + this.width;
            }
    
            /**
             * returns the top edge of the rectangle
             *
             * @member {number}
             */
    
        }, {
            key: 'top',
            get: function get() {
                return this.y;
            }
    
            /**
             * returns the bottom edge of the rectangle
             *
             * @member {number}
             */
    
        }, {
            key: 'bottom',
            get: function get() {
                return this.y + this.height;
            }
    
            /**
             * A constant empty rectangle.
             *
             * @static
             * @constant
             */
    
        }], [{
            key: 'EMPTY',
            get: function get() {
                return new Rectangle(0, 0, 0, 0);
            }
        }]);
    
        return Rectangle;
    }();
    
    exports.default = Rectangle;
    
    },{"../../const":45}],74:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _const = require('../../const');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
     * top-left corner point (x, y) and by its width and its height and its radius.
     *
     * @class
     * @memberof PIXI
     */
    var RoundedRectangle = function () {
        /**
         * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
         * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
         * @param {number} [width=0] - The overall width of this rounded rectangle
         * @param {number} [height=0] - The overall height of this rounded rectangle
         * @param {number} [radius=20] - Controls the radius of the rounded corners
         */
        function RoundedRectangle() {
            var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;
    
            _classCallCheck(this, RoundedRectangle);
    
            /**
             * @member {number}
             * @default 0
             */
            this.x = x;
    
            /**
             * @member {number}
             * @default 0
             */
            this.y = y;
    
            /**
             * @member {number}
             * @default 0
             */
            this.width = width;
    
            /**
             * @member {number}
             * @default 0
             */
            this.height = height;
    
            /**
             * @member {number}
             * @default 20
             */
            this.radius = radius;
    
            /**
             * The type of the object, mainly used to avoid `instanceof` checks
             *
             * @member {number}
             * @readonly
             * @default PIXI.SHAPES.RREC
             * @see PIXI.SHAPES
             */
            this.type = _const.SHAPES.RREC;
        }
    
        /**
         * Creates a clone of this Rounded Rectangle
         *
         * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
         */
    
    
        RoundedRectangle.prototype.clone = function clone() {
            return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
        };
    
        /**
         * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
         *
         * @param {number} x - The X coordinate of the point to test
         * @param {number} y - The Y coordinate of the point to test
         * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
         */
    
    
        RoundedRectangle.prototype.contains = function contains(x, y) {
            if (this.width <= 0 || this.height <= 0) {
                return false;
            }
            if (x >= this.x && x <= this.x + this.width) {
                if (y >= this.y && y <= this.y + this.height) {
                    if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
                        return true;
                    }
                    var dx = x - (this.x + this.radius);
                    var dy = y - (this.y + this.radius);
                    var radius2 = this.radius * this.radius;
    
                    if (dx * dx + dy * dy <= radius2) {
                        return true;
                    }
                    dx = x - (this.x + this.width - this.radius);
                    if (dx * dx + dy * dy <= radius2) {
                        return true;
                    }
                    dy = y - (this.y + this.height - this.radius);
                    if (dx * dx + dy * dy <= radius2) {
                        return true;
                    }
                    dx = x - (this.x + this.radius);
                    if (dx * dx + dy * dy <= radius2) {
                        return true;
                    }
                }
            }
    
            return false;
        };
    
        return RoundedRectangle;
    }();
    
    exports.default = RoundedRectangle;
    
    },{"../../const":45}],75:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _utils = require('../utils');
    
    var _math = require('../math');
    
    var _const = require('../const');
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _Container = require('../display/Container');
    
    var _Container2 = _interopRequireDefault(_Container);
    
    var _RenderTexture = require('../textures/RenderTexture');
    
    var _RenderTexture2 = _interopRequireDefault(_RenderTexture);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var tempMatrix = new _math.Matrix();
    
    /**
     * The SystemRenderer is the base for a Pixi Renderer. It is extended by the {@link PIXI.CanvasRenderer}
     * and {@link PIXI.WebGLRenderer} which can be used for rendering a Pixi scene.
     *
     * @abstract
     * @class
     * @extends EventEmitter
     * @memberof PIXI
     */
    
    var SystemRenderer = function (_EventEmitter) {
      _inherits(SystemRenderer, _EventEmitter);
    
      /**
       * @param {string} system - The name of the system this renderer is for.
       * @param {number} [screenWidth=800] - the width of the screen
       * @param {number} [screenHeight=600] - the height of the screen
       * @param {object} [options] - The optional renderer parameters
       * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
       * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
       * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
       * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
       * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
       *  resolution of the renderer retina would be 2.
       * @param {boolean} [options.clearBeforeRender=true] - This sets if the CanvasRenderer will clear the canvas or
       *      not before the new render pass.
       * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
       *  (shown if not transparent).
       * @param {boolean} [options.roundPixels=false] - If true Pixi will Math.floor() x/y values when rendering,
       *  stopping pixel interpolation.
       */
      function SystemRenderer(system, screenWidth, screenHeight, options) {
        _classCallCheck(this, SystemRenderer);
    
        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
    
        (0, _utils.sayHello)(system);
    
        // prepare options
        if (options) {
          for (var i in _settings2.default.RENDER_OPTIONS) {
            if (typeof options[i] === 'undefined') {
              options[i] = _settings2.default.RENDER_OPTIONS[i];
            }
          }
        } else {
          options = _settings2.default.RENDER_OPTIONS;
        }
    
        /**
         * The type of the renderer.
         *
         * @member {number}
         * @default PIXI.RENDERER_TYPE.UNKNOWN
         * @see PIXI.RENDERER_TYPE
         */
        _this.type = _const.RENDERER_TYPE.UNKNOWN;
    
        /**
         * Measurements of the screen. (0, 0, screenWidth, screenHeight)
         *
         * Its safe to use as filterArea or hitArea for whole stage
         *
         * @member {PIXI.Rectangle}
         */
        _this.screen = new _math.Rectangle(0, 0, screenWidth || 800, screenHeight || 600);
    
        /**
         * The canvas element that everything is drawn to
         *
         * @member {HTMLCanvasElement}
         */
        _this.view = options.view || document.createElement('canvas');
    
        /**
         * The resolution / device pixel ratio of the renderer
         *
         * @member {number}
         * @default 1
         */
        _this.resolution = options.resolution || _settings2.default.RESOLUTION;
    
        /**
         * Whether the render view is transparent
         *
         * @member {boolean}
         */
        _this.transparent = options.transparent;
    
        /**
         * Whether css dimensions of canvas view should be resized to screen dimensions automatically
         *
         * @member {boolean}
         */
        _this.autoResize = options.autoResize || false;
    
        /**
         * Tracks the blend modes useful for this renderer.
         *
         * @member {object<string, mixed>}
         */
        _this.blendModes = null;
    
        /**
         * The value of the preserveDrawingBuffer flag affects whether or not the contents of
         * the stencil buffer is retained after rendering.
         *
         * @member {boolean}
         */
        _this.preserveDrawingBuffer = options.preserveDrawingBuffer;
    
        /**
         * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
         * If the scene is NOT transparent Pixi will use a canvas sized fillRect operation every
         * frame to set the canvas background color. If the scene is transparent Pixi will use clearRect
         * to clear the canvas every frame. Disable this by setting this to false. For example if
         * your game has a canvas filling background image you often don't need this set.
         *
         * @member {boolean}
         * @default
         */
        _this.clearBeforeRender = options.clearBeforeRender;
    
        /**
         * If true Pixi will Math.floor() x/y values when rendering, stopping pixel interpolation.
         * Handy for crisp pixel art and speed on legacy devices.
         *
         * @member {boolean}
         */
        _this.roundPixels = options.roundPixels;
    
        /**
         * The background color as a number.
         *
         * @member {number}
         * @private
         */
        _this._backgroundColor = 0x000000;
    
        /**
         * The background color as an [R, G, B] array.
         *
         * @member {number[]}
         * @private
         */
        _this._backgroundColorRgba = [0, 0, 0, 0];
    
        /**
         * The background color as a string.
         *
         * @member {string}
         * @private
         */
        _this._backgroundColorString = '#000000';
    
        _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter
    
        /**
         * This temporary display object used as the parent of the currently being rendered item
         *
         * @member {PIXI.DisplayObject}
         * @private
         */
        _this._tempDisplayObjectParent = new _Container2.default();
    
        /**
         * The last root object that the renderer tried to render.
         *
         * @member {PIXI.DisplayObject}
         * @private
         */
        _this._lastObjectRendered = _this._tempDisplayObjectParent;
        return _this;
      }
    
      /**
       * Same as view.width, actual number of pixels in the canvas by horizontal
       *
       * @member {number}
       * @readonly
       * @default 800
       */
    
    
      /**
       * Resizes the screen and canvas to the specified width and height
       * Canvas dimensions are multiplied by resolution
       *
       * @param {number} screenWidth - the new width of the screen
       * @param {number} screenHeight - the new height of the screen
       */
      SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
        this.screen.width = screenWidth;
        this.screen.height = screenHeight;
    
        this.view.width = screenWidth * this.resolution;
        this.view.height = screenHeight * this.resolution;
    
        if (this.autoResize) {
          this.view.style.width = screenWidth + 'px';
          this.view.style.height = screenHeight + 'px';
        }
      };
    
      /**
       * Useful function that returns a texture of the display object that can then be used to create sprites
       * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
       *
       * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
       * @param {number} scaleMode - Should be one of the scaleMode consts
       * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
       * @return {PIXI.Texture} a texture of the graphics object
       */
    
    
      SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution) {
        var bounds = displayObject.getLocalBounds();
    
        var renderTexture = _RenderTexture2.default.create(bounds.width | 0, bounds.height | 0, scaleMode, resolution);
    
        tempMatrix.tx = -bounds.x;
        tempMatrix.ty = -bounds.y;
    
        this.render(displayObject, renderTexture, false, tempMatrix, true);
    
        return renderTexture;
      };
    
      /**
       * Removes everything from the renderer and optionally removes the Canvas DOM element.
       *
       * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
       */
    
    
      SystemRenderer.prototype.destroy = function destroy(removeView) {
        if (removeView && this.view.parentNode) {
          this.view.parentNode.removeChild(this.view);
        }
    
        this.type = _const.RENDERER_TYPE.UNKNOWN;
    
        this.view = null;
    
        this.screen = null;
    
        this.resolution = 0;
    
        this.transparent = false;
    
        this.autoResize = false;
    
        this.blendModes = null;
    
        this.preserveDrawingBuffer = false;
        this.clearBeforeRender = false;
    
        this.roundPixels = false;
    
        this._backgroundColor = 0;
        this._backgroundColorRgba = null;
        this._backgroundColorString = null;
    
        this.backgroundColor = 0;
        this._tempDisplayObjectParent = null;
        this._lastObjectRendered = null;
      };
    
      /**
       * The background color to fill if not transparent
       *
       * @member {number}
       */
    
    
      _createClass(SystemRenderer, [{
        key: 'width',
        get: function get() {
          return this.view.width;
        }
    
        /**
         * Same as view.height, actual number of pixels in the canvas by vertical
         *
         * @member {number}
         * @readonly
         * @default 600
         */
    
      }, {
        key: 'height',
        get: function get() {
          return this.view.height;
        }
      }, {
        key: 'backgroundColor',
        get: function get() {
          return this._backgroundColor;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
          this._backgroundColor = value;
          this._backgroundColorString = (0, _utils.hex2string)(value);
          (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
        }
      }]);
    
      return SystemRenderer;
    }(_eventemitter2.default);
    
    exports.default = SystemRenderer;
    
    },{"../const":45,"../display/Container":47,"../math":69,"../settings":100,"../textures/RenderTexture":111,"../utils":121,"eventemitter3":4}],76:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _SystemRenderer2 = require('../SystemRenderer');
    
    var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
    
    var _CanvasMaskManager = require('./utils/CanvasMaskManager');
    
    var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);
    
    var _CanvasRenderTarget = require('./utils/CanvasRenderTarget');
    
    var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);
    
    var _mapCanvasBlendModesToPixi = require('./utils/mapCanvasBlendModesToPixi');
    
    var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);
    
    var _utils = require('../../utils');
    
    var _const = require('../../const');
    
    var _settings = require('../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
     * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
     * your DOM or you will not see anything :)
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.SystemRenderer
     */
    var CanvasRenderer = function (_SystemRenderer) {
        _inherits(CanvasRenderer, _SystemRenderer);
    
        /**
         * @param {number} [screenWidth=800] - the width of the screen
         * @param {number} [screenHeight=600] - the height of the screen
         * @param {object} [options] - The optional renderer parameters
         * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
         * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
         * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
         * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
         * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
         *  resolution of the renderer retina would be 2.
         * @param {boolean} [options.clearBeforeRender=true] - This sets if the CanvasRenderer will clear the canvas or
         *      not before the new render pass.
         * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
         *  (shown if not transparent).
         * @param {boolean} [options.roundPixels=false] - If true Pixi will Math.floor() x/y values when rendering,
         *  stopping pixel interpolation.
         */
        function CanvasRenderer(screenWidth, screenHeight) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    
            _classCallCheck(this, CanvasRenderer);
    
            var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', screenWidth, screenHeight, options));
    
            _this.type = _const.RENDERER_TYPE.CANVAS;
    
            /**
             * The canvas 2d context that everything is drawn with.
             *
             * @member {CanvasRenderingContext2D}
             */
            _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });
    
            /**
             * Boolean flag controlling canvas refresh.
             *
             * @member {boolean}
             */
            _this.refresh = true;
    
            /**
             * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
             *
             * @member {PIXI.CanvasMaskManager}
             */
            _this.maskManager = new _CanvasMaskManager2.default(_this);
    
            /**
             * The canvas property used to set the canvas smoothing property.
             *
             * @member {string}
             */
            _this.smoothProperty = 'imageSmoothingEnabled';
    
            if (!_this.rootContext.imageSmoothingEnabled) {
                if (_this.rootContext.webkitImageSmoothingEnabled) {
                    _this.smoothProperty = 'webkitImageSmoothingEnabled';
                } else if (_this.rootContext.mozImageSmoothingEnabled) {
                    _this.smoothProperty = 'mozImageSmoothingEnabled';
                } else if (_this.rootContext.oImageSmoothingEnabled) {
                    _this.smoothProperty = 'oImageSmoothingEnabled';
                } else if (_this.rootContext.msImageSmoothingEnabled) {
                    _this.smoothProperty = 'msImageSmoothingEnabled';
                }
            }
    
            _this.initPlugins();
    
            _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
            _this._activeBlendMode = null;
    
            _this.context = null;
            _this.renderingToScreen = false;
    
            _this.resize(screenWidth, screenHeight);
            return _this;
        }
    
        /**
         * Renders the object to this canvas view
         *
         * @param {PIXI.DisplayObject} displayObject - The object to be rendered
         * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
         *  If unset, it will render to the root context.
         * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
         * @param {PIXI.Transform} [transform] - A transformation to be applied
         * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
         */
    
    
        CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
            if (!this.view) {
                return;
            }
    
            // can be handy to know!
            this.renderingToScreen = !renderTexture;
    
            this.emit('prerender');
    
            var rootResolution = this.resolution;
    
            if (renderTexture) {
                renderTexture = renderTexture.baseTexture || renderTexture;
    
                if (!renderTexture._canvasRenderTarget) {
                    renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
                    renderTexture.source = renderTexture._canvasRenderTarget.canvas;
                    renderTexture.valid = true;
                }
    
                this.context = renderTexture._canvasRenderTarget.context;
                this.resolution = renderTexture._canvasRenderTarget.resolution;
            } else {
                this.context = this.rootContext;
            }
    
            var context = this.context;
    
            if (!renderTexture) {
                this._lastObjectRendered = displayObject;
            }
    
            if (!skipUpdateTransform) {
                // update the scene graph
                var cacheParent = displayObject.parent;
                var tempWt = this._tempDisplayObjectParent.transform.worldTransform;
    
                if (transform) {
                    transform.copy(tempWt);
    
                    // lets not forget to flag the parent transform as dirty...
                    this._tempDisplayObjectParent.transform._worldID = -1;
                } else {
                    tempWt.identity();
                }
    
                displayObject.parent = this._tempDisplayObjectParent;
    
                displayObject.updateTransform();
                displayObject.parent = cacheParent;
                // displayObject.hitArea = //TODO add a temp hit area
            }
    
            context.setTransform(1, 0, 0, 1, 0, 0);
            context.globalAlpha = 1;
            context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];
    
            if (navigator.isCocoonJS && this.view.screencanvas) {
                context.fillStyle = 'black';
                context.clear();
            }
    
            if (clear !== undefined ? clear : this.clearBeforeRender) {
                if (this.renderingToScreen) {
                    if (this.transparent) {
                        context.clearRect(0, 0, this.width, this.height);
                    } else {
                        context.fillStyle = this._backgroundColorString;
                        context.fillRect(0, 0, this.width, this.height);
                    }
                } // else {
                // TODO: implement background for CanvasRenderTarget or RenderTexture?
                // }
            }
    
            // TODO RENDER TARGET STUFF HERE..
            var tempContext = this.context;
    
            this.context = context;
            displayObject.renderCanvas(this);
            this.context = tempContext;
    
            this.resolution = rootResolution;
    
            this.emit('postrender');
        };
    
        /**
         * Clear the canvas of renderer.
         *
         * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
         */
    
    
        CanvasRenderer.prototype.clear = function clear(clearColor) {
            var context = this.context;
    
            clearColor = clearColor || this._backgroundColorString;
    
            if (!this.transparent && clearColor) {
                context.fillStyle = clearColor;
                context.fillRect(0, 0, this.width, this.height);
            } else {
                context.clearRect(0, 0, this.width, this.height);
            }
        };
    
        /**
         * Sets the blend mode of the renderer.
         *
         * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
         */
    
    
        CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
            if (this._activeBlendMode === blendMode) {
                return;
            }
    
            this._activeBlendMode = blendMode;
            this.context.globalCompositeOperation = this.blendModes[blendMode];
        };
    
        /**
         * Removes everything from the renderer and optionally removes the Canvas DOM element.
         *
         * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
         */
    
    
        CanvasRenderer.prototype.destroy = function destroy(removeView) {
            this.destroyPlugins();
    
            // call the base destroy
            _SystemRenderer.prototype.destroy.call(this, removeView);
    
            this.context = null;
    
            this.refresh = true;
    
            this.maskManager.destroy();
            this.maskManager = null;
    
            this.smoothProperty = null;
        };
    
        /**
         * Resizes the canvas view to the specified width and height.
         *
         * @extends PIXI.SystemRenderer#resize
         *
         * @param {number} screenWidth - the new width of the screen
         * @param {number} screenHeight - the new height of the screen
         */
    
    
        CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
            _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);
    
            // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
            // surely a browser bug?? Let pixi fix that for you..
            if (this.smoothProperty) {
                this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
            }
        };
    
        return CanvasRenderer;
    }(_SystemRenderer3.default);
    
    exports.default = CanvasRenderer;
    
    
    _utils.pluginTarget.mixin(CanvasRenderer);
    
    },{"../../const":45,"../../settings":100,"../../utils":121,"../SystemRenderer":75,"./utils/CanvasMaskManager":77,"./utils/CanvasRenderTarget":78,"./utils/mapCanvasBlendModesToPixi":80}],77:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _const = require('../../../const');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * A set of functions used to handle masking.
     *
     * @class
     * @memberof PIXI
     */
    var CanvasMaskManager = function () {
        /**
         * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
         */
        function CanvasMaskManager(renderer) {
            _classCallCheck(this, CanvasMaskManager);
    
            this.renderer = renderer;
        }
    
        /**
         * This method adds it to the current stack of masks.
         *
         * @param {object} maskData - the maskData that will be pushed
         */
    
    
        CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
            var renderer = this.renderer;
    
            renderer.context.save();
    
            var cacheAlpha = maskData.alpha;
            var transform = maskData.transform.worldTransform;
            var resolution = renderer.resolution;
    
            renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
    
            // TODO suport sprite alpha masks??
            // lots of effort required. If demand is great enough..
            if (!maskData._texture) {
                this.renderGraphicsShape(maskData);
                renderer.context.clip();
            }
    
            maskData.worldAlpha = cacheAlpha;
        };
    
        /**
         * Renders a PIXI.Graphics shape.
         *
         * @param {PIXI.Graphics} graphics - The object to render.
         */
    
    
        CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
            var context = this.renderer.context;
            var len = graphics.graphicsData.length;
    
            if (len === 0) {
                return;
            }
    
            context.beginPath();
    
            for (var i = 0; i < len; i++) {
                var data = graphics.graphicsData[i];
                var shape = data.shape;
    
                if (data.type === _const.SHAPES.POLY) {
                    var points = shape.points;
    
                    context.moveTo(points[0], points[1]);
    
                    for (var j = 1; j < points.length / 2; j++) {
                        context.lineTo(points[j * 2], points[j * 2 + 1]);
                    }
    
                    // if the first and last point are the same close the path - much neater :)
                    if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
                        context.closePath();
                    }
                } else if (data.type === _const.SHAPES.RECT) {
                    context.rect(shape.x, shape.y, shape.width, shape.height);
                    context.closePath();
                } else if (data.type === _const.SHAPES.CIRC) {
                    // TODO - need to be Undefined!
                    context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                    context.closePath();
                } else if (data.type === _const.SHAPES.ELIP) {
                    // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas
    
                    var w = shape.width * 2;
                    var h = shape.height * 2;
    
                    var x = shape.x - w / 2;
                    var y = shape.y - h / 2;
    
                    var kappa = 0.5522848;
                    var ox = w / 2 * kappa; // control point offset horizontal
                    var oy = h / 2 * kappa; // control point offset vertical
                    var xe = x + w; // x-end
                    var ye = y + h; // y-end
                    var xm = x + w / 2; // x-middle
                    var ym = y + h / 2; // y-middle
    
                    context.moveTo(x, ym);
                    context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                    context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                    context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                    context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                    context.closePath();
                } else if (data.type === _const.SHAPES.RREC) {
                    var rx = shape.x;
                    var ry = shape.y;
                    var width = shape.width;
                    var height = shape.height;
                    var radius = shape.radius;
    
                    var maxRadius = Math.min(width, height) / 2 | 0;
    
                    radius = radius > maxRadius ? maxRadius : radius;
    
                    context.moveTo(rx, ry + radius);
                    context.lineTo(rx, ry + height - radius);
                    context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                    context.lineTo(rx + width - radius, ry + height);
                    context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                    context.lineTo(rx + width, ry + radius);
                    context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                    context.lineTo(rx + radius, ry);
                    context.quadraticCurveTo(rx, ry, rx, ry + radius);
                    context.closePath();
                }
            }
        };
    
        /**
         * Restores the current drawing context to the state it was before the mask was applied.
         *
         * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
         */
    
    
        CanvasMaskManager.prototype.popMask = function popMask(renderer) {
            renderer.context.restore();
        };
    
        /**
         * Destroys this canvas mask manager.
         *
         */
    
    
        CanvasMaskManager.prototype.destroy = function destroy() {
            /* empty */
        };
    
        return CanvasMaskManager;
    }();
    
    exports.default = CanvasMaskManager;
    
    },{"../../../const":45}],78:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _settings = require('../../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Creates a Canvas element of the given size.
     *
     * @class
     * @memberof PIXI
     */
    var CanvasRenderTarget = function () {
      /**
       * @param {number} width - the width for the newly created canvas
       * @param {number} height - the height for the newly created canvas
       * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
       */
      function CanvasRenderTarget(width, height, resolution) {
        _classCallCheck(this, CanvasRenderTarget);
    
        /**
         * The Canvas object that belongs to this CanvasRenderTarget.
         *
         * @member {HTMLCanvasElement}
         */
        this.canvas = document.createElement('canvas');
    
        /**
         * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
         *
         * @member {CanvasRenderingContext2D}
         */
        this.context = this.canvas.getContext('2d');
    
        this.resolution = resolution || _settings2.default.RESOLUTION;
    
        this.resize(width, height);
      }
    
      /**
       * Clears the canvas that was created by the CanvasRenderTarget class.
       *
       * @private
       */
    
    
      CanvasRenderTarget.prototype.clear = function clear() {
        this.context.setTransform(1, 0, 0, 1, 0, 0);
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      };
    
      /**
       * Resizes the canvas to the specified width and height.
       *
       * @param {number} width - the new width of the canvas
       * @param {number} height - the new height of the canvas
       */
    
    
      CanvasRenderTarget.prototype.resize = function resize(width, height) {
        this.canvas.width = width * this.resolution;
        this.canvas.height = height * this.resolution;
      };
    
      /**
       * Destroys this canvas.
       *
       */
    
    
      CanvasRenderTarget.prototype.destroy = function destroy() {
        this.context = null;
        this.canvas = null;
      };
    
      /**
       * The width of the canvas buffer in pixels.
       *
       * @member {number}
       */
    
    
      _createClass(CanvasRenderTarget, [{
        key: 'width',
        get: function get() {
          return this.canvas.width;
        },
        set: function set(val) // eslint-disable-line require-jsdoc
        {
          this.canvas.width = val;
        }
    
        /**
         * The height of the canvas buffer in pixels.
         *
         * @member {number}
         */
    
      }, {
        key: 'height',
        get: function get() {
          return this.canvas.height;
        },
        set: function set(val) // eslint-disable-line require-jsdoc
        {
          this.canvas.height = val;
        }
      }]);
    
      return CanvasRenderTarget;
    }();
    
    exports.default = CanvasRenderTarget;
    
    },{"../../../settings":100}],79:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = canUseNewCanvasBlendModes;
    /**
     * Creates a little colored canvas
     *
     * @ignore
     * @param {string} color - The color to make the canvas
     * @return {canvas} a small canvas element
     */
    function createColoredCanvas(color) {
        var canvas = document.createElement('canvas');
    
        canvas.width = 6;
        canvas.height = 1;
    
        var context = canvas.getContext('2d');
    
        context.fillStyle = color;
        context.fillRect(0, 0, 6, 1);
    
        return canvas;
    }
    
    /**
     * Checks whether the Canvas BlendModes are supported by the current browser
     *
     * @return {boolean} whether they are supported
     */
    function canUseNewCanvasBlendModes() {
        if (typeof document === 'undefined') {
            return false;
        }
    
        var magenta = createColoredCanvas('#ff00ff');
        var yellow = createColoredCanvas('#ffff00');
    
        var canvas = document.createElement('canvas');
    
        canvas.width = 6;
        canvas.height = 1;
    
        var context = canvas.getContext('2d');
    
        context.globalCompositeOperation = 'multiply';
        context.drawImage(magenta, 0, 0);
        context.drawImage(yellow, 2, 0);
    
        var imageData = context.getImageData(2, 0, 1, 1);
    
        if (!imageData) {
            return false;
        }
    
        var data = imageData.data;
    
        return data[0] === 255 && data[1] === 0 && data[2] === 0;
    }
    
    },{}],80:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = mapCanvasBlendModesToPixi;
    
    var _const = require('../../../const');
    
    var _canUseNewCanvasBlendModes = require('./canUseNewCanvasBlendModes');
    
    var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Maps blend combinations to Canvas.
     *
     * @memberof PIXI
     * @function mapCanvasBlendModesToPixi
     * @private
     * @param {string[]} [array=[]] - The array to output into.
     * @return {string[]} Mapped modes.
     */
    function mapCanvasBlendModesToPixi() {
        var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    
        if ((0, _canUseNewCanvasBlendModes2.default)()) {
            array[_const.BLEND_MODES.NORMAL] = 'source-over';
            array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
            array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
            array[_const.BLEND_MODES.SCREEN] = 'screen';
            array[_const.BLEND_MODES.OVERLAY] = 'overlay';
            array[_const.BLEND_MODES.DARKEN] = 'darken';
            array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
            array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
            array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
            array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
            array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
            array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
            array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
            array[_const.BLEND_MODES.HUE] = 'hue';
            array[_const.BLEND_MODES.SATURATION] = 'saturate';
            array[_const.BLEND_MODES.COLOR] = 'color';
            array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
        } else {
            // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
            array[_const.BLEND_MODES.NORMAL] = 'source-over';
            array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
            array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
            array[_const.BLEND_MODES.SCREEN] = 'source-over';
            array[_const.BLEND_MODES.OVERLAY] = 'source-over';
            array[_const.BLEND_MODES.DARKEN] = 'source-over';
            array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
            array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
            array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
            array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
            array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
            array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
            array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
            array[_const.BLEND_MODES.HUE] = 'source-over';
            array[_const.BLEND_MODES.SATURATION] = 'source-over';
            array[_const.BLEND_MODES.COLOR] = 'source-over';
            array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
        }
    
        return array;
    }
    
    },{"../../../const":45,"./canUseNewCanvasBlendModes":79}],81:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _const = require('../../const');
    
    var _settings = require('../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
     * up with textures that are no longer being used.
     *
     * @class
     * @memberof PIXI
     */
    var TextureGarbageCollector = function () {
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
         */
        function TextureGarbageCollector(renderer) {
            _classCallCheck(this, TextureGarbageCollector);
    
            this.renderer = renderer;
    
            this.count = 0;
            this.checkCount = 0;
            this.maxIdle = _settings2.default.GC_MAX_IDLE;
            this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
            this.mode = _settings2.default.GC_MODE;
        }
    
        /**
         * Checks to see when the last time a texture was used
         * if the texture has not been used for a specified amount of time it will be removed from the GPU
         */
    
    
        TextureGarbageCollector.prototype.update = function update() {
            this.count++;
    
            if (this.mode === _const.GC_MODES.MANUAL) {
                return;
            }
    
            this.checkCount++;
    
            if (this.checkCount > this.checkCountMax) {
                this.checkCount = 0;
    
                this.run();
            }
        };
    
        /**
         * Checks to see when the last time a texture was used
         * if the texture has not been used for a specified amount of time it will be removed from the GPU
         */
    
    
        TextureGarbageCollector.prototype.run = function run() {
            var tm = this.renderer.textureManager;
            var managedTextures = tm._managedTextures;
            var wasRemoved = false;
    
            for (var i = 0; i < managedTextures.length; i++) {
                var texture = managedTextures[i];
    
                // only supports non generated textures at the moment!
                if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
                    tm.destroyTexture(texture, true);
                    managedTextures[i] = null;
                    wasRemoved = true;
                }
            }
    
            if (wasRemoved) {
                var j = 0;
    
                for (var _i = 0; _i < managedTextures.length; _i++) {
                    if (managedTextures[_i] !== null) {
                        managedTextures[j++] = managedTextures[_i];
                    }
                }
    
                managedTextures.length = j;
            }
        };
    
        /**
         * Removes all the textures within the specified displayObject and its children from the GPU
         *
         * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
         */
    
    
        TextureGarbageCollector.prototype.unload = function unload(displayObject) {
            var tm = this.renderer.textureManager;
    
            // only destroy non generated textures
            if (displayObject._texture && displayObject._texture._glRenderTargets) {
                tm.destroyTexture(displayObject._texture, true);
            }
    
            for (var i = displayObject.children.length - 1; i >= 0; i--) {
                this.unload(displayObject.children[i]);
            }
        };
    
        return TextureGarbageCollector;
    }();
    
    exports.default = TextureGarbageCollector;
    
    },{"../../const":45,"../../settings":100}],82:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _const = require('../../const');
    
    var _RenderTarget = require('./utils/RenderTarget');
    
    var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
    
    var _utils = require('../../utils');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Helper class to create a webGL Texture
     *
     * @class
     * @memberof PIXI
     */
    var TextureManager = function () {
        /**
         * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
         */
        function TextureManager(renderer) {
            _classCallCheck(this, TextureManager);
    
            /**
             * A reference to the current renderer
             *
             * @member {PIXI.WebGLRenderer}
             */
            this.renderer = renderer;
    
            /**
             * The current WebGL rendering context
             *
             * @member {WebGLRenderingContext}
             */
            this.gl = renderer.gl;
    
            /**
             * Track textures in the renderer so we can no longer listen to them on destruction.
             *
             * @member {Array<*>}
             * @private
             */
            this._managedTextures = [];
        }
    
        /**
         * Binds a texture.
         *
         */
    
    
        TextureManager.prototype.bindTexture = function bindTexture() {}
        // empty
    
    
        /**
         * Gets a texture.
         *
         */
        ;
    
        TextureManager.prototype.getTexture = function getTexture() {}
        // empty
    
    
        /**
         * Updates and/or Creates a WebGL texture for the renderer's context.
         *
         * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
         * @param {number} location - the location the texture will be bound to.
         * @return {GLTexture} The gl texture.
         */
        ;
    
        TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
            // assume it good!
            // texture = texture.baseTexture || texture;
    
            var gl = this.gl;
    
            var isRenderTexture = !!texture._glRenderTargets;
    
            if (!texture.hasLoaded) {
                return null;
            }
    
            var boundTextures = this.renderer.boundTextures;
    
            // if the location is undefined then this may have been called by n event.
            // this being the case the texture may already be bound to a slot. As a texture can only be bound once
            // we need to find its current location if it exists.
            if (location === undefined) {
                location = 0;
    
                // TODO maybe we can use texture bound ids later on...
                // check if texture is already bound..
                for (var i = 0; i < boundTextures.length; ++i) {
                    if (boundTextures[i] === texture) {
                        location = i;
                        break;
                    }
                }
            }
    
            boundTextures[location] = texture;
    
            gl.activeTexture(gl.TEXTURE0 + location);
    
            var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];
    
            if (!glTexture) {
                if (isRenderTexture) {
                    var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);
    
                    renderTarget.resize(texture.width, texture.height);
                    texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
                    glTexture = renderTarget.texture;
                } else {
                    glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
                    glTexture.bind(location);
                    glTexture.premultiplyAlpha = true;
                    glTexture.upload(texture.source);
                }
    
                texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;
    
                texture.on('update', this.updateTexture, this);
                texture.on('dispose', this.destroyTexture, this);
    
                this._managedTextures.push(texture);
    
                if (texture.isPowerOfTwo) {
                    if (texture.mipmap) {
                        glTexture.enableMipmap();
                    }
    
                    if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
                        glTexture.enableWrapClamp();
                    } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
                        glTexture.enableWrapRepeat();
                    } else {
                        glTexture.enableWrapMirrorRepeat();
                    }
                } else {
                    glTexture.enableWrapClamp();
                }
    
                if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
                    glTexture.enableNearestScaling();
                } else {
                    glTexture.enableLinearScaling();
                }
            }
            // the texture already exists so we only need to update it..
            else if (isRenderTexture) {
                    texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
                } else {
                    glTexture.upload(texture.source);
                }
    
            return glTexture;
        };
    
        /**
         * Deletes the texture from WebGL
         *
         * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
         * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
         */
    
    
        TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
            texture = texture.baseTexture || texture;
    
            if (!texture.hasLoaded) {
                return;
            }
    
            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
                this.renderer.unbindTexture(texture);
    
                texture._glTextures[this.renderer.CONTEXT_UID].destroy();
                texture.off('update', this.updateTexture, this);
                texture.off('dispose', this.destroyTexture, this);
    
                delete texture._glTextures[this.renderer.CONTEXT_UID];
    
                if (!skipRemove) {
                    var i = this._managedTextures.indexOf(texture);
    
                    if (i !== -1) {
                        (0, _utils.removeItems)(this._managedTextures, i, 1);
                    }
                }
            }
        };
    
        /**
         * Deletes all the textures from WebGL
         */
    
    
        TextureManager.prototype.removeAll = function removeAll() {
            // empty all the old gl textures as they are useless now
            for (var i = 0; i < this._managedTextures.length; ++i) {
                var texture = this._managedTextures[i];
    
                if (texture._glTextures[this.renderer.CONTEXT_UID]) {
                    delete texture._glTextures[this.renderer.CONTEXT_UID];
                }
            }
        };
    
        /**
         * Destroys this manager and removes all its textures
         */
    
    
        TextureManager.prototype.destroy = function destroy() {
            // destroy managed textures
            for (var i = 0; i < this._managedTextures.length; ++i) {
                var texture = this._managedTextures[i];
    
                this.destroyTexture(texture, true);
    
                texture.off('update', this.updateTexture, this);
                texture.off('dispose', this.destroyTexture, this);
            }
    
            this._managedTextures = null;
        };
    
        return TextureManager;
    }();
    
    exports.default = TextureManager;
    
    },{"../../const":45,"../../utils":121,"./utils/RenderTarget":95,"pixi-gl-core":16}],83:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _SystemRenderer2 = require('../SystemRenderer');
    
    var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);
    
    var _MaskManager = require('./managers/MaskManager');
    
    var _MaskManager2 = _interopRequireDefault(_MaskManager);
    
    var _StencilManager = require('./managers/StencilManager');
    
    var _StencilManager2 = _interopRequireDefault(_StencilManager);
    
    var _FilterManager = require('./managers/FilterManager');
    
    var _FilterManager2 = _interopRequireDefault(_FilterManager);
    
    var _RenderTarget = require('./utils/RenderTarget');
    
    var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
    
    var _ObjectRenderer = require('./utils/ObjectRenderer');
    
    var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);
    
    var _TextureManager = require('./TextureManager');
    
    var _TextureManager2 = _interopRequireDefault(_TextureManager);
    
    var _BaseTexture = require('../../textures/BaseTexture');
    
    var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
    
    var _TextureGarbageCollector = require('./TextureGarbageCollector');
    
    var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);
    
    var _WebGLState = require('./WebGLState');
    
    var _WebGLState2 = _interopRequireDefault(_WebGLState);
    
    var _mapWebGLDrawModesToPixi = require('./utils/mapWebGLDrawModesToPixi');
    
    var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);
    
    var _validateContext = require('./utils/validateContext');
    
    var _validateContext2 = _interopRequireDefault(_validateContext);
    
    var _utils = require('../../utils');
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    var _const = require('../../const');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var CONTEXT_UID = 0;
    
    /**
     * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
     * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
     * So no need for Sprite Batches or Sprite Clouds.
     * Don't forget to add the view to your DOM or you will not see anything :)
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.SystemRenderer
     */
    
    var WebGLRenderer = function (_SystemRenderer) {
        _inherits(WebGLRenderer, _SystemRenderer);
    
        /**
         *
         * @param {number} [screenWidth=800] - the width of the screen
         * @param {number} [screenHeight=600] - the height of the screen
         * @param {object} [options] - The optional renderer parameters
         * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
         * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
         * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
         * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
         *  antialiasing is used
         * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
         *  FXAA is faster, but may not always look as great
         * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
         *  The resolution of the renderer retina would be 2.
         * @param {boolean} [options.clearBeforeRender=true] - This sets if the CanvasRenderer will clear
         *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
         *  preserveDrawingBuffer to `true`.
         * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
         *  enable this if you need to call toDataUrl on the webgl context.
         * @param {boolean} [options.roundPixels=false] - If true Pixi will Math.floor() x/y values when
         *  rendering, stopping pixel interpolation.
         * @param {boolean} [options.legacy=false] - If true Pixi will aim to ensure compatibility
         * with older / less advanced devices. If you experiance unexplained flickering try setting this to true.
         */
        function WebGLRenderer(screenWidth, screenHeight) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    
            _classCallCheck(this, WebGLRenderer);
    
            var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', screenWidth, screenHeight, options));
    
            _this.legacy = !!options.legacy;
    
            if (_this.legacy) {
                _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
            }
    
            /**
             * The type of this renderer as a standardised const
             *
             * @member {number}
             * @see PIXI.RENDERER_TYPE
             */
            _this.type = _const.RENDERER_TYPE.WEBGL;
    
            _this.handleContextLost = _this.handleContextLost.bind(_this);
            _this.handleContextRestored = _this.handleContextRestored.bind(_this);
    
            _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
            _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);
    
            /**
             * The options passed in to create a new webgl context.
             *
             * @member {object}
             * @private
             */
            _this._contextOptions = {
                alpha: _this.transparent,
                antialias: options.antialias,
                premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
                stencil: true,
                preserveDrawingBuffer: options.preserveDrawingBuffer
            };
    
            _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;
    
            /**
             * Manages the masks using the stencil buffer.
             *
             * @member {PIXI.MaskManager}
             */
            _this.maskManager = new _MaskManager2.default(_this);
    
            /**
             * Manages the stencil buffer.
             *
             * @member {PIXI.StencilManager}
             */
            _this.stencilManager = new _StencilManager2.default(_this);
    
            /**
             * An empty renderer.
             *
             * @member {PIXI.ObjectRenderer}
             */
            _this.emptyRenderer = new _ObjectRenderer2.default(_this);
    
            /**
             * The currently active ObjectRenderer.
             *
             * @member {PIXI.ObjectRenderer}
             */
            _this.currentRenderer = _this.emptyRenderer;
    
            _this.initPlugins();
    
            /**
             * The current WebGL rendering context, it is created here
             *
             * @member {WebGLRenderingContext}
             */
            // initialize the context so it is ready for the managers.
            if (options.context) {
                // checks to see if a context is valid..
                (0, _validateContext2.default)(options.context);
            }
    
            _this.gl = options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);
    
            _this.CONTEXT_UID = CONTEXT_UID++;
    
            /**
             * The currently active ObjectRenderer.
             *
             * @member {PIXI.WebGLState}
             */
            _this.state = new _WebGLState2.default(_this.gl);
    
            _this.renderingToScreen = true;
    
            /**
             * Holds the current state of textures bound to the GPU.
             * @type {Array}
             */
            _this.boundTextures = null;
    
            /**
             * Holds the current shader
             *
             * @member {PIXI.Shader}
             */
            _this._activeShader = null;
    
            _this._activeVao = null;
    
            /**
             * Holds the current render target
             *
             * @member {PIXI.RenderTarget}
             */
            _this._activeRenderTarget = null;
    
            _this._initContext();
    
            /**
             * Manages the filters.
             *
             * @member {PIXI.FilterManager}
             */
            _this.filterManager = new _FilterManager2.default(_this);
            // map some webGL blend and drawmodes..
            _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);
    
            _this._nextTextureLocation = 0;
    
            _this.setBlendMode(0);
            return _this;
        }
    
        /**
         * Creates the WebGL context
         *
         * @private
         */
    
    
        WebGLRenderer.prototype._initContext = function _initContext() {
            var gl = this.gl;
    
            // restore a context if it was previously lost
            if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
                gl.getExtension('WEBGL_lose_context').restoreContext();
            }
    
            var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    
            this.boundTextures = new Array(maxTextures);
            this.emptyTextures = new Array(maxTextures);
    
            // create a texture manager...
            this.textureManager = new _TextureManager2.default(this);
            this.textureGC = new _TextureGarbageCollector2.default(this);
    
            this.state.resetToDefault();
    
            this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
            this.rootRenderTarget.clearColor = this._backgroundColorRgba;
    
            this.bindRenderTarget(this.rootRenderTarget);
    
            // now lets fill up the textures with empty ones!
            var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);
    
            var tempObj = { _glTextures: {} };
    
            tempObj._glTextures[this.CONTEXT_UID] = {};
    
            for (var i = 0; i < maxTextures; i++) {
                var empty = new _BaseTexture2.default();
    
                empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;
    
                this.boundTextures[i] = tempObj;
                this.emptyTextures[i] = empty;
                this.bindTexture(null, i);
            }
    
            this.emit('context', gl);
    
            // setup the width/height properties and gl viewport
            this.resize(this.screen.width, this.screen.height);
        };
    
        /**
         * Renders the object to its webGL view
         *
         * @param {PIXI.DisplayObject} displayObject - the object to be rendered
         * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
         * @param {boolean} [clear] - Should the canvas be cleared before the new render
         * @param {PIXI.Transform} [transform] - A transform to apply to the render texture before rendering.
         * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
         */
    
    
        WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
            // can be handy to know!
            this.renderingToScreen = !renderTexture;
    
            this.emit('prerender');
    
            // no point rendering if our context has been blown up!
            if (!this.gl || this.gl.isContextLost()) {
                return;
            }
    
            this._nextTextureLocation = 0;
    
            if (!renderTexture) {
                this._lastObjectRendered = displayObject;
            }
    
            if (!skipUpdateTransform) {
                // update the scene graph
                var cacheParent = displayObject.parent;
    
                displayObject.parent = this._tempDisplayObjectParent;
                displayObject.updateTransform();
                displayObject.parent = cacheParent;
                // displayObject.hitArea = //TODO add a temp hit area
            }
    
            this.bindRenderTexture(renderTexture, transform);
    
            this.currentRenderer.start();
    
            if (clear !== undefined ? clear : this.clearBeforeRender) {
                this._activeRenderTarget.clear();
            }
    
            displayObject.renderWebGL(this);
    
            // apply transform..
            this.currentRenderer.flush();
    
            // this.setObjectRenderer(this.emptyRenderer);
    
            this.textureGC.update();
    
            this.emit('postrender');
        };
    
        /**
         * Changes the current renderer to the one given in parameter
         *
         * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
         */
    
    
        WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
            if (this.currentRenderer === objectRenderer) {
                return;
            }
    
            this.currentRenderer.stop();
            this.currentRenderer = objectRenderer;
            this.currentRenderer.start();
        };
    
        /**
         * This should be called if you wish to do some custom rendering
         * It will basically render anything that may be batched up such as sprites
         *
         */
    
    
        WebGLRenderer.prototype.flush = function flush() {
            this.setObjectRenderer(this.emptyRenderer);
        };
    
        /**
         * Resizes the webGL view to the specified width and height.
         *
         * @param {number} screenWidth - the new width of the screen
         * @param {number} screenHeight - the new height of the screen
         */
    
    
        WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
            //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;
    
            _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);
    
            this.rootRenderTarget.resize(screenWidth, screenHeight);
    
            if (this._activeRenderTarget === this.rootRenderTarget) {
                this.rootRenderTarget.activate();
    
                if (this._activeShader) {
                    this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
                }
            }
        };
    
        /**
         * Resizes the webGL view to the specified width and height.
         *
         * @param {number} blendMode - the desired blend mode
         */
    
    
        WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
            this.state.setBlendMode(blendMode);
        };
    
        /**
         * Erases the active render target and fills the drawing area with a colour
         *
         * @param {number} [clearColor] - The colour
         */
    
    
        WebGLRenderer.prototype.clear = function clear(clearColor) {
            this._activeRenderTarget.clear(clearColor);
        };
    
        /**
         * Sets the transform of the active render target to the given matrix
         *
         * @param {PIXI.Matrix} matrix - The transformation matrix
         */
    
    
        WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
            this._activeRenderTarget.transform = matrix;
        };
    
        /**
         * Erases the render texture and fills the drawing area with a colour
         *
         * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
         * @param {number} [clearColor] - The colour
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
            var baseTexture = renderTexture.baseTexture;
            var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
    
            if (renderTarget) {
                renderTarget.clear(clearColor);
            }
    
            return this;
        };
    
        /**
         * Binds a render texture for rendering
         *
         * @param {PIXI.RenderTexture} renderTexture - The render texture to render
         * @param {PIXI.Transform} transform - The transform to be applied to the render texture
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
            var renderTarget = void 0;
    
            if (renderTexture) {
                var baseTexture = renderTexture.baseTexture;
    
                if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
                    // bind the current texture
                    this.textureManager.updateTexture(baseTexture, 0);
                }
    
                this.unbindTexture(baseTexture);
    
                renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
                renderTarget.setFrame(renderTexture.frame);
            } else {
                renderTarget = this.rootRenderTarget;
            }
    
            renderTarget.transform = transform;
            this.bindRenderTarget(renderTarget);
    
            return this;
        };
    
        /**
         * Changes the current render target to the one given in parameter
         *
         * @param {PIXI.RenderTarget} renderTarget - the new render target
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
            if (renderTarget !== this._activeRenderTarget) {
                this._activeRenderTarget = renderTarget;
                renderTarget.activate();
    
                if (this._activeShader) {
                    this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
                }
    
                this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
            }
    
            return this;
        };
    
        /**
         * Changes the current shader to the one given in parameter
         *
         * @param {PIXI.Shader} shader - the new shader
         * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
            // TODO cache
            if (this._activeShader !== shader) {
                this._activeShader = shader;
                shader.bind();
    
                // `autoProject` normally would be a default parameter set to true
                // but because of how Babel transpiles default parameters
                // it hinders the performance of this method.
                if (autoProject !== false) {
                    // automatically set the projection matrix
                    shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
                }
            }
    
            return this;
        };
    
        /**
         * Binds the texture. This will return the location of the bound texture.
         * It may not be the same as the one you pass in. This is due to optimisation that prevents
         * needless binding of textures. For example if the texture is already bound it will return the
         * current location of the texture instead of the one provided. To bypass this use force location
         *
         * @param {PIXI.Texture} texture - the new texture
         * @param {number} location - the suggested texture location
         * @param {boolean} forceLocation - force the location
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
            texture = texture || this.emptyTextures[location];
            texture = texture.baseTexture || texture;
            texture.touched = this.textureGC.count;
    
            if (!forceLocation) {
                // TODO - maybe look into adding boundIds.. save us the loop?
                for (var i = 0; i < this.boundTextures.length; i++) {
                    if (this.boundTextures[i] === texture) {
                        return i;
                    }
                }
    
                if (location === undefined) {
                    this._nextTextureLocation++;
                    this._nextTextureLocation %= this.boundTextures.length;
                    location = this.boundTextures.length - this._nextTextureLocation - 1;
                }
            } else {
                location = location || 0;
            }
    
            var gl = this.gl;
            var glTexture = texture._glTextures[this.CONTEXT_UID];
    
            if (!glTexture) {
                // this will also bind the texture..
                this.textureManager.updateTexture(texture, location);
            } else {
                // bind the current texture
                this.boundTextures[location] = texture;
                gl.activeTexture(gl.TEXTURE0 + location);
                gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
            }
    
            return location;
        };
    
        /**
        * unbinds the texture ...
        *
        * @param {PIXI.Texture} texture - the texture to unbind
        * @return {PIXI.WebGLRenderer} Returns itself.
        */
    
    
        WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
            var gl = this.gl;
    
            texture = texture.baseTexture || texture;
    
            for (var i = 0; i < this.boundTextures.length; i++) {
                if (this.boundTextures[i] === texture) {
                    this.boundTextures[i] = this.emptyTextures[i];
    
                    gl.activeTexture(gl.TEXTURE0 + i);
                    gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
                }
            }
    
            return this;
        };
    
        /**
         * Creates a new VAO from this renderer's context and state.
         *
         * @return {VertexArrayObject} The new VAO.
         */
    
    
        WebGLRenderer.prototype.createVao = function createVao() {
            return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
        };
    
        /**
         * Changes the current Vao to the one given in parameter
         *
         * @param {PIXI.VertexArrayObject} vao - the new Vao
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.bindVao = function bindVao(vao) {
            if (this._activeVao === vao) {
                return this;
            }
    
            if (vao) {
                vao.bind();
            } else if (this._activeVao) {
                // TODO this should always be true i think?
                this._activeVao.unbind();
            }
    
            this._activeVao = vao;
    
            return this;
        };
    
        /**
         * Resets the WebGL state so you can render things however you fancy!
         *
         * @return {PIXI.WebGLRenderer} Returns itself.
         */
    
    
        WebGLRenderer.prototype.reset = function reset() {
            this.setObjectRenderer(this.emptyRenderer);
    
            this._activeShader = null;
            this._activeRenderTarget = this.rootRenderTarget;
    
            // bind the main frame buffer (the screen);
            this.rootRenderTarget.activate();
    
            this.state.resetToDefault();
    
            return this;
        };
    
        /**
         * Handles a lost webgl context
         *
         * @private
         * @param {WebGLContextEvent} event - The context lost event.
         */
    
    
        WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
            event.preventDefault();
        };
    
        /**
         * Handles a restored webgl context
         *
         * @private
         */
    
    
        WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
            this._initContext();
            this.textureManager.removeAll();
        };
    
        /**
         * Removes everything from the renderer (event listeners, spritebatch, etc...)
         *
         * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
         *  See: https://github.com/pixijs/pixi.js/issues/2233
         */
    
    
        WebGLRenderer.prototype.destroy = function destroy(removeView) {
            this.destroyPlugins();
    
            // remove listeners
            this.view.removeEventListener('webglcontextlost', this.handleContextLost);
            this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);
    
            this.textureManager.destroy();
    
            // call base destroy
            _SystemRenderer.prototype.destroy.call(this, removeView);
    
            this.uid = 0;
    
            // destroy the managers
            this.maskManager.destroy();
            this.stencilManager.destroy();
            this.filterManager.destroy();
    
            this.maskManager = null;
            this.filterManager = null;
            this.textureManager = null;
            this.currentRenderer = null;
    
            this.handleContextLost = null;
            this.handleContextRestored = null;
    
            this._contextOptions = null;
            this.gl.useProgram(null);
    
            if (this.gl.getExtension('WEBGL_lose_context')) {
                this.gl.getExtension('WEBGL_lose_context').loseContext();
            }
    
            this.gl = null;
    
            // this = null;
        };
    
        return WebGLRenderer;
    }(_SystemRenderer3.default);
    
    exports.default = WebGLRenderer;
    
    
    _utils.pluginTarget.mixin(WebGLRenderer);
    
    },{"../../const":45,"../../textures/BaseTexture":110,"../../utils":121,"../SystemRenderer":75,"./TextureGarbageCollector":81,"./TextureManager":82,"./WebGLState":84,"./managers/FilterManager":89,"./managers/MaskManager":90,"./managers/StencilManager":91,"./utils/ObjectRenderer":93,"./utils/RenderTarget":95,"./utils/mapWebGLDrawModesToPixi":98,"./utils/validateContext":99,"pixi-gl-core":16}],84:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _mapWebGLBlendModesToPixi = require('./utils/mapWebGLBlendModesToPixi');
    
    var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var BLEND = 0;
    var DEPTH_TEST = 1;
    var FRONT_FACE = 2;
    var CULL_FACE = 3;
    var BLEND_FUNC = 4;
    
    /**
     * A WebGL state machines
     *
     * @memberof PIXI
     * @class
     */
    
    var WebGLState = function () {
        /**
         * @param {WebGLRenderingContext} gl - The current WebGL rendering context
         */
        function WebGLState(gl) {
            _classCallCheck(this, WebGLState);
    
            /**
             * The current active state
             *
             * @member {Uint8Array}
             */
            this.activeState = new Uint8Array(16);
    
            /**
             * The default state
             *
             * @member {Uint8Array}
             */
            this.defaultState = new Uint8Array(16);
    
            // default blend mode..
            this.defaultState[0] = 1;
    
            /**
             * The current state index in the stack
             *
             * @member {number}
             * @private
             */
            this.stackIndex = 0;
    
            /**
             * The stack holding all the different states
             *
             * @member {Array<*>}
             * @private
             */
            this.stack = [];
    
            /**
             * The current WebGL rendering context
             *
             * @member {WebGLRenderingContext}
             */
            this.gl = gl;
    
            this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    
            this.attribState = {
                tempAttribState: new Array(this.maxAttribs),
                attribState: new Array(this.maxAttribs)
            };
    
            this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);
    
            // check we have vao..
            this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
        }
    
        /**
         * Pushes a new active state
         */
    
    
        WebGLState.prototype.push = function push() {
            // next state..
            var state = this.stack[this.stackIndex];
    
            if (!state) {
                state = this.stack[this.stackIndex] = new Uint8Array(16);
            }
    
            ++this.stackIndex;
    
            // copy state..
            // set active state so we can force overrides of gl state
            for (var i = 0; i < this.activeState.length; i++) {
                state[i] = this.activeState[i];
            }
        };
    
        /**
         * Pops a state out
         */
    
    
        WebGLState.prototype.pop = function pop() {
            var state = this.stack[--this.stackIndex];
    
            this.setState(state);
        };
    
        /**
         * Sets the current state
         *
         * @param {*} state - The state to set.
         */
    
    
        WebGLState.prototype.setState = function setState(state) {
            this.setBlend(state[BLEND]);
            this.setDepthTest(state[DEPTH_TEST]);
            this.setFrontFace(state[FRONT_FACE]);
            this.setCullFace(state[CULL_FACE]);
            this.setBlendMode(state[BLEND_FUNC]);
        };
    
        /**
         * Enables or disabled blending.
         *
         * @param {boolean} value - Turn on or off webgl blending.
         */
    
    
        WebGLState.prototype.setBlend = function setBlend(value) {
            value = value ? 1 : 0;
    
            if (this.activeState[BLEND] === value) {
                return;
            }
    
            this.activeState[BLEND] = value;
            this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
        };
    
        /**
         * Sets the blend mode.
         *
         * @param {number} value - The blend mode to set to.
         */
    
    
        WebGLState.prototype.setBlendMode = function setBlendMode(value) {
            if (value === this.activeState[BLEND_FUNC]) {
                return;
            }
    
            this.activeState[BLEND_FUNC] = value;
    
            this.gl.blendFunc(this.blendModes[value][0], this.blendModes[value][1]);
        };
    
        /**
         * Sets whether to enable or disable depth test.
         *
         * @param {boolean} value - Turn on or off webgl depth testing.
         */
    
    
        WebGLState.prototype.setDepthTest = function setDepthTest(value) {
            value = value ? 1 : 0;
    
            if (this.activeState[DEPTH_TEST] === value) {
                return;
            }
    
            this.activeState[DEPTH_TEST] = value;
            this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
        };
    
        /**
         * Sets whether to enable or disable cull face.
         *
         * @param {boolean} value - Turn on or off webgl cull face.
         */
    
    
        WebGLState.prototype.setCullFace = function setCullFace(value) {
            value = value ? 1 : 0;
    
            if (this.activeState[CULL_FACE] === value) {
                return;
            }
    
            this.activeState[CULL_FACE] = value;
            this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
        };
    
        /**
         * Sets the gl front face.
         *
         * @param {boolean} value - true is clockwise and false is counter-clockwise
         */
    
    
        WebGLState.prototype.setFrontFace = function setFrontFace(value) {
            value = value ? 1 : 0;
    
            if (this.activeState[FRONT_FACE] === value) {
                return;
            }
    
            this.activeState[FRONT_FACE] = value;
            this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
        };
    
        /**
         * Disables all the vaos in use
         *
         */
    
    
        WebGLState.prototype.resetAttributes = function resetAttributes() {
            for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
                this.attribState.tempAttribState[i] = 0;
            }
    
            for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
                this.attribState.attribState[_i] = 0;
            }
    
            // im going to assume one is always active for performance reasons.
            for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
                this.gl.disableVertexAttribArray(_i2);
            }
        };
    
        // used
        /**
         * Resets all the logic and disables the vaos
         */
    
    
        WebGLState.prototype.resetToDefault = function resetToDefault() {
            // unbind any VAO if they exist..
            if (this.nativeVaoExtension) {
                this.nativeVaoExtension.bindVertexArrayOES(null);
            }
    
            // reset all attributes..
            this.resetAttributes();
    
            // set active state so we can force overrides of gl state
            for (var i = 0; i < this.activeState.length; ++i) {
                this.activeState[i] = 32;
            }
    
            this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);
    
            this.setState(this.defaultState);
        };
    
        return WebGLState;
    }();
    
    exports.default = WebGLState;
    
    },{"./utils/mapWebGLBlendModesToPixi":97}],85:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _extractUniformsFromSrc = require('./extractUniformsFromSrc');
    
    var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);
    
    var _utils = require('../../../utils');
    
    var _const = require('../../../const');
    
    var _settings = require('../../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var SOURCE_KEY_MAP = {};
    
    // let math = require('../../../math');
    /**
     * @class
     * @memberof PIXI
     * @extends PIXI.Shader
     */
    
    var Filter = function () {
      /**
       * @param {string} [vertexSrc] - The source of the vertex shader.
       * @param {string} [fragmentSrc] - The source of the fragment shader.
       * @param {object} [uniforms] - Custom uniforms to use to augment the built-in ones.
       */
      function Filter(vertexSrc, fragmentSrc, uniforms) {
        _classCallCheck(this, Filter);
    
        /**
         * The vertex shader.
         *
         * @member {string}
         */
        this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;
    
        /**
         * The fragment shader.
         *
         * @member {string}
         */
        this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;
    
        this.blendMode = _const.BLEND_MODES.NORMAL;
    
        this.uniformData = uniforms || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');
    
        /**
         * An object containing the current values of custom uniforms.
         * @example <caption>Updating the value of a custom uniform</caption>
         * filter.uniforms.time = performance.now();
         *
         * @member {object}
         */
        this.uniforms = {};
    
        for (var i in this.uniformData) {
          this.uniforms[i] = this.uniformData[i].value;
        }
    
        // this is where we store shader references..
        // TODO we could cache this!
        this.glShaders = {};
    
        // used for cacheing.. sure there is a better way!
        if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
          SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
        }
    
        this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];
    
        /**
         * The padding of the filter. Some filters require extra space to breath such as a blur.
         * Increasing this will add extra width and height to the bounds of the object that the
         * filter is applied to.
         *
         * @member {number}
         */
        this.padding = 4;
    
        /**
         * The resolution of the filter. Setting this to be lower will lower the quality but
         * increase the performance of the filter.
         *
         * @member {number}
         */
        this.resolution = _settings2.default.RESOLUTION;
    
        /**
         * If enabled is true the filter is applied, if false it will not.
         *
         * @member {boolean}
         */
        this.enabled = true;
    
        /**
         * If enabled, pixi will fit the filter area into boundaries for better performance.
         * Switch it off if it does not work for specific shader.
         *
         * @member {boolean}
         */
        this.autoFit = true;
      }
    
      /**
       * Applies the filter
       *
       * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
       * @param {PIXI.RenderTarget} input - The input render target.
       * @param {PIXI.RenderTarget} output - The target to output to.
       * @param {boolean} clear - Should the output be cleared before rendering to it
       * @param {object} [currentState] - It's current state of filter.
       *        There are some useful properties in the currentState :
       *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
       */
    
    
      Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
      {
        // --- //
        //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );
    
        // do as you please!
    
        filterManager.applyFilter(this, input, output, clear);
    
        // or just do a regular render..
      };
    
      /**
       * The default vertex shader source
       *
       * @static
       * @constant
       */
    
    
      _createClass(Filter, null, [{
        key: 'defaultVertexSrc',
        get: function get() {
          return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
        }
    
        /**
         * The default fragment shader source
         *
         * @static
         * @constant
         */
    
      }, {
        key: 'defaultFragmentSrc',
        get: function get() {
          return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
          // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
          '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
        }
      }]);
    
      return Filter;
    }();
    
    exports.default = Filter;
    
    },{"../../../const":45,"../../../settings":100,"../../../utils":121,"./extractUniformsFromSrc":86}],86:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = extractUniformsFromSrc;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var defaultValue = _pixiGlCore2.default.shader.defaultValue;
    
    function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
        var vertUniforms = extractUniformsFromString(vertexSrc, mask);
        var fragUniforms = extractUniformsFromString(fragmentSrc, mask);
    
        return Object.assign(vertUniforms, fragUniforms);
    }
    
    function extractUniformsFromString(string) {
        var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');
    
        var uniforms = {};
        var nameSplit = void 0;
    
        // clean the lines a little - remove extra spaces / tabs etc
        // then split along ';'
        var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);
    
        // loop through..
        for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
    
            if (line.indexOf('uniform') > -1) {
                var splitLine = line.split(' ');
                var type = splitLine[1];
    
                var name = splitLine[2];
                var size = 1;
    
                if (name.indexOf('[') > -1) {
                    // array!
                    nameSplit = name.split(/\[|]/);
                    name = nameSplit[0];
                    size *= Number(nameSplit[1]);
                }
    
                if (!name.match(maskRegex)) {
                    uniforms[name] = {
                        value: defaultValue(type, size),
                        name: name,
                        type: type
                    };
                }
            }
        }
    
        return uniforms;
    }
    
    },{"pixi-gl-core":16}],87:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
    exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
    exports.calculateSpriteMatrix = calculateSpriteMatrix;
    
    var _math = require('../../../math');
    
    /*
     * Calculates the mapped matrix
     * @param filterArea {Rectangle} The filter area
     * @param sprite {Sprite} the target sprite
     * @param outputMatrix {Matrix} @alvin
     */
    // TODO playing around here.. this is temporary - (will end up in the shader)
    // this returns a matrix that will normalise map filter cords in the filter to screen space
    function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
        // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
        // let texture = {width:1136, height:700};//sprite._texture.baseTexture;
    
        // TODO unwrap?
        var mappedMatrix = outputMatrix.identity();
    
        mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
    
        mappedMatrix.scale(textureSize.width, textureSize.height);
    
        return mappedMatrix;
    }
    
    function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
        var mappedMatrix = outputMatrix.identity();
    
        mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
    
        var translateScaleX = textureSize.width / filterArea.width;
        var translateScaleY = textureSize.height / filterArea.height;
    
        mappedMatrix.scale(translateScaleX, translateScaleY);
    
        return mappedMatrix;
    }
    
    // this will map the filter coord so that a texture can be used based on the transform of a sprite
    function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
        var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);
        var texture = sprite._texture.baseTexture;
    
        // TODO unwrap?
        var mappedMatrix = outputMatrix.identity();
    
        // scale..
        var ratio = textureSize.height / textureSize.width;
    
        mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);
    
        mappedMatrix.scale(1, ratio);
    
        var translateScaleX = textureSize.width / texture.width;
        var translateScaleY = textureSize.height / texture.height;
    
        worldTransform.tx /= texture.width * translateScaleX;
    
        // this...?  free beer for anyone who can explain why this makes sense!
        worldTransform.ty /= texture.width * translateScaleX;
        // worldTransform.ty /= texture.height * translateScaleY;
    
        worldTransform.invert();
        mappedMatrix.prepend(worldTransform);
    
        // apply inverse scale..
        mappedMatrix.scale(1, 1 / ratio);
    
        mappedMatrix.scale(translateScaleX, translateScaleY);
    
        mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);
    
        return mappedMatrix;
    }
    
    },{"../../../math":69}],88:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Filter2 = require('../Filter');
    
    var _Filter3 = _interopRequireDefault(_Filter2);
    
    var _math = require('../../../../math');
    
    var _path = require('path');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The SpriteMaskFilter class
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI
     */
    var SpriteMaskFilter = function (_Filter) {
        _inherits(SpriteMaskFilter, _Filter);
    
        /**
         * @param {PIXI.Sprite} sprite - the target sprite
         */
        function SpriteMaskFilter(sprite) {
            _classCallCheck(this, SpriteMaskFilter);
    
            var maskMatrix = new _math.Matrix();
    
            var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float alpha;\nuniform sampler2D mask;\n\nvoid main(void)\n{\n    // check clip! this will stop the mask bleeding out from the edges\n    vec2 text = abs( vMaskCoord - 0.5 );\n    text = step(0.5, text);\n\n    float clip = 1.0 - max(text.y, text.x);\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));
    
            sprite.renderable = false;
    
            _this.maskSprite = sprite;
            _this.maskMatrix = maskMatrix;
            return _this;
        }
    
        /**
         * Applies the filter
         *
         * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
         * @param {PIXI.RenderTarget} input - The input render target.
         * @param {PIXI.RenderTarget} output - The target to output to.
         */
    
    
        SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output) {
            var maskSprite = this.maskSprite;
    
            this.uniforms.mask = maskSprite._texture;
            this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite);
            this.uniforms.alpha = maskSprite.worldAlpha;
    
            filterManager.applyFilter(this, input, output);
        };
    
        return SpriteMaskFilter;
    }(_Filter3.default);
    
    exports.default = SpriteMaskFilter;
    
    },{"../../../../math":69,"../Filter":85,"path":9}],89:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLManager2 = require('./WebGLManager');
    
    var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
    
    var _RenderTarget = require('../utils/RenderTarget');
    
    var _RenderTarget2 = _interopRequireDefault(_RenderTarget);
    
    var _Quad = require('../utils/Quad');
    
    var _Quad2 = _interopRequireDefault(_Quad);
    
    var _math = require('../../../math');
    
    var _Shader = require('../../../Shader');
    
    var _Shader2 = _interopRequireDefault(_Shader);
    
    var _filterTransforms = require('../filters/filterTransforms');
    
    var filterTransforms = _interopRequireWildcard(_filterTransforms);
    
    var _bitTwiddle = require('bit-twiddle');
    
    var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @ignore
     * @class
     */
    var FilterState =
    /**
     *
     */
    function FilterState() {
        _classCallCheck(this, FilterState);
    
        this.renderTarget = null;
        this.sourceFrame = new _math.Rectangle();
        this.destinationFrame = new _math.Rectangle();
        this.filters = [];
        this.target = null;
        this.resolution = 1;
    };
    
    /**
     * @class
     * @memberof PIXI
     * @extends PIXI.WebGLManager
     */
    
    
    var FilterManager = function (_WebGLManager) {
        _inherits(FilterManager, _WebGLManager);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
         */
        function FilterManager(renderer) {
            _classCallCheck(this, FilterManager);
    
            var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
    
            _this.gl = _this.renderer.gl;
            // know about sprites!
            _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);
    
            _this.shaderCache = {};
            // todo add default!
            _this.pool = {};
    
            _this.filterData = null;
            return _this;
        }
    
        /**
         * Adds a new filter to the manager.
         *
         * @param {PIXI.DisplayObject} target - The target of the filter to render.
         * @param {PIXI.Filter[]} filters - The filters to apply.
         */
    
    
        FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
            var renderer = this.renderer;
    
            var filterData = this.filterData;
    
            if (!filterData) {
                filterData = this.renderer._activeRenderTarget.filterStack;
    
                // add new stack
                var filterState = new FilterState();
    
                filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
                filterState.renderTarget = renderer._activeRenderTarget;
    
                this.renderer._activeRenderTarget.filterData = filterData = {
                    index: 0,
                    stack: [filterState]
                };
    
                this.filterData = filterData;
            }
    
            // get the current filter state..
            var currentState = filterData.stack[++filterData.index];
    
            if (!currentState) {
                currentState = filterData.stack[filterData.index] = new FilterState();
            }
    
            // for now we go off the filter of the first resolution..
            var resolution = filters[0].resolution;
            var padding = filters[0].padding | 0;
            var targetBounds = target.filterArea || target.getBounds(true);
            var sourceFrame = currentState.sourceFrame;
            var destinationFrame = currentState.destinationFrame;
    
            sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
            sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
            sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
            sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;
    
            if (filterData.stack[0].renderTarget.transform) {//
    
                // TODO we should fit the rect around the transform..
            } else if (filters[0].autoFit) {
                sourceFrame.fit(filterData.stack[0].destinationFrame);
            }
    
            // lets apply the padding After we fit the element to the screen.
            // this should stop the strange side effects that can occur when cropping to the edges
            sourceFrame.pad(padding);
    
            destinationFrame.width = sourceFrame.width;
            destinationFrame.height = sourceFrame.height;
    
            // lets play the padding after we fit the element to the screen.
            // this should stop the strange side effects that can occur when cropping to the edges
    
            var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);
    
            currentState.target = target;
            currentState.filters = filters;
            currentState.resolution = resolution;
            currentState.renderTarget = renderTarget;
    
            // bind the render target to draw the shape in the top corner..
    
            renderTarget.setFrame(destinationFrame, sourceFrame);
    
            // bind the render target
            renderer.bindRenderTarget(renderTarget);
            renderTarget.clear();
        };
    
        /**
         * Pops off the filter and applies it.
         *
         */
    
    
        FilterManager.prototype.popFilter = function popFilter() {
            var filterData = this.filterData;
    
            var lastState = filterData.stack[filterData.index - 1];
            var currentState = filterData.stack[filterData.index];
    
            this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();
    
            var filters = currentState.filters;
    
            if (filters.length === 1) {
                filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
                this.freePotRenderTarget(currentState.renderTarget);
            } else {
                var flip = currentState.renderTarget;
                var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);
    
                flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);
    
                // finally lets clear the render target before drawing to it..
                flop.clear();
    
                var i = 0;
    
                for (i = 0; i < filters.length - 1; ++i) {
                    filters[i].apply(this, flip, flop, true, currentState);
    
                    var t = flip;
    
                    flip = flop;
                    flop = t;
                }
    
                filters[i].apply(this, flip, lastState.renderTarget, false, currentState);
    
                this.freePotRenderTarget(flip);
                this.freePotRenderTarget(flop);
            }
    
            filterData.index--;
    
            if (filterData.index === 0) {
                this.filterData = null;
            }
        };
    
        /**
         * Draws a filter.
         *
         * @param {PIXI.Filter} filter - The filter to draw.
         * @param {PIXI.RenderTarget} input - The input render target.
         * @param {PIXI.RenderTarget} output - The target to output to.
         * @param {boolean} clear - Should the output be cleared before rendering to it
         */
    
    
        FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
            var renderer = this.renderer;
            var gl = renderer.gl;
    
            var shader = filter.glShaders[renderer.CONTEXT_UID];
    
            // cacheing..
            if (!shader) {
                if (filter.glShaderKey) {
                    shader = this.shaderCache[filter.glShaderKey];
    
                    if (!shader) {
                        shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
    
                        filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
                    }
                } else {
                    shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
                }
    
                // TODO - this only needs to be done once?
                renderer.bindVao(null);
    
                this.quad.initVao(shader);
            }
    
            renderer.bindVao(this.quad.vao);
    
            renderer.bindRenderTarget(output);
    
            if (clear) {
                gl.disable(gl.SCISSOR_TEST);
                renderer.clear(); // [1, 1, 1, 1]);
                gl.enable(gl.SCISSOR_TEST);
            }
    
            // in case the render target is being masked using a scissor rect
            if (output === renderer.maskManager.scissorRenderTarget) {
                renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
            }
    
            renderer.bindShader(shader);
    
            // free unit 0 for us, doesn't matter what was there
            // don't try to restore it, because syncUniforms can upload it to another slot
            // and it'll be a problem
            var tex = this.renderer.emptyTextures[0];
    
            this.renderer.boundTextures[0] = tex;
            // this syncs the pixi filters  uniforms with glsl uniforms
            this.syncUniforms(shader, filter);
    
            renderer.state.setBlendMode(filter.blendMode);
    
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);
    
            this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
    
            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
        };
    
        /**
         * Uploads the uniforms of the filter.
         *
         * @param {GLShader} shader - The underlying gl shader.
         * @param {PIXI.Filter} filter - The filter we are synchronizing.
         */
    
    
        FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
            var uniformData = filter.uniformData;
            var uniforms = filter.uniforms;
    
            // 0 is reserved for the pixi texture so we start at 1!
            var textureCount = 1;
            var currentState = void 0;
    
            // filterArea and filterClamp that are handled by FilterManager directly
            // they must not appear in uniformData
    
            if (shader.uniforms.filterArea) {
                currentState = this.filterData.stack[this.filterData.index];
    
                var filterArea = shader.uniforms.filterArea;
    
                filterArea[0] = currentState.renderTarget.size.width;
                filterArea[1] = currentState.renderTarget.size.height;
                filterArea[2] = currentState.sourceFrame.x;
                filterArea[3] = currentState.sourceFrame.y;
    
                shader.uniforms.filterArea = filterArea;
            }
    
            // use this to clamp displaced texture coords so they belong to filterArea
            // see displacementFilter fragment shader for an example
            if (shader.uniforms.filterClamp) {
                currentState = currentState || this.filterData.stack[this.filterData.index];
    
                var filterClamp = shader.uniforms.filterClamp;
    
                filterClamp[0] = 0;
                filterClamp[1] = 0;
                filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
                filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;
    
                shader.uniforms.filterClamp = filterClamp;
            }
    
            // TODO Cacheing layer..
            for (var i in uniformData) {
                if (uniformData[i].type === 'sampler2D' && uniforms[i] !== 0) {
                    if (uniforms[i].baseTexture) {
                        shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
                    } else {
                        shader.uniforms[i] = textureCount;
    
                        // TODO
                        // this is helpful as renderTargets can also be set.
                        // Although thinking about it, we could probably
                        // make the filter texture cache return a RenderTexture
                        // rather than a renderTarget
                        var gl = this.renderer.gl;
    
                        this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
                        gl.activeTexture(gl.TEXTURE0 + textureCount);
    
                        uniforms[i].texture.bind();
                    }
    
                    textureCount++;
                } else if (uniformData[i].type === 'mat3') {
                    // check if its pixi matrix..
                    if (uniforms[i].a !== undefined) {
                        shader.uniforms[i] = uniforms[i].toArray(true);
                    } else {
                        shader.uniforms[i] = uniforms[i];
                    }
                } else if (uniformData[i].type === 'vec2') {
                    // check if its a point..
                    if (uniforms[i].x !== undefined) {
                        var val = shader.uniforms[i] || new Float32Array(2);
    
                        val[0] = uniforms[i].x;
                        val[1] = uniforms[i].y;
                        shader.uniforms[i] = val;
                    } else {
                        shader.uniforms[i] = uniforms[i];
                    }
                } else if (uniformData[i].type === 'float') {
                    if (shader.uniforms.data[i].value !== uniformData[i]) {
                        shader.uniforms[i] = uniforms[i];
                    }
                } else {
                    shader.uniforms[i] = uniforms[i];
                }
            }
        };
    
        /**
         * Gets a render target from the pool, or creates a new one.
         *
         * @param {boolean} clear - Should we clear the render texture when we get it?
         * @param {number} resolution - The resolution of the target.
         * @return {PIXI.RenderTarget} The new render target
         */
    
    
        FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
            var currentState = this.filterData.stack[this.filterData.index];
            var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);
    
            renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);
    
            return renderTarget;
        };
    
        /**
         * Returns a render target to the pool.
         *
         * @param {PIXI.RenderTarget} renderTarget - The render target to return.
         */
    
    
        FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
            this.freePotRenderTarget(renderTarget);
        };
    
        /**
         * Calculates the mapped matrix.
         *
         * TODO playing around here.. this is temporary - (will end up in the shader)
         * this returns a matrix that will normalise map filter cords in the filter to screen space
         *
         * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
         * @return {PIXI.Matrix} The mapped matrix.
         */
    
    
        FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
            var currentState = this.filterData.stack[this.filterData.index];
    
            return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
        };
    
        /**
         * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
         *
         * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
         * @return {PIXI.Matrix} The mapped matrix.
         */
    
    
        FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
            var currentState = this.filterData.stack[this.filterData.index];
    
            return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
        };
    
        /**
         * This will map the filter coord so that a texture can be used based on the transform of a sprite
         *
         * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
         * @param {PIXI.Sprite} sprite - The sprite to map to.
         * @return {PIXI.Matrix} The mapped matrix.
         */
    
    
        FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
            var currentState = this.filterData.stack[this.filterData.index];
    
            return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
        };
    
        /**
         * Destroys this Filter Manager.
         *
         */
    
    
        FilterManager.prototype.destroy = function destroy() {
            this.shaderCache = {};
            this.emptyPool();
        };
    
        /**
         * Gets a Power-of-Two render texture.
         *
         * TODO move to a seperate class could be on renderer?
         * also - could cause issue with multiple contexts?
         *
         * @private
         * @param {WebGLRenderingContext} gl - The webgl rendering context
         * @param {number} minWidth - The minimum width of the render target.
         * @param {number} minHeight - The minimum height of the render target.
         * @param {number} resolution - The resolution of the render target.
         * @return {PIXI.RenderTarget} The new render target.
         */
    
    
        FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
            // TODO you could return a bigger texture if there is not one in the pool?
            minWidth = _bitTwiddle2.default.nextPow2(minWidth * resolution);
            minHeight = _bitTwiddle2.default.nextPow2(minHeight * resolution);
    
            var key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
    
            if (!this.pool[key]) {
                this.pool[key] = [];
            }
    
            var renderTarget = this.pool[key].pop();
    
            // creating render target will cause texture to be bound!
            if (!renderTarget) {
                // temporary bypass cache..
                var tex = this.renderer.boundTextures[0];
    
                gl.activeTexture(gl.TEXTURE0);
    
                // internally - this will cause a texture to be bound..
                renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);
    
                // set the current one back
                gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
            }
    
            // manually tweak the resolution...
            // this will not modify the size of the frame buffer, just its resolution.
            renderTarget.resolution = resolution;
            renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
            renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
    
            return renderTarget;
        };
    
        /**
         * Empties the texture pool.
         *
         */
    
    
        FilterManager.prototype.emptyPool = function emptyPool() {
            for (var i in this.pool) {
                var textures = this.pool[i];
    
                if (textures) {
                    for (var j = 0; j < textures.length; j++) {
                        textures[j].destroy(true);
                    }
                }
            }
    
            this.pool = {};
        };
    
        /**
         * Frees a render target back into the pool.
         *
         * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
         */
    
    
        FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
            var minWidth = renderTarget.size.width * renderTarget.resolution;
            var minHeight = renderTarget.size.height * renderTarget.resolution;
            var key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
    
            this.pool[key].push(renderTarget);
        };
    
        return FilterManager;
    }(_WebGLManager3.default);
    
    exports.default = FilterManager;
    
    },{"../../../Shader":43,"../../../math":69,"../filters/filterTransforms":87,"../utils/Quad":94,"../utils/RenderTarget":95,"./WebGLManager":92,"bit-twiddle":1}],90:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLManager2 = require('./WebGLManager');
    
    var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
    
    var _SpriteMaskFilter = require('../filters/spriteMask/SpriteMaskFilter');
    
    var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @class
     * @extends PIXI.WebGLManager
     * @memberof PIXI
     */
    var MaskManager = function (_WebGLManager) {
        _inherits(MaskManager, _WebGLManager);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
         */
        function MaskManager(renderer) {
            _classCallCheck(this, MaskManager);
    
            // TODO - we don't need both!
            var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
    
            _this.scissor = false;
            _this.scissorData = null;
            _this.scissorRenderTarget = null;
    
            _this.enableScissor = true;
    
            _this.alphaMaskPool = [];
            _this.alphaMaskIndex = 0;
            return _this;
        }
    
        /**
         * Applies the Mask and adds it to the current filter stack.
         *
         * @param {PIXI.DisplayObject} target - Display Object to push the mask to
         * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
         */
    
    
        MaskManager.prototype.pushMask = function pushMask(target, maskData) {
            // TODO the root check means scissor rect will not
            // be used on render textures more info here:
            // https://github.com/pixijs/pixi.js/pull/3545
    
            if (maskData.texture) {
                this.pushSpriteMask(target, maskData);
            } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
                var matrix = maskData.worldTransform;
    
                var rot = Math.atan2(matrix.b, matrix.a);
    
                // use the nearest degree!
                rot = Math.round(rot * (180 / Math.PI));
    
                if (rot % 90) {
                    this.pushStencilMask(maskData);
                } else {
                    this.pushScissorMask(target, maskData);
                }
            } else {
                this.pushStencilMask(maskData);
            }
        };
    
        /**
         * Removes the last mask from the mask stack and doesn't return it.
         *
         * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
         * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
         */
    
    
        MaskManager.prototype.popMask = function popMask(target, maskData) {
            if (maskData.texture) {
                this.popSpriteMask(target, maskData);
            } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
                this.popScissorMask(target, maskData);
            } else {
                this.popStencilMask(target, maskData);
            }
        };
    
        /**
         * Applies the Mask and adds it to the current filter stack.
         *
         * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
         * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
         */
    
    
        MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
            var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];
    
            if (!alphaMaskFilter) {
                alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
            }
    
            alphaMaskFilter[0].resolution = this.renderer.resolution;
            alphaMaskFilter[0].maskSprite = maskData;
    
            // TODO - may cause issues!
            target.filterArea = maskData.getBounds(true);
    
            this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
    
            this.alphaMaskIndex++;
        };
    
        /**
         * Removes the last filter from the filter stack and doesn't return it.
         *
         */
    
    
        MaskManager.prototype.popSpriteMask = function popSpriteMask() {
            this.renderer.filterManager.popFilter();
            this.alphaMaskIndex--;
        };
    
        /**
         * Applies the Mask and adds it to the current filter stack.
         *
         * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
         */
    
    
        MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
            this.renderer.currentRenderer.stop();
            this.renderer.stencilManager.pushStencil(maskData);
        };
    
        /**
         * Removes the last filter from the filter stack and doesn't return it.
         *
         */
    
    
        MaskManager.prototype.popStencilMask = function popStencilMask() {
            this.renderer.currentRenderer.stop();
            this.renderer.stencilManager.popStencil();
        };
    
        /**
         *
         * @param {PIXI.DisplayObject} target - Display Object to push the mask to
         * @param {PIXI.Graphics} maskData - The masking data.
         */
    
    
        MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
            maskData.renderable = true;
    
            var renderTarget = this.renderer._activeRenderTarget;
    
            var bounds = maskData.getBounds();
    
            bounds.fit(renderTarget.size);
            maskData.renderable = false;
    
            this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);
    
            var resolution = this.renderer.resolution;
    
            this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);
    
            this.scissorRenderTarget = renderTarget;
            this.scissorData = maskData;
            this.scissor = true;
        };
    
        /**
         *
         *
         */
    
    
        MaskManager.prototype.popScissorMask = function popScissorMask() {
            this.scissorRenderTarget = null;
            this.scissorData = null;
            this.scissor = false;
    
            // must be scissor!
            var gl = this.renderer.gl;
    
            gl.disable(gl.SCISSOR_TEST);
        };
    
        return MaskManager;
    }(_WebGLManager3.default);
    
    exports.default = MaskManager;
    
    },{"../filters/spriteMask/SpriteMaskFilter":88,"./WebGLManager":92}],91:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLManager2 = require('./WebGLManager');
    
    var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @class
     * @extends PIXI.WebGLManager
     * @memberof PIXI
     */
    var StencilManager = function (_WebGLManager) {
        _inherits(StencilManager, _WebGLManager);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
         */
        function StencilManager(renderer) {
            _classCallCheck(this, StencilManager);
    
            var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));
    
            _this.stencilMaskStack = null;
            return _this;
        }
    
        /**
         * Changes the mask stack that is used by this manager.
         *
         * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
         */
    
    
        StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
            this.stencilMaskStack = stencilMaskStack;
    
            var gl = this.renderer.gl;
    
            if (stencilMaskStack.length === 0) {
                gl.disable(gl.STENCIL_TEST);
            } else {
                gl.enable(gl.STENCIL_TEST);
            }
        };
    
        /**
         * Applies the Mask and adds it to the current filter stack. @alvin
         *
         * @param {PIXI.Graphics} graphics - The mask
         */
    
    
        StencilManager.prototype.pushStencil = function pushStencil(graphics) {
            this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
    
            this.renderer._activeRenderTarget.attachStencilBuffer();
    
            var gl = this.renderer.gl;
            var sms = this.stencilMaskStack;
    
            if (sms.length === 0) {
                gl.enable(gl.STENCIL_TEST);
                gl.clear(gl.STENCIL_BUFFER_BIT);
                gl.stencilFunc(gl.ALWAYS, 1, 1);
            }
    
            sms.push(graphics);
    
            gl.colorMask(false, false, false, false);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
    
            this.renderer.plugins.graphics.render(graphics);
    
            gl.colorMask(true, true, true, true);
            gl.stencilFunc(gl.NOTEQUAL, 0, sms.length);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        };
    
        /**
         * TODO @alvin
         */
    
    
        StencilManager.prototype.popStencil = function popStencil() {
            this.renderer.setObjectRenderer(this.renderer.plugins.graphics);
    
            var gl = this.renderer.gl;
            var sms = this.stencilMaskStack;
    
            var graphics = sms.pop();
    
            if (sms.length === 0) {
                // the stack is empty!
                gl.disable(gl.STENCIL_TEST);
            } else {
                gl.colorMask(false, false, false, false);
                gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
    
                this.renderer.plugins.graphics.render(graphics);
    
                gl.colorMask(true, true, true, true);
                gl.stencilFunc(gl.NOTEQUAL, 0, sms.length);
                gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
            }
        };
    
        /**
         * Destroys the mask stack.
         *
         */
    
    
        StencilManager.prototype.destroy = function destroy() {
            _WebGLManager3.default.prototype.destroy.call(this);
    
            this.stencilMaskStack.stencilStack = null;
        };
    
        return StencilManager;
    }(_WebGLManager3.default);
    
    exports.default = StencilManager;
    
    },{"./WebGLManager":92}],92:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @class
     * @memberof PIXI
     */
    var WebGLManager = function () {
      /**
       * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
       */
      function WebGLManager(renderer) {
        _classCallCheck(this, WebGLManager);
    
        /**
         * The renderer this manager works for.
         *
         * @member {PIXI.WebGLRenderer}
         */
        this.renderer = renderer;
    
        this.renderer.on('context', this.onContextChange, this);
      }
    
      /**
       * Generic method called when there is a WebGL context change.
       *
       */
    
    
      WebGLManager.prototype.onContextChange = function onContextChange() {}
      // do some codes init!
    
    
      /**
       * Generic destroy methods to be overridden by the subclass
       *
       */
      ;
    
      WebGLManager.prototype.destroy = function destroy() {
        this.renderer.off('context', this.onContextChange, this);
    
        this.renderer = null;
      };
    
      return WebGLManager;
    }();
    
    exports.default = WebGLManager;
    
    },{}],93:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLManager2 = require('../managers/WebGLManager');
    
    var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * Base for a common object renderer that can be used as a system renderer plugin.
     *
     * @class
     * @extends PIXI.WebGLManager
     * @memberof PIXI
     */
    var ObjectRenderer = function (_WebGLManager) {
      _inherits(ObjectRenderer, _WebGLManager);
    
      function ObjectRenderer() {
        _classCallCheck(this, ObjectRenderer);
    
        return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
      }
    
      /**
       * Starts the renderer and sets the shader
       *
       */
      ObjectRenderer.prototype.start = function start() {}
      // set the shader..
    
    
      /**
       * Stops the renderer
       *
       */
      ;
    
      ObjectRenderer.prototype.stop = function stop() {
        this.flush();
      };
    
      /**
       * Stub method for rendering content and emptying the current batch.
       *
       */
    
    
      ObjectRenderer.prototype.flush = function flush() {}
      // flush!
    
    
      /**
       * Renders an object
       *
       * @param {PIXI.DisplayObject} object - The object to render.
       */
      ;
    
      ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
      {
        // render the object
      };
    
      return ObjectRenderer;
    }(_WebGLManager3.default);
    
    exports.default = ObjectRenderer;
    
    },{"../managers/WebGLManager":92}],94:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    var _createIndicesForQuads = require('../../../utils/createIndicesForQuads');
    
    var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Helper class to create a quad
     *
     * @class
     * @memberof PIXI
     */
    var Quad = function () {
      /**
       * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
       * @param {object} state - TODO: Description
       */
      function Quad(gl, state) {
        _classCallCheck(this, Quad);
    
        /*
         * the current WebGL drawing context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */
        this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);
    
        /**
         * The Uvs of the quad
         *
         * @member {Float32Array}
         */
        this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    
        this.interleaved = new Float32Array(8 * 2);
    
        for (var i = 0; i < 4; i++) {
          this.interleaved[i * 4] = this.vertices[i * 2];
          this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
          this.interleaved[i * 4 + 2] = this.uvs[i * 2];
          this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
        }
    
        /*
         * @member {Uint16Array} An array containing the indices of the vertices
         */
        this.indices = (0, _createIndicesForQuads2.default)(1);
    
        /*
         * @member {glCore.GLBuffer} The vertex buffer
         */
        this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);
    
        /*
         * @member {glCore.GLBuffer} The index buffer
         */
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
    
        /*
         * @member {glCore.VertexArrayObject} The index buffer
         */
        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
      }
    
      /**
       * Initialises the vaos and uses the shader.
       *
       * @param {PIXI.Shader} shader - the shader to use
       */
    
    
      Quad.prototype.initVao = function initVao(shader) {
        this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
      };
    
      /**
       * Maps two Rectangle to the quad.
       *
       * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
       * @param {PIXI.Rectangle} destinationFrame - the second rectangle
       * @return {PIXI.Quad} Returns itself.
       */
    
    
      Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
        var x = 0; // destinationFrame.x / targetTextureFrame.width;
        var y = 0; // destinationFrame.y / targetTextureFrame.height;
    
        this.uvs[0] = x;
        this.uvs[1] = y;
    
        this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[3] = y;
    
        this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
        this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;
    
        this.uvs[6] = x;
        this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;
    
        x = destinationFrame.x;
        y = destinationFrame.y;
    
        this.vertices[0] = x;
        this.vertices[1] = y;
    
        this.vertices[2] = x + destinationFrame.width;
        this.vertices[3] = y;
    
        this.vertices[4] = x + destinationFrame.width;
        this.vertices[5] = y + destinationFrame.height;
    
        this.vertices[6] = x;
        this.vertices[7] = y + destinationFrame.height;
    
        return this;
      };
    
      /**
       * Binds the buffer and uploads the data
       *
       * @return {PIXI.Quad} Returns itself.
       */
    
    
      Quad.prototype.upload = function upload() {
        for (var i = 0; i < 4; i++) {
          this.interleaved[i * 4] = this.vertices[i * 2];
          this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
          this.interleaved[i * 4 + 2] = this.uvs[i * 2];
          this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
        }
    
        this.vertexBuffer.upload(this.interleaved);
    
        return this;
      };
    
      /**
       * Removes this quad from WebGL
       */
    
    
      Quad.prototype.destroy = function destroy() {
        var gl = this.gl;
    
        gl.deleteBuffer(this.vertexBuffer);
        gl.deleteBuffer(this.indexBuffer);
      };
    
      return Quad;
    }();
    
    exports.default = Quad;
    
    },{"../../../utils/createIndicesForQuads":119,"pixi-gl-core":16}],95:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _math = require('../../../math');
    
    var _const = require('../../../const');
    
    var _settings = require('../../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _pixiGlCore = require('pixi-gl-core');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @class
     * @memberof PIXI
     */
    var RenderTarget = function () {
      /**
       * @param {WebGLRenderingContext} gl - The current WebGL drawing context
       * @param {number} [width=0] - the horizontal range of the filter
       * @param {number} [height=0] - the vertical range of the filter
       * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
       * @param {number} [resolution=1] - The current resolution / device pixel ratio
       * @param {boolean} [root=false] - Whether this object is the root element or not
       */
      function RenderTarget(gl, width, height, scaleMode, resolution, root) {
        _classCallCheck(this, RenderTarget);
    
        // TODO Resolution could go here ( eg low res blurs )
    
        /**
         * The current WebGL drawing context.
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;
    
        // next time to create a frame buffer and texture
    
        /**
         * A frame buffer
         *
         * @member {PIXI.glCore.GLFramebuffer}
         */
        this.frameBuffer = null;
    
        /**
         * The texture
         *
         * @member {PIXI.glCore.GLTexture}
         */
        this.texture = null;
    
        /**
         * The background colour of this render target, as an array of [r,g,b,a] values
         *
         * @member {number[]}
         */
        this.clearColor = [0, 0, 0, 0];
    
        /**
         * The size of the object as a rectangle
         *
         * @member {PIXI.Rectangle}
         */
        this.size = new _math.Rectangle(0, 0, 1, 1);
    
        /**
         * The current resolution / device pixel ratio
         *
         * @member {number}
         * @default 1
         */
        this.resolution = resolution || _settings2.default.RESOLUTION;
    
        /**
         * The projection matrix
         *
         * @member {PIXI.Matrix}
         */
        this.projectionMatrix = new _math.Matrix();
    
        /**
         * The object's transform
         *
         * @member {PIXI.Matrix}
         */
        this.transform = null;
    
        /**
         * The frame.
         *
         * @member {PIXI.Rectangle}
         */
        this.frame = null;
    
        /**
         * The stencil buffer stores masking data for the render target
         *
         * @member {glCore.GLBuffer}
         */
        this.defaultFrame = new _math.Rectangle();
        this.destinationFrame = null;
        this.sourceFrame = null;
    
        /**
         * The stencil buffer stores masking data for the render target
         *
         * @member {glCore.GLBuffer}
         */
        this.stencilBuffer = null;
    
        /**
         * The data structure for the stencil masks
         *
         * @member {PIXI.Graphics[]}
         */
        this.stencilMaskStack = [];
    
        /**
         * Stores filter data for the render target
         *
         * @member {object[]}
         */
        this.filterData = null;
    
        /**
         * The scale mode.
         *
         * @member {number}
         * @default PIXI.settings.SCALE_MODE
         * @see PIXI.SCALE_MODES
         */
        this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
    
        /**
         * Whether this object is the root element or not
         *
         * @member {boolean}
         */
        this.root = root;
    
        if (!this.root) {
          this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);
    
          if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
            this.frameBuffer.texture.enableNearestScaling();
          } else {
            this.frameBuffer.texture.enableLinearScaling();
          }
          /*
              A frame buffer needs a target to render to..
              create a texture and bind it attach it to the framebuffer..
           */
    
          // this is used by the base texture
          this.texture = this.frameBuffer.texture;
        } else {
          // make it a null framebuffer..
          this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
          this.frameBuffer.framebuffer = null;
        }
    
        this.setFrame();
    
        this.resize(width, height);
      }
    
      /**
       * Clears the filter texture.
       *
       * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
       */
    
    
      RenderTarget.prototype.clear = function clear(clearColor) {
        var cc = clearColor || this.clearColor;
    
        this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
      };
    
      /**
       * Binds the stencil buffer.
       *
       */
    
    
      RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
        // TODO check if stencil is done?
        /**
         * The stencil buffer is used for masking in pixi
         * lets create one and then add attach it to the framebuffer..
         */
        if (!this.root) {
          this.frameBuffer.enableStencil();
        }
      };
    
      /**
       * Sets the frame of the render target.
       *
       * @param {Rectangle} destinationFrame - The destination frame.
       * @param {Rectangle} sourceFrame - The source frame.
       */
    
    
      RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
        this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
        this.sourceFrame = sourceFrame || this.sourceFrame || destinationFrame;
      };
    
      /**
       * Binds the buffers and initialises the viewport.
       *
       */
    
    
      RenderTarget.prototype.activate = function activate() {
        // TOOD refactor usage of frame..
        var gl = this.gl;
    
        // make sure the texture is unbound!
        this.frameBuffer.bind();
    
        this.calculateProjection(this.destinationFrame, this.sourceFrame);
    
        if (this.transform) {
          this.projectionMatrix.append(this.transform);
        }
    
        // TODO add a check as them may be the same!
        if (this.destinationFrame !== this.sourceFrame) {
          gl.enable(gl.SCISSOR_TEST);
          gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
        } else {
          gl.disable(gl.SCISSOR_TEST);
        }
    
        // TODO - does not need to be updated all the time??
        gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
      };
    
      /**
       * Updates the projection matrix based on a projection frame (which is a rectangle)
       *
       * @param {Rectangle} destinationFrame - The destination frame.
       * @param {Rectangle} sourceFrame - The source frame.
       */
    
    
      RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
        var pm = this.projectionMatrix;
    
        sourceFrame = sourceFrame || destinationFrame;
    
        pm.identity();
    
        // TODO: make dest scale source
        if (!this.root) {
          pm.a = 1 / destinationFrame.width * 2;
          pm.d = 1 / destinationFrame.height * 2;
    
          pm.tx = -1 - sourceFrame.x * pm.a;
          pm.ty = -1 - sourceFrame.y * pm.d;
        } else {
          pm.a = 1 / destinationFrame.width * 2;
          pm.d = -1 / destinationFrame.height * 2;
    
          pm.tx = -1 - sourceFrame.x * pm.a;
          pm.ty = 1 - sourceFrame.y * pm.d;
        }
      };
    
      /**
       * Resizes the texture to the specified width and height
       *
       * @param {number} width - the new width of the texture
       * @param {number} height - the new height of the texture
       */
    
    
      RenderTarget.prototype.resize = function resize(width, height) {
        width = width | 0;
        height = height | 0;
    
        if (this.size.width === width && this.size.height === height) {
          return;
        }
    
        this.size.width = width;
        this.size.height = height;
    
        this.defaultFrame.width = width;
        this.defaultFrame.height = height;
    
        this.frameBuffer.resize(width * this.resolution, height * this.resolution);
    
        var projectionFrame = this.frame || this.size;
    
        this.calculateProjection(projectionFrame);
      };
    
      /**
       * Destroys the render target.
       *
       */
    
    
      RenderTarget.prototype.destroy = function destroy() {
        this.frameBuffer.destroy();
    
        this.frameBuffer = null;
        this.texture = null;
      };
    
      return RenderTarget;
    }();
    
    exports.default = RenderTarget;
    
    },{"../../../const":45,"../../../math":69,"../../../settings":100,"pixi-gl-core":16}],96:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = checkMaxIfStatmentsInShader;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');
    
    function checkMaxIfStatmentsInShader(maxIfs, gl) {
        var createTempContext = !gl;
    
        if (maxIfs === 0) {
            throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
        }
    
        if (createTempContext) {
            var tinyCanvas = document.createElement('canvas');
    
            tinyCanvas.width = 1;
            tinyCanvas.height = 1;
    
            gl = _pixiGlCore2.default.createContext(tinyCanvas);
        }
    
        var shader = gl.createShader(gl.FRAGMENT_SHADER);
    
        while (true) // eslint-disable-line no-constant-condition
        {
            var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));
    
            gl.shaderSource(shader, fragmentSrc);
            gl.compileShader(shader);
    
            if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
                maxIfs = maxIfs / 2 | 0;
            } else {
                // valid!
                break;
            }
        }
    
        if (createTempContext) {
            // get rid of context
            if (gl.getExtension('WEBGL_lose_context')) {
                gl.getExtension('WEBGL_lose_context').loseContext();
            }
        }
    
        return maxIfs;
    }
    
    function generateIfTestSrc(maxIfs) {
        var src = '';
    
        for (var i = 0; i < maxIfs; ++i) {
            if (i > 0) {
                src += '\nelse ';
            }
    
            if (i < maxIfs - 1) {
                src += 'if(test == ' + i + '.0){}';
            }
        }
    
        return src;
    }
    
    },{"pixi-gl-core":16}],97:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = mapWebGLBlendModesToPixi;
    
    var _const = require('../../../const');
    
    /**
     * Maps gl blend combinations to WebGL.
     *
     * @memberof PIXI
     * @function mapWebGLBlendModesToPixi
     * @private
     * @param {WebGLRenderingContext} gl - The rendering context.
     * @param {string[]} [array=[]] - The array to output into.
     * @return {string[]} Mapped modes.
     */
    function mapWebGLBlendModesToPixi(gl) {
        var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    
        // TODO - premultiply alpha would be different.
        // add a boolean for that!
        array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.ONE];
        array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR];
        array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
        array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    
        return array;
    }
    
    },{"../../../const":45}],98:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = mapWebGLDrawModesToPixi;
    
    var _const = require('../../../const');
    
    /**
     * Generic Mask Stack data structure.
     *
     * @memberof PIXI
     * @function mapWebGLDrawModesToPixi
     * @private
     * @param {WebGLRenderingContext} gl - The current WebGL drawing context
     * @param {object} [object={}] - The object to map into
     * @return {object} The mapped draw modes.
     */
    function mapWebGLDrawModesToPixi(gl) {
      var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
      object[_const.DRAW_MODES.POINTS] = gl.POINTS;
      object[_const.DRAW_MODES.LINES] = gl.LINES;
      object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
      object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
      object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
      object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
      object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;
    
      return object;
    }
    
    },{"../../../const":45}],99:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = validateContext;
    function validateContext(gl) {
        var attributes = gl.getContextAttributes();
    
        // this is going to be fairly simple for now.. but at least we have room to grow!
        if (!attributes.stencil) {
            /* eslint-disable no-console */
            console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
            /* eslint-enable no-console */
        }
    }
    
    },{}],100:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _maxRecommendedTextures = require('./utils/maxRecommendedTextures');
    
    var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);
    
    var _canUploadSameBuffer = require('./utils/canUploadSameBuffer');
    
    var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * @namespace PIXI.settings
     */
    exports.default = {
    
      /**
       * Target frames per millisecond.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 0.06
       */
      TARGET_FPMS: 0.06,
    
      /**
       * If set to true WebGL will attempt make textures mimpaped by default.
       * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
       *
       * @static
       * @memberof PIXI.settings
       * @type {boolean}
       * @default true
       */
      MIPMAP_TEXTURES: true,
    
      /**
       * Default resolution / device pixel ratio of the renderer.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 1
       */
      RESOLUTION: 1,
    
      /**
       * Default filter resolution.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 1
       */
      FILTER_RESOLUTION: 1,
    
      /**
       * The maximum textures that this device supports.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 32
       */
      SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),
    
      // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
      // TODO: maybe add PARTICLE.BATCH_SIZE: 15000
    
      /**
       * The default sprite batch size.
       *
       * The default aims to balance desktop and mobile devices.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 4096
       */
      SPRITE_BATCH_SIZE: 4096,
    
      /**
       * The prefix that denotes a URL is for a retina asset.
       *
       * @static
       * @memberof PIXI.settings
       * @type {RegExp}
       * @example `@2x`
       * @default /@([0-9\.]+)x/
       */
      RETINA_PREFIX: /@([0-9\.]+)x/,
    
      /**
       * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
       * or {@link PIXI.CanvasRenderer}.
       *
       * @static
       * @constant
       * @memberof PIXI.settings
       * @type {object}
       * @property {HTMLCanvasElement} view=null
       * @property {number} resolution=1
       * @property {boolean} antialias=false
       * @property {boolean} forceFXAA=false
       * @property {boolean} autoResize=false
       * @property {boolean} transparent=false
       * @property {number} backgroundColor=0x000000
       * @property {boolean} clearBeforeRender=true
       * @property {boolean} preserveDrawingBuffer=false
       * @property {boolean} roundPixels=false
       */
      RENDER_OPTIONS: {
        view: null,
        antialias: false,
        forceFXAA: false,
        autoResize: false,
        transparent: false,
        backgroundColor: 0x000000,
        clearBeforeRender: true,
        preserveDrawingBuffer: false,
        roundPixels: false
      },
    
      /**
       * Default transform type.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.TRANSFORM_MODE}
       * @default PIXI.TRANSFORM_MODE.STATIC
       */
      TRANSFORM_MODE: 0,
    
      /**
       * Default Garbage Collection mode.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.GC_MODES}
       * @default PIXI.GC_MODES.AUTO
       */
      GC_MODE: 0,
    
      /**
       * Default Garbage Collection max idle.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 3600
       */
      GC_MAX_IDLE: 60 * 60,
    
      /**
       * Default Garbage Collection maximum check count.
       *
       * @static
       * @memberof PIXI.settings
       * @type {number}
       * @default 600
       */
      GC_MAX_CHECK_COUNT: 60 * 10,
    
      /**
       * Default wrap modes that are supported by pixi.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.WRAP_MODES}
       * @default PIXI.WRAP_MODES.CLAMP
       */
      WRAP_MODE: 0,
    
      /**
       * The scale modes that are supported by pixi.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.SCALE_MODES}
       * @default PIXI.SCALE_MODES.LINEAR
       */
      SCALE_MODE: 0,
    
      /**
       * Default specify float precision in vertex shader.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.PRECISION}
       * @default PIXI.PRECISION.HIGH
       */
      PRECISION_VERTEX: 'highp',
    
      /**
       * Default specify float precision in fragment shader.
       *
       * @static
       * @memberof PIXI.settings
       * @type {PIXI.PRECISION}
       * @default PIXI.PRECISION.MEDIUM
       */
      PRECISION_FRAGMENT: 'mediump',
    
      /**
       * Can we upload the same buffer in a single frame?
       *
       * @static
       * @constant
       * @memberof PIXI
       * @type {boolean}
       */
      CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)()
    
    };
    
    },{"./utils/canUploadSameBuffer":118,"./utils/maxRecommendedTextures":122}],101:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _math = require('../math');
    
    var _utils = require('../utils');
    
    var _const = require('../const');
    
    var _Texture = require('../textures/Texture');
    
    var _Texture2 = _interopRequireDefault(_Texture);
    
    var _Container2 = require('../display/Container');
    
    var _Container3 = _interopRequireDefault(_Container2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var tempPoint = new _math.Point();
    
    /**
     * The Sprite object is the base for all textured objects that are rendered to the screen
     *
     * A sprite can be created directly from an image like this:
     *
     * ```js
     * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
     * ```
     *
     * @class
     * @extends PIXI.Container
     * @memberof PIXI
     */
    
    var Sprite = function (_Container) {
        _inherits(Sprite, _Container);
    
        /**
         * @param {PIXI.Texture} texture - The texture for this sprite
         */
        function Sprite(texture) {
            _classCallCheck(this, Sprite);
    
            /**
             * The anchor sets the origin point of the texture.
             * The default is 0,0 this means the texture's origin is the top left
             * Setting the anchor to 0.5,0.5 means the texture's origin is centered
             * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
             *
             * @member {PIXI.ObservablePoint}
             * @private
             */
            var _this = _possibleConstructorReturn(this, _Container.call(this));
    
            _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this);
    
            /**
             * The texture that the sprite is using
             *
             * @private
             * @member {PIXI.Texture}
             */
            _this._texture = null;
    
            /**
             * The width of the sprite (this is initially set by the texture)
             *
             * @private
             * @member {number}
             */
            _this._width = 0;
    
            /**
             * The height of the sprite (this is initially set by the texture)
             *
             * @private
             * @member {number}
             */
            _this._height = 0;
    
            /**
             * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
             *
             * @private
             * @member {number}
             * @default 0xFFFFFF
             */
            _this._tint = null;
            _this._tintRGB = null;
            _this.tint = 0xFFFFFF;
    
            /**
             * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
             *
             * @member {number}
             * @default PIXI.BLEND_MODES.NORMAL
             * @see PIXI.BLEND_MODES
             */
            _this.blendMode = _const.BLEND_MODES.NORMAL;
    
            /**
             * The shader that will be used to render the sprite. Set to null to remove a current shader.
             *
             * @member {PIXI.Filter|PIXI.Shader}
             */
            _this.shader = null;
    
            /**
             * An internal cached value of the tint.
             *
             * @private
             * @member {number}
             * @default 0xFFFFFF
             */
            _this.cachedTint = 0xFFFFFF;
    
            // call texture setter
            _this.texture = texture || _Texture2.default.EMPTY;
    
            /**
             * this is used to store the vertex data of the sprite (basically a quad)
             *
             * @private
             * @member {Float32Array}
             */
            _this.vertexData = new Float32Array(8);
    
            /**
             * This is used to calculate the bounds of the object IF it is a trimmed sprite
             *
             * @private
             * @member {Float32Array}
             */
            _this.vertexTrimmedData = null;
    
            _this._transformID = -1;
            _this._textureID = -1;
    
            _this._transformTrimmedID = -1;
            _this._textureTrimmedID = -1;
    
            /**
             * Plugin that is responsible for rendering this element.
             * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
             *
             * @member {string}
             * @default 'sprite'
             */
            _this.pluginName = 'sprite';
            return _this;
        }
    
        /**
         * When the texture is updated, this event will fire to update the scale and frame
         *
         * @private
         */
    
    
        Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
            this._textureID = -1;
            this._textureTrimmedID = -1;
    
            // so if _width is 0 then width was not set..
            if (this._width) {
                this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this.texture.orig.width;
            }
    
            if (this._height) {
                this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this.texture.orig.height;
            }
        };
    
        /**
         * Called when the anchor position updates.
         *
         * @private
         */
    
    
        Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
            this._transformID = -1;
            this._transformTrimmedID = -1;
        };
    
        /**
         * calculates worldTransform * vertices, store it in vertexData
         */
    
    
        Sprite.prototype.calculateVertices = function calculateVertices() {
            if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
                return;
            }
    
            this._transformID = this.transform._worldID;
            this._textureID = this._texture._updateID;
    
            // set the vertex data
    
            var texture = this._texture;
            var wt = this.transform.worldTransform;
            var a = wt.a;
            var b = wt.b;
            var c = wt.c;
            var d = wt.d;
            var tx = wt.tx;
            var ty = wt.ty;
            var vertexData = this.vertexData;
            var trim = texture.trim;
            var orig = texture.orig;
            var anchor = this._anchor;
    
            var w0 = 0;
            var w1 = 0;
            var h0 = 0;
            var h1 = 0;
    
            if (trim) {
                // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
                // space before transforming the sprite coords.
                w1 = trim.x - anchor._x * orig.width;
                w0 = w1 + trim.width;
    
                h1 = trim.y - anchor._y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w1 = -anchor._x * orig.width;
                w0 = w1 + orig.width;
    
                h1 = -anchor._y * orig.height;
                h0 = h1 + orig.height;
            }
    
            // xy
            vertexData[0] = a * w1 + c * h1 + tx;
            vertexData[1] = d * h1 + b * w1 + ty;
    
            // xy
            vertexData[2] = a * w0 + c * h1 + tx;
            vertexData[3] = d * h1 + b * w0 + ty;
    
            // xy
            vertexData[4] = a * w0 + c * h0 + tx;
            vertexData[5] = d * h0 + b * w0 + ty;
    
            // xy
            vertexData[6] = a * w1 + c * h0 + tx;
            vertexData[7] = d * h0 + b * w1 + ty;
        };
    
        /**
         * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
         * This is used to ensure that the true width and height of a trimmed texture is respected
         */
    
    
        Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
            if (!this.vertexTrimmedData) {
                this.vertexTrimmedData = new Float32Array(8);
            } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
                return;
            }
    
            this._transformTrimmedID = this.transform._worldID;
            this._textureTrimmedID = this._texture._updateID;
    
            // lets do some special trim code!
            var texture = this._texture;
            var vertexData = this.vertexTrimmedData;
            var orig = texture.orig;
            var anchor = this._anchor;
    
            // lets calculate the new untrimmed bounds..
            var wt = this.transform.worldTransform;
            var a = wt.a;
            var b = wt.b;
            var c = wt.c;
            var d = wt.d;
            var tx = wt.tx;
            var ty = wt.ty;
    
            var w1 = -anchor._x * orig.width;
            var w0 = w1 + orig.width;
    
            var h1 = -anchor._y * orig.height;
            var h0 = h1 + orig.height;
    
            // xy
            vertexData[0] = a * w1 + c * h1 + tx;
            vertexData[1] = d * h1 + b * w1 + ty;
    
            // xy
            vertexData[2] = a * w0 + c * h1 + tx;
            vertexData[3] = d * h1 + b * w0 + ty;
    
            // xy
            vertexData[4] = a * w0 + c * h0 + tx;
            vertexData[5] = d * h0 + b * w0 + ty;
    
            // xy
            vertexData[6] = a * w1 + c * h0 + tx;
            vertexData[7] = d * h0 + b * w1 + ty;
        };
    
        /**
        *
        * Renders the object using the WebGL renderer
        *
        * @private
        * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
        */
    
    
        Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
            this.calculateVertices();
    
            renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
            renderer.plugins[this.pluginName].render(this);
        };
    
        /**
        * Renders the object using the Canvas renderer
        *
        * @private
        * @param {PIXI.CanvasRenderer} renderer - The renderer
        */
    
    
        Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
            renderer.plugins[this.pluginName].render(this);
        };
    
        /**
         * Updates the bounds of the sprite.
         *
         * @private
         */
    
    
        Sprite.prototype._calculateBounds = function _calculateBounds() {
            var trim = this._texture.trim;
            var orig = this._texture.orig;
    
            // First lets check to see if the current texture has a trim..
            if (!trim || trim.width === orig.width && trim.height === orig.height) {
                // no trim! lets use the usual calculations..
                this.calculateVertices();
                this._bounds.addQuad(this.vertexData);
            } else {
                // lets calculate a special trimmed bounds...
                this.calculateTrimmedVertices();
                this._bounds.addQuad(this.vertexTrimmedData);
            }
        };
    
        /**
         * Gets the local bounds of the sprite object.
         *
         * @param {PIXI.Rectangle} rect - The output rectangle.
         * @return {PIXI.Rectangle} The bounds.
         */
    
    
        Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
            // we can do a fast local bounds if the sprite has no children!
            if (this.children.length === 0) {
                this._bounds.minX = this._texture.orig.width * -this._anchor._x;
                this._bounds.minY = this._texture.orig.height * -this._anchor._y;
                this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
                this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._x);
    
                if (!rect) {
                    if (!this._localBoundsRect) {
                        this._localBoundsRect = new _math.Rectangle();
                    }
    
                    rect = this._localBoundsRect;
                }
    
                return this._bounds.getRectangle(rect);
            }
    
            return _Container.prototype.getLocalBounds.call(this, rect);
        };
    
        /**
         * Tests if a point is inside this sprite
         *
         * @param {PIXI.Point} point - the point to test
         * @return {boolean} the result of the test
         */
    
    
        Sprite.prototype.containsPoint = function containsPoint(point) {
            this.worldTransform.applyInverse(point, tempPoint);
    
            var width = this._texture.orig.width;
            var height = this._texture.orig.height;
            var x1 = -width * this.anchor.x;
            var y1 = 0;
    
            if (tempPoint.x > x1 && tempPoint.x < x1 + width) {
                y1 = -height * this.anchor.y;
    
                if (tempPoint.y > y1 && tempPoint.y < y1 + height) {
                    return true;
                }
            }
    
            return false;
        };
    
        /**
         * Destroys this sprite and optionally its texture and children
         *
         * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
         *  have been set to that value
         * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
         *      method called as well. 'options' will be passed on to those calls.
         * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
         * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
         */
    
    
        Sprite.prototype.destroy = function destroy(options) {
            _Container.prototype.destroy.call(this, options);
    
            this._anchor = null;
    
            var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;
    
            if (destroyTexture) {
                var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;
    
                this._texture.destroy(!!destroyBaseTexture);
            }
    
            this._texture = null;
            this.shader = null;
        };
    
        // some helper functions..
    
        /**
         * Helper function that creates a new sprite based on the source you provide.
         * The source can be - frame id, image url, video url, canvas element, video element, base texture
         *
         * @static
         * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
         * @return {PIXI.Sprite} The newly created sprite
         */
    
    
        Sprite.from = function from(source) {
            return new Sprite(_Texture2.default.from(source));
        };
    
        /**
         * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
         * The frame ids are created when a Texture packer file has been loaded
         *
         * @static
         * @param {string} frameId - The frame Id of the texture in the cache
         * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
         */
    
    
        Sprite.fromFrame = function fromFrame(frameId) {
            var texture = _utils.TextureCache[frameId];
    
            if (!texture) {
                throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
            }
    
            return new Sprite(texture);
        };
    
        /**
         * Helper function that creates a sprite that will contain a texture based on an image url
         * If the image is not in the texture cache it will be loaded
         *
         * @static
         * @param {string} imageId - The image url of the texture
         * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
         *  see {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
         */
    
    
        Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
            return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
        };
    
        /**
         * The width of the sprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */
    
    
        _createClass(Sprite, [{
            key: 'width',
            get: function get() {
                return Math.abs(this.scale.x) * this._texture.orig.width;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                var s = (0, _utils.sign)(this.scale.x) || 1;
    
                this.scale.x = s * value / this._texture.orig.width;
                this._width = value;
            }
    
            /**
             * The height of the sprite, setting this will actually modify the scale to achieve the value set
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                return Math.abs(this.scale.y) * this._texture.orig.height;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                var s = (0, _utils.sign)(this.scale.y) || 1;
    
                this.scale.y = s * value / this._texture.orig.height;
                this._height = value;
            }
    
            /**
             * The anchor sets the origin point of the texture.
             * The default is 0,0 this means the texture's origin is the top left
             * Setting the anchor to 0.5,0.5 means the texture's origin is centered
             * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner
             *
             * @member {PIXI.ObservablePoint}
             */
    
        }, {
            key: 'anchor',
            get: function get() {
                return this._anchor;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._anchor.copy(value);
            }
    
            /**
             * The tint applied to the sprite. This is a hex value.
             * A value of 0xFFFFFF will remove any tint effect.
             *
             * @member {number}
             * @default 0xFFFFFF
             */
    
        }, {
            key: 'tint',
            get: function get() {
                return this._tint;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._tint = value;
                this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
            }
    
            /**
             * The texture that the sprite is using
             *
             * @member {PIXI.Texture}
             */
    
        }, {
            key: 'texture',
            get: function get() {
                return this._texture;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (this._texture === value) {
                    return;
                }
    
                this._texture = value;
                this.cachedTint = 0xFFFFFF;
    
                this._textureID = -1;
                this._textureTrimmedID = -1;
    
                if (value) {
                    // wait for the texture to load
                    if (value.baseTexture.hasLoaded) {
                        this._onTextureUpdate();
                    } else {
                        value.once('update', this._onTextureUpdate, this);
                    }
                }
            }
        }]);
    
        return Sprite;
    }(_Container3.default);
    
    exports.default = Sprite;
    
    },{"../const":45,"../display/Container":47,"../math":69,"../textures/Texture":113,"../utils":121}],102:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _CanvasRenderer = require('../../renderers/canvas/CanvasRenderer');
    
    var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);
    
    var _const = require('../../const');
    
    var _math = require('../../math');
    
    var _CanvasTinter = require('./CanvasTinter');
    
    var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var canvasRenderWorldTransform = new _math.Matrix();
    
    /**
     * @author Mat Groves
     *
     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
     * for creating the original pixi version!
     * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
     * share 4 bytes on the vertex buffer
     *
     * Heavily inspired by LibGDX's CanvasSpriteRenderer:
     * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
     */
    
    /**
     * Renderer dedicated to drawing and batching sprites.
     *
     * @class
     * @private
     * @memberof PIXI
     */
    
    var CanvasSpriteRenderer = function () {
        /**
         * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
         */
        function CanvasSpriteRenderer(renderer) {
            _classCallCheck(this, CanvasSpriteRenderer);
    
            this.renderer = renderer;
        }
    
        /**
         * Renders the sprite object.
         *
         * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
         */
    
    
        CanvasSpriteRenderer.prototype.render = function render(sprite) {
            var texture = sprite._texture;
            var renderer = this.renderer;
    
            var width = texture._frame.width;
            var height = texture._frame.height;
    
            var wt = sprite.transform.worldTransform;
            var dx = 0;
            var dy = 0;
    
            if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
                return;
            }
    
            renderer.setBlendMode(sprite.blendMode);
    
            //  Ignore null sources
            if (texture.valid) {
                renderer.context.globalAlpha = sprite.worldAlpha;
    
                // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
                var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;
    
                if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
                    renderer.context[renderer.smoothProperty] = smoothingEnabled;
                }
    
                if (texture.trim) {
                    dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
                    dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
                } else {
                    dx = (0.5 - sprite.anchor.x) * texture.orig.width;
                    dy = (0.5 - sprite.anchor.y) * texture.orig.height;
                }
    
                if (texture.rotate) {
                    wt.copy(canvasRenderWorldTransform);
                    wt = canvasRenderWorldTransform;
                    _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
                    // the anchor has already been applied above, so lets set it to zero
                    dx = 0;
                    dy = 0;
                }
    
                dx -= width / 2;
                dy -= height / 2;
    
                // Allow for pixel rounding
                if (renderer.roundPixels) {
                    renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);
    
                    dx = dx | 0;
                    dy = dy | 0;
                } else {
                    renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
                }
    
                var resolution = texture.baseTexture.resolution;
    
                if (sprite.tint !== 0xFFFFFF) {
                    if (sprite.cachedTint !== sprite.tint) {
                        sprite.cachedTint = sprite.tint;
    
                        // TODO clean up caching - how to clean up the caches?
                        sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
                    }
    
                    renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
                } else {
                    renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
                }
            }
        };
    
        /**
         * destroy the sprite object.
         *
         */
    
    
        CanvasSpriteRenderer.prototype.destroy = function destroy() {
            this.renderer = null;
        };
    
        return CanvasSpriteRenderer;
    }();
    
    exports.default = CanvasSpriteRenderer;
    
    
    _CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
    
    },{"../../const":45,"../../math":69,"../../renderers/canvas/CanvasRenderer":76,"./CanvasTinter":103}],103:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _utils = require('../../utils');
    
    var _canUseNewCanvasBlendModes = require('../../renderers/canvas/utils/canUseNewCanvasBlendModes');
    
    var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * Utility methods for Sprite/Texture tinting.
     *
     * @class
     * @memberof PIXI
     */
    var CanvasTinter = {
        /**
         * Basically this method just needs a sprite and a color and tints the sprite with the given color.
         *
         * @memberof PIXI.CanvasTinter
         * @param {PIXI.Sprite} sprite - the sprite to tint
         * @param {number} color - the color to use to tint the sprite with
         * @return {HTMLCanvasElement} The tinted canvas
         */
        getTintedTexture: function getTintedTexture(sprite, color) {
            var texture = sprite.texture;
    
            color = CanvasTinter.roundColor(color);
    
            var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
    
            texture.tintCache = texture.tintCache || {};
    
            if (texture.tintCache[stringColor]) {
                return texture.tintCache[stringColor];
            }
    
            // clone texture..
            var canvas = CanvasTinter.canvas || document.createElement('canvas');
    
            // CanvasTinter.tintWithPerPixel(texture, stringColor, canvas);
            CanvasTinter.tintMethod(texture, color, canvas);
    
            if (CanvasTinter.convertTintToImage) {
                // is this better?
                var tintImage = new Image();
    
                tintImage.src = canvas.toDataURL();
    
                texture.tintCache[stringColor] = tintImage;
            } else {
                texture.tintCache[stringColor] = canvas;
                // if we are not converting the texture to an image then we need to lose the reference to the canvas
                CanvasTinter.canvas = null;
            }
    
            return canvas;
        },
    
        /**
         * Tint a texture using the 'multiply' operation.
         *
         * @memberof PIXI.CanvasTinter
         * @param {PIXI.Texture} texture - the texture to tint
         * @param {number} color - the color to use to tint the sprite with
         * @param {HTMLCanvasElement} canvas - the current canvas
         */
        tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
            var context = canvas.getContext('2d');
            var crop = texture._frame.clone();
            var resolution = texture.baseTexture.resolution;
    
            crop.x *= resolution;
            crop.y *= resolution;
            crop.width *= resolution;
            crop.height *= resolution;
    
            canvas.width = Math.ceil(crop.width);
            canvas.height = Math.ceil(crop.height);
    
            context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
    
            context.fillRect(0, 0, crop.width, crop.height);
    
            context.globalCompositeOperation = 'multiply';
    
            context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    
            context.globalCompositeOperation = 'destination-atop';
    
            context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        },
    
        /**
         * Tint a texture using the 'overlay' operation.
         *
         * @memberof PIXI.CanvasTinter
         * @param {PIXI.Texture} texture - the texture to tint
         * @param {number} color - the color to use to tint the sprite with
         * @param {HTMLCanvasElement} canvas - the current canvas
         */
        tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
            var context = canvas.getContext('2d');
            var crop = texture._frame.clone();
            var resolution = texture.baseTexture.resolution;
    
            crop.x *= resolution;
            crop.y *= resolution;
            crop.width *= resolution;
            crop.height *= resolution;
    
            canvas.width = Math.ceil(crop.width);
            canvas.height = Math.ceil(crop.height);
    
            context.globalCompositeOperation = 'copy';
            context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
            context.fillRect(0, 0, crop.width, crop.height);
    
            context.globalCompositeOperation = 'destination-atop';
            context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    
            // context.globalCompositeOperation = 'copy';
        },
    
    
        /**
         * Tint a texture pixel per pixel.
         *
         * @memberof PIXI.CanvasTinter
         * @param {PIXI.Texture} texture - the texture to tint
         * @param {number} color - the color to use to tint the sprite with
         * @param {HTMLCanvasElement} canvas - the current canvas
         */
        tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
            var context = canvas.getContext('2d');
            var crop = texture._frame.clone();
            var resolution = texture.baseTexture.resolution;
    
            crop.x *= resolution;
            crop.y *= resolution;
            crop.width *= resolution;
            crop.height *= resolution;
    
            canvas.width = Math.ceil(crop.width);
            canvas.height = Math.ceil(crop.height);
    
            context.globalCompositeOperation = 'copy';
            context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    
            var rgbValues = (0, _utils.hex2rgb)(color);
            var r = rgbValues[0];
            var g = rgbValues[1];
            var b = rgbValues[2];
    
            var pixelData = context.getImageData(0, 0, crop.width, crop.height);
    
            var pixels = pixelData.data;
    
            for (var i = 0; i < pixels.length; i += 4) {
                pixels[i + 0] *= r;
                pixels[i + 1] *= g;
                pixels[i + 2] *= b;
            }
    
            context.putImageData(pixelData, 0, 0);
        },
    
        /**
         * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
         *
         * @memberof PIXI.CanvasTinter
         * @param {number} color - the color to round, should be a hex color
         * @return {number} The rounded color.
         */
        roundColor: function roundColor(color) {
            var step = CanvasTinter.cacheStepsPerColorChannel;
    
            var rgbValues = (0, _utils.hex2rgb)(color);
    
            rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
            rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
            rgbValues[2] = Math.min(255, rgbValues[2] / step * step);
    
            return (0, _utils.rgb2hex)(rgbValues);
        },
    
        /**
         * Number of steps which will be used as a cap when rounding colors.
         *
         * @memberof PIXI.CanvasTinter
         * @type {number}
         */
        cacheStepsPerColorChannel: 8,
    
        /**
         * Tint cache boolean flag.
         *
         * @memberof PIXI.CanvasTinter
         * @type {boolean}
         */
        convertTintToImage: false,
    
        /**
         * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
         *
         * @memberof PIXI.CanvasTinter
         * @type {boolean}
         */
        canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),
    
        /**
         * The tinting method that will be used.
         *
         * @memberof PIXI.CanvasTinter
         * @type {tintMethodFunctionType}
         */
        tintMethod: 0
    };
    
    CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;
    
    /**
     * The tintMethod type.
     *
     * @memberof PIXI.CanvasTinter
     * @callback tintMethodFunctionType
     * @param texture {PIXI.Texture} the texture to tint
     * @param color {number} the color to use to tint the sprite with
     * @param canvas {HTMLCanvasElement} the current canvas
     */
    
    exports.default = CanvasTinter;
    
    },{"../../renderers/canvas/utils/canUseNewCanvasBlendModes":79,"../../utils":121}],104:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @class
     * @memberof PIXI
     */
    var Buffer = function () {
      /**
       * @param {number} size - The size of the buffer in bytes.
       */
      function Buffer(size) {
        _classCallCheck(this, Buffer);
    
        this.vertices = new ArrayBuffer(size);
    
        /**
         * View on the vertices as a Float32Array for positions
         *
         * @member {Float32Array}
         */
        this.float32View = new Float32Array(this.vertices);
    
        /**
         * View on the vertices as a Uint32Array for uvs
         *
         * @member {Float32Array}
         */
        this.uint32View = new Uint32Array(this.vertices);
      }
    
      /**
       * Destroys the buffer.
       *
       */
    
    
      Buffer.prototype.destroy = function destroy() {
        this.vertices = null;
        this.positions = null;
        this.uvs = null;
        this.colors = null;
      };
    
      return Buffer;
    }();
    
    exports.default = Buffer;
    
    },{}],105:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _ObjectRenderer2 = require('../../renderers/webgl/utils/ObjectRenderer');
    
    var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);
    
    var _WebGLRenderer = require('../../renderers/webgl/WebGLRenderer');
    
    var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);
    
    var _createIndicesForQuads = require('../../utils/createIndicesForQuads');
    
    var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
    
    var _generateMultiTextureShader = require('./generateMultiTextureShader');
    
    var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);
    
    var _checkMaxIfStatmentsInShader = require('../../renderers/webgl/utils/checkMaxIfStatmentsInShader');
    
    var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);
    
    var _BatchBuffer = require('./BatchBuffer');
    
    var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);
    
    var _settings = require('../../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    var _bitTwiddle = require('bit-twiddle');
    
    var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var TICK = 0;
    var TEXTURE_TICK = 0;
    
    /**
     * Renderer dedicated to drawing and batching sprites.
     *
     * @class
     * @private
     * @memberof PIXI
     * @extends PIXI.ObjectRenderer
     */
    
    var SpriteRenderer = function (_ObjectRenderer) {
        _inherits(SpriteRenderer, _ObjectRenderer);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
         */
        function SpriteRenderer(renderer) {
            _classCallCheck(this, SpriteRenderer);
    
            /**
             * Number of values sent in the vertex buffer.
             * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
             *
             * @member {number}
             */
            var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));
    
            _this.vertSize = 5;
    
            /**
             * The size of the vertex information in bytes.
             *
             * @member {number}
             */
            _this.vertByteSize = _this.vertSize * 4;
    
            /**
             * The number of images in the SpriteRenderer before it flushes.
             *
             * @member {number}
             */
            _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop
    
            // the total number of bytes in our batch
            // let numVerts = this.size * 4 * this.vertByteSize;
    
            _this.buffers = [];
            for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
                _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
            }
    
            /**
             * Holds the indices of the geometry (quads) to draw
             *
             * @member {Uint16Array}
             */
            _this.indices = (0, _createIndicesForQuads2.default)(_this.size);
    
            /**
             * The default shaders that is used if a sprite doesn't have a more specific one.
             * there is a shader for each number of textures that can be rendererd.
             * These shaders will also be generated on the fly as required.
             * @member {PIXI.Shader[]}
             */
            _this.shader = null;
    
            _this.currentIndex = 0;
            _this.groups = [];
    
            for (var k = 0; k < _this.size; k++) {
                _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
            }
    
            _this.sprites = [];
    
            _this.vertexBuffers = [];
            _this.vaos = [];
    
            _this.vaoMax = 2;
            _this.vertexCount = 0;
    
            _this.renderer.on('prerender', _this.onPrerender, _this);
            return _this;
        }
    
        /**
         * Sets up the renderer context and necessary buffers.
         *
         * @private
         */
    
    
        SpriteRenderer.prototype.onContextChange = function onContextChange() {
            var gl = this.renderer.gl;
    
            if (this.renderer.legacy) {
                this.MAX_TEXTURES = 1;
            } else {
                // step 1: first check max textures the GPU can handle.
                this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);
    
                // step 2: check the maximum number of if statements the shader can have too..
                this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
            }
    
            var shader = this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);
    
            // create a couple of buffers
            this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
    
            // we use the second shader as the first one depending on your browser may omit aTextureId
            // as it is not used by the shader so is optimized out.
    
            this.renderer.bindVao(null);
    
            for (var i = 0; i < this.vaoMax; i++) {
                this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
    
                /* eslint-disable max-len */
    
                // build the vao object that will render..
                this.vaos[i] = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(this.vertexBuffers[i], shader.attributes.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(this.vertexBuffers[i], shader.attributes.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(this.vertexBuffers[i], shader.attributes.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
    
                if (shader.attributes.aTextureId) {
                    this.vaos[i].addAttribute(this.vertexBuffers[i], shader.attributes.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
                }
    
                /* eslint-enable max-len */
            }
    
            this.vao = this.vaos[0];
            this.currentBlendMode = 99999;
    
            this.boundTextures = new Array(this.MAX_TEXTURES);
        };
    
        /**
         * Called before the renderer starts rendering.
         *
         */
    
    
        SpriteRenderer.prototype.onPrerender = function onPrerender() {
            this.vertexCount = 0;
        };
    
        /**
         * Renders the sprite object.
         *
         * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
         */
    
    
        SpriteRenderer.prototype.render = function render(sprite) {
            // TODO set blend modes..
            // check texture..
            if (this.currentIndex >= this.size) {
                this.flush();
            }
    
            // get the uvs for the texture
    
            // if the uvs have not updated then no point rendering just yet!
            if (!sprite._texture._uvs) {
                return;
            }
    
            // push a texture.
            // increment the batchsize
            this.sprites[this.currentIndex++] = sprite;
        };
    
        /**
         * Renders the content and empties the current batch.
         *
         */
    
    
        SpriteRenderer.prototype.flush = function flush() {
            if (this.currentIndex === 0) {
                return;
            }
    
            var gl = this.renderer.gl;
            var MAX_TEXTURES = this.MAX_TEXTURES;
    
            var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
            var log2 = _bitTwiddle2.default.log2(np2);
            var buffer = this.buffers[log2];
    
            var sprites = this.sprites;
            var groups = this.groups;
    
            var float32View = buffer.float32View;
            var uint32View = buffer.uint32View;
    
            var boundTextures = this.boundTextures;
            var rendererBoundTextures = this.renderer.boundTextures;
            var touch = this.renderer.textureGC.count;
    
            var index = 0;
            var nextTexture = void 0;
            var currentTexture = void 0;
            var groupCount = 1;
            var textureCount = 0;
            var currentGroup = groups[0];
            var vertexData = void 0;
            var uvs = void 0;
            var blendMode = sprites[0].blendMode;
    
            currentGroup.textureCount = 0;
            currentGroup.start = 0;
            currentGroup.blend = blendMode;
    
            TICK++;
    
            var i = void 0;
    
            // copy textures..
            for (i = 0; i < MAX_TEXTURES; ++i) {
                boundTextures[i] = rendererBoundTextures[i];
                boundTextures[i]._virtalBoundId = i;
            }
    
            for (i = 0; i < this.currentIndex; ++i) {
                // upload the sprite elemetns...
                // they have all ready been calculated so we just need to push them into the buffer.
                var sprite = sprites[i];
    
                nextTexture = sprite._texture.baseTexture;
    
                if (blendMode !== sprite.blendMode) {
                    // finish a group..
                    blendMode = sprite.blendMode;
    
                    // force the batch to break!
                    currentTexture = null;
                    textureCount = MAX_TEXTURES;
                    TICK++;
                }
    
                if (currentTexture !== nextTexture) {
                    currentTexture = nextTexture;
    
                    if (nextTexture._enabled !== TICK) {
                        if (textureCount === MAX_TEXTURES) {
                            TICK++;
    
                            currentGroup.size = i - currentGroup.start;
    
                            textureCount = 0;
    
                            currentGroup = groups[groupCount++];
                            currentGroup.blend = blendMode;
                            currentGroup.textureCount = 0;
                            currentGroup.start = i;
                        }
    
                        nextTexture.touched = touch;
    
                        if (nextTexture._virtalBoundId === -1) {
                            for (var j = 0; j < MAX_TEXTURES; ++j) {
                                var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;
    
                                var t = boundTextures[tIndex];
    
                                if (t._enabled !== TICK) {
                                    TEXTURE_TICK++;
    
                                    t._virtalBoundId = -1;
    
                                    nextTexture._virtalBoundId = tIndex;
    
                                    boundTextures[tIndex] = nextTexture;
                                    break;
                                }
                            }
                        }
    
                        nextTexture._enabled = TICK;
    
                        currentGroup.textureCount++;
                        currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
                        currentGroup.textures[textureCount++] = nextTexture;
                    }
                }
    
                vertexData = sprite.vertexData;
    
                // TODO this sum does not need to be set each frame..
                uvs = sprite._texture._uvs.uvsUint32;
    
                if (this.renderer.roundPixels) {
                    var resolution = this.renderer.resolution;
    
                    // xy
                    float32View[index] = (vertexData[0] * resolution | 0) / resolution;
                    float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;
    
                    // xy
                    float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
                    float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;
    
                    // xy
                    float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
                    float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;
    
                    // xy
                    float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
                    float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
                } else {
                    // xy
                    float32View[index] = vertexData[0];
                    float32View[index + 1] = vertexData[1];
    
                    // xy
                    float32View[index + 5] = vertexData[2];
                    float32View[index + 6] = vertexData[3];
    
                    // xy
                    float32View[index + 10] = vertexData[4];
                    float32View[index + 11] = vertexData[5];
    
                    // xy
                    float32View[index + 15] = vertexData[6];
                    float32View[index + 16] = vertexData[7];
                }
    
                uint32View[index + 2] = uvs[0];
                uint32View[index + 7] = uvs[1];
                uint32View[index + 12] = uvs[2];
                uint32View[index + 17] = uvs[3];
    
                /* eslint-disable max-len */
                uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = sprite._tintRGB + (Math.min(sprite.worldAlpha, 1) * 255 << 24);
    
                float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
                /* eslint-enable max-len */
    
                index += 20;
            }
    
            currentGroup.size = i - currentGroup.start;
    
            if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
                // this is still needed for IOS performance..
                // it really does not like uploading to the same buffer in a single frame!
                if (this.vaoMax <= this.vertexCount) {
                    this.vaoMax++;
                    this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
    
                    /* eslint-disable max-len */
    
                    // build the vao object that will render..
                    this.vaos[this.vertexCount] = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(this.vertexBuffers[this.vertexCount], this.shader.attributes.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(this.vertexBuffers[this.vertexCount], this.shader.attributes.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(this.vertexBuffers[this.vertexCount], this.shader.attributes.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);
    
                    if (this.shader.attributes.aTextureId) {
                        this.vaos[this.vertexCount].addAttribute(this.vertexBuffers[this.vertexCount], this.shader.attributes.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
                    }
    
                    /* eslint-enable max-len */
                }
    
                this.renderer.bindVao(this.vaos[this.vertexCount]);
    
                this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);
    
                this.vertexCount++;
            } else {
                // lets use the faster option, always use buffer number 0
                this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
            }
    
            for (i = 0; i < MAX_TEXTURES; ++i) {
                rendererBoundTextures[i]._virtalBoundId = -1;
            }
    
            // render the groups..
            for (i = 0; i < groupCount; ++i) {
                var group = groups[i];
                var groupTextureCount = group.textureCount;
    
                for (var _j = 0; _j < groupTextureCount; _j++) {
                    currentTexture = group.textures[_j];
    
                    // reset virtual ids..
                    // lets do a quick check..
                    if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
                        this.renderer.bindTexture(currentTexture, group.ids[_j], true);
                    }
    
                    // reset the virtualId..
                    currentTexture._virtalBoundId = -1;
                }
    
                // set the blend mode..
                this.renderer.state.setBlendMode(group.blend);
    
                gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
            }
    
            // reset elements for the next flush
            this.currentIndex = 0;
        };
    
        /**
         * Starts a new sprite batch.
         */
    
    
        SpriteRenderer.prototype.start = function start() {
            this.renderer.bindShader(this.shader);
    
            if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
                // bind buffer #0, we don't need others
                this.renderer.bindVao(this.vaos[this.vertexCount]);
    
                this.vertexBuffers[this.vertexCount].bind();
            }
        };
    
        /**
         * Stops and flushes the current batch.
         *
         */
    
    
        SpriteRenderer.prototype.stop = function stop() {
            this.flush();
        };
    
        /**
         * Destroys the SpriteRenderer.
         *
         */
    
    
        SpriteRenderer.prototype.destroy = function destroy() {
            for (var i = 0; i < this.vaoMax; i++) {
                if (this.vertexBuffers[i]) {
                    this.vertexBuffers[i].destroy();
                }
                if (this.vaos[i]) {
                    this.vaos[i].destroy();
                }
            }
    
            if (this.indexBuffer) {
                this.indexBuffer.destroy();
            }
    
            this.renderer.off('prerender', this.onPrerender, this);
    
            _ObjectRenderer.prototype.destroy.call(this);
    
            if (this.shader) {
                this.shader.destroy();
                this.shader = null;
            }
    
            this.vertexBuffers = null;
            this.vaos = null;
            this.indexBuffer = null;
            this.indices = null;
    
            this.sprites = null;
    
            for (var _i = 0; _i < this.buffers.length; ++_i) {
                this.buffers[_i].destroy();
            }
        };
    
        return SpriteRenderer;
    }(_ObjectRenderer3.default);
    
    exports.default = SpriteRenderer;
    
    
    _WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
    
    },{"../../renderers/webgl/WebGLRenderer":83,"../../renderers/webgl/utils/ObjectRenderer":93,"../../renderers/webgl/utils/checkMaxIfStatmentsInShader":96,"../../settings":100,"../../utils/createIndicesForQuads":119,"./BatchBuffer":104,"./generateMultiTextureShader":106,"bit-twiddle":1,"pixi-gl-core":16}],106:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = generateMultiTextureShader;
    
    var _Shader = require('../../Shader');
    
    var _Shader2 = _interopRequireDefault(_Shader);
    
    var _path = require('path');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', 'float textureId = floor(vTextureId+0.5);', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');
    
    function generateMultiTextureShader(gl, maxTextures) {
        var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = vec4(aColor.rgb * aColor.a, aColor.a);\n}\n';
        var fragmentSrc = fragTemplate;
    
        fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
        fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));
    
        var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);
    
        var sampleValues = [];
    
        for (var i = 0; i < maxTextures; i++) {
            sampleValues[i] = i;
        }
    
        shader.bind();
        shader.uniforms.uSamplers = sampleValues;
    
        return shader;
    }
    
    function generateSampleSrc(maxTextures) {
        var src = '';
    
        src += '\n';
        src += '\n';
    
        for (var i = 0; i < maxTextures; i++) {
            if (i > 0) {
                src += '\nelse ';
            }
    
            if (i < maxTextures - 1) {
                src += 'if(textureId == ' + i + '.0)';
            }
    
            src += '\n{';
            src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
            src += '\n}';
        }
    
        src += '\n';
        src += '\n';
    
        return src;
    }
    
    },{"../../Shader":43,"path":9}],107:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _Sprite2 = require('../sprites/Sprite');
    
    var _Sprite3 = _interopRequireDefault(_Sprite2);
    
    var _Texture = require('../textures/Texture');
    
    var _Texture2 = _interopRequireDefault(_Texture);
    
    var _math = require('../math');
    
    var _utils = require('../utils');
    
    var _const = require('../const');
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _TextStyle = require('./TextStyle');
    
    var _TextStyle2 = _interopRequireDefault(_TextStyle);
    
    var _trimCanvas = require('../utils/trimCanvas');
    
    var _trimCanvas2 = _interopRequireDefault(_trimCanvas);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-depth: [2, 8] */
    
    
    var defaultDestroyOptions = {
        texture: true,
        children: false,
        baseTexture: true
    };
    
    /**
     * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
     * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
     *
     * A Text can be created directly from a string and a style object
     *
     * ```js
     * let text = new PIXI.Text('This is a pixi text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
     * ```
     *
     * @class
     * @extends PIXI.Sprite
     * @memberof PIXI
     */
    
    var Text = function (_Sprite) {
        _inherits(Text, _Sprite);
    
        /**
         * @param {string} text - The string that you would like the text to display
         * @param {object|PIXI.TextStyle} [style] - The style parameters
         * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
         */
        function Text(text, style, canvas) {
            _classCallCheck(this, Text);
    
            canvas = canvas || document.createElement('canvas');
    
            canvas.width = 3;
            canvas.height = 3;
    
            var texture = _Texture2.default.fromCanvas(canvas);
    
            texture.orig = new _math.Rectangle();
            texture.trim = new _math.Rectangle();
    
            /**
             * The canvas element that everything is drawn to
             *
             * @member {HTMLCanvasElement}
             */
            var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));
    
            _this.canvas = canvas;
    
            /**
             * The canvas 2d context that everything is drawn with
             * @member {CanvasRenderingContext2D}
             */
            _this.context = _this.canvas.getContext('2d');
    
            /**
             * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
             * @member {number}
             * @default 1
             */
            _this.resolution = _settings2.default.RESOLUTION;
    
            /**
             * Private tracker for the current text.
             *
             * @member {string}
             * @private
             */
            _this._text = null;
    
            /**
             * Private tracker for the current style.
             *
             * @member {object}
             * @private
             */
            _this._style = null;
            /**
             * Private listener to track style changes.
             *
             * @member {Function}
             * @private
             */
            _this._styleListener = null;
    
            /**
             * Private tracker for the current font.
             *
             * @member {string}
             * @private
             */
            _this._font = '';
    
            _this.text = text;
            _this.style = style;
    
            _this.localStyleID = -1;
            return _this;
        }
    
        /**
         * Renders text and updates it when needed.
         *
         * @private
         * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
         */
    
    
        Text.prototype.updateText = function updateText(respectDirty) {
            var style = this._style;
    
            // check if style has changed..
            if (this.localStyleID !== style.styleID) {
                this.dirty = true;
                this.localStyleID = style.styleID;
            }
    
            if (!this.dirty && respectDirty) {
                return;
            }
    
            this._font = Text.getFontStyle(style);
    
            this.context.font = this._font;
    
            // word wrap
            // preserve original text
            var outputText = style.wordWrap ? this.wordWrap(this._text) : this._text;
    
            // split text into lines
            var lines = outputText.split(/(?:\r\n|\r|\n)/);
    
            // calculate text width
            var lineWidths = new Array(lines.length);
            var maxLineWidth = 0;
            var fontProperties = Text.calculateFontProperties(this._font);
    
            for (var i = 0; i < lines.length; i++) {
                var lineWidth = this.context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;
    
                lineWidths[i] = lineWidth;
                maxLineWidth = Math.max(maxLineWidth, lineWidth);
            }
    
            var width = maxLineWidth + style.strokeThickness;
    
            if (style.dropShadow) {
                width += style.dropShadowDistance;
            }
    
            this.canvas.width = Math.ceil((width + style.padding * 2) * this.resolution);
    
            // calculate text height
            var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
    
            var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * lineHeight;
    
            if (style.dropShadow) {
                height += style.dropShadowDistance;
            }
    
            this.canvas.height = Math.ceil((height + style.padding * 2) * this.resolution);
    
            this.context.scale(this.resolution, this.resolution);
    
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
    
            this.context.font = this._font;
            this.context.strokeStyle = style.stroke;
            this.context.lineWidth = style.strokeThickness;
            this.context.textBaseline = style.textBaseline;
            this.context.lineJoin = style.lineJoin;
            this.context.miterLimit = style.miterLimit;
    
            var linePositionX = void 0;
            var linePositionY = void 0;
    
            if (style.dropShadow) {
                this.context.shadowBlur = style.dropShadowBlur;
                this.context.globalAlpha = style.dropShadowAlpha;
    
                if (style.dropShadowBlur > 0) {
                    this.context.shadowColor = style.dropShadowColor;
                } else {
                    this.context.fillStyle = style.dropShadowColor;
                }
    
                var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
                var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;
    
                for (var _i = 0; _i < lines.length; _i++) {
                    linePositionX = style.strokeThickness / 2;
                    linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;
    
                    if (style.align === 'right') {
                        linePositionX += maxLineWidth - lineWidths[_i];
                    } else if (style.align === 'center') {
                        linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
                    }
    
                    if (style.fill) {
                        this.drawLetterSpacing(lines[_i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);
    
                        if (style.stroke && style.strokeThickness) {
                            this.context.strokeStyle = style.dropShadowColor;
                            this.drawLetterSpacing(lines[_i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
                            this.context.strokeStyle = style.stroke;
                        }
                    }
                }
            }
    
            // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
            this.context.shadowBlur = 0;
            this.context.globalAlpha = 1;
    
            // set canvas text styles
            this.context.fillStyle = this._generateFillStyle(style, lines);
    
            // draw lines line by line
            for (var _i2 = 0; _i2 < lines.length; _i2++) {
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + _i2 * lineHeight + fontProperties.ascent;
    
                if (style.align === 'right') {
                    linePositionX += maxLineWidth - lineWidths[_i2];
                } else if (style.align === 'center') {
                    linePositionX += (maxLineWidth - lineWidths[_i2]) / 2;
                }
    
                if (style.stroke && style.strokeThickness) {
                    this.drawLetterSpacing(lines[_i2], linePositionX + style.padding, linePositionY + style.padding, true);
                }
    
                if (style.fill) {
                    this.drawLetterSpacing(lines[_i2], linePositionX + style.padding, linePositionY + style.padding);
                }
            }
    
            this.updateTexture();
        };
    
        /**
         * Render the text with letter-spacing.
         * @param {string} text - The text to draw
         * @param {number} x - Horizontal position to draw the text
         * @param {number} y - Vertical position to draw the text
         * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
         *  text? If not, it's for the inside fill
         * @private
         */
    
    
        Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
            var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    
            var style = this._style;
    
            // letterSpacing of 0 means normal
            var letterSpacing = style.letterSpacing;
    
            if (letterSpacing === 0) {
                if (isStroke) {
                    this.context.strokeText(text, x, y);
                } else {
                    this.context.fillText(text, x, y);
                }
    
                return;
            }
    
            var characters = String.prototype.split.call(text, '');
            var currentPosition = x;
            var index = 0;
            var current = '';
    
            while (index < text.length) {
                current = characters[index++];
                if (isStroke) {
                    this.context.strokeText(current, currentPosition, y);
                } else {
                    this.context.fillText(current, currentPosition, y);
                }
                currentPosition += this.context.measureText(current).width + letterSpacing;
            }
        };
    
        /**
         * Updates texture size based on canvas size
         *
         * @private
         */
    
    
        Text.prototype.updateTexture = function updateTexture() {
            if (this._style.trim) {
                var trimmed = (0, _trimCanvas2.default)(this.canvas);
    
                this.canvas.width = trimmed.width;
                this.canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
    
            var texture = this._texture;
            var style = this._style;
    
            texture.baseTexture.hasLoaded = true;
            texture.baseTexture.resolution = this.resolution;
    
            texture.baseTexture.realWidth = this.canvas.width;
            texture.baseTexture.realHeight = this.canvas.height;
            texture.baseTexture.width = this.canvas.width / this.resolution;
            texture.baseTexture.height = this.canvas.height / this.resolution;
            texture.trim.width = texture._frame.width = this.canvas.width / this.resolution;
            texture.trim.height = texture._frame.height = this.canvas.height / this.resolution;
    
            texture.trim.x = -style.padding;
            texture.trim.y = -style.padding;
    
            texture.orig.width = texture._frame.width - style.padding * 2;
            texture.orig.height = texture._frame.height - style.padding * 2;
    
            // call sprite onTextureUpdate to update scale if _width or _height were set
            this._onTextureUpdate();
    
            texture.baseTexture.emit('update', texture.baseTexture);
    
            this.dirty = false;
        };
    
        /**
         * Renders the object using the WebGL renderer
         *
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        Text.prototype.renderWebGL = function renderWebGL(renderer) {
            if (this.resolution !== renderer.resolution) {
                this.resolution = renderer.resolution;
                this.dirty = true;
            }
    
            this.updateText(true);
    
            _Sprite.prototype.renderWebGL.call(this, renderer);
        };
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - The renderer
         */
    
    
        Text.prototype._renderCanvas = function _renderCanvas(renderer) {
            if (this.resolution !== renderer.resolution) {
                this.resolution = renderer.resolution;
                this.dirty = true;
            }
    
            this.updateText(true);
    
            _Sprite.prototype._renderCanvas.call(this, renderer);
        };
    
        /**
         * Applies newlines to a string to have it optimally fit into the horizontal
         * bounds set by the Text object's wordWrapWidth property.
         *
         * @private
         * @param {string} text - String to apply word wrapping to
         * @return {string} New string with new lines applied where required
         */
    
    
        Text.prototype.wordWrap = function wordWrap(text) {
            // Greedy wrapping algorithm that will wrap words as the line grows longer
            // than its horizontal bounds.
            var result = '';
            var style = this._style;
            var lines = text.split('\n');
            var wordWrapWidth = style.wordWrapWidth;
    
            for (var i = 0; i < lines.length; i++) {
                var spaceLeft = wordWrapWidth;
                var words = lines[i].split(' ');
    
                for (var j = 0; j < words.length; j++) {
                    var wordWidth = this.context.measureText(words[j]).width;
    
                    if (style.breakWords && wordWidth > wordWrapWidth) {
                        // Word should be split in the middle
                        var characters = words[j].split('');
    
                        for (var c = 0; c < characters.length; c++) {
                            var characterWidth = this.context.measureText(characters[c]).width;
    
                            if (characterWidth > spaceLeft) {
                                result += '\n' + characters[c];
                                spaceLeft = wordWrapWidth - characterWidth;
                            } else {
                                if (c === 0) {
                                    result += ' ';
                                }
    
                                result += characters[c];
                                spaceLeft -= characterWidth;
                            }
                        }
                    } else {
                        var wordWidthWithSpace = wordWidth + this.context.measureText(' ').width;
    
                        if (j === 0 || wordWidthWithSpace > spaceLeft) {
                            // Skip printing the newline if it's the first word of the line that is
                            // greater than the word wrap width.
                            if (j > 0) {
                                result += '\n';
                            }
                            result += words[j];
                            spaceLeft = wordWrapWidth - wordWidth;
                        } else {
                            spaceLeft -= wordWidthWithSpace;
                            result += ' ' + words[j];
                        }
                    }
                }
    
                if (i < lines.length - 1) {
                    result += '\n';
                }
            }
    
            return result;
        };
    
        /**
         * Gets the local bounds of the text object.
         *
         * @param {Rectangle} rect - The output rectangle.
         * @return {Rectangle} The bounds.
         */
    
    
        Text.prototype.getLocalBounds = function getLocalBounds(rect) {
            this.updateText(true);
    
            return _Sprite.prototype.getLocalBounds.call(this, rect);
        };
    
        /**
         * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
         */
    
    
        Text.prototype._calculateBounds = function _calculateBounds() {
            this.updateText(true);
            this.calculateVertices();
            // if we have already done this on THIS frame.
            this._bounds.addQuad(this.vertexData);
        };
    
        /**
         * Method to be called upon a TextStyle change.
         * @private
         */
    
    
        Text.prototype._onStyleChange = function _onStyleChange() {
            this.dirty = true;
        };
    
        /**
         * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
         *
         * @private
         * @param {object} style - The style.
         * @param {string[]} lines - The lines of text.
         * @return {string|number|CanvasGradient} The fill style
         */
    
    
        Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
            if (!Array.isArray(style.fill)) {
                return style.fill;
            }
    
            // cocoon on canvas+ cannot generate textures, so use the first colour instead
            if (navigator.isCocoonJS) {
                return style.fill[0];
            }
    
            // the gradient will be evenly spaced out according to how large the array is.
            // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
            var gradient = void 0;
            var totalIterations = void 0;
            var currentIteration = void 0;
            var stop = void 0;
    
            var width = this.canvas.width / this.resolution;
            var height = this.canvas.height / this.resolution;
    
            // make a copy of the style settings, so we can manipulate them later
            var fill = style.fill.slice();
            var fillGradientStops = style.fillGradientStops.slice();
    
            // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
            if (!fillGradientStops.length) {
                var lengthPlus1 = fill.length + 1;
    
                for (var i = 1; i < lengthPlus1; ++i) {
                    fillGradientStops.push(i / lengthPlus1);
                }
            }
    
            // stop the bleeding of the last gradient on the line above to the top gradient of the this line
            // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
            fill.unshift(style.fill[0]);
            fillGradientStops.unshift(0);
    
            fill.push(style.fill[style.fill.length - 1]);
            fillGradientStops.push(1);
    
            if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
                // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
                gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);
    
                // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
                // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
                totalIterations = (fill.length + 1) * lines.length;
                currentIteration = 0;
                for (var _i3 = 0; _i3 < lines.length; _i3++) {
                    currentIteration += 1;
                    for (var j = 0; j < fill.length; j++) {
                        if (fillGradientStops[j]) {
                            stop = fillGradientStops[j] / lines.length + _i3 / lines.length;
                        } else {
                            stop = currentIteration / totalIterations;
                        }
                        gradient.addColorStop(stop, fill[j]);
                        currentIteration++;
                    }
                }
            } else {
                // start the gradient at the center left of the canvas, and end at the center right of the canvas
                gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);
    
                // can just evenly space out the gradients in this case, as multiple lines makes no difference
                // to an even left to right gradient
                totalIterations = fill.length + 1;
                currentIteration = 1;
    
                for (var _i4 = 0; _i4 < fill.length; _i4++) {
                    if (fillGradientStops[_i4]) {
                        stop = fillGradientStops[_i4];
                    } else {
                        stop = currentIteration / totalIterations;
                    }
                    gradient.addColorStop(stop, fill[_i4]);
                    currentIteration++;
                }
            }
    
            return gradient;
        };
    
        /**
         * Destroys this text object.
         * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
         * the majority of the time the texture will not be shared with any other Sprites.
         *
         * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
         *  have been set to that value
         * @param {boolean} [options.children=false] - if set to true, all the children will have their
         *  destroy method called as well. 'options' will be passed on to those calls.
         * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
         * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
         */
    
    
        Text.prototype.destroy = function destroy(options) {
            if (typeof options === 'boolean') {
                options = { children: options };
            }
    
            options = Object.assign({}, defaultDestroyOptions, options);
    
            _Sprite.prototype.destroy.call(this, options);
    
            // make sure to reset the the context and canvas.. dont want this hanging around in memory!
            this.context = null;
            this.canvas = null;
    
            this._style = null;
        };
    
        /**
         * The width of the Text, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */
    
    
        /**
         * Generates a font style string to use for Text.calculateFontProperties(). Takes the same parameter
         * as Text.style.
         *
         * @static
         * @param {object|TextStyle} style - String representing the style of the font
         * @return {string} Font style string, for passing to Text.calculateFontProperties()
         */
        Text.getFontStyle = function getFontStyle(style) {
            style = style || {};
    
            if (!(style instanceof _TextStyle2.default)) {
                style = new _TextStyle2.default(style);
            }
    
            // build canvas api font setting from individual components. Convert a numeric style.fontSize to px
            var fontSizeString = typeof style.fontSize === 'number' ? style.fontSize + 'px' : style.fontSize;
    
            // Clean-up fontFamily property by quoting each font name
            // this will support font names with spaces
            var fontFamilies = style.fontFamily;
    
            if (!Array.isArray(style.fontFamily)) {
                fontFamilies = style.fontFamily.split(',');
            }
    
            for (var i = fontFamilies.length - 1; i >= 0; i--) {
                // Trim any extra white-space
                var fontFamily = fontFamilies[i].trim();
    
                // Check if font already contains strings
                if (!/([\"\'])[^\'\"]+\1/.test(fontFamily)) {
                    fontFamily = '"' + fontFamily + '"';
                }
                fontFamilies[i] = fontFamily;
            }
    
            return style.fontStyle + ' ' + style.fontVariant + ' ' + style.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
        };
    
        /**
         * Calculates the ascent, descent and fontSize of a given fontStyle
         *
         * @static
         * @param {string} fontStyle - String representing the style of the font
         * @return {Object} Font properties object
         */
    
    
        Text.calculateFontProperties = function calculateFontProperties(fontStyle) {
            // as this method is used for preparing assets, don't recalculate things if we don't need to
            if (Text.fontPropertiesCache[fontStyle]) {
                return Text.fontPropertiesCache[fontStyle];
            }
    
            var properties = {};
    
            var canvas = Text.fontPropertiesCanvas;
            var context = Text.fontPropertiesContext;
    
            context.font = fontStyle;
    
            var width = Math.ceil(context.measureText('|MÃ‰q').width);
            var baseline = Math.ceil(context.measureText('M').width);
            var height = 2 * baseline;
    
            baseline = baseline * 1.4 | 0;
    
            canvas.width = width;
            canvas.height = height;
    
            context.fillStyle = '#f00';
            context.fillRect(0, 0, width, height);
    
            context.font = fontStyle;
    
            context.textBaseline = 'alphabetic';
            context.fillStyle = '#000';
            context.fillText('|MÃ‰q', 0, baseline);
    
            var imagedata = context.getImageData(0, 0, width, height).data;
            var pixels = imagedata.length;
            var line = width * 4;
    
            var i = 0;
            var idx = 0;
            var stop = false;
    
            // ascent. scan from top to bottom until we find a non red pixel
            for (i = 0; i < baseline; ++i) {
                for (var j = 0; j < line; j += 4) {
                    if (imagedata[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                }
                if (!stop) {
                    idx += line;
                } else {
                    break;
                }
            }
    
            properties.ascent = baseline - i;
    
            idx = pixels - line;
            stop = false;
    
            // descent. scan from bottom to top until we find a non red pixel
            for (i = height; i > baseline; --i) {
                for (var _j = 0; _j < line; _j += 4) {
                    if (imagedata[idx + _j] !== 255) {
                        stop = true;
                        break;
                    }
                }
    
                if (!stop) {
                    idx -= line;
                } else {
                    break;
                }
            }
    
            properties.descent = i - baseline;
            properties.fontSize = properties.ascent + properties.descent;
    
            Text.fontPropertiesCache[fontStyle] = properties;
    
            return properties;
        };
    
        _createClass(Text, [{
            key: 'width',
            get: function get() {
                this.updateText(true);
    
                return Math.abs(this.scale.x) * this._texture.orig.width;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.updateText(true);
    
                var s = (0, _utils.sign)(this.scale.x) || 1;
    
                this.scale.x = s * value / this._texture.orig.width;
                this._width = value;
            }
    
            /**
             * The height of the Text, setting this will actually modify the scale to achieve the value set
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                this.updateText(true);
    
                return Math.abs(this.scale.y) * this._texture.orig.height;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.updateText(true);
    
                var s = (0, _utils.sign)(this.scale.y) || 1;
    
                this.scale.y = s * value / this._texture.orig.height;
                this._height = value;
            }
    
            /**
             * Set the style of the text. Set up an event listener to listen for changes on the style
             * object and mark the text as dirty.
             *
             * @member {object|PIXI.TextStyle}
             */
    
        }, {
            key: 'style',
            get: function get() {
                return this._style;
            },
            set: function set(style) // eslint-disable-line require-jsdoc
            {
                style = style || {};
    
                if (style instanceof _TextStyle2.default) {
                    this._style = style;
                } else {
                    this._style = new _TextStyle2.default(style);
                }
    
                this.localStyleID = -1;
                this.dirty = true;
            }
    
            /**
             * Set the copy for the text object. To split a line you can use '\n'.
             *
             * @member {string}
             */
    
        }, {
            key: 'text',
            get: function get() {
                return this._text;
            },
            set: function set(text) // eslint-disable-line require-jsdoc
            {
                text = String(text === '' || text === null || text === undefined ? ' ' : text);
    
                if (this._text === text) {
                    return;
                }
                this._text = text;
                this.dirty = true;
            }
        }]);
    
        return Text;
    }(_Sprite3.default);
    
    exports.default = Text;
    
    
    Text.fontPropertiesCache = {};
    Text.fontPropertiesCanvas = document.createElement('canvas');
    Text.fontPropertiesContext = Text.fontPropertiesCanvas.getContext('2d');
    
    },{"../const":45,"../math":69,"../settings":100,"../sprites/Sprite":101,"../textures/Texture":113,"../utils":121,"../utils/trimCanvas":125,"./TextStyle":108}],108:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // disabling eslint for now, going to rewrite this in v5
    /* eslint-disable */
    
    var _const = require('../const');
    
    var _utils = require('../utils');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var defaultStyle = {
        align: 'left',
        breakWords: false,
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: Math.PI / 6,
        dropShadowBlur: 0,
        dropShadowColor: '#000000',
        dropShadowDistance: 5,
        fill: 'black',
        fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
        fillGradientStops: [],
        fontFamily: 'Arial',
        fontSize: 26,
        fontStyle: 'normal',
        fontVariant: 'normal',
        fontWeight: 'normal',
        letterSpacing: 0,
        lineHeight: 0,
        lineJoin: 'miter',
        miterLimit: 10,
        padding: 0,
        stroke: 'black',
        strokeThickness: 0,
        textBaseline: 'alphabetic',
        trim: false,
        wordWrap: false,
        wordWrapWidth: 100
    };
    
    /**
     * A TextStyle Object decorates a Text Object. It can be shared between
     * multiple Text objects. Changing the style will update all text objects using it.
     *
     * @class
     * @memberof PIXI
     */
    
    var TextStyle = function () {
        /**
         * @param {object} [style] - The style parameters
         * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
         *  does not affect single line text
         * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
         *  needs wordWrap to be set to true
         * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
         * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
         * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
         * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
         * @param {string} [style.dropShadowColor='#000000'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
         * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
         * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
         *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
         *  eg ['#000000','#FFFFFF']
         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
         * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
         *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
         * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
         * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
         * @param {string|string[]} [style.fontFamily='Arial'] - The font family
         * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
         *  equivalents are '26px','20pt','160%' or '1.6em')
         * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
         * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
         * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
         *  '200', '300', '400', '500', '600', '700', 800' or '900')
         * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
         * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
         * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
         *      spiked text issues. Default is 'miter' (creates a sharp corner).
         * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
         *      or increase the spikiness of rendered text.
         * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
         *     happening by adding padding to all sides of the text.
         * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
         *  e.g 'blue', '#FCFF00'
         * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
         *  Default is 0 (no stroke)
         * @param {boolean} [style.trim=false] - Trim transparent borders
         * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
         * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
         * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
         */
        function TextStyle(style) {
            _classCallCheck(this, TextStyle);
    
            this.styleID = 0;
    
            Object.assign(this, defaultStyle, style);
        }
    
        /**
         * Creates a new TextStyle object with the same values as this one.
         * Note that the only the properties of the object are cloned.
         *
         * @return {PIXI.TextStyle} New cloned TextStyle object
         */
    
    
        TextStyle.prototype.clone = function clone() {
            var clonedProperties = {};
    
            for (var key in defaultStyle) {
                clonedProperties[key] = this[key];
            }
    
            return new TextStyle(clonedProperties);
        };
    
        /**
         * Resets all properties to the defaults specified in TextStyle.prototype._default
         */
    
    
        TextStyle.prototype.reset = function reset() {
            Object.assign(this, defaultStyle);
        };
    
        _createClass(TextStyle, [{
            key: 'align',
            get: function get() {
                return this._align;
            },
            set: function set(align) {
                if (this._align !== align) {
                    this._align = align;
                    this.styleID++;
                }
            }
        }, {
            key: 'breakWords',
            get: function get() {
                return this._breakWords;
            },
            set: function set(breakWords) {
                if (this._breakWords !== breakWords) {
                    this._breakWords = breakWords;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadow',
            get: function get() {
                return this._dropShadow;
            },
            set: function set(dropShadow) {
                if (this._dropShadow !== dropShadow) {
                    this._dropShadow = dropShadow;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadowAlpha',
            get: function get() {
                return this._dropShadowAlpha;
            },
            set: function set(dropShadowAlpha) {
                if (this._dropShadowAlpha !== dropShadowAlpha) {
                    this._dropShadowAlpha = dropShadowAlpha;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadowAngle',
            get: function get() {
                return this._dropShadowAngle;
            },
            set: function set(dropShadowAngle) {
                if (this._dropShadowAngle !== dropShadowAngle) {
                    this._dropShadowAngle = dropShadowAngle;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadowBlur',
            get: function get() {
                return this._dropShadowBlur;
            },
            set: function set(dropShadowBlur) {
                if (this._dropShadowBlur !== dropShadowBlur) {
                    this._dropShadowBlur = dropShadowBlur;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadowColor',
            get: function get() {
                return this._dropShadowColor;
            },
            set: function set(dropShadowColor) {
                var outputColor = getColor(dropShadowColor);
                if (this._dropShadowColor !== outputColor) {
                    this._dropShadowColor = outputColor;
                    this.styleID++;
                }
            }
        }, {
            key: 'dropShadowDistance',
            get: function get() {
                return this._dropShadowDistance;
            },
            set: function set(dropShadowDistance) {
                if (this._dropShadowDistance !== dropShadowDistance) {
                    this._dropShadowDistance = dropShadowDistance;
                    this.styleID++;
                }
            }
        }, {
            key: 'fill',
            get: function get() {
                return this._fill;
            },
            set: function set(fill) {
                var outputColor = getColor(fill);
                if (this._fill !== outputColor) {
                    this._fill = outputColor;
                    this.styleID++;
                }
            }
        }, {
            key: 'fillGradientType',
            get: function get() {
                return this._fillGradientType;
            },
            set: function set(fillGradientType) {
                if (this._fillGradientType !== fillGradientType) {
                    this._fillGradientType = fillGradientType;
                    this.styleID++;
                }
            }
        }, {
            key: 'fillGradientStops',
            get: function get() {
                return this._fillGradientStops;
            },
            set: function set(fillGradientStops) {
                if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
                    this._fillGradientStops = fillGradientStops;
                    this.styleID++;
                }
            }
        }, {
            key: 'fontFamily',
            get: function get() {
                return this._fontFamily;
            },
            set: function set(fontFamily) {
                if (this.fontFamily !== fontFamily) {
                    this._fontFamily = fontFamily;
                    this.styleID++;
                }
            }
        }, {
            key: 'fontSize',
            get: function get() {
                return this._fontSize;
            },
            set: function set(fontSize) {
                if (this._fontSize !== fontSize) {
                    this._fontSize = fontSize;
                    this.styleID++;
                }
            }
        }, {
            key: 'fontStyle',
            get: function get() {
                return this._fontStyle;
            },
            set: function set(fontStyle) {
                if (this._fontStyle !== fontStyle) {
                    this._fontStyle = fontStyle;
                    this.styleID++;
                }
            }
        }, {
            key: 'fontVariant',
            get: function get() {
                return this._fontVariant;
            },
            set: function set(fontVariant) {
                if (this._fontVariant !== fontVariant) {
                    this._fontVariant = fontVariant;
                    this.styleID++;
                }
            }
        }, {
            key: 'fontWeight',
            get: function get() {
                return this._fontWeight;
            },
            set: function set(fontWeight) {
                if (this._fontWeight !== fontWeight) {
                    this._fontWeight = fontWeight;
                    this.styleID++;
                }
            }
        }, {
            key: 'letterSpacing',
            get: function get() {
                return this._letterSpacing;
            },
            set: function set(letterSpacing) {
                if (this._letterSpacing !== letterSpacing) {
                    this._letterSpacing = letterSpacing;
                    this.styleID++;
                }
            }
        }, {
            key: 'lineHeight',
            get: function get() {
                return this._lineHeight;
            },
            set: function set(lineHeight) {
                if (this._lineHeight !== lineHeight) {
                    this._lineHeight = lineHeight;
                    this.styleID++;
                }
            }
        }, {
            key: 'lineJoin',
            get: function get() {
                return this._lineJoin;
            },
            set: function set(lineJoin) {
                if (this._lineJoin !== lineJoin) {
                    this._lineJoin = lineJoin;
                    this.styleID++;
                }
            }
        }, {
            key: 'miterLimit',
            get: function get() {
                return this._miterLimit;
            },
            set: function set(miterLimit) {
                if (this._miterLimit !== miterLimit) {
                    this._miterLimit = miterLimit;
                    this.styleID++;
                }
            }
        }, {
            key: 'padding',
            get: function get() {
                return this._padding;
            },
            set: function set(padding) {
                if (this._padding !== padding) {
                    this._padding = padding;
                    this.styleID++;
                }
            }
        }, {
            key: 'stroke',
            get: function get() {
                return this._stroke;
            },
            set: function set(stroke) {
                var outputColor = getColor(stroke);
                if (this._stroke !== outputColor) {
                    this._stroke = outputColor;
                    this.styleID++;
                }
            }
        }, {
            key: 'strokeThickness',
            get: function get() {
                return this._strokeThickness;
            },
            set: function set(strokeThickness) {
                if (this._strokeThickness !== strokeThickness) {
                    this._strokeThickness = strokeThickness;
                    this.styleID++;
                }
            }
        }, {
            key: 'textBaseline',
            get: function get() {
                return this._textBaseline;
            },
            set: function set(textBaseline) {
                if (this._textBaseline !== textBaseline) {
                    this._textBaseline = textBaseline;
                    this.styleID++;
                }
            }
        }, {
            key: 'trim',
            get: function get() {
                return this._trim;
            },
            set: function set(trim) {
                if (this._trim !== trim) {
                    this._trim = trim;
                    this.styleID++;
                }
            }
        }, {
            key: 'wordWrap',
            get: function get() {
                return this._wordWrap;
            },
            set: function set(wordWrap) {
                if (this._wordWrap !== wordWrap) {
                    this._wordWrap = wordWrap;
                    this.styleID++;
                }
            }
        }, {
            key: 'wordWrapWidth',
            get: function get() {
                return this._wordWrapWidth;
            },
            set: function set(wordWrapWidth) {
                if (this._wordWrapWidth !== wordWrapWidth) {
                    this._wordWrapWidth = wordWrapWidth;
                    this.styleID++;
                }
            }
        }]);
    
        return TextStyle;
    }();
    
    /**
     * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
     *
     * @param {number|number[]} color
     * @return {string} The color as a string.
     */
    
    
    exports.default = TextStyle;
    function getSingleColor(color) {
        if (typeof color === 'number') {
            return (0, _utils.hex2string)(color);
        } else if (typeof color === 'string') {
            if (color.indexOf('0x') === 0) {
                color = color.replace('0x', '#');
            }
        }
    
        return color;
    }
    
    /**
     * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
     * This version can also convert array of colors
     *
     * @param {number|number[]} color
     * @return {string} The color as a string.
     */
    function getColor(color) {
        if (!Array.isArray(color)) {
            return getSingleColor(color);
        } else {
            for (var i = 0; i < color.length; ++i) {
                color[i] = getSingleColor(color[i]);
            }
    
            return color;
        }
    }
    
    /**
     * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
     * This version can also convert array of colors
     *
     * @param {Array} array1 First array to compare
     * @param {Array} array2 Second array to compare
     * @return {boolean} Do the arrays contain the same values in the same order
     */
    function areArraysEqual(array1, array2) {
        if (!Array.isArray(array1) || !Array.isArray(array2)) {
            return false;
        }
    
        if (array1.length !== array2.length) {
            return false;
        }
    
        for (var i = 0; i < array1.length; ++i) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
    
        return true;
    }
    
    },{"../const":45,"../utils":121}],109:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _BaseTexture2 = require('./BaseTexture');
    
    var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A BaseRenderTexture is a special texture that allows any Pixi display object to be rendered to it.
     *
     * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
     * otherwise black rectangles will be drawn instead.
     *
     * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
     * and rotation of the given Display Objects is ignored. For example:
     *
     * ```js
     * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
     * let baseRenderTexture = new PIXI.BaseRenderTexture(renderer, 800, 600);
     * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
     *
     * sprite.position.x = 800/2;
     * sprite.position.y = 600/2;
     * sprite.anchor.x = 0.5;
     * sprite.anchor.y = 0.5;
     *
     * baseRenderTexture.render(sprite);
     * ```
     *
     * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
     * you can clear the transform
     *
     * ```js
     *
     * sprite.setTransform()
     *
     * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
     * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
     *
     * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
     * ```
     *
     * @class
     * @extends PIXI.BaseTexture
     * @memberof PIXI
     */
    var BaseRenderTexture = function (_BaseTexture) {
      _inherits(BaseRenderTexture, _BaseTexture);
    
      /**
       * @param {number} [width=100] - The width of the base render texture
       * @param {number} [height=100] - The height of the base render texture
       * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
       * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
       */
      function BaseRenderTexture() {
        var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
        var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        var scaleMode = arguments[2];
        var resolution = arguments[3];
    
        _classCallCheck(this, BaseRenderTexture);
    
        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));
    
        _this.resolution = resolution || _settings2.default.RESOLUTION;
    
        _this.width = width;
        _this.height = height;
    
        _this.realWidth = _this.width * _this.resolution;
        _this.realHeight = _this.height * _this.resolution;
    
        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
        _this.hasLoaded = true;
    
        /**
         * A map of renderer IDs to webgl renderTargets
         *
         * @private
         * @member {object<number, WebGLTexture>}
         */
        _this._glRenderTargets = {};
    
        /**
         * A reference to the canvas render target (we only need one as this can be shared across renderers)
         *
         * @private
         * @member {object<number, WebGLTexture>}
         */
        _this._canvasRenderTarget = null;
    
        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */
        _this.valid = false;
        return _this;
      }
    
      /**
       * Resizes the BaseRenderTexture.
       *
       * @param {number} width - The width to resize to.
       * @param {number} height - The height to resize to.
       */
    
    
      BaseRenderTexture.prototype.resize = function resize(width, height) {
        if (width === this.width && height === this.height) {
          return;
        }
    
        this.valid = width > 0 && height > 0;
    
        this.width = width;
        this.height = height;
    
        this.realWidth = this.width * this.resolution;
        this.realHeight = this.height * this.resolution;
    
        if (!this.valid) {
          return;
        }
    
        this.emit('update', this);
      };
    
      /**
       * Destroys this texture
       *
       */
    
    
      BaseRenderTexture.prototype.destroy = function destroy() {
        _BaseTexture.prototype.destroy.call(this, true);
        this.renderer = null;
      };
    
      return BaseRenderTexture;
    }(_BaseTexture3.default);
    
    exports.default = BaseRenderTexture;
    
    },{"../settings":100,"./BaseTexture":110}],110:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _utils = require('../utils');
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _determineCrossOrigin = require('../utils/determineCrossOrigin');
    
    var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);
    
    var _bitTwiddle = require('bit-twiddle');
    
    var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A texture stores the information that represents an image. All textures have a base texture.
     *
     * @class
     * @extends EventEmitter
     * @memberof PIXI
     */
    var BaseTexture = function (_EventEmitter) {
        _inherits(BaseTexture, _EventEmitter);
    
        /**
         * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
         */
        function BaseTexture(source, scaleMode, resolution) {
            _classCallCheck(this, BaseTexture);
    
            var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
    
            _this.uid = (0, _utils.uid)();
    
            _this.touched = 0;
    
            /**
             * The resolution / device pixel ratio of the texture
             *
             * @member {number}
             * @default 1
             */
            _this.resolution = resolution || _settings2.default.RESOLUTION;
    
            /**
             * The width of the base texture set when the image has loaded
             *
             * @readonly
             * @member {number}
             */
            _this.width = 100;
    
            /**
             * The height of the base texture set when the image has loaded
             *
             * @readonly
             * @member {number}
             */
            _this.height = 100;
    
            // TODO docs
            // used to store the actual dimensions of the source
            /**
             * Used to store the actual width of the source of this texture
             *
             * @readonly
             * @member {number}
             */
            _this.realWidth = 100;
            /**
             * Used to store the actual height of the source of this texture
             *
             * @readonly
             * @member {number}
             */
            _this.realHeight = 100;
    
            /**
             * The scale mode to apply when scaling this texture
             *
             * @member {number}
             * @default PIXI.settings.SCALE_MODE
             * @see PIXI.SCALE_MODES
             */
            _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
    
            /**
             * Set to true once the base texture has successfully loaded.
             *
             * This is never true if the underlying source fails to load or has no texture data.
             *
             * @readonly
             * @member {boolean}
             */
            _this.hasLoaded = false;
    
            /**
             * Set to true if the source is currently loading.
             *
             * If an Image source is loading the 'loaded' or 'error' event will be
             * dispatched when the operation ends. An underyling source that is
             * immediately-available bypasses loading entirely.
             *
             * @readonly
             * @member {boolean}
             */
            _this.isLoading = false;
    
            /**
             * The image source that is used to create the texture.
             *
             * TODO: Make this a setter that calls loadSource();
             *
             * @readonly
             * @member {HTMLImageElement|HTMLCanvasElement}
             */
            _this.source = null; // set in loadSource, if at all
    
            /**
             * The image source that is used to create the texture. This is used to
             * store the original Svg source when it is replaced with a canvas element.
             *
             * TODO: Currently not in use but could be used when re-scaling svg.
             *
             * @readonly
             * @member {Image}
             */
            _this.origSource = null; // set in loadSvg, if at all
    
            /**
             * Type of image defined in source, eg. `png` or `svg`
             *
             * @readonly
             * @member {string}
             */
            _this.imageType = null; // set in updateImageType
    
            /**
             * Scale for source image. Used with Svg images to scale them before rasterization.
             *
             * @readonly
             * @member {number}
             */
            _this.sourceScale = 1.0;
    
            /**
             * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
             * All blend modes, and shaders written for default value. Change it on your own risk.
             *
             * @member {boolean}
             * @default true
             */
            _this.premultipliedAlpha = true;
    
            /**
             * The image url of the texture
             *
             * @member {string}
             */
            _this.imageUrl = null;
    
            /**
             * Whether or not the texture is a power of two, try to use power of two textures as much
             * as you can
             *
             * @private
             * @member {boolean}
             */
            _this.isPowerOfTwo = false;
    
            // used for webGL
    
            /**
             *
             * Set this to true if a mipmap of this texture needs to be generated. This value needs
             * to be set before the texture is used
             * Also the texture must be a power of two size to work
             *
             * @member {boolean}
             * @see PIXI.MIPMAP_TEXTURES
             */
            _this.mipmap = _settings2.default.MIPMAP_TEXTURES;
    
            /**
             *
             * WebGL Texture wrap mode
             *
             * @member {number}
             * @see PIXI.WRAP_MODES
             */
            _this.wrapMode = _settings2.default.WRAP_MODE;
    
            /**
             * A map of renderer IDs to webgl textures
             *
             * @private
             * @member {object<number, WebGLTexture>}
             */
            _this._glTextures = {};
    
            _this._enabled = 0;
            _this._virtalBoundId = -1;
    
            // if no source passed don't try to load
            if (source) {
                _this.loadSource(source);
            }
    
            /**
             * If the object has been destroyed via destroy(). If true, it should not be used.
             *
             * @member {boolean}
             * @private
             * @readonly
             */
            _this._destroyed = false;
    
            /**
             * Fired when a not-immediately-available source finishes loading.
             *
             * @protected
             * @event loaded
             * @memberof PIXI.BaseTexture#
             */
    
            /**
             * Fired when a not-immediately-available source fails to load.
             *
             * @protected
             * @event error
             * @memberof PIXI.BaseTexture#
             */
            return _this;
        }
    
        /**
         * Updates the texture on all the webgl renderers, this also assumes the src has changed.
         *
         * @fires update
         */
    
    
        BaseTexture.prototype.update = function update() {
            // Svg size is handled during load
            if (this.imageType !== 'svg') {
                this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
                this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;
    
                this._updateDimensions();
            }
    
            this.emit('update', this);
        };
    
        /**
         * Update dimensions from real values
         */
    
    
        BaseTexture.prototype._updateDimensions = function _updateDimensions() {
            this.width = this.realWidth / this.resolution;
            this.height = this.realHeight / this.resolution;
    
            this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
        };
    
        /**
         * Load a source.
         *
         * If the source is not-immediately-available, such as an image that needs to be
         * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
         * and `hasLoaded` will remain false after this call.
         *
         * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
         *
         *     if (texture.hasLoaded) {
         *        // texture ready for use
         *     } else if (texture.isLoading) {
         *        // listen to 'loaded' and/or 'error' events on texture
         *     } else {
         *        // not loading, not going to load UNLESS the source is reloaded
         *        // (it may still make sense to listen to the events)
         *     }
         *
         * @protected
         * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
         */
    
    
        BaseTexture.prototype.loadSource = function loadSource(source) {
            var wasLoading = this.isLoading;
    
            this.hasLoaded = false;
            this.isLoading = false;
    
            if (wasLoading && this.source) {
                this.source.onload = null;
                this.source.onerror = null;
            }
    
            var firstSourceLoaded = !this.source;
    
            this.source = source;
    
            // Apply source if loaded. Otherwise setup appropriate loading monitors.
            if ((source.src && source.complete || source.getContext) && source.width && source.height) {
                this._updateImageType();
    
                if (this.imageType === 'svg') {
                    this._loadSvgSource();
                } else {
                    this._sourceLoaded();
                }
    
                if (firstSourceLoaded) {
                    // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
                    this.emit('loaded', this);
                }
            } else if (!source.getContext) {
                // Image fail / not ready
                this.isLoading = true;
    
                var scope = this;
    
                source.onload = function () {
                    scope._updateImageType();
                    source.onload = null;
                    source.onerror = null;
    
                    if (!scope.isLoading) {
                        return;
                    }
    
                    scope.isLoading = false;
                    scope._sourceLoaded();
    
                    if (scope.imageType === 'svg') {
                        scope._loadSvgSource();
    
                        return;
                    }
    
                    scope.emit('loaded', scope);
                };
    
                source.onerror = function () {
                    source.onload = null;
                    source.onerror = null;
    
                    if (!scope.isLoading) {
                        return;
                    }
    
                    scope.isLoading = false;
                    scope.emit('error', scope);
                };
    
                // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
                //   "The value of `complete` can thus change while a script is executing."
                // So complete needs to be re-checked after the callbacks have been added..
                // NOTE: complete will be true if the image has no src so best to check if the src is set.
                if (source.complete && source.src) {
                    // ..and if we're complete now, no need for callbacks
                    source.onload = null;
                    source.onerror = null;
    
                    if (scope.imageType === 'svg') {
                        scope._loadSvgSource();
    
                        return;
                    }
    
                    this.isLoading = false;
    
                    if (source.width && source.height) {
                        this._sourceLoaded();
    
                        // If any previous subscribers possible
                        if (wasLoading) {
                            this.emit('loaded', this);
                        }
                    }
                    // If any previous subscribers possible
                    else if (wasLoading) {
                            this.emit('error', this);
                        }
                }
            }
        };
    
        /**
         * Updates type of the source image.
         */
    
    
        BaseTexture.prototype._updateImageType = function _updateImageType() {
            if (!this.imageUrl) {
                return;
            }
    
            var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
            var imageType = void 0;
    
            if (dataUri && dataUri.mediaType === 'image') {
                // Check for subType validity
                var firstSubType = dataUri.subType.split('+')[0];
    
                imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);
    
                if (!imageType) {
                    throw new Error('Invalid image type in data URI.');
                }
            } else {
                imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);
    
                if (!imageType) {
                    imageType = 'png';
                }
            }
    
            this.imageType = imageType;
        };
    
        /**
         * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
         * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
         */
    
    
        BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
            if (this.imageType !== 'svg') {
                // Do nothing if source is not svg
                return;
            }
    
            var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
    
            if (dataUri) {
                this._loadSvgSourceUsingDataUri(dataUri);
            } else {
                // We got an URL, so we need to do an XHR to check the svg size
                this._loadSvgSourceUsingXhr();
            }
        };
    
        /**
         * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
         *
         * @param {string} dataUri - The data uri to load from.
         */
    
    
        BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
            var svgString = void 0;
    
            if (dataUri.encoding === 'base64') {
                if (!atob) {
                    throw new Error('Your browser doesn\'t support base64 conversions.');
                }
                svgString = atob(dataUri.data);
            } else {
                svgString = dataUri.data;
            }
    
            this._loadSvgSourceUsingString(svgString);
        };
    
        /**
         * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
         */
    
    
        BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
            var _this2 = this;
    
            var svgXhr = new XMLHttpRequest();
    
            // This throws error on IE, so SVG Document can't be used
            // svgXhr.responseType = 'document';
    
            // This is not needed since we load the svg as string (breaks IE too)
            // but overrideMimeType() can be used to force the response to be parsed as XML
            // svgXhr.overrideMimeType('image/svg+xml');
    
            svgXhr.onload = function () {
                if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
                    throw new Error('Failed to load SVG using XHR.');
                }
    
                _this2._loadSvgSourceUsingString(svgXhr.response);
            };
    
            svgXhr.onerror = function () {
                return _this2.emit('error', _this2);
            };
    
            svgXhr.open('GET', this.imageUrl, true);
            svgXhr.send();
        };
    
        /**
         * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
         * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
         * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
         *
         * @param  {string} svgString SVG source as string
         *
         * @fires loaded
         */
    
    
        BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
            var svgSize = (0, _utils.getSvgSize)(svgString);
    
            var svgWidth = svgSize.width;
            var svgHeight = svgSize.height;
    
            if (!svgWidth || !svgHeight) {
                throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
            }
    
            // Scale realWidth and realHeight
            this.realWidth = Math.round(svgWidth * this.sourceScale);
            this.realHeight = Math.round(svgHeight * this.sourceScale);
    
            this._updateDimensions();
    
            // Create a canvas element
            var canvas = document.createElement('canvas');
    
            canvas.width = this.realWidth;
            canvas.height = this.realHeight;
            canvas._pixiId = 'canvas_' + (0, _utils.uid)();
    
            // Draw the Svg to the canvas
            canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);
    
            // Replace the original source image with the canvas
            this.origSource = this.source;
            this.source = canvas;
    
            // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
            _utils.BaseTextureCache[canvas._pixiId] = this;
    
            this.isLoading = false;
            this._sourceLoaded();
            this.emit('loaded', this);
        };
    
        /**
         * Used internally to update the width, height, and some other tracking vars once
         * a source has successfully loaded.
         *
         * @private
         */
    
    
        BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
            this.hasLoaded = true;
            this.update();
        };
    
        /**
         * Destroys this base texture
         *
         */
    
    
        BaseTexture.prototype.destroy = function destroy() {
            if (this.imageUrl) {
                delete _utils.BaseTextureCache[this.imageUrl];
                delete _utils.TextureCache[this.imageUrl];
    
                this.imageUrl = null;
    
                if (!navigator.isCocoonJS) {
                    this.source.src = '';
                }
            }
            // An svg source has both `imageUrl` and `__pixiId`, so no `else if` here
            if (this.source && this.source._pixiId) {
                delete _utils.BaseTextureCache[this.source._pixiId];
            }
    
            this.source = null;
    
            this.dispose();
    
            this._destroyed = true;
        };
    
        /**
         * Frees the texture from WebGL memory without destroying this texture object.
         * This means you can still use the texture later which will upload it to GPU
         * memory again.
         *
         */
    
    
        BaseTexture.prototype.dispose = function dispose() {
            this.emit('dispose', this);
        };
    
        /**
         * Changes the source image of the texture.
         * The original source must be an Image element.
         *
         * @param {string} newSrc - the path of the image
         */
    
    
        BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
            this.source.src = newSrc;
    
            this.loadSource(this.source);
        };
    
        /**
         * Helper function that creates a base texture from the given image url.
         * If the image is not in the base texture cache it will be created and loaded.
         *
         * @static
         * @param {string} imageUrl - The image url of the texture
         * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
         * @return {PIXI.BaseTexture} The new base texture.
         */
    
    
        BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
            var baseTexture = _utils.BaseTextureCache[imageUrl];
    
            if (!baseTexture) {
                // new Image() breaks tex loading in some versions of Chrome.
                // See https://code.google.com/p/chromium/issues/detail?id=238071
                var image = new Image(); // document.createElement('img');
    
                if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
                    image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
                }
    
                baseTexture = new BaseTexture(image, scaleMode);
                baseTexture.imageUrl = imageUrl;
    
                if (sourceScale) {
                    baseTexture.sourceScale = sourceScale;
                }
    
                // if there is an @2x at the end of the url we are going to assume its a highres image
                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
    
                image.src = imageUrl; // Setting this triggers load
    
                _utils.BaseTextureCache[imageUrl] = baseTexture;
            }
    
            return baseTexture;
        };
    
        /**
         * Helper function that creates a base texture from the given canvas element.
         *
         * @static
         * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
         * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.BaseTexture} The new base texture.
         */
    
    
        BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
            if (!canvas._pixiId) {
                canvas._pixiId = 'canvas_' + (0, _utils.uid)();
            }
    
            var baseTexture = _utils.BaseTextureCache[canvas._pixiId];
    
            if (!baseTexture) {
                baseTexture = new BaseTexture(canvas, scaleMode);
                _utils.BaseTextureCache[canvas._pixiId] = baseTexture;
            }
    
            return baseTexture;
        };
    
        /**
         * Helper function that creates a base texture based on the source you provide.
         * The source can be - image url, image element, canvas element.
         *
         * @static
         * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
         * @return {PIXI.BaseTexture} The new base texture.
         */
    
    
        BaseTexture.from = function from(source, scaleMode, sourceScale) {
            if (typeof source === 'string') {
                return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
            } else if (source instanceof HTMLImageElement) {
                var imageUrl = source.src;
                var baseTexture = _utils.BaseTextureCache[imageUrl];
    
                if (!baseTexture) {
                    baseTexture = new BaseTexture(source, scaleMode);
                    baseTexture.imageUrl = imageUrl;
    
                    if (sourceScale) {
                        baseTexture.sourceScale = sourceScale;
                    }
    
                    // if there is an @2x at the end of the url we are going to assume its a highres image
                    baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);
    
                    _utils.BaseTextureCache[imageUrl] = baseTexture;
                }
    
                return baseTexture;
            } else if (source instanceof HTMLCanvasElement) {
                return BaseTexture.fromCanvas(source, scaleMode);
            }
    
            // lets assume its a base texture!
            return source;
        };
    
        return BaseTexture;
    }(_eventemitter2.default);
    
    exports.default = BaseTexture;
    
    },{"../settings":100,"../utils":121,"../utils/determineCrossOrigin":120,"bit-twiddle":1,"eventemitter3":4}],111:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _BaseRenderTexture = require('./BaseRenderTexture');
    
    var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);
    
    var _Texture2 = require('./Texture');
    
    var _Texture3 = _interopRequireDefault(_Texture2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A RenderTexture is a special texture that allows any Pixi display object to be rendered to it.
     *
     * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
     * otherwise black rectangles will be drawn instead.
     *
     * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
     *
     * ```js
     * let renderer = PIXI.autoDetectRenderer(1024, 1024, { view: canvas, ratio: 1 });
     * let renderTexture = PIXI.RenderTexture.create(800, 600);
     * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
     *
     * sprite.position.x = 800/2;
     * sprite.position.y = 600/2;
     * sprite.anchor.x = 0.5;
     * sprite.anchor.y = 0.5;
     *
     * renderer.render(sprite, renderTexture);
     * ```
     *
     * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
     * you can clear the transform
     *
     * ```js
     *
     * sprite.setTransform()
     *
     * let renderTexture = new PIXI.RenderTexture.create(100, 100);
     *
     * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
     * ```
     *
     * @class
     * @extends PIXI.Texture
     * @memberof PIXI
     */
    var RenderTexture = function (_Texture) {
        _inherits(RenderTexture, _Texture);
    
        /**
         * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
         * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
         */
        function RenderTexture(baseRenderTexture, frame) {
            _classCallCheck(this, RenderTexture);
    
            // support for legacy..
            var _legacyRenderer = null;
    
            if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
                /* eslint-disable prefer-rest-params, no-console */
                var width = arguments[1];
                var height = arguments[2];
                var scaleMode = arguments[3];
                var resolution = arguments[4];
    
                // we have an old render texture..
                console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
                _legacyRenderer = arguments[0];
                /* eslint-enable prefer-rest-params, no-console */
    
                frame = null;
                baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
            }
    
            /**
             * The base texture object that this texture uses
             *
             * @member {BaseTexture}
             */
    
            var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));
    
            _this.legacyRenderer = _legacyRenderer;
    
            /**
             * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
             *
             * @member {boolean}
             */
            _this.valid = true;
    
            _this._updateUvs();
            return _this;
        }
    
        /**
         * Resizes the RenderTexture.
         *
         * @param {number} width - The width to resize to.
         * @param {number} height - The height to resize to.
         * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
         */
    
    
        RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
            // TODO - could be not required..
            this.valid = width > 0 && height > 0;
    
            this._frame.width = this.orig.width = width;
            this._frame.height = this.orig.height = height;
    
            if (!doNotResizeBaseTexture) {
                this.baseTexture.resize(width, height);
            }
    
            this._updateUvs();
        };
    
        /**
         * A short hand way of creating a render texture.
         *
         * @param {number} [width=100] - The width of the render texture
         * @param {number} [height=100] - The height of the render texture
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
         * @return {PIXI.RenderTexture} The new render texture
         */
    
    
        RenderTexture.create = function create(width, height, scaleMode, resolution) {
            return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
        };
    
        return RenderTexture;
    }(_Texture3.default);
    
    exports.default = RenderTexture;
    
    },{"./BaseRenderTexture":109,"./Texture":113}],112:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _ = require('../');
    
    var _utils = require('../utils');
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Utility class for maintaining reference to a collection
     * of Textures on a single Spritesheet.
     *
     * @class
     * @memberof PIXI
     */
    var Spritesheet = function () {
        _createClass(Spritesheet, null, [{
            key: 'BATCH_SIZE',
    
            /**
             * The maximum number of Textures to build per process.
             *
             * @type {number}
             * @default 1000
             */
            get: function get() {
                return 1000;
            }
    
            /**
             * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
             * @param {Object} data - Spritesheet image data.
             * @param {string} [resolutionFilename] - The filename to consider when determining
             *        the resolution of the spritesheet. If not provided, the imageUrl will
             *        be used on the BaseTexture.
             */
    
        }]);
    
        function Spritesheet(baseTexture, data) {
            var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    
            _classCallCheck(this, Spritesheet);
    
            /**
             * Reference to ths source texture
             * @type {PIXI.BaseTexture}
             */
            this.baseTexture = baseTexture;
    
            /**
             * Map of spritesheet textures.
             * @type {Object}
             */
            this.textures = {};
    
            /**
             * Reference to the original JSON data.
             * @type {Object}
             */
            this.data = data;
    
            /**
             * The resolution of the spritesheet.
             * @type {number}
             */
            this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);
    
            /**
             * Map of spritesheet frames.
             * @type {Object}
             * @private
             */
            this._frames = this.data.frames;
    
            /**
             * Collection of frame names.
             * @type {string[]}
             * @private
             */
            this._frameKeys = Object.keys(this._frames);
    
            /**
             * Current batch index being processed.
             * @type {number}
             * @private
             */
            this._batchIndex = 0;
    
            /**
             * Callback when parse is completed.
             * @type {Function}
             * @private
             */
            this._callback = null;
        }
    
        /**
         * Generate the resolution from the filename or fallback
         * to the meta.scale field of the JSON data.
         *
         * @private
         * @param {string} resolutionFilename - The filename to use for resolving
         *        the default resolution.
         * @return {number} Resolution to use for spritesheet.
         */
    
    
        Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
            var scale = this.data.meta.scale;
    
            // Use a defaultValue of `null` to check if a url-based resolution is set
            var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);
    
            // No resolution found via URL
            if (resolution === null) {
                // Use the scale value or default to 1
                resolution = scale !== undefined ? parseFloat(scale) : 1;
            }
    
            // For non-1 resolutions, update baseTexture
            if (resolution !== 1) {
                this.baseTexture.resolution = resolution;
                this.baseTexture.update();
            }
    
            return resolution;
        };
    
        /**
         * Parser spritesheet from loaded data. This is done asynchronously
         * to prevent creating too many Texture within a single process.
         *
         * @param {Function} callback - Callback when complete returns
         *        a map of the Textures for this spritesheet.
         */
    
    
        Spritesheet.prototype.parse = function parse(callback) {
            this._batchIndex = 0;
            this._callback = callback;
    
            if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
                this._processFrames(0);
                this._parseComplete();
            } else {
                this._nextBatch();
            }
        };
    
        /**
         * Process a batch of frames
         *
         * @private
         * @param {number} initialFrameIndex - The index of frame to start.
         */
    
    
        Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
            var frameIndex = initialFrameIndex;
            var maxFrames = Spritesheet.BATCH_SIZE;
    
            while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
                var i = this._frameKeys[frameIndex];
                var rect = this._frames[i].frame;
    
                if (rect) {
                    var frame = null;
                    var trim = null;
                    var orig = new _.Rectangle(0, 0, this._frames[i].sourceSize.w / this.resolution, this._frames[i].sourceSize.h / this.resolution);
    
                    if (this._frames[i].rotated) {
                        frame = new _.Rectangle(rect.x / this.resolution, rect.y / this.resolution, rect.h / this.resolution, rect.w / this.resolution);
                    } else {
                        frame = new _.Rectangle(rect.x / this.resolution, rect.y / this.resolution, rect.w / this.resolution, rect.h / this.resolution);
                    }
    
                    //  Check to see if the sprite is trimmed
                    if (this._frames[i].trimmed) {
                        trim = new _.Rectangle(this._frames[i].spriteSourceSize.x / this.resolution, this._frames[i].spriteSourceSize.y / this.resolution, rect.w / this.resolution, rect.h / this.resolution);
                    }
    
                    this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, this._frames[i].rotated ? 2 : 0);
    
                    // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
                    _utils.TextureCache[i] = this.textures[i];
                }
    
                frameIndex++;
            }
        };
    
        /**
         * The parse has completed.
         *
         * @private
         */
    
    
        Spritesheet.prototype._parseComplete = function _parseComplete() {
            var callback = this._callback;
    
            this._callback = null;
            this._batchIndex = 0;
            callback.call(this, this.textures);
        };
    
        /**
         * Begin the next batch of textures.
         *
         * @private
         */
    
    
        Spritesheet.prototype._nextBatch = function _nextBatch() {
            var _this = this;
    
            this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
            this._batchIndex++;
            setTimeout(function () {
                if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
                    _this._nextBatch();
                } else {
                    _this._parseComplete();
                }
            }, 0);
        };
    
        /**
         * Destroy Spritesheet and don't use after this.
         *
         * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
         */
    
    
        Spritesheet.prototype.destroy = function destroy() {
            var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    
            for (var i in this.textures) {
                this.textures[i].destroy();
            }
            this._frames = null;
            this._frameKeys = null;
            this.data = null;
            this.textures = null;
            if (destroyBase) {
                this.baseTexture.destroy();
            }
            this.baseTexture = null;
        };
    
        return Spritesheet;
    }();
    
    exports.default = Spritesheet;
    
    },{"../":64,"../utils":121}],113:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _BaseTexture = require('./BaseTexture');
    
    var _BaseTexture2 = _interopRequireDefault(_BaseTexture);
    
    var _VideoBaseTexture = require('./VideoBaseTexture');
    
    var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);
    
    var _TextureUvs = require('./TextureUvs');
    
    var _TextureUvs2 = _interopRequireDefault(_TextureUvs);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _math = require('../math');
    
    var _utils = require('../utils');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A texture stores the information that represents an image or part of an image. It cannot be added
     * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
     * then the whole image is used.
     *
     * You can directly create a texture from an image and then reuse it multiple times like this :
     *
     * ```js
     * let texture = PIXI.Texture.fromImage('assets/image.png');
     * let sprite1 = new PIXI.Sprite(texture);
     * let sprite2 = new PIXI.Sprite(texture);
     * ```
     *
     * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
     * You can check for this by checking the sprite's _textureID property.
     * ```js
     * var texture = PIXI.Texture.fromImage('assets/image.svg');
     * var sprite1 = new PIXI.Sprite(texture);
     * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
     * ```
     * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
     *
     * @class
     * @extends EventEmitter
     * @memberof PIXI
     */
    var Texture = function (_EventEmitter) {
        _inherits(Texture, _EventEmitter);
    
        /**
         * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
         * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
         * @param {PIXI.Rectangle} [orig] - The area of original texture
         * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
         * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
         */
        function Texture(baseTexture, frame, orig, trim, rotate) {
            _classCallCheck(this, Texture);
    
            /**
             * Does this Texture have any frame data assigned to it?
             *
             * @member {boolean}
             */
            var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
    
            _this.noFrame = false;
    
            if (!frame) {
                _this.noFrame = true;
                frame = new _math.Rectangle(0, 0, 1, 1);
            }
    
            if (baseTexture instanceof Texture) {
                baseTexture = baseTexture.baseTexture;
            }
    
            /**
             * The base texture that this texture uses.
             *
             * @member {PIXI.BaseTexture}
             */
            _this.baseTexture = baseTexture;
    
            /**
             * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
             * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
             *
             * @member {PIXI.Rectangle}
             */
            _this._frame = frame;
    
            /**
             * This is the trimmed area of original texture, before it was put in atlas
             *
             * @member {PIXI.Rectangle}
             */
            _this.trim = trim;
    
            /**
             * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
             *
             * @member {boolean}
             */
            _this.valid = false;
    
            /**
             * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
             *
             * @member {boolean}
             */
            _this.requiresUpdate = false;
    
            /**
             * The WebGL UV data cache.
             *
             * @member {PIXI.TextureUvs}
             * @private
             */
            _this._uvs = null;
    
            /**
             * This is the area of original texture, before it was put in atlas
             *
             * @member {PIXI.Rectangle}
             */
            _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);
    
            _this._rotate = Number(rotate || 0);
    
            if (rotate === true) {
                // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
                _this._rotate = 2;
            } else if (_this._rotate % 2 !== 0) {
                throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
            }
    
            if (baseTexture.hasLoaded) {
                if (_this.noFrame) {
                    frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
    
                    // if there is no frame we should monitor for any base texture changes..
                    baseTexture.on('update', _this.onBaseTextureUpdated, _this);
                }
                _this.frame = frame;
            } else {
                baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
            }
    
            /**
             * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
             *
             * @event update
             * @memberof PIXI.Texture#
             * @protected
             */
    
            _this._updateID = 0;
    
            /**
             * Extra field for extra plugins. May contain clamp settings and some matrices
             * @type {Object}
             */
            _this.transform = null;
            return _this;
        }
    
        /**
         * Updates this texture on the gpu.
         *
         */
    
    
        Texture.prototype.update = function update() {
            this.baseTexture.update();
        };
    
        /**
         * Called when the base texture is loaded
         *
         * @private
         * @param {PIXI.BaseTexture} baseTexture - The base texture.
         */
    
    
        Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
            this._updateID++;
    
            // TODO this code looks confusing.. boo to abusing getters and setters!
            if (this.noFrame) {
                this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
            } else {
                this.frame = this._frame;
            }
    
            this.baseTexture.on('update', this.onBaseTextureUpdated, this);
            this.emit('update', this);
        };
    
        /**
         * Called when the base texture is updated
         *
         * @private
         * @param {PIXI.BaseTexture} baseTexture - The base texture.
         */
    
    
        Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
            this._updateID++;
    
            this._frame.width = baseTexture.width;
            this._frame.height = baseTexture.height;
    
            this.emit('update', this);
        };
    
        /**
         * Destroys this texture
         *
         * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
         */
    
    
        Texture.prototype.destroy = function destroy(destroyBase) {
            if (this.baseTexture) {
                if (destroyBase) {
                    // delete the texture if it exists in the texture cache..
                    // this only needs to be removed if the base texture is actually destroyed too..
                    if (_utils.TextureCache[this.baseTexture.imageUrl]) {
                        delete _utils.TextureCache[this.baseTexture.imageUrl];
                    }
    
                    this.baseTexture.destroy();
                }
    
                this.baseTexture.off('update', this.onBaseTextureUpdated, this);
                this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);
    
                this.baseTexture = null;
            }
    
            this._frame = null;
            this._uvs = null;
            this.trim = null;
            this.orig = null;
    
            this.valid = false;
    
            this.off('dispose', this.dispose, this);
            this.off('update', this.update, this);
        };
    
        /**
         * Creates a new texture object that acts the same as this one.
         *
         * @return {PIXI.Texture} The new texture
         */
    
    
        Texture.prototype.clone = function clone() {
            return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate);
        };
    
        /**
         * Updates the internal WebGL UV cache.
         *
         * @protected
         */
    
    
        Texture.prototype._updateUvs = function _updateUvs() {
            if (!this._uvs) {
                this._uvs = new _TextureUvs2.default();
            }
    
            this._uvs.set(this._frame, this.baseTexture, this.rotate);
    
            this._updateID++;
        };
    
        /**
         * Helper function that creates a Texture object from the given image url.
         * If the image is not in the texture cache it will be  created and loaded.
         *
         * @static
         * @param {string} imageUrl - The image url of the texture
         * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
            var texture = _utils.TextureCache[imageUrl];
    
            if (!texture) {
                texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
                _utils.TextureCache[imageUrl] = texture;
            }
    
            return texture;
        };
    
        /**
         * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
         * The frame ids are created when a Texture packer file has been loaded
         *
         * @static
         * @param {string} frameId - The frame Id of the texture in the cache
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.fromFrame = function fromFrame(frameId) {
            var texture = _utils.TextureCache[frameId];
    
            if (!texture) {
                throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
            }
    
            return texture;
        };
    
        /**
         * Helper function that creates a new Texture based on the given canvas element.
         *
         * @static
         * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
            return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode));
        };
    
        /**
         * Helper function that creates a new Texture based on the given video element.
         *
         * @static
         * @param {HTMLVideoElement|string} video - The URL or actual element of the video
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.fromVideo = function fromVideo(video, scaleMode) {
            if (typeof video === 'string') {
                return Texture.fromVideoUrl(video, scaleMode);
            }
    
            return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode));
        };
    
        /**
         * Helper function that creates a new Texture based on the video url.
         *
         * @static
         * @param {string} videoUrl - URL of the video
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode) {
            return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode));
        };
    
        /**
         * Helper function that creates a new Texture based on the source you provide.
         * The source can be - frame id, image url, video url, canvas element, video element, base texture
         *
         * @static
         * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
         *        source - Source to create texture from
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        Texture.from = function from(source) {
            // TODO auto detect cross origin..
            // TODO pass in scale mode?
            if (typeof source === 'string') {
                var texture = _utils.TextureCache[source];
    
                if (!texture) {
                    // check if its a video..
                    var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;
    
                    if (isVideo) {
                        return Texture.fromVideoUrl(source);
                    }
    
                    return Texture.fromImage(source);
                }
    
                return texture;
            } else if (source instanceof HTMLImageElement) {
                return new Texture(_BaseTexture2.default.from(source));
            } else if (source instanceof HTMLCanvasElement) {
                return Texture.fromCanvas(source);
            } else if (source instanceof HTMLVideoElement) {
                return Texture.fromVideo(source);
            } else if (source instanceof _BaseTexture2.default) {
                return new Texture(source);
            }
    
            // lets assume its a texture!
            return source;
        };
    
        /**
         * Create a texture from a source and add to the cache.
         *
         * @static
         * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
         * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
         * @param {String} [name] - Human readible name for the texture cache. If no name is
         *        specified, only `imageUrl` will be used as the cache ID.
         * @return {PIXI.Texture} Output texture
         */
    
    
        Texture.fromLoader = function fromLoader(source, imageUrl, name) {
            var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
            var texture = new Texture(baseTexture);
    
            baseTexture.imageUrl = imageUrl;
    
            // No name, use imageUrl instead
            if (!name) {
                name = imageUrl;
            }
    
            // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
            _utils.BaseTextureCache[name] = baseTexture;
            _utils.TextureCache[name] = texture;
    
            // also add references by url if they are different.
            if (name !== imageUrl) {
                _utils.BaseTextureCache[imageUrl] = baseTexture;
                _utils.TextureCache[imageUrl] = texture;
            }
    
            return texture;
        };
    
        /**
         * Adds a texture to the global TextureCache. This cache is shared across the whole PIXI object.
         *
         * @static
         * @param {PIXI.Texture} texture - The Texture to add to the cache.
         * @param {string} id - The id that the texture will be stored against.
         */
    
    
        Texture.addTextureToCache = function addTextureToCache(texture, id) {
            _utils.TextureCache[id] = texture;
        };
    
        /**
         * Remove a texture from the global TextureCache.
         *
         * @static
         * @param {string} id - The id of the texture to be removed
         * @return {PIXI.Texture} The texture that was removed
         */
    
    
        Texture.removeTextureFromCache = function removeTextureFromCache(id) {
            var texture = _utils.TextureCache[id];
    
            delete _utils.TextureCache[id];
            delete _utils.BaseTextureCache[id];
    
            return texture;
        };
    
        /**
         * The frame specifies the region of the base texture that this texture uses.
         *
         * @member {PIXI.Rectangle}
         */
    
    
        _createClass(Texture, [{
            key: 'frame',
            get: function get() {
                return this._frame;
            },
            set: function set(frame) // eslint-disable-line require-jsdoc
            {
                this._frame = frame;
    
                this.noFrame = false;
    
                if (frame.x + frame.width > this.baseTexture.width || frame.y + frame.height > this.baseTexture.height) {
                    throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + ('X: ' + frame.x + ' + ' + frame.width + ' > ' + this.baseTexture.width + ' ') + ('Y: ' + frame.y + ' + ' + frame.height + ' > ' + this.baseTexture.height));
                }
    
                // this.valid = frame && frame.width && frame.height && this.baseTexture.source && this.baseTexture.hasLoaded;
                this.valid = frame && frame.width && frame.height && this.baseTexture.hasLoaded;
    
                if (!this.trim && !this.rotate) {
                    this.orig = frame;
                }
    
                if (this.valid) {
                    this._updateUvs();
                }
            }
    
            /**
             * Indicates whether the texture is rotated inside the atlas
             * set to 2 to compensate for texture packer rotation
             * set to 6 to compensate for spine packer rotation
             * can be used to rotate or mirror sprites
             * See {@link PIXI.GroupD8} for explanation
             *
             * @member {number}
             */
    
        }, {
            key: 'rotate',
            get: function get() {
                return this._rotate;
            },
            set: function set(rotate) // eslint-disable-line require-jsdoc
            {
                this._rotate = rotate;
                if (this.valid) {
                    this._updateUvs();
                }
            }
    
            /**
             * The width of the Texture in pixels.
             *
             * @member {number}
             */
    
        }, {
            key: 'width',
            get: function get() {
                return this.orig.width;
            }
    
            /**
             * The height of the Texture in pixels.
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                return this.orig.height;
            }
        }]);
    
        return Texture;
    }(_eventemitter2.default);
    
    exports.default = Texture;
    
    
    function createWhiteTexture() {
        var canvas = document.createElement('canvas');
    
        canvas.width = 10;
        canvas.height = 10;
    
        var context = canvas.getContext('2d');
    
        context.fillStyle = 'white';
        context.fillRect(0, 0, 10, 10);
    
        return new Texture(new _BaseTexture2.default(canvas));
    }
    
    function removeAllHandlers(tex) {
        tex.destroy = function _emptyDestroy() {/* empty */};
        tex.on = function _emptyOn() {/* empty */};
        tex.once = function _emptyOnce() {/* empty */};
        tex.emit = function _emptyEmit() {/* empty */};
    }
    
    /**
     * An empty texture, used often to not have to create multiple empty textures.
     * Can not be destroyed.
     *
     * @static
     * @constant
     */
    Texture.EMPTY = new Texture(new _BaseTexture2.default());
    removeAllHandlers(Texture.EMPTY);
    removeAllHandlers(Texture.EMPTY.baseTexture);
    
    /**
     * A white texture of 10x10 size, used for graphics and other things
     * Can not be destroyed.
     *
     * @static
     * @constant
     */
    Texture.WHITE = createWhiteTexture();
    removeAllHandlers(Texture.WHITE);
    removeAllHandlers(Texture.WHITE.baseTexture);
    
    },{"../math":69,"../utils":121,"./BaseTexture":110,"./TextureUvs":114,"./VideoBaseTexture":115,"eventemitter3":4}],114:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _GroupD = require('../math/GroupD8');
    
    var _GroupD2 = _interopRequireDefault(_GroupD);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * A standard object to store the Uvs of a texture
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var TextureUvs = function () {
        /**
         *
         */
        function TextureUvs() {
            _classCallCheck(this, TextureUvs);
    
            this.x0 = 0;
            this.y0 = 0;
    
            this.x1 = 1;
            this.y1 = 0;
    
            this.x2 = 1;
            this.y2 = 1;
    
            this.x3 = 0;
            this.y3 = 1;
    
            this.uvsUint32 = new Uint32Array(4);
        }
    
        /**
         * Sets the texture Uvs based on the given frame information.
         *
         * @private
         * @param {PIXI.Rectangle} frame - The frame of the texture
         * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
         * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
         */
    
    
        TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
            var tw = baseFrame.width;
            var th = baseFrame.height;
    
            if (rotate) {
                // width and height div 2 div baseFrame size
                var w2 = frame.width / 2 / tw;
                var h2 = frame.height / 2 / th;
    
                // coordinates of center
                var cX = frame.x / tw + w2;
                var cY = frame.y / th + h2;
    
                rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
                this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
                this.y0 = cY + h2 * _GroupD2.default.uY(rotate);
    
                rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
                this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
                this.y1 = cY + h2 * _GroupD2.default.uY(rotate);
    
                rotate = _GroupD2.default.add(rotate, 2);
                this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
                this.y2 = cY + h2 * _GroupD2.default.uY(rotate);
    
                rotate = _GroupD2.default.add(rotate, 2);
                this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
                this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
            } else {
                this.x0 = frame.x / tw;
                this.y0 = frame.y / th;
    
                this.x1 = (frame.x + frame.width) / tw;
                this.y1 = frame.y / th;
    
                this.x2 = (frame.x + frame.width) / tw;
                this.y2 = (frame.y + frame.height) / th;
    
                this.x3 = frame.x / tw;
                this.y3 = (frame.y + frame.height) / th;
            }
    
            this.uvsUint32[0] = (this.y0 * 65535 & 0xFFFF) << 16 | this.x0 * 65535 & 0xFFFF;
            this.uvsUint32[1] = (this.y1 * 65535 & 0xFFFF) << 16 | this.x1 * 65535 & 0xFFFF;
            this.uvsUint32[2] = (this.y2 * 65535 & 0xFFFF) << 16 | this.x2 * 65535 & 0xFFFF;
            this.uvsUint32[3] = (this.y3 * 65535 & 0xFFFF) << 16 | this.x3 * 65535 & 0xFFFF;
        };
    
        return TextureUvs;
    }();
    
    exports.default = TextureUvs;
    
    },{"../math/GroupD8":65}],115:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _BaseTexture2 = require('./BaseTexture');
    
    var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);
    
    var _utils = require('../utils');
    
    var _ticker = require('../ticker');
    
    var ticker = _interopRequireWildcard(_ticker);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A texture of a [playing] Video.
     *
     * Video base textures mimic Pixi BaseTexture.from.... method in their creation process.
     *
     * This can be used in several ways, such as:
     *
     * ```js
     * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
     *
     * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
     *
     * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
     *
     * let texture = PIXI.VideoBaseTexture.fromUrls([
     *     { src: '/video.webm', mime: 'video/webm' },
     *     { src: '/video.mp4', mime: 'video/mp4' }
     * ]);
     * ```
     *
     * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
     *
     * @class
     * @extends PIXI.BaseTexture
     * @memberof PIXI
     */
    var VideoBaseTexture = function (_BaseTexture) {
        _inherits(VideoBaseTexture, _BaseTexture);
    
        /**
         * @param {HTMLVideoElement} source - Video source
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         */
        function VideoBaseTexture(source, scaleMode) {
            _classCallCheck(this, VideoBaseTexture);
    
            if (!source) {
                throw new Error('No video source element specified.');
            }
    
            // hook in here to check if video is already available.
            // BaseTexture looks for a source.complete boolean, plus width & height.
    
            if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
                source.complete = true;
            }
    
            var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));
    
            _this.width = source.videoWidth;
            _this.height = source.videoHeight;
    
            _this._autoUpdate = true;
            _this._isAutoUpdating = false;
    
            /**
             * When set to true will automatically play videos used by this texture once
             * they are loaded. If false, it will not modify the playing state.
             *
             * @member {boolean}
             * @default true
             */
            _this.autoPlay = true;
    
            _this.update = _this.update.bind(_this);
            _this._onCanPlay = _this._onCanPlay.bind(_this);
    
            source.addEventListener('play', _this._onPlayStart.bind(_this));
            source.addEventListener('pause', _this._onPlayStop.bind(_this));
            _this.hasLoaded = false;
            _this.__loaded = false;
    
            if (!_this._isSourceReady()) {
                source.addEventListener('canplay', _this._onCanPlay);
                source.addEventListener('canplaythrough', _this._onCanPlay);
            } else {
                _this._onCanPlay();
            }
            return _this;
        }
    
        /**
         * Returns true if the underlying source is playing.
         *
         * @private
         * @return {boolean} True if playing.
         */
    
    
        VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
            var source = this.source;
    
            return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
        };
    
        /**
         * Returns true if the underlying source is ready for playing.
         *
         * @private
         * @return {boolean} True if ready.
         */
    
    
        VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
            return this.source.readyState === 3 || this.source.readyState === 4;
        };
    
        /**
         * Runs the update loop when the video is ready to play
         *
         * @private
         */
    
    
        VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
            // Just in case the video has not received its can play even yet..
            if (!this.hasLoaded) {
                this._onCanPlay();
            }
    
            if (!this._isAutoUpdating && this.autoUpdate) {
                ticker.shared.add(this.update, this);
                this._isAutoUpdating = true;
            }
        };
    
        /**
         * Fired when a pause event is triggered, stops the update loop
         *
         * @private
         */
    
    
        VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
            if (this._isAutoUpdating) {
                ticker.shared.remove(this.update, this);
                this._isAutoUpdating = false;
            }
        };
    
        /**
         * Fired when the video is loaded and ready to play
         *
         * @private
         */
    
    
        VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
            this.hasLoaded = true;
    
            if (this.source) {
                this.source.removeEventListener('canplay', this._onCanPlay);
                this.source.removeEventListener('canplaythrough', this._onCanPlay);
    
                this.width = this.source.videoWidth;
                this.height = this.source.videoHeight;
    
                // prevent multiple loaded dispatches..
                if (!this.__loaded) {
                    this.__loaded = true;
                    this.emit('loaded', this);
                }
    
                if (this._isSourcePlaying()) {
                    this._onPlayStart();
                } else if (this.autoPlay) {
                    this.source.play();
                }
            }
        };
    
        /**
         * Destroys this texture
         *
         */
    
    
        VideoBaseTexture.prototype.destroy = function destroy() {
            if (this._isAutoUpdating) {
                ticker.shared.remove(this.update, this);
            }
    
            if (this.source && this.source._pixiId) {
                delete _utils.BaseTextureCache[this.source._pixiId];
                delete this.source._pixiId;
            }
    
            _BaseTexture.prototype.destroy.call(this);
        };
    
        /**
         * Mimic Pixi BaseTexture.from.... method.
         *
         * @static
         * @param {HTMLVideoElement} video - Video to create texture from
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
         */
    
    
        VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode) {
            if (!video._pixiId) {
                video._pixiId = 'video_' + (0, _utils.uid)();
            }
    
            var baseTexture = _utils.BaseTextureCache[video._pixiId];
    
            if (!baseTexture) {
                baseTexture = new VideoBaseTexture(video, scaleMode);
                _utils.BaseTextureCache[video._pixiId] = baseTexture;
            }
    
            return baseTexture;
        };
    
        /**
         * Helper function that creates a new BaseTexture based on the given video element.
         * This BaseTexture can then be used to create a texture
         *
         * @static
         * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
         * @param {string} [videoSrc.src] - One of the source urls for the video
         * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
         *  the url's extension will be used as the second part of the mime type.
         * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
         */
    
    
        VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode) {
            var video = document.createElement('video');
    
            video.setAttribute('webkit-playsinline', '');
            video.setAttribute('playsinline', '');
    
            // array of objects or strings
            if (Array.isArray(videoSrc)) {
                for (var i = 0; i < videoSrc.length; ++i) {
                    video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
                }
            }
            // single object or string
            else {
                    video.appendChild(createSource(videoSrc.src || videoSrc, videoSrc.mime));
                }
    
            video.load();
    
            return VideoBaseTexture.fromVideo(video, scaleMode);
        };
    
        /**
         * Should the base texture automatically update itself, set to true by default
         *
         * @member {boolean}
         */
    
    
        _createClass(VideoBaseTexture, [{
            key: 'autoUpdate',
            get: function get() {
                return this._autoUpdate;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (value !== this._autoUpdate) {
                    this._autoUpdate = value;
    
                    if (!this._autoUpdate && this._isAutoUpdating) {
                        ticker.shared.remove(this.update, this);
                        this._isAutoUpdating = false;
                    } else if (this._autoUpdate && !this._isAutoUpdating) {
                        ticker.shared.add(this.update, this);
                        this._isAutoUpdating = true;
                    }
                }
            }
        }]);
    
        return VideoBaseTexture;
    }(_BaseTexture3.default);
    
    exports.default = VideoBaseTexture;
    
    
    VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;
    
    function createSource(path, type) {
        if (!type) {
            type = 'video/' + path.substr(path.lastIndexOf('.') + 1);
        }
    
        var source = document.createElement('source');
    
        source.src = path;
        source.type = type;
    
        return source;
    }
    
    },{"../ticker":117,"../utils":121,"./BaseTexture":110}],116:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    // Internal event used by composed emitter
    var TICK = 'tick';
    
    /**
     * A Ticker class that runs an update loop that other objects listen to.
     * This class is composed around an EventEmitter object to add listeners
     * meant for execution on the next requested animation frame.
     * Animation frames are requested only when necessary,
     * e.g. When the ticker is started and the emitter has listeners.
     *
     * @class
     * @memberof PIXI.ticker
     */
    
    var Ticker = function () {
        /**
         *
         */
        function Ticker() {
            var _this = this;
    
            _classCallCheck(this, Ticker);
    
            /**
             * Internal emitter used to fire 'tick' event
             * @private
             */
            this._emitter = new _eventemitter2.default();
    
            /**
             * Internal current frame request ID
             * @private
             */
            this._requestId = null;
    
            /**
             * Internal value managed by minFPS property setter and getter.
             * This is the maximum allowed milliseconds between updates.
             * @private
             */
            this._maxElapsedMS = 100;
    
            /**
             * Whether or not this ticker should invoke the method
             * {@link PIXI.ticker.Ticker#start} automatically
             * when a listener is added.
             *
             * @member {boolean}
             * @default false
             */
            this.autoStart = false;
    
            /**
             * Scalar time value from last frame to this frame.
             * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
             * and is scaled with {@link PIXI.ticker.Ticker#speed}.
             * **Note:** The cap may be exceeded by scaling.
             *
             * @member {number}
             * @default 1
             */
            this.deltaTime = 1;
    
            /**
             * Time elapsed in milliseconds from last frame to this frame.
             * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
             * is based, this value is neither capped nor scaled.
             * If the platform supports DOMHighResTimeStamp,
             * this value will have a precision of 1 Âµs.
             * Defaults to target frame time
             *
             * @member {number}
             * @default 16.66
             */
            this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;
    
            /**
             * The last time {@link PIXI.ticker.Ticker#update} was invoked.
             * This value is also reset internally outside of invoking
             * update, but only when a new animation frame is requested.
             * If the platform supports DOMHighResTimeStamp,
             * this value will have a precision of 1 Âµs.
             *
             * @member {number}
             * @default 0
             */
            this.lastTime = 0;
    
            /**
             * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
             * @example
             * // Scales ticker.deltaTime to what would be
             * // the equivalent of approximately 120 FPS
             * ticker.speed = 2;
             *
             * @member {number}
             * @default 1
             */
            this.speed = 1;
    
            /**
             * Whether or not this ticker has been started.
             * `true` if {@link PIXI.ticker.Ticker#start} has been called.
             * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
             * While `false`, this value may change to `true` in the
             * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
             * and a listener is added.
             *
             * @member {boolean}
             * @default false
             */
            this.started = false;
    
            /**
             * Internal tick method bound to ticker instance.
             * This is because in early 2015, Function.bind
             * is still 60% slower in high performance scenarios.
             * Also separating frame requests from update method
             * so listeners may be called at any time and with
             * any animation API, just invoke ticker.update(time).
             *
             * @private
             * @param {number} time - Time since last tick.
             */
            this._tick = function (time) {
                _this._requestId = null;
    
                if (_this.started) {
                    // Invoke listeners now
                    _this.update(time);
                    // Listener side effects may have modified ticker state.
                    if (_this.started && _this._requestId === null && _this._emitter.listeners(TICK, true)) {
                        _this._requestId = requestAnimationFrame(_this._tick);
                    }
                }
            };
        }
    
        /**
         * Conditionally requests a new animation frame.
         * If a frame has not already been requested, and if the internal
         * emitter has listeners, a new frame is requested.
         *
         * @private
         */
    
    
        Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
            if (this._requestId === null && this._emitter.listeners(TICK, true)) {
                // ensure callbacks get correct delta
                this.lastTime = performance.now();
                this._requestId = requestAnimationFrame(this._tick);
            }
        };
    
        /**
         * Conditionally cancels a pending animation frame.
         *
         * @private
         */
    
    
        Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
            if (this._requestId !== null) {
                cancelAnimationFrame(this._requestId);
                this._requestId = null;
            }
        };
    
        /**
         * Conditionally requests a new animation frame.
         * If the ticker has been started it checks if a frame has not already
         * been requested, and if the internal emitter has listeners. If these
         * conditions are met, a new frame is requested. If the ticker has not
         * been started, but autoStart is `true`, then the ticker starts now,
         * and continues with the previous conditions to request a new frame.
         *
         * @private
         */
    
    
        Ticker.prototype._startIfPossible = function _startIfPossible() {
            if (this.started) {
                this._requestIfNeeded();
            } else if (this.autoStart) {
                this.start();
            }
        };
    
        /**
         * Calls {@link module:eventemitter3.EventEmitter#on} internally for the
         * internal 'tick' event. It checks if the emitter has listeners,
         * and if so it requests a new animation frame at this point.
         *
         * @param {Function} fn - The listener function to be added for updates
         * @param {Function} [context] - The listener context
         * @returns {PIXI.ticker.Ticker} This instance of a ticker
         */
    
    
        Ticker.prototype.add = function add(fn, context) {
            this._emitter.on(TICK, fn, context);
    
            this._startIfPossible();
    
            return this;
        };
    
        /**
         * Calls {@link module:eventemitter3.EventEmitter#once} internally for the
         * internal 'tick' event. It checks if the emitter has listeners,
         * and if so it requests a new animation frame at this point.
         *
         * @param {Function} fn - The listener function to be added for one update
         * @param {Function} [context] - The listener context
         * @returns {PIXI.ticker.Ticker} This instance of a ticker
         */
    
    
        Ticker.prototype.addOnce = function addOnce(fn, context) {
            this._emitter.once(TICK, fn, context);
    
            this._startIfPossible();
    
            return this;
        };
    
        /**
         * Calls {@link module:eventemitter3.EventEmitter#off} internally for 'tick' event.
         * It checks if the emitter has listeners for 'tick' event.
         * If it does, then it cancels the animation frame.
         *
         * @param {Function} [fn] - The listener function to be removed
         * @param {Function} [context] - The listener context to be removed
         * @returns {PIXI.ticker.Ticker} This instance of a ticker
         */
    
    
        Ticker.prototype.remove = function remove(fn, context) {
            this._emitter.off(TICK, fn, context);
    
            if (!this._emitter.listeners(TICK, true)) {
                this._cancelIfNeeded();
            }
    
            return this;
        };
    
        /**
         * Starts the ticker. If the ticker has listeners
         * a new animation frame is requested at this point.
         */
    
    
        Ticker.prototype.start = function start() {
            if (!this.started) {
                this.started = true;
                this._requestIfNeeded();
            }
        };
    
        /**
         * Stops the ticker. If the ticker has requested
         * an animation frame it is canceled at this point.
         */
    
    
        Ticker.prototype.stop = function stop() {
            if (this.started) {
                this.started = false;
                this._cancelIfNeeded();
            }
        };
    
        /**
         * Triggers an update. An update entails setting the
         * current {@link PIXI.ticker.Ticker#elapsedMS},
         * the current {@link PIXI.ticker.Ticker#deltaTime},
         * invoking all listeners with current deltaTime,
         * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
         * with the value of currentTime that was provided.
         * This method will be called automatically by animation
         * frame callbacks if the ticker instance has been started
         * and listeners are added.
         *
         * @param {number} [currentTime=performance.now()] - the current time of execution
         */
    
    
        Ticker.prototype.update = function update() {
            var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
    
            var elapsedMS = void 0;
    
            // If the difference in time is zero or negative, we ignore most of the work done here.
            // If there is no valid difference, then should be no reason to let anyone know about it.
            // A zero delta, is exactly that, nothing should update.
            //
            // The difference in time can be negative, and no this does not mean time traveling.
            // This can be the result of a race condition between when an animation frame is requested
            // on the current JavaScript engine event loop, and when the ticker's start method is invoked
            // (which invokes the internal _requestIfNeeded method). If a frame is requested before
            // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
            // can receive a time argument that can be less than the lastTime value that was set within
            // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
            //
            // This check covers this browser engine timing issue, as well as if consumers pass an invalid
            // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.
    
            if (currentTime > this.lastTime) {
                // Save uncapped elapsedMS for measurement
                elapsedMS = this.elapsedMS = currentTime - this.lastTime;
    
                // cap the milliseconds elapsed used for deltaTime
                if (elapsedMS > this._maxElapsedMS) {
                    elapsedMS = this._maxElapsedMS;
                }
    
                this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;
    
                // Invoke listeners added to internal emitter
                this._emitter.emit(TICK, this.deltaTime);
            } else {
                this.deltaTime = this.elapsedMS = 0;
            }
    
            this.lastTime = currentTime;
        };
    
        /**
         * The frames per second at which this ticker is running.
         * The default is approximately 60 in most modern browsers.
         * **Note:** This does not factor in the value of
         * {@link PIXI.ticker.Ticker#speed}, which is specific
         * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
         *
         * @member {number}
         * @readonly
         */
    
    
        _createClass(Ticker, [{
            key: 'FPS',
            get: function get() {
                return 1000 / this.elapsedMS;
            }
    
            /**
             * Manages the maximum amount of milliseconds allowed to
             * elapse between invoking {@link PIXI.ticker.Ticker#update}.
             * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
             * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
             * When setting this property it is clamped to a value between
             * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
             *
             * @member {number}
             * @default 10
             */
    
        }, {
            key: 'minFPS',
            get: function get() {
                return 1000 / this._maxElapsedMS;
            },
            set: function set(fps) // eslint-disable-line require-jsdoc
            {
                // Clamp: 0 to TARGET_FPMS
                var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);
    
                this._maxElapsedMS = 1 / minFPMS;
            }
        }]);
    
        return Ticker;
    }();
    
    exports.default = Ticker;
    
    },{"../settings":100,"eventemitter3":4}],117:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.Ticker = exports.shared = undefined;
    
    var _Ticker = require('./Ticker');
    
    var _Ticker2 = _interopRequireDefault(_Ticker);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    /**
     * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
     * and by {@link PIXI.interaction.InteractionManager}.
     * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
     * for this instance. Please follow the examples for usage, including
     * how to opt-out of auto-starting the shared ticker.
     *
     * @example
     * let ticker = PIXI.ticker.shared;
     * // Set this to prevent starting this ticker when listeners are added.
     * // By default this is true only for the PIXI.ticker.shared instance.
     * ticker.autoStart = false;
     * // FYI, call this to ensure the ticker is stopped. It should be stopped
     * // if you have not attempted to render anything yet.
     * ticker.stop();
     * // Call this when you are ready for a running shared ticker.
     * ticker.start();
     *
     * @example
     * // You may use the shared ticker to render...
     * let renderer = PIXI.autoDetectRenderer(800, 600);
     * let stage = new PIXI.Container();
     * let interactionManager = PIXI.interaction.InteractionManager(renderer);
     * document.body.appendChild(renderer.view);
     * ticker.add(function (time) {
     *     renderer.render(stage);
     * });
     *
     * @example
     * // Or you can just update it manually.
     * ticker.autoStart = false;
     * ticker.stop();
     * function animate(time) {
     *     ticker.update(time);
     *     renderer.render(stage);
     *     requestAnimationFrame(animate);
     * }
     * animate(performance.now());
     *
     * @type {PIXI.ticker.Ticker}
     * @memberof PIXI.ticker
     */
    var shared = new _Ticker2.default();
    
    shared.autoStart = true;
    
    /**
     * @namespace PIXI.ticker
     */
    exports.shared = shared;
    exports.Ticker = _Ticker2.default;
    
    },{"./Ticker":116}],118:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    exports.default = canUploadSameBuffer;
    function canUploadSameBuffer() {
        // Uploading the same buffer multiple times in a single frame can cause perf issues.
        // Apparent on IOS so only check for that at the moment
        // this check may become more complex if this issue pops up elsewhere.
        var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    
        return !ios;
    }
    
    },{}],119:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    exports.default = createIndicesForQuads;
    /**
     * Generic Mask Stack data structure
     *
     * @memberof PIXI
     * @function createIndicesForQuads
     * @private
     * @param {number} size - Number of quads
     * @return {Uint16Array} indices
     */
    function createIndicesForQuads(size) {
        // the total number of indices in our array, there are 6 points per quad.
    
        var totalIndices = size * 6;
    
        var indices = new Uint16Array(totalIndices);
    
        // fill the indices with the quads to draw
        for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
            indices[i + 0] = j + 0;
            indices[i + 1] = j + 1;
            indices[i + 2] = j + 2;
            indices[i + 3] = j + 0;
            indices[i + 4] = j + 2;
            indices[i + 5] = j + 3;
        }
    
        return indices;
    }
    
    },{}],120:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = determineCrossOrigin;
    
    var _url2 = require('url');
    
    var _url3 = _interopRequireDefault(_url2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var tempAnchor = void 0;
    
    /**
     * Sets the `crossOrigin` property for this resource based on if the url
     * for this resource is cross-origin. If crossOrigin was manually set, this
     * function does nothing.
     * Nipped from the resource loader!
     *
     * @ignore
     * @param {string} url - The url to test.
     * @param {object} [loc=window.location] - The location object to test against.
     * @return {string} The crossOrigin value to use (or empty string for none).
     */
    function determineCrossOrigin(url) {
        var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
    
        // data: and javascript: urls are considered same-origin
        if (url.indexOf('data:') === 0) {
            return '';
        }
    
        // default is window.location
        loc = loc || window.location;
    
        if (!tempAnchor) {
            tempAnchor = document.createElement('a');
        }
    
        // let the browser determine the full href for the url of this resource and then
        // parse with the node url lib, we can't use the properties of the anchor element
        // because they don't work in IE9 :(
        tempAnchor.href = url;
        url = _url3.default.parse(tempAnchor.href);
    
        var samePort = !url.port && loc.port === '' || url.port === loc.port;
    
        // if cross origin
        if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
            return 'anonymous';
        }
    
        return '';
    }
    
    },{"url":37}],121:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.BaseTextureCache = exports.TextureCache = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.isMobile = undefined;
    exports.uid = uid;
    exports.hex2rgb = hex2rgb;
    exports.hex2string = hex2string;
    exports.rgb2hex = rgb2hex;
    exports.getResolutionOfUrl = getResolutionOfUrl;
    exports.decomposeDataUri = decomposeDataUri;
    exports.getUrlFileExtension = getUrlFileExtension;
    exports.getSvgSize = getSvgSize;
    exports.skipHello = skipHello;
    exports.sayHello = sayHello;
    exports.isWebGLSupported = isWebGLSupported;
    exports.sign = sign;
    exports.removeItems = removeItems;
    exports.destroyTextureCache = destroyTextureCache;
    exports.clearTextureCache = clearTextureCache;
    
    var _const = require('../const');
    
    var _settings = require('../settings');
    
    var _settings2 = _interopRequireDefault(_settings);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _pluginTarget = require('./pluginTarget');
    
    var _pluginTarget2 = _interopRequireDefault(_pluginTarget);
    
    var _mixin = require('./mixin');
    
    var mixins = _interopRequireWildcard(_mixin);
    
    var _ismobilejs = require('ismobilejs');
    
    var isMobile = _interopRequireWildcard(_ismobilejs);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    var nextUid = 0;
    var saidHello = false;
    
    /**
     * @namespace PIXI.utils
     */
    exports.isMobile = isMobile;
    exports.EventEmitter = _eventemitter2.default;
    exports.pluginTarget = _pluginTarget2.default;
    exports.mixins = mixins;
    
    /**
     * Gets the next unique identifier
     *
     * @memberof PIXI.utils
     * @function uid
     * @return {number} The next unique identifier to use.
     */
    
    function uid() {
        return ++nextUid;
    }
    
    /**
     * Converts a hex color number to an [R, G, B] array
     *
     * @memberof PIXI.utils
     * @function hex2rgb
     * @param {number} hex - The number to convert
     * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
     * @return {number[]} An array representing the [R, G, B] of the color.
     */
    function hex2rgb(hex, out) {
        out = out || [];
    
        out[0] = (hex >> 16 & 0xFF) / 255;
        out[1] = (hex >> 8 & 0xFF) / 255;
        out[2] = (hex & 0xFF) / 255;
    
        return out;
    }
    
    /**
     * Converts a hex color number to a string.
     *
     * @memberof PIXI.utils
     * @function hex2string
     * @param {number} hex - Number in hex
     * @return {string} The string color.
     */
    function hex2string(hex) {
        hex = hex.toString(16);
        hex = '000000'.substr(0, 6 - hex.length) + hex;
    
        return '#' + hex;
    }
    
    /**
     * Converts a color as an [R, G, B] array to a hex number
     *
     * @memberof PIXI.utils
     * @function rgb2hex
     * @param {number[]} rgb - rgb array
     * @return {number} The color number
     */
    function rgb2hex(rgb) {
        return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
    }
    
    /**
     * get the resolution / device pixel ratio of an asset by looking for the prefix
     * used by spritesheets and image urls
     *
     * @memberof PIXI.utils
     * @function getResolutionOfUrl
     * @param {string} url - the image path
     * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
     * @return {number} resolution / device pixel ratio of an asset
     */
    function getResolutionOfUrl(url, defaultValue) {
        var resolution = _settings2.default.RETINA_PREFIX.exec(url);
    
        if (resolution) {
            return parseFloat(resolution[1]);
        }
    
        return defaultValue !== undefined ? defaultValue : 1;
    }
    
    /**
     * Typedef for decomposeDataUri return object.
     *
     * @typedef {object} DecomposedDataUri
     * @property {mediaType} Media type, eg. `image`
     * @property {subType} Sub type, eg. `png`
     * @property {encoding} Data encoding, eg. `base64`
     * @property {data} The actual data
     */
    
    /**
     * Split a data URI into components. Returns undefined if
     * parameter `dataUri` is not a valid data URI.
     *
     * @memberof PIXI.utils
     * @function decomposeDataUri
     * @param {string} dataUri - the data URI to check
     * @return {DecomposedDataUri|undefined} The decomposed data uri or undefined
     */
    function decomposeDataUri(dataUri) {
        var dataUriMatch = _const.DATA_URI.exec(dataUri);
    
        if (dataUriMatch) {
            return {
                mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
                subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
                encoding: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
                data: dataUriMatch[4]
            };
        }
    
        return undefined;
    }
    
    /**
     * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
     *
     * @memberof PIXI.utils
     * @function getUrlFileExtension
     * @param {string} url - the image path
     * @return {string|undefined} image extension
     */
    function getUrlFileExtension(url) {
        var extension = _const.URL_FILE_EXTENSION.exec(url);
    
        if (extension) {
            return extension[1].toLowerCase();
        }
    
        return undefined;
    }
    
    /**
     * Typedef for Size object.
     *
     * @typedef {object} Size
     * @property {width} Width component
     * @property {height} Height component
     */
    
    /**
     * Get size from an svg string using regexp.
     *
     * @memberof PIXI.utils
     * @function getSvgSize
     * @param {string} svgString - a serialized svg element
     * @return {Size|undefined} image extension
     */
    function getSvgSize(svgString) {
        var sizeMatch = _const.SVG_SIZE.exec(svgString);
        var size = {};
    
        if (sizeMatch) {
            size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
            size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
        }
    
        return size;
    }
    
    /**
     * Skips the hello message of renderers that are created after this is run.
     *
     * @function skipHello
     * @memberof PIXI.utils
     */
    function skipHello() {
        saidHello = true;
    }
    
    /**
     * Logs out the version and renderer information for this running instance of PIXI.
     * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
     * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
     *
     * @static
     * @function sayHello
     * @memberof PIXI.utils
     * @param {string} type - The string renderer type to log.
     */
    function sayHello(type) {
        if (saidHello) {
            return;
        }
    
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            var args = ['\n %c %c %c Pixi.js ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];
    
            window.console.log.apply(console, args);
        } else if (window.console) {
            window.console.log('Pixi.js ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
        }
    
        saidHello = true;
    }
    
    /**
     * Helper for checking for webgl support
     *
     * @memberof PIXI.utils
     * @function isWebGLSupported
     * @return {boolean} is webgl supported
     */
    function isWebGLSupported() {
        var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };
    
        try {
            if (!window.WebGLRenderingContext) {
                return false;
            }
    
            var canvas = document.createElement('canvas');
            var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);
    
            var success = !!(gl && gl.getContextAttributes().stencil);
    
            if (gl) {
                var loseContext = gl.getExtension('WEBGL_lose_context');
    
                if (loseContext) {
                    loseContext.loseContext();
                }
            }
    
            gl = null;
    
            return success;
        } catch (e) {
            return false;
        }
    }
    
    /**
     * Returns sign of number
     *
     * @memberof PIXI.utils
     * @function sign
     * @param {number} n - the number to check the sign of
     * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
     */
    function sign(n) {
        if (n === 0) return 0;
    
        return n < 0 ? -1 : 1;
    }
    
    /**
     * Remove a range of items from an array
     *
     * @memberof PIXI.utils
     * @function removeItems
     * @param {Array<*>} arr The target array
     * @param {number} startIdx The index to begin removing from (inclusive)
     * @param {number} removeCount How many items to remove
     */
    function removeItems(arr, startIdx, removeCount) {
        var length = arr.length;
    
        if (startIdx >= length || removeCount === 0) {
            return;
        }
    
        removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    
        var len = length - removeCount;
    
        for (var i = startIdx; i < len; ++i) {
            arr[i] = arr[i + removeCount];
        }
    
        arr.length = len;
    }
    
    /**
     * @todo Describe property usage
     *
     * @memberof PIXI.utils
     * @private
     */
    var TextureCache = exports.TextureCache = {};
    
    /**
     * @todo Describe property usage
     *
     * @memberof PIXI.utils
     * @private
     */
    var BaseTextureCache = exports.BaseTextureCache = {};
    
    /**
     * Destroys all texture in the cache
     *
     * @memberof PIXI.utils
     * @function destroyTextureCache
     */
    function destroyTextureCache() {
        var key = void 0;
    
        for (key in TextureCache) {
            TextureCache[key].destroy();
        }
        for (key in BaseTextureCache) {
            BaseTextureCache[key].destroy();
        }
    }
    
    /**
     * Removes all textures from cache, but does not destroy them
     *
     * @memberof PIXI.utils
     * @function clearTextureCache
     */
    function clearTextureCache() {
        var key = void 0;
    
        for (key in TextureCache) {
            delete TextureCache[key];
        }
        for (key in BaseTextureCache) {
            delete BaseTextureCache[key];
        }
    }
    
    },{"../const":45,"../settings":100,"./mixin":123,"./pluginTarget":124,"eventemitter3":4,"ismobilejs":5}],122:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = maxRecommendedTextures;
    
    var _ismobilejs = require('ismobilejs');
    
    var _ismobilejs2 = _interopRequireDefault(_ismobilejs);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function maxRecommendedTextures(max) {
        if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
            // check if the res is iphone 6 or higher..
            return 4;
        }
    
        // desktop should be ok
        return max;
    }
    
    },{"ismobilejs":5}],123:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    exports.mixin = mixin;
    exports.delayMixin = delayMixin;
    exports.performMixins = performMixins;
    /**
     * Mixes all enumerable properties and methods from a source object to a target object.
     *
     * @memberof PIXI.utils.mixins
     * @function mixin
     * @param {object} target The prototype or instance that properties and methods should be added to.
     * @param {object} source The source of properties and methods to mix in.
     */
    function mixin(target, source) {
        if (!target || !source) return;
        // in ES8/ES2017, this would be really easy:
        // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    
        // get all the enumerable property keys
        var keys = Object.keys(source);
    
        // loop through properties
        for (var i = 0; i < keys.length; ++i) {
            var propertyName = keys[i];
    
            // Set the property using the property descriptor - this works for accessors and normal value properties
            Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
        }
    }
    
    var mixins = [];
    
    /**
     * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
     * can take effect.
     *
     * @memberof PIXI.utils.mixins
     * @function delayMixin
     * @private
     * @param {object} target The prototype or instance that properties and methods should be added to.
     * @param {object} source The source of properties and methods to mix in.
     */
    function delayMixin(target, source) {
        mixins.push(target, source);
    }
    
    /**
     * Handles all mixins queued via delayMixin().
     *
     * @memberof PIXI.utils.mixins
     * @function performMixins
     * @private
     */
    function performMixins() {
        for (var i = 0; i < mixins.length; i += 2) {
            mixin(mixins[i], mixins[i + 1]);
        }
        mixins.length = 0;
    }
    
    },{}],124:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    /**
     * Mixins functionality to make an object have "plugins".
     *
     * @example
     *      function MyObject() {}
     *
     *      pluginTarget.mixin(MyObject);
     *
     * @mixin
     * @memberof PIXI.utils
     * @param {object} obj - The object to mix into.
     */
    function pluginTarget(obj) {
        obj.__plugins = {};
    
        /**
         * Adds a plugin to an object
         *
         * @param {string} pluginName - The events that should be listed.
         * @param {Function} ctor - The constructor function for the plugin.
         */
        obj.registerPlugin = function registerPlugin(pluginName, ctor) {
            obj.__plugins[pluginName] = ctor;
        };
    
        /**
         * Instantiates all the plugins of this object
         *
         */
        obj.prototype.initPlugins = function initPlugins() {
            this.plugins = this.plugins || {};
    
            for (var o in obj.__plugins) {
                this.plugins[o] = new obj.__plugins[o](this);
            }
        };
    
        /**
         * Removes all the plugins of this object
         *
         */
        obj.prototype.destroyPlugins = function destroyPlugins() {
            for (var o in this.plugins) {
                this.plugins[o].destroy();
                this.plugins[o] = null;
            }
    
            this.plugins = null;
        };
    }
    
    exports.default = {
        /**
         * Mixes in the properties of the pluginTarget into another object
         *
         * @param {object} obj - The obj to mix into
         */
        mixin: function mixin(obj) {
            pluginTarget(obj);
        }
    };
    
    },{}],125:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = trimCanvas;
    /**
     * Trim transparent borders from a canvas
     *
     * @memberof PIXI
     * @function trimCanvas
     * @private
     * @param {HTMLCanvasElement} canvas - the canvas to trim
     * @returns {object} Trim data
     */
    function trimCanvas(canvas) {
        // https://gist.github.com/remy/784508
    
        var width = canvas.width;
        var height = canvas.height;
    
        var context = canvas.getContext('2d');
        var imageData = context.getImageData(0, 0, width, height);
        var pixels = imageData.data;
        var len = pixels.length;
    
        var bound = {
            top: null,
            left: null,
            right: null,
            bottom: null
        };
        var i = void 0;
        var x = void 0;
        var y = void 0;
    
        for (i = 0; i < len; i += 4) {
            if (pixels[i + 3] !== 0) {
                x = i / 4 % width;
                y = ~~(i / 4 / width);
    
                if (bound.top === null) {
                    bound.top = y;
                }
    
                if (bound.left === null) {
                    bound.left = x;
                } else if (x < bound.left) {
                    bound.left = x;
                }
    
                if (bound.right === null) {
                    bound.right = x + 1;
                } else if (bound.right < x) {
                    bound.right = x + 1;
                }
    
                if (bound.bottom === null) {
                    bound.bottom = y;
                } else if (bound.bottom < y) {
                    bound.bottom = y;
                }
            }
        }
    
        width = bound.right - bound.left;
        height = bound.bottom - bound.top + 1;
    
        var data = context.getImageData(bound.left, bound.top, width, height);
    
        return {
            height: height,
            width: width,
            data: data
        };
    }
    
    },{}],126:[function(require,module,exports){
    'use strict';
    
    var _core = require('./core');
    
    var core = _interopRequireWildcard(_core);
    
    var _mesh = require('./mesh');
    
    var mesh = _interopRequireWildcard(_mesh);
    
    var _particles = require('./particles');
    
    var particles = _interopRequireWildcard(_particles);
    
    var _extras = require('./extras');
    
    var extras = _interopRequireWildcard(_extras);
    
    var _filters = require('./filters');
    
    var filters = _interopRequireWildcard(_filters);
    
    var _prepare = require('./prepare');
    
    var prepare = _interopRequireWildcard(_prepare);
    
    var _loaders = require('./loaders');
    
    var loaders = _interopRequireWildcard(_loaders);
    
    var _interaction = require('./interaction');
    
    var interaction = _interopRequireWildcard(_interaction);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    // provide method to give a stack track for warnings
    // useful for tracking-down where deprecated methods/properties/classes
    // are being used within the code
    function warn(msg) {
        /* eslint-disable no-console */
        var stack = new Error().stack;
    
        // Handle IE < 10 and Safari < 6
        if (typeof stack === 'undefined') {
            console.warn('Deprecation Warning: ', msg);
        } else {
            // chop off the stack trace which includes pixi.js internal calls
            stack = stack.split('\n').splice(3).join('\n');
    
            if (console.groupCollapsed) {
                console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
                console.warn(stack);
                console.groupEnd();
            } else {
                console.warn('Deprecation Warning: ', msg);
                console.warn(stack);
            }
        }
        /* eslint-enable no-console */
    }
    
    /**
     * @class
     * @private
     * @name SpriteBatch
     * @memberof PIXI
     * @see PIXI.ParticleContainer
     * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
     * @deprecated since version 3.0.0
     */
    core.SpriteBatch = function () {
        throw new ReferenceError('SpriteBatch does not exist any more, please use the new ParticleContainer instead.');
    };
    
    /**
     * @class
     * @private
     * @name AssetLoader
     * @memberof PIXI
     * @see PIXI.loaders.Loader
     * @throws {ReferenceError} The loader system was overhauled in pixi v3, please see the new PIXI.loaders.Loader class.
     * @deprecated since version 3.0.0
     */
    core.AssetLoader = function () {
        throw new ReferenceError('The loader system was overhauled in pixi v3, please see the new PIXI.loaders.Loader class.');
    };
    
    Object.defineProperties(core, {
    
        /**
         * @class
         * @private
         * @name Stage
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        Stage: {
            enumerable: true,
            get: function get() {
                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');
    
                return core.Container;
            }
        },
    
        /**
         * @class
         * @private
         * @name DisplayObjectContainer
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        DisplayObjectContainer: {
            enumerable: true,
            get: function get() {
                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');
    
                return core.Container;
            }
        },
    
        /**
         * @class
         * @private
         * @name Strip
         * @memberof PIXI
         * @see PIXI.mesh.Mesh
         * @deprecated since version 3.0.0
         */
        Strip: {
            enumerable: true,
            get: function get() {
                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');
    
                return mesh.Mesh;
            }
        },
    
        /**
         * @class
         * @private
         * @name Rope
         * @memberof PIXI
         * @see PIXI.mesh.Rope
         * @deprecated since version 3.0.0
         */
        Rope: {
            enumerable: true,
            get: function get() {
                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');
    
                return mesh.Rope;
            }
        },
    
        /**
         * @class
         * @private
         * @name ParticleContainer
         * @memberof PIXI
         * @see PIXI.particles.ParticleContainer
         * @deprecated since version 4.0.0
         */
        ParticleContainer: {
            enumerable: true,
            get: function get() {
                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');
    
                return particles.ParticleContainer;
            }
        },
    
        /**
         * @class
         * @private
         * @name MovieClip
         * @memberof PIXI
         * @see PIXI.extras.MovieClip
         * @deprecated since version 3.0.0
         */
        MovieClip: {
            enumerable: true,
            get: function get() {
                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');
    
                return extras.AnimatedSprite;
            }
        },
    
        /**
         * @class
         * @private
         * @name TilingSprite
         * @memberof PIXI
         * @see PIXI.extras.TilingSprite
         * @deprecated since version 3.0.0
         */
        TilingSprite: {
            enumerable: true,
            get: function get() {
                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');
    
                return extras.TilingSprite;
            }
        },
    
        /**
         * @class
         * @private
         * @name BitmapText
         * @memberof PIXI
         * @see PIXI.extras.BitmapText
         * @deprecated since version 3.0.0
         */
        BitmapText: {
            enumerable: true,
            get: function get() {
                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');
    
                return extras.BitmapText;
            }
        },
    
        /**
         * @class
         * @private
         * @name blendModes
         * @memberof PIXI
         * @see PIXI.BLEND_MODES
         * @deprecated since version 3.0.0
         */
        blendModes: {
            enumerable: true,
            get: function get() {
                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');
    
                return core.BLEND_MODES;
            }
        },
    
        /**
         * @class
         * @private
         * @name scaleModes
         * @memberof PIXI
         * @see PIXI.SCALE_MODES
         * @deprecated since version 3.0.0
         */
        scaleModes: {
            enumerable: true,
            get: function get() {
                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');
    
                return core.SCALE_MODES;
            }
        },
    
        /**
         * @class
         * @private
         * @name BaseTextureCache
         * @memberof PIXI
         * @see PIXI.utils.BaseTextureCache
         * @deprecated since version 3.0.0
         */
        BaseTextureCache: {
            enumerable: true,
            get: function get() {
                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');
    
                return core.utils.BaseTextureCache;
            }
        },
    
        /**
         * @class
         * @private
         * @name TextureCache
         * @memberof PIXI
         * @see PIXI.utils.TextureCache
         * @deprecated since version 3.0.0
         */
        TextureCache: {
            enumerable: true,
            get: function get() {
                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');
    
                return core.utils.TextureCache;
            }
        },
    
        /**
         * @namespace
         * @private
         * @name math
         * @memberof PIXI
         * @see PIXI
         * @deprecated since version 3.0.6
         */
        math: {
            enumerable: true,
            get: function get() {
                warn('The math namespace is deprecated, please access members already accessible on PIXI.');
    
                return core;
            }
        },
    
        /**
         * @class
         * @private
         * @name PIXI.AbstractFilter
         * @see PIXI.Filter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            enumerable: true,
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
    
                return core.Filter;
            }
        },
    
        /**
         * @class
         * @private
         * @name PIXI.TransformManual
         * @see PIXI.TransformBase
         * @deprecated since version 4.0.0
         */
        TransformManual: {
            enumerable: true,
            get: function get() {
                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');
    
                return core.TransformBase;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.TARGET_FPMS
         * @see PIXI.settings.TARGET_FPMS
         * @deprecated since version 4.2.0
         */
        TARGET_FPMS: {
            enumerable: true,
            get: function get() {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
    
                return core.settings.TARGET_FPMS;
            },
            set: function set(value) {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');
    
                core.settings.TARGET_FPMS = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.FILTER_RESOLUTION
         * @see PIXI.settings.FILTER_RESOLUTION
         * @deprecated since version 4.2.0
         */
        FILTER_RESOLUTION: {
            enumerable: true,
            get: function get() {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
    
                return core.settings.FILTER_RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');
    
                core.settings.FILTER_RESOLUTION = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.RESOLUTION
         * @see PIXI.settings.RESOLUTION
         * @deprecated since version 4.2.0
         */
        RESOLUTION: {
            enumerable: true,
            get: function get() {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
    
                return core.settings.RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');
    
                core.settings.RESOLUTION = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.MIPMAP_TEXTURES
         * @see PIXI.settings.MIPMAP_TEXTURES
         * @deprecated since version 4.2.0
         */
        MIPMAP_TEXTURES: {
            enumerable: true,
            get: function get() {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
    
                return core.settings.MIPMAP_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');
    
                core.settings.MIPMAP_TEXTURES = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_BATCH_SIZE
         * @see PIXI.settings.SPRITE_BATCH_SIZE
         * @deprecated since version 4.2.0
         */
        SPRITE_BATCH_SIZE: {
            enumerable: true,
            get: function get() {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
    
                return core.settings.SPRITE_BATCH_SIZE;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');
    
                core.settings.SPRITE_BATCH_SIZE = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_MAX_TEXTURES
         * @see PIXI.settings.SPRITE_MAX_TEXTURES
         * @deprecated since version 4.2.0
         */
        SPRITE_MAX_TEXTURES: {
            enumerable: true,
            get: function get() {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
    
                return core.settings.SPRITE_MAX_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');
    
                core.settings.SPRITE_MAX_TEXTURES = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.RETINA_PREFIX
         * @see PIXI.settings.RETINA_PREFIX
         * @deprecated since version 4.2.0
         */
        RETINA_PREFIX: {
            enumerable: true,
            get: function get() {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
    
                return core.settings.RETINA_PREFIX;
            },
            set: function set(value) {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');
    
                core.settings.RETINA_PREFIX = value;
            }
        },
    
        /**
         * @static
         * @constant
         * @name PIXI.DEFAULT_RENDER_OPTIONS
         * @see PIXI.settings.RENDER_OPTIONS
         * @deprecated since version 4.2.0
         */
        DEFAULT_RENDER_OPTIONS: {
            enumerable: true,
            get: function get() {
                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');
    
                return core.settings.RENDER_OPTIONS;
            }
        }
    });
    
    // Move the default properties to settings
    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];
    
    var _loop = function _loop(i) {
        var deprecation = defaults[i];
    
        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
            enumerable: true,
            get: function get() {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, please use PIXI.settings.' + deprecation.target);
    
                return core.settings[deprecation.target];
            },
            set: function set(value) {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, please use PIXI.settings.' + deprecation.target);
    
                core.settings[deprecation.target] = value;
            }
        });
    };
    
    for (var i = 0; i < defaults.length; i++) {
        _loop(i);
    }
    
    Object.defineProperties(core.settings, {
    
        /**
         * @static
         * @name PRECISION
         * @memberof PIXI.settings
         * @see PIXI.PRECISION
         * @deprecated since version 4.4.0
         */
        PRECISION: {
            enumerable: true,
            get: function get() {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
    
                return core.settings.PRECISION_FRAGMENT;
            },
            set: function set(value) {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');
    
                core.settings.PRECISION_FRAGMENT = value;
            }
        }
    });
    
    Object.defineProperties(extras, {
    
        /**
         * @class
         * @name MovieClip
         * @memberof PIXI.extras
         * @see PIXI.extras.AnimatedSprite
         * @deprecated since version 4.2.0
         */
        MovieClip: {
            enumerable: true,
            get: function get() {
                warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');
    
                return extras.AnimatedSprite;
            }
        }
    });
    
    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');
    
        return renderer.generateTexture(this, scaleMode, resolution);
    };
    
    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');
    
        return this.generateCanvasTexture(scaleMode, resolution);
    };
    
    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
    };
    
    core.RenderTexture.prototype.getImage = function getImage(target) {
        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');
    
        return this.legacyRenderer.extract.image(target);
    };
    
    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');
    
        return this.legacyRenderer.extract.base64(target);
    };
    
    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');
    
        return this.legacyRenderer.extract.canvas(target);
    };
    
    core.RenderTexture.prototype.getPixels = function getPixels(target) {
        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');
    
        return this.legacyRenderer.pixels(target);
    };
    
    /**
     * @method
     * @private
     * @name PIXI.Sprite#setTexture
     * @see PIXI.Sprite#texture
     * @deprecated since version 3.0.0
     * @param {PIXI.Texture} texture - The texture to set to.
     */
    core.Sprite.prototype.setTexture = function setTexture(texture) {
        this.texture = texture;
        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
    };
    
    /**
     * @method
     * @name PIXI.extras.BitmapText#setText
     * @see PIXI.extras.BitmapText#text
     * @deprecated since version 3.0.0
     * @param {string} text - The text to set to.
     */
    extras.BitmapText.prototype.setText = function setText(text) {
        this.text = text;
        warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
    };
    
    /**
     * @method
     * @name PIXI.Text#setText
     * @see PIXI.Text#text
     * @deprecated since version 3.0.0
     * @param {string} text - The text to set to.
     */
    core.Text.prototype.setText = function setText(text) {
        this.text = text;
        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
    };
    
    /**
     * @method
     * @name PIXI.Text#setStyle
     * @see PIXI.Text#style
     * @deprecated since version 3.0.0
     * @param {*} style - The style to set to.
     */
    core.Text.prototype.setStyle = function setStyle(style) {
        this.style = style;
        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
    };
    
    /**
     * @method
     * @name PIXI.Text#determineFontProperties
     * @see PIXI.Text#calculateFontProperties
     * @deprecated since version 4.2.0
     * @private
     * @param {string} fontStyle - String representing the style of the font
     * @return {Object} Font properties object
     */
    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
        warn('determineFontProperties is now deprecated, please use the static calculateFontProperties method, ' + 'e.g : Text.calculateFontProperties(fontStyle);');
    
        return core.Text.calculateFontProperties(fontStyle);
    };
    
    Object.defineProperties(core.TextStyle.prototype, {
        /**
         * Set all properties of a font as a single string
         *
         * @name PIXI.TextStyle#font
         * @deprecated since version 4.0.0
         */
        font: {
            get: function get() {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');
    
                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;
    
                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
            },
            set: function set(font) {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');
    
                // can work out fontStyle from search of whole string
                if (font.indexOf('italic') > 1) {
                    this._fontStyle = 'italic';
                } else if (font.indexOf('oblique') > -1) {
                    this._fontStyle = 'oblique';
                } else {
                    this._fontStyle = 'normal';
                }
    
                // can work out fontVariant from search of whole string
                if (font.indexOf('small-caps') > -1) {
                    this._fontVariant = 'small-caps';
                } else {
                    this._fontVariant = 'normal';
                }
    
                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
                var splits = font.split(' ');
                var fontSizeIndex = -1;
    
                this._fontSize = 26;
                for (var i = 0; i < splits.length; ++i) {
                    if (splits[i].match(/(px|pt|em|%)/)) {
                        fontSizeIndex = i;
                        this._fontSize = splits[i];
                        break;
                    }
                }
    
                // we can now search for fontWeight as we know it must occur before the fontSize
                this._fontWeight = 'normal';
                for (var _i = 0; _i < fontSizeIndex; ++_i) {
                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
                        this._fontWeight = splits[_i];
                        break;
                    }
                }
    
                // and finally join everything together after the fontSize in case the font family has multiple words
                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
                    this._fontFamily = '';
                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
                        this._fontFamily += splits[_i2] + ' ';
                    }
    
                    this._fontFamily = this._fontFamily.slice(0, -1);
                } else {
                    this._fontFamily = 'Arial';
                }
    
                this.styleID++;
            }
        }
    });
    
    /**
     * @method
     * @name PIXI.Texture#setFrame
     * @see PIXI.Texture#setFrame
     * @deprecated since version 3.0.0
     * @param {PIXI.Rectangle} frame - The frame to set.
     */
    core.Texture.prototype.setFrame = function setFrame(frame) {
        this.frame = frame;
        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
    };
    
    Object.defineProperties(filters, {
    
        /**
         * @class
         * @private
         * @name PIXI.filters.AbstractFilter
         * @see PIXI.AbstractFilter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');
    
                return core.AbstractFilter;
            }
        },
    
        /**
         * @class
         * @private
         * @name PIXI.filters.SpriteMaskFilter
         * @see PIXI.SpriteMaskFilter
         * @deprecated since version 3.0.6
         */
        SpriteMaskFilter: {
            get: function get() {
                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');
    
                return core.SpriteMaskFilter;
            }
        }
    });
    
    /**
     * @method
     * @name PIXI.utils.uuid
     * @see PIXI.utils.uid
     * @deprecated since version 3.0.6
     * @return {number} The uid
     */
    core.utils.uuid = function () {
        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');
    
        return core.utils.uid();
    };
    
    /**
     * @method
     * @name PIXI.utils.canUseNewCanvasBlendModes
     * @see PIXI.CanvasTinter
     * @deprecated
     * @return {boolean} Can use blend modes.
     */
    core.utils.canUseNewCanvasBlendModes = function () {
        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');
    
        return core.CanvasTinter.canUseMultiply;
    };
    
    var saidHello = true;
    
    /**
     * @name PIXI.utils._saidHello
     * @type {boolean}
     * @see PIXI.utils.skipHello
     * @deprecated since 4.1.0
     */
    Object.defineProperty(core.utils, '_saidHello', {
        set: function set(bool) {
            if (bool) {
                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
                this.skipHello();
            }
            saidHello = bool;
        },
        get: function get() {
            return saidHello;
        }
    });
    
    /**
     * The number of graphics or textures to upload to the GPU.
     *
     * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
     * @static
     * @type {number}
     * @see PIXI.prepare.BasePrepare.limiter
     * @deprecated since 4.2.0
     */
    Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
        set: function set() {
            warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
            // because we don't have a reference to the renderer, we can't actually set
            // the uploads per frame, so we'll have to stick with the warning.
        },
        get: function get() {
            warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
    
            return NaN;
        }
    });
    
    /**
     * The number of graphics or textures to upload to the GPU.
     *
     * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
     * @static
     * @type {number}
     * @see PIXI.prepare.BasePrepare.limiter
     * @deprecated since 4.2.0
     */
    Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
        set: function set() {
            warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
            // because we don't have a reference to the renderer, we can't actually set
            // the uploads per frame, so we'll have to stick with the warning.
        },
        get: function get() {
            warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');
    
            return NaN;
        }
    });
    
    Object.defineProperties(loaders.Resource.prototype, {
        isJson: {
            get: function get() {
                warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');
    
                return this.type === loaders.Loader.Resource.TYPE.JSON;
            }
        },
        isXml: {
            get: function get() {
                warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');
    
                return this.type === loaders.Loader.Resource.TYPE.XML;
            }
        },
        isImage: {
            get: function get() {
                warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');
    
                return this.type === loaders.Loader.Resource.TYPE.IMAGE;
            }
        },
        isAudio: {
            get: function get() {
                warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');
    
                return this.type === loaders.Loader.Resource.TYPE.AUDIO;
            }
        },
        isVideo: {
            get: function get() {
                warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');
    
                return this.type === loaders.Loader.Resource.TYPE.VIDEO;
            }
        }
    });
    
    Object.defineProperties(loaders.Loader.prototype, {
        before: {
            get: function get() {
                warn('The before() method is deprecated, please use pre().');
    
                return this.pre;
            }
        },
        after: {
            get: function get() {
                warn('The after() method is deprecated, please use use().');
    
                return this.use;
            }
        }
    });
    
    /**
     * @name PIXI.interaction.interactiveTarget#defaultCursor
     * @static
     * @type {number}
     * @see PIXI.interaction.interactiveTarget#cursor
     * @deprecated since 4.3.0
     */
    Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
        set: function set(value) {
            warn('Property defaultCursor has been replaced with \'cursor\'. ');
            this.cursor = value;
        },
        get: function get() {
            warn('Property defaultCursor has been replaced with \'cursor\'. ');
    
            return this.cursor;
        },
    
        enumerable: true
    });
    
    /**
     * @name PIXI.interaction.InteractionManager#defaultCursorStyle
     * @static
     * @type {string}
     * @see PIXI.interaction.InteractionManager#cursorStyles
     * @deprecated since 4.3.0
     */
    Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
        set: function set(value) {
            warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
            this.cursorStyles.default = value;
        },
        get: function get() {
            warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
    
            return this.cursorStyles.default;
        }
    });
    
    /**
     * @name PIXI.interaction.InteractionManager#currentCursorStyle
     * @static
     * @type {string}
     * @see PIXI.interaction.InteractionManager#cursorStyles
     * @deprecated since 4.3.0
     */
    Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
        set: function set(value) {
            warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
            this.currentCursorMode = value;
        },
        get: function get() {
            warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
    
            return this.currentCursorMode;
        }
    });
    
    },{"./core":64,"./extras":137,"./filters":148,"./interaction":155,"./loaders":158,"./mesh":167,"./particles":170,"./prepare":180}],127:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var TEMP_RECT = new core.Rectangle();
    
    /**
     * The extract manager provides functionality to export content from the renderers.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
     *
     * @class
     * @memberof PIXI
     */
    
    var CanvasExtract = function () {
        /**
         * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
         */
        function CanvasExtract(renderer) {
            _classCallCheck(this, CanvasExtract);
    
            this.renderer = renderer;
            /**
             * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
             *
             * @member {PIXI.CanvasExtract} extract
             * @memberof PIXI.CanvasRenderer#
             * @see PIXI.CanvasExtract
             */
            renderer.extract = this;
        }
    
        /**
         * Will return a HTML Image of the target
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {HTMLImageElement} HTML Image of the target
         */
    
    
        CanvasExtract.prototype.image = function image(target) {
            var image = new Image();
    
            image.src = this.base64(target);
    
            return image;
        };
    
        /**
         * Will return a a base64 encoded string of this target. It works by calling
         *  `CanvasExtract.getCanvas` and then running toDataURL on that.
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {string} A base64 encoded string of the texture.
         */
    
    
        CanvasExtract.prototype.base64 = function base64(target) {
            return this.canvas(target).toDataURL();
        };
    
        /**
         * Creates a Canvas element, renders this target to it and then returns it.
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
         */
    
    
        CanvasExtract.prototype.canvas = function canvas(target) {
            var renderer = this.renderer;
            var context = void 0;
            var resolution = void 0;
            var frame = void 0;
            var renderTexture = void 0;
    
            if (target) {
                if (target instanceof core.RenderTexture) {
                    renderTexture = target;
                } else {
                    renderTexture = renderer.generateTexture(target);
                }
            }
    
            if (renderTexture) {
                context = renderTexture.baseTexture._canvasRenderTarget.context;
                resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
                frame = renderTexture.frame;
            } else {
                context = renderer.rootContext;
    
                frame = TEMP_RECT;
                frame.width = this.renderer.width;
                frame.height = this.renderer.height;
            }
    
            var width = frame.width * resolution;
            var height = frame.height * resolution;
    
            var canvasBuffer = new core.CanvasRenderTarget(width, height);
            var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);
    
            canvasBuffer.context.putImageData(canvasData, 0, 0);
    
            // send the canvas back..
            return canvasBuffer.canvas;
        };
    
        /**
         * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
         * order, with integer values between 0 and 255 (included).
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
         */
    
    
        CanvasExtract.prototype.pixels = function pixels(target) {
            var renderer = this.renderer;
            var context = void 0;
            var resolution = void 0;
            var frame = void 0;
            var renderTexture = void 0;
    
            if (target) {
                if (target instanceof core.RenderTexture) {
                    renderTexture = target;
                } else {
                    renderTexture = renderer.generateTexture(target);
                }
            }
    
            if (renderTexture) {
                context = renderTexture.baseTexture._canvasRenderTarget.context;
                resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
                frame = renderTexture.frame;
            } else {
                context = renderer.rootContext;
    
                frame = TEMP_RECT;
                frame.width = renderer.width;
                frame.height = renderer.height;
            }
    
            return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
        };
    
        /**
         * Destroys the extract
         *
         */
    
    
        CanvasExtract.prototype.destroy = function destroy() {
            this.renderer.extract = null;
            this.renderer = null;
        };
    
        return CanvasExtract;
    }();
    
    exports.default = CanvasExtract;
    
    
    core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
    
    },{"../../core":64}],128:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLExtract = require('./webgl/WebGLExtract');
    
    Object.defineProperty(exports, 'webgl', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_WebGLExtract).default;
      }
    });
    
    var _CanvasExtract = require('./canvas/CanvasExtract');
    
    Object.defineProperty(exports, 'canvas', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasExtract).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./canvas/CanvasExtract":127,"./webgl/WebGLExtract":129}],129:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var TEMP_RECT = new core.Rectangle();
    var BYTES_PER_PIXEL = 4;
    
    /**
     * The extract manager provides functionality to export content from the renderers.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
     *
     * @class
     * @memberof PIXI
     */
    
    var WebGLExtract = function () {
        /**
         * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
         */
        function WebGLExtract(renderer) {
            _classCallCheck(this, WebGLExtract);
    
            this.renderer = renderer;
            /**
             * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
             *
             * @member {PIXI.WebGLExtract} extract
             * @memberof PIXI.WebGLRenderer#
             * @see PIXI.WebGLExtract
             */
            renderer.extract = this;
        }
    
        /**
         * Will return a HTML Image of the target
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {HTMLImageElement} HTML Image of the target
         */
    
    
        WebGLExtract.prototype.image = function image(target) {
            var image = new Image();
    
            image.src = this.base64(target);
    
            return image;
        };
    
        /**
         * Will return a a base64 encoded string of this target. It works by calling
         *  `WebGLExtract.getCanvas` and then running toDataURL on that.
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {string} A base64 encoded string of the texture.
         */
    
    
        WebGLExtract.prototype.base64 = function base64(target) {
            return this.canvas(target).toDataURL();
        };
    
        /**
         * Creates a Canvas element, renders this target to it and then returns it.
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
         */
    
    
        WebGLExtract.prototype.canvas = function canvas(target) {
            var renderer = this.renderer;
            var textureBuffer = void 0;
            var resolution = void 0;
            var frame = void 0;
            var flipY = false;
            var renderTexture = void 0;
    
            if (target) {
                if (target instanceof core.RenderTexture) {
                    renderTexture = target;
                } else {
                    renderTexture = this.renderer.generateTexture(target);
                }
            }
    
            if (renderTexture) {
                textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
                resolution = textureBuffer.resolution;
                frame = renderTexture.frame;
                flipY = false;
            } else {
                textureBuffer = this.renderer.rootRenderTarget;
                resolution = textureBuffer.resolution;
                flipY = true;
    
                frame = TEMP_RECT;
                frame.width = textureBuffer.size.width;
                frame.height = textureBuffer.size.height;
            }
    
            var width = frame.width * resolution;
            var height = frame.height * resolution;
    
            var canvasBuffer = new core.CanvasRenderTarget(width, height);
    
            if (textureBuffer) {
                // bind the buffer
                renderer.bindRenderTarget(textureBuffer);
    
                // set up an array of pixels
                var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
    
                // read pixels to the array
                var gl = renderer.gl;
    
                gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
    
                // add the pixels to the canvas
                var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);
    
                canvasData.data.set(webglPixels);
    
                canvasBuffer.context.putImageData(canvasData, 0, 0);
    
                // pulling pixels
                if (flipY) {
                    canvasBuffer.context.scale(1, -1);
                    canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
                }
            }
    
            // send the canvas back..
            return canvasBuffer.canvas;
        };
    
        /**
         * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
         * order, with integer values between 0 and 255 (included).
         *
         * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
         *  to convert. If left empty will use use the main renderer
         * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
         */
    
    
        WebGLExtract.prototype.pixels = function pixels(target) {
            var renderer = this.renderer;
            var textureBuffer = void 0;
            var resolution = void 0;
            var frame = void 0;
            var renderTexture = void 0;
    
            if (target) {
                if (target instanceof core.RenderTexture) {
                    renderTexture = target;
                } else {
                    renderTexture = this.renderer.generateTexture(target);
                }
            }
    
            if (renderTexture) {
                textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
                resolution = textureBuffer.resolution;
                frame = renderTexture.frame;
            } else {
                textureBuffer = this.renderer.rootRenderTarget;
                resolution = textureBuffer.resolution;
    
                frame = TEMP_RECT;
                frame.width = textureBuffer.size.width;
                frame.height = textureBuffer.size.height;
            }
    
            var width = frame.width * resolution;
            var height = frame.height * resolution;
    
            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);
    
            if (textureBuffer) {
                // bind the buffer
                renderer.bindRenderTarget(textureBuffer);
                // read pixels to the array
                var gl = renderer.gl;
    
                gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
            }
    
            return webglPixels;
        };
    
        /**
         * Destroys the extract
         *
         */
    
    
        WebGLExtract.prototype.destroy = function destroy() {
            this.renderer.extract = null;
            this.renderer = null;
        };
    
        return WebGLExtract;
    }();
    
    exports.default = WebGLExtract;
    
    
    core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
    
    },{"../../core":64}],130:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @typedef FrameObject
     * @type {object}
     * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
     * @property {number} time - the duration of the frame in ms
     */
    
    /**
     * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
     *
     * ```js
     * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
     * let textureArray = [];
     *
     * for (let i=0; i < 4; i++)
     * {
     *      let texture = PIXI.Texture.fromImage(alienImages[i]);
     *      textureArray.push(texture);
     * };
     *
     * let mc = new PIXI.AnimatedSprite(textureArray);
     * ```
     *
     * @class
     * @extends PIXI.Sprite
     * @memberof PIXI.extras
     */
    var AnimatedSprite = function (_core$Sprite) {
        _inherits(AnimatedSprite, _core$Sprite);
    
        /**
         * @param {PIXI.Texture[]|FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
         *  objects that make up the animation
         * @param {boolean} [autoUpdate=true] - Whether use PIXI.ticker.shared to auto update animation time.
         */
        function AnimatedSprite(textures, autoUpdate) {
            _classCallCheck(this, AnimatedSprite);
    
            /**
             * @private
             */
            var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));
    
            _this._textures = null;
    
            /**
             * @private
             */
            _this._durations = null;
    
            _this.textures = textures;
    
            /**
             * `true` uses PIXI.ticker.shared to auto update animation time.
             * @type {boolean}
             * @default true
             * @private
             */
            _this._autoUpdate = autoUpdate !== false;
    
            /**
             * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
             *
             * @member {number}
             * @default 1
             */
            _this.animationSpeed = 1;
    
            /**
             * Whether or not the animate sprite repeats after playing.
             *
             * @member {boolean}
             * @default true
             */
            _this.loop = true;
    
            /**
             * Function to call when a AnimatedSprite finishes playing
             *
             * @member {Function}
             */
            _this.onComplete = null;
    
            /**
             * Function to call when a AnimatedSprite changes which texture is being rendered
             *
             * @member {Function}
             */
            _this.onFrameChange = null;
    
            /**
             * Elapsed time since animation has been started, used internally to display current texture
             *
             * @member {number}
             * @private
             */
            _this._currentTime = 0;
    
            /**
             * Indicates if the AnimatedSprite is currently playing
             *
             * @member {boolean}
             * @readonly
             */
            _this.playing = false;
            return _this;
        }
    
        /**
         * Stops the AnimatedSprite
         *
         */
    
    
        AnimatedSprite.prototype.stop = function stop() {
            if (!this.playing) {
                return;
            }
    
            this.playing = false;
            if (this._autoUpdate) {
                core.ticker.shared.remove(this.update, this);
            }
        };
    
        /**
         * Plays the AnimatedSprite
         *
         */
    
    
        AnimatedSprite.prototype.play = function play() {
            if (this.playing) {
                return;
            }
    
            this.playing = true;
            if (this._autoUpdate) {
                core.ticker.shared.add(this.update, this);
            }
        };
    
        /**
         * Stops the AnimatedSprite and goes to a specific frame
         *
         * @param {number} frameNumber - frame index to stop at
         */
    
    
        AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
            this.stop();
    
            var previousFrame = this.currentFrame;
    
            this._currentTime = frameNumber;
    
            if (previousFrame !== this.currentFrame) {
                this.updateTexture();
            }
        };
    
        /**
         * Goes to a specific frame and begins playing the AnimatedSprite
         *
         * @param {number} frameNumber - frame index to start at
         */
    
    
        AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
            var previousFrame = this.currentFrame;
    
            this._currentTime = frameNumber;
    
            if (previousFrame !== this.currentFrame) {
                this.updateTexture();
            }
    
            this.play();
        };
    
        /**
         * Updates the object transform for rendering.
         *
         * @private
         * @param {number} deltaTime - Time since last tick.
         */
    
    
        AnimatedSprite.prototype.update = function update(deltaTime) {
            var elapsed = this.animationSpeed * deltaTime;
            var previousFrame = this.currentFrame;
    
            if (this._durations !== null) {
                var lag = this._currentTime % 1 * this._durations[this.currentFrame];
    
                lag += elapsed / 60 * 1000;
    
                while (lag < 0) {
                    this._currentTime--;
                    lag += this._durations[this.currentFrame];
                }
    
                var sign = Math.sign(this.animationSpeed * deltaTime);
    
                this._currentTime = Math.floor(this._currentTime);
    
                while (lag >= this._durations[this.currentFrame]) {
                    lag -= this._durations[this.currentFrame] * sign;
                    this._currentTime += sign;
                }
    
                this._currentTime += lag / this._durations[this.currentFrame];
            } else {
                this._currentTime += elapsed;
            }
    
            if (this._currentTime < 0 && !this.loop) {
                this.gotoAndStop(0);
    
                if (this.onComplete) {
                    this.onComplete();
                }
            } else if (this._currentTime >= this._textures.length && !this.loop) {
                this.gotoAndStop(this._textures.length - 1);
    
                if (this.onComplete) {
                    this.onComplete();
                }
            } else if (previousFrame !== this.currentFrame) {
                this.updateTexture();
            }
        };
    
        /**
         * Updates the displayed texture to match the current frame index
         *
         * @private
         */
    
    
        AnimatedSprite.prototype.updateTexture = function updateTexture() {
            this._texture = this._textures[this.currentFrame];
            this._textureID = -1;
    
            if (this.onFrameChange) {
                this.onFrameChange(this.currentFrame);
            }
        };
    
        /**
         * Stops the AnimatedSprite and destroys it
         *
         */
    
    
        AnimatedSprite.prototype.destroy = function destroy() {
            this.stop();
            _core$Sprite.prototype.destroy.call(this);
        };
    
        /**
         * A short hand way of creating a movieclip from an array of frame ids
         *
         * @static
         * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
         * @return {AnimatedSprite} The new animated sprite with the specified frames.
         */
    
    
        AnimatedSprite.fromFrames = function fromFrames(frames) {
            var textures = [];
    
            for (var i = 0; i < frames.length; ++i) {
                textures.push(core.Texture.fromFrame(frames[i]));
            }
    
            return new AnimatedSprite(textures);
        };
    
        /**
         * A short hand way of creating a movieclip from an array of image ids
         *
         * @static
         * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
         * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
         */
    
    
        AnimatedSprite.fromImages = function fromImages(images) {
            var textures = [];
    
            for (var i = 0; i < images.length; ++i) {
                textures.push(core.Texture.fromImage(images[i]));
            }
    
            return new AnimatedSprite(textures);
        };
    
        /**
         * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
         * assigned to the AnimatedSprite.
         *
         * @readonly
         * @member {number}
         * @default 0
         */
    
    
        _createClass(AnimatedSprite, [{
            key: 'totalFrames',
            get: function get() {
                return this._textures.length;
            }
    
            /**
             * The array of textures used for this AnimatedSprite
             *
             * @member {PIXI.Texture[]}
             */
    
        }, {
            key: 'textures',
            get: function get() {
                return this._textures;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (value[0] instanceof core.Texture) {
                    this._textures = value;
                    this._durations = null;
                } else {
                    this._textures = [];
                    this._durations = [];
    
                    for (var i = 0; i < value.length; i++) {
                        this._textures.push(value[i].texture);
                        this._durations.push(value[i].time);
                    }
                }
            }
    
            /**
            * The AnimatedSprites current frame index
            *
            * @member {number}
            * @readonly
            */
    
        }, {
            key: 'currentFrame',
            get: function get() {
                var currentFrame = Math.floor(this._currentTime) % this._textures.length;
    
                if (currentFrame < 0) {
                    currentFrame += this._textures.length;
                }
    
                return currentFrame;
            }
        }]);
    
        return AnimatedSprite;
    }(core.Sprite);
    
    exports.default = AnimatedSprite;
    
    },{"../core":64}],131:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _ObservablePoint = require('../core/math/ObservablePoint');
    
    var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * A BitmapText object will create a line or multiple lines of text using bitmap font. To
     * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
     *
     * A BitmapText can only be created when the font is loaded
     *
     * ```js
     * // in this case the font is in a file called 'desyrel.fnt'
     * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
     * ```
     *
     * http://www.angelcode.com/products/bmfont/ for windows or
     * http://www.bmglyph.com/ for mac.
     *
     * @class
     * @extends PIXI.Container
     * @memberof PIXI.extras
     */
    var BitmapText = function (_core$Container) {
        _inherits(BitmapText, _core$Container);
    
        /**
         * @param {string} text - The copy that you would like the text to display
         * @param {object} style - The style parameters
         * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
         *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
         * @param {string} [style.font.name] - The bitmap font id
         * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
         * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
         *      single line text
         * @param {number} [style.tint=0xFFFFFF] - The tint color
         */
        function BitmapText(text) {
            var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    
            _classCallCheck(this, BitmapText);
    
            /**
             * Private tracker for the width of the overall text
             *
             * @member {number}
             * @private
             */
            var _this = _possibleConstructorReturn(this, _core$Container.call(this));
    
            _this._textWidth = 0;
    
            /**
             * Private tracker for the height of the overall text
             *
             * @member {number}
             * @private
             */
            _this._textHeight = 0;
    
            /**
             * Private tracker for the letter sprite pool.
             *
             * @member {PIXI.Sprite[]}
             * @private
             */
            _this._glyphs = [];
    
            /**
             * Private tracker for the current style.
             *
             * @member {object}
             * @private
             */
            _this._font = {
                tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
                align: style.align || 'left',
                name: null,
                size: 0
            };
    
            /**
             * Private tracker for the current font.
             *
             * @member {object}
             * @private
             */
            _this.font = style.font; // run font setter
    
            /**
             * Private tracker for the current text.
             *
             * @member {string}
             * @private
             */
            _this._text = text;
    
            /**
             * The max width of this bitmap text in pixels. If the text provided is longer than the
             * value provided, line breaks will be automatically inserted in the last whitespace.
             * Disable by setting value to 0
             *
             * @member {number}
             */
            _this.maxWidth = 0;
    
            /**
             * The max line height. This is useful when trying to use the total height of the Text,
             * ie: when trying to vertically align.
             *
             * @member {number}
             */
            _this.maxLineHeight = 0;
    
            /**
             * Text anchor. read-only
             *
             * @member {PIXI.ObservablePoint}
             * @private
             */
            _this._anchor = new _ObservablePoint2.default(function () {
                _this.dirty = true;
            }, _this, 0, 0);
    
            /**
             * The dirty state of this object.
             *
             * @member {boolean}
             */
            _this.dirty = false;
    
            _this.updateText();
            return _this;
        }
    
        /**
         * Renders text and updates it when needed
         *
         * @private
         */
    
    
        BitmapText.prototype.updateText = function updateText() {
            var data = BitmapText.fonts[this._font.name];
            var scale = this._font.size / data.size;
            var pos = new core.Point();
            var chars = [];
            var lineWidths = [];
    
            var prevCharCode = null;
            var lastLineWidth = 0;
            var maxLineWidth = 0;
            var line = 0;
            var lastSpace = -1;
            var lastSpaceWidth = 0;
            var maxLineHeight = 0;
    
            for (var i = 0; i < this.text.length; i++) {
                var charCode = this.text.charCodeAt(i);
    
                if (/(\s)/.test(this.text.charAt(i))) {
                    lastSpace = i;
                    lastSpaceWidth = lastLineWidth;
                }
    
                if (/(?:\r\n|\r|\n)/.test(this.text.charAt(i))) {
                    lineWidths.push(lastLineWidth);
                    maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                    line++;
    
                    pos.x = 0;
                    pos.y += data.lineHeight;
                    prevCharCode = null;
                    continue;
                }
    
                if (lastSpace !== -1 && this.maxWidth > 0 && pos.x * scale > this.maxWidth) {
                    core.utils.removeItems(chars, lastSpace, i - lastSpace);
                    i = lastSpace;
                    lastSpace = -1;
    
                    lineWidths.push(lastSpaceWidth);
                    maxLineWidth = Math.max(maxLineWidth, lastSpaceWidth);
                    line++;
    
                    pos.x = 0;
                    pos.y += data.lineHeight;
                    prevCharCode = null;
                    continue;
                }
    
                var charData = data.chars[charCode];
    
                if (!charData) {
                    continue;
                }
    
                if (prevCharCode && charData.kerning[prevCharCode]) {
                    pos.x += charData.kerning[prevCharCode];
                }
    
                chars.push({
                    texture: charData.texture,
                    line: line,
                    charCode: charCode,
                    position: new core.Point(pos.x + charData.xOffset, pos.y + charData.yOffset)
                });
                lastLineWidth = pos.x + (charData.texture.width + charData.xOffset);
                pos.x += charData.xAdvance;
                maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
                prevCharCode = charCode;
            }
    
            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
    
            var lineAlignOffsets = [];
    
            for (var _i = 0; _i <= line; _i++) {
                var alignOffset = 0;
    
                if (this._font.align === 'right') {
                    alignOffset = maxLineWidth - lineWidths[_i];
                } else if (this._font.align === 'center') {
                    alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
                }
    
                lineAlignOffsets.push(alignOffset);
            }
    
            var lenChars = chars.length;
            var tint = this.tint;
    
            for (var _i2 = 0; _i2 < lenChars; _i2++) {
                var c = this._glyphs[_i2]; // get the next glyph sprite
    
                if (c) {
                    c.texture = chars[_i2].texture;
                } else {
                    c = new core.Sprite(chars[_i2].texture);
                    this._glyphs.push(c);
                }
    
                c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
                c.position.y = chars[_i2].position.y * scale;
                c.scale.x = c.scale.y = scale;
                c.tint = tint;
    
                if (!c.parent) {
                    this.addChild(c);
                }
            }
    
            // remove unnecessary children.
            for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
                this.removeChild(this._glyphs[_i3]);
            }
    
            this._textWidth = maxLineWidth * scale;
            this._textHeight = (pos.y + data.lineHeight) * scale;
    
            // apply anchor
            if (this.anchor.x !== 0 || this.anchor.y !== 0) {
                for (var _i4 = 0; _i4 < lenChars; _i4++) {
                    this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
                    this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
                }
            }
            this.maxLineHeight = maxLineHeight * scale;
        };
    
        /**
         * Updates the transform of this object
         *
         * @private
         */
    
    
        BitmapText.prototype.updateTransform = function updateTransform() {
            this.validate();
            this.containerUpdateTransform();
        };
    
        /**
         * Validates text before calling parent's getLocalBounds
         *
         * @return {PIXI.Rectangle} The rectangular bounding area
         */
    
    
        BitmapText.prototype.getLocalBounds = function getLocalBounds() {
            this.validate();
    
            return _core$Container.prototype.getLocalBounds.call(this);
        };
    
        /**
         * Updates text when needed
         *
         * @private
         */
    
    
        BitmapText.prototype.validate = function validate() {
            if (this.dirty) {
                this.updateText();
                this.dirty = false;
            }
        };
    
        /**
         * The tint of the BitmapText object
         *
         * @member {number}
         */
    
    
        /**
         * Register a bitmap font with data and a texture.
         *
         * @static
         * @param {XMLDocument} xml - The XML document data.
         * @param {PIXI.Texture} texture - Texture with all symbols.
         * @return {Object} Result font object with font, size, lineHeight and char fields.
         */
        BitmapText.registerFont = function registerFont(xml, texture) {
            var data = {};
            var info = xml.getElementsByTagName('info')[0];
            var common = xml.getElementsByTagName('common')[0];
    
            data.font = info.getAttribute('face');
            data.size = parseInt(info.getAttribute('size'), 10);
            data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10);
            data.chars = {};
    
            // parse letters
            var letters = xml.getElementsByTagName('char');
    
            for (var i = 0; i < letters.length; i++) {
                var letter = letters[i];
                var charCode = parseInt(letter.getAttribute('id'), 10);
    
                var textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) + texture.frame.x, parseInt(letter.getAttribute('y'), 10) + texture.frame.y, parseInt(letter.getAttribute('width'), 10), parseInt(letter.getAttribute('height'), 10));
    
                data.chars[charCode] = {
                    xOffset: parseInt(letter.getAttribute('xoffset'), 10),
                    yOffset: parseInt(letter.getAttribute('yoffset'), 10),
                    xAdvance: parseInt(letter.getAttribute('xadvance'), 10),
                    kerning: {},
                    texture: new core.Texture(texture.baseTexture, textureRect)
    
                };
            }
    
            // parse kernings
            var kernings = xml.getElementsByTagName('kerning');
    
            for (var _i5 = 0; _i5 < kernings.length; _i5++) {
                var kerning = kernings[_i5];
                var first = parseInt(kerning.getAttribute('first'), 10);
                var second = parseInt(kerning.getAttribute('second'), 10);
                var amount = parseInt(kerning.getAttribute('amount'), 10);
    
                if (data.chars[second]) {
                    data.chars[second].kerning[first] = amount;
                }
            }
    
            // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
            // but it's very likely to change
            BitmapText.fonts[data.font] = data;
    
            return data;
        };
    
        _createClass(BitmapText, [{
            key: 'tint',
            get: function get() {
                return this._font.tint;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;
    
                this.dirty = true;
            }
    
            /**
             * The alignment of the BitmapText object
             *
             * @member {string}
             * @default 'left'
             */
    
        }, {
            key: 'align',
            get: function get() {
                return this._font.align;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._font.align = value || 'left';
    
                this.dirty = true;
            }
    
            /**
             * The anchor sets the origin point of the text.
             * The default is 0,0 this means the text's origin is the top left
             * Setting the anchor to 0.5,0.5 means the text's origin is centered
             * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
             *
             * @member {PIXI.Point | number}
             */
    
        }, {
            key: 'anchor',
            get: function get() {
                return this._anchor;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (typeof value === 'number') {
                    this._anchor.set(value);
                } else {
                    this._anchor.copy(value);
                }
            }
    
            /**
             * The font descriptor of the BitmapText object
             *
             * @member {string|object}
             */
    
        }, {
            key: 'font',
            get: function get() {
                return this._font;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                if (!value) {
                    return;
                }
    
                if (typeof value === 'string') {
                    value = value.split(' ');
    
                    this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
                    this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
                } else {
                    this._font.name = value.name;
                    this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
                }
    
                this.dirty = true;
            }
    
            /**
             * The text of the BitmapText object
             *
             * @member {string}
             */
    
        }, {
            key: 'text',
            get: function get() {
                return this._text;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                value = value.toString() || ' ';
                if (this._text === value) {
                    return;
                }
                this._text = value;
                this.dirty = true;
            }
    
            /**
             * The width of the overall text, different from fontSize,
             * which is defined in the style object
             *
             * @member {number}
             * @readonly
             */
    
        }, {
            key: 'textWidth',
            get: function get() {
                this.validate();
    
                return this._textWidth;
            }
    
            /**
             * The height of the overall text, different from fontSize,
             * which is defined in the style object
             *
             * @member {number}
             * @readonly
             */
    
        }, {
            key: 'textHeight',
            get: function get() {
                this.validate();
    
                return this._textHeight;
            }
        }]);
    
        return BitmapText;
    }(core.Container);
    
    exports.default = BitmapText;
    
    
    BitmapText.fonts = {};
    
    },{"../core":64,"../core/math/ObservablePoint":67}],132:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _Matrix = require('../core/math/Matrix');
    
    var _Matrix2 = _interopRequireDefault(_Matrix);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var tempMat = new _Matrix2.default();
    
    /**
     * class controls uv transform and frame clamp for texture
     *
     * @class
     * @memberof PIXI.extras
     */
    
    var TextureTransform = function () {
        /**
         *
         * @param {PIXI.Texture} texture observed texture
         * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
         * @constructor
         */
        function TextureTransform(texture, clampMargin) {
            _classCallCheck(this, TextureTransform);
    
            this._texture = texture;
    
            this.mapCoord = new _Matrix2.default();
    
            this.uClampFrame = new Float32Array(4);
    
            this.uClampOffset = new Float32Array(2);
    
            this._lastTextureID = -1;
    
            /**
             * Changes frame clamping
             * Works with TilingSprite and Mesh
             * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
             *
             * @default 0
             * @member {number}
             */
            this.clampOffset = 0;
    
            /**
             * Changes frame clamping
             * Works with TilingSprite and Mesh
             * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
             *
             * @default 0.5
             * @member {number}
             */
            this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
        }
    
        /**
         * texture property
         * @member {PIXI.Texture}
         */
    
    
        /**
         * updates matrices if texture was changed
         * @param {boolean} forceUpdate if true, matrices will be updated any case
         */
        TextureTransform.prototype.update = function update(forceUpdate) {
            var tex = this._texture;
    
            if (!tex || !tex.valid) {
                return;
            }
    
            if (!forceUpdate && this._lastTextureID === tex._updateID) {
                return;
            }
    
            this._lastTextureID = tex._updateID;
    
            var uvs = tex._uvs;
    
            this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);
    
            var orig = tex.orig;
            var trim = tex.trim;
    
            if (trim) {
                tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
                this.mapCoord.append(tempMat);
            }
    
            var texBase = tex.baseTexture;
            var frame = this.uClampFrame;
            var margin = this.clampMargin / texBase.resolution;
            var offset = this.clampOffset;
    
            frame[0] = (tex._frame.x + margin + offset) / texBase.width;
            frame[1] = (tex._frame.y + margin + offset) / texBase.height;
            frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
            frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
            this.uClampOffset[0] = offset / texBase.realWidth;
            this.uClampOffset[1] = offset / texBase.realHeight;
        };
    
        _createClass(TextureTransform, [{
            key: 'texture',
            get: function get() {
                return this._texture;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._texture = value;
                this._lastTextureID = -1;
            }
        }]);
    
        return TextureTransform;
    }();
    
    exports.default = TextureTransform;
    
    },{"../core/math/Matrix":66}],133:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _CanvasTinter = require('../core/sprites/canvas/CanvasTinter');
    
    var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);
    
    var _TextureTransform = require('./TextureTransform');
    
    var _TextureTransform2 = _interopRequireDefault(_TextureTransform);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var tempPoint = new core.Point();
    
    /**
     * A tiling sprite is a fast way of rendering a tiling image
     *
     * @class
     * @extends PIXI.Sprite
     * @memberof PIXI.extras
     */
    
    var TilingSprite = function (_core$Sprite) {
        _inherits(TilingSprite, _core$Sprite);
    
        /**
         * @param {PIXI.Texture} texture - the texture of the tiling sprite
         * @param {number} [width=100] - the width of the tiling sprite
         * @param {number} [height=100] - the height of the tiling sprite
         */
        function TilingSprite(texture) {
            var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
            var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    
            _classCallCheck(this, TilingSprite);
    
            /**
             * Tile transform
             *
             * @member {PIXI.TransformStatic}
             */
            var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));
    
            _this.tileTransform = new core.TransformStatic();
    
            // /// private
    
            /**
             * The with of the tiling sprite
             *
             * @member {number}
             * @private
             */
            _this._width = width;
    
            /**
             * The height of the tiling sprite
             *
             * @member {number}
             * @private
             */
            _this._height = height;
    
            /**
             * Canvas pattern
             *
             * @type {CanvasPattern}
             * @private
             */
            _this._canvasPattern = null;
    
            /**
             * transform that is applied to UV to get the texture coords
             *
             * @member {PIXI.extras.TextureTransform}
             */
            _this.uvTransform = texture.transform || new _TextureTransform2.default(texture);
    
            /**
             * Plugin that is responsible for rendering this element.
             * Allows to customize the rendering process without overriding '_renderWebGL' method.
             *
             * @member {string}
             * @default 'tilingSprite'
             */
            _this.pluginName = 'tilingSprite';
    
            /**
             * Whether or not anchor affects uvs
             *
             * @member {boolean}
             * @default false
             */
            _this.uvRespectAnchor = false;
            return _this;
        }
        /**
         * Changes frame clamping in corresponding textureTransform, shortcut
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */
    
    
        /**
         * @private
         */
        TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
            if (this.uvTransform) {
                this.uvTransform.texture = this._texture;
            }
        };
    
        /**
         * Renders the object using the WebGL renderer
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The renderer
         */
    
    
        TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
            // tweak our texture temporarily..
            var texture = this._texture;
    
            if (!texture || !texture.valid) {
                return;
            }
    
            this.tileTransform.updateLocalTransform();
            this.uvTransform.update();
    
            renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
            renderer.plugins[this.pluginName].render(this);
        };
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
         */
    
    
        TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
            var texture = this._texture;
    
            if (!texture.baseTexture.hasLoaded) {
                return;
            }
    
            var context = renderer.context;
            var transform = this.worldTransform;
            var resolution = renderer.resolution;
            var baseTexture = texture.baseTexture;
            var baseTextureResolution = texture.baseTexture.resolution;
            var modX = this.tilePosition.x / this.tileScale.x % texture._frame.width;
            var modY = this.tilePosition.y / this.tileScale.y % texture._frame.height;
    
            // create a nice shiny pattern!
            // TODO this needs to be refreshed if texture changes..
            if (!this._canvasPattern) {
                // cut an object from a spritesheet..
                var tempCanvas = new core.CanvasRenderTarget(texture._frame.width, texture._frame.height, baseTextureResolution);
    
                // Tint the tiling sprite
                if (this.tint !== 0xFFFFFF) {
                    if (this.cachedTint !== this.tint) {
                        this.cachedTint = this.tint;
    
                        this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
                    }
                    tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
                } else {
                    tempCanvas.context.drawImage(baseTexture.source, -texture._frame.x, -texture._frame.y);
                }
                this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
            }
    
            // set context state..
            context.globalAlpha = this.worldAlpha;
            context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);
    
            renderer.setBlendMode(this.blendMode);
    
            // fill the pattern!
            context.fillStyle = this._canvasPattern;
    
            // TODO - this should be rolled into the setTransform above..
            context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);
    
            var anchorX = this.anchor.x * -this._width;
            var anchorY = this.anchor.y * -this._height;
    
            if (this.uvRespectAnchor) {
                context.translate(modX, modY);
    
                context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
            } else {
                context.translate(modX + anchorX, modY + anchorY);
    
                context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
            }
        };
    
        /**
         * Updates the bounds of the tiling sprite.
         *
         * @private
         */
    
    
        TilingSprite.prototype._calculateBounds = function _calculateBounds() {
            var minX = this._width * -this._anchor._x;
            var minY = this._height * -this._anchor._y;
            var maxX = this._width * (1 - this._anchor._x);
            var maxY = this._height * (1 - this._anchor._y);
    
            this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
        };
    
        /**
         * Gets the local bounds of the sprite object.
         *
         * @param {PIXI.Rectangle} rect - The output rectangle.
         * @return {PIXI.Rectangle} The bounds.
         */
    
    
        TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
            // we can do a fast local bounds if the sprite has no children!
            if (this.children.length === 0) {
                this._bounds.minX = this._width * -this._anchor._x;
                this._bounds.minY = this._height * -this._anchor._y;
                this._bounds.maxX = this._width * (1 - this._anchor._x);
                this._bounds.maxY = this._height * (1 - this._anchor._x);
    
                if (!rect) {
                    if (!this._localBoundsRect) {
                        this._localBoundsRect = new core.Rectangle();
                    }
    
                    rect = this._localBoundsRect;
                }
    
                return this._bounds.getRectangle(rect);
            }
    
            return _core$Sprite.prototype.getLocalBounds.call(this, rect);
        };
    
        /**
         * Checks if a point is inside this tiling sprite.
         *
         * @param {PIXI.Point} point - the point to check
         * @return {boolean} Whether or not the sprite contains the point.
         */
    
    
        TilingSprite.prototype.containsPoint = function containsPoint(point) {
            this.worldTransform.applyInverse(point, tempPoint);
    
            var width = this._width;
            var height = this._height;
            var x1 = -width * this.anchor._x;
    
            if (tempPoint.x > x1 && tempPoint.x < x1 + width) {
                var y1 = -height * this.anchor._y;
    
                if (tempPoint.y > y1 && tempPoint.y < y1 + height) {
                    return true;
                }
            }
    
            return false;
        };
    
        /**
         * Destroys this tiling sprite
         *
         */
    
    
        TilingSprite.prototype.destroy = function destroy() {
            _core$Sprite.prototype.destroy.call(this);
    
            this.tileTransform = null;
            this.uvTransform = null;
        };
    
        /**
         * Helper function that creates a new tiling sprite based on the source you provide.
         * The source can be - frame id, image url, video url, canvas element, video element, base texture
         *
         * @static
         * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
         * @param {number} width - the width of the tiling sprite
         * @param {number} height - the height of the tiling sprite
         * @return {PIXI.Texture} The newly created texture
         */
    
    
        TilingSprite.from = function from(source, width, height) {
            return new TilingSprite(core.Texture.from(source), width, height);
        };
    
        /**
         * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
         * The frame ids are created when a Texture packer file has been loaded
         *
         * @static
         * @param {string} frameId - The frame Id of the texture in the cache
         * @param {number} width - the width of the tiling sprite
         * @param {number} height - the height of the tiling sprite
         * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
         */
    
    
        TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
            var texture = core.utils.TextureCache[frameId];
    
            if (!texture) {
                throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
            }
    
            return new TilingSprite(texture, width, height);
        };
    
        /**
         * Helper function that creates a sprite that will contain a texture based on an image url
         * If the image is not in the texture cache it will be loaded
         *
         * @static
         * @param {string} imageId - The image url of the texture
         * @param {number} width - the width of the tiling sprite
         * @param {number} height - the height of the tiling sprite
         * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
         * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
         *  see {@link PIXI.SCALE_MODES} for possible values
         * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
         */
    
    
        TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
            return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
        };
    
        /**
         * The width of the sprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */
    
    
        _createClass(TilingSprite, [{
            key: 'clampMargin',
            get: function get() {
                return this.uvTransform.clampMargin;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.uvTransform.clampMargin = value;
                this.uvTransform.update(true);
            }
    
            /**
             * The scaling of the image that is being tiled
             *
             * @member {PIXI.ObservablePoint}
             */
    
        }, {
            key: 'tileScale',
            get: function get() {
                return this.tileTransform.scale;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.tileTransform.scale.copy(value);
            }
    
            /**
             * The offset of the image that is being tiled
             *
             * @member {PIXI.ObservablePoint}
             */
    
        }, {
            key: 'tilePosition',
            get: function get() {
                return this.tileTransform.position;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.tileTransform.position.copy(value);
            }
        }, {
            key: 'width',
            get: function get() {
                return this._width;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._width = value;
            }
    
            /**
             * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                return this._height;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._height = value;
            }
        }]);
    
        return TilingSprite;
    }(core.Sprite);
    
    exports.default = TilingSprite;
    
    },{"../core":64,"../core/sprites/canvas/CanvasTinter":103,"./TextureTransform":132}],134:[function(require,module,exports){
    'use strict';
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var DisplayObject = core.DisplayObject;
    var _tempMatrix = new core.Matrix();
    
    DisplayObject.prototype._cacheAsBitmap = false;
    DisplayObject.prototype._cacheData = false;
    
    // figured theres no point adding ALL the extra variables to prototype.
    // this model can hold the information needed. This can also be generated on demand as
    // most objects are not cached as bitmaps.
    /**
     * @class
     * @ignore
     */
    
    var CacheData =
    /**
     *
     */
    function CacheData() {
        _classCallCheck(this, CacheData);
    
        this.originalRenderWebGL = null;
        this.originalRenderCanvas = null;
        this.originalCalculateBounds = null;
        this.originalGetLocalBounds = null;
    
        this.originalUpdateTransform = null;
        this.originalHitTest = null;
        this.originalDestroy = null;
        this.originalMask = null;
        this.originalFilterArea = null;
        this.sprite = null;
    };
    
    Object.defineProperties(DisplayObject.prototype, {
        /**
         * Set this to true if you want this display object to be cached as a bitmap.
         * This basically takes a snap shot of the display object as it is at that moment. It can
         * provide a performance benefit for complex static displayObjects.
         * To remove simply set this property to 'false'
         *
         * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
         * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
         *
         * @member {boolean}
         * @memberof PIXI.DisplayObject#
         */
        cacheAsBitmap: {
            get: function get() {
                return this._cacheAsBitmap;
            },
            set: function set(value) {
                if (this._cacheAsBitmap === value) {
                    return;
                }
    
                this._cacheAsBitmap = value;
    
                var data = void 0;
    
                if (value) {
                    if (!this._cacheData) {
                        this._cacheData = new CacheData();
                    }
    
                    data = this._cacheData;
    
                    data.originalRenderWebGL = this.renderWebGL;
                    data.originalRenderCanvas = this.renderCanvas;
    
                    data.originalUpdateTransform = this.updateTransform;
                    data.originalCalculateBounds = this._calculateBounds;
                    data.originalGetLocalBounds = this.getLocalBounds;
    
                    data.originalDestroy = this.destroy;
    
                    data.originalContainsPoint = this.containsPoint;
    
                    data.originalMask = this._mask;
                    data.originalFilterArea = this.filterArea;
    
                    this.renderWebGL = this._renderCachedWebGL;
                    this.renderCanvas = this._renderCachedCanvas;
    
                    this.destroy = this._cacheAsBitmapDestroy;
                } else {
                    data = this._cacheData;
    
                    if (data.sprite) {
                        this._destroyCachedDisplayObject();
                    }
    
                    this.renderWebGL = data.originalRenderWebGL;
                    this.renderCanvas = data.originalRenderCanvas;
                    this._calculateBounds = data.originalCalculateBounds;
                    this.getLocalBounds = data.originalGetLocalBounds;
    
                    this.destroy = data.originalDestroy;
    
                    this.updateTransform = data.originalUpdateTransform;
                    this.containsPoint = data.originalContainsPoint;
    
                    this._mask = data.originalMask;
                    this.filterArea = data.originalFilterArea;
                }
            }
        }
    });
    
    /**
     * Renders a cached version of the sprite with WebGL
     *
     * @private
     * @memberof PIXI.DisplayObject#
     * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
     */
    DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }
    
        this._initCachedDisplayObject(renderer);
    
        this._cacheData.sprite._transformID = -1;
        this._cacheData.sprite.worldAlpha = this.worldAlpha;
        this._cacheData.sprite._renderWebGL(renderer);
    };
    
    /**
     * Prepares the WebGL renderer to cache the sprite
     *
     * @private
     * @memberof PIXI.DisplayObject#
     * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
     */
    DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
        if (this._cacheData && this._cacheData.sprite) {
            return;
        }
    
        // make sure alpha is set to 1 otherwise it will get rendered as invisible!
        var cacheAlpha = this.alpha;
    
        this.alpha = 1;
    
        // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
        renderer.currentRenderer.flush();
        // this.filters= [];
    
        // next we find the dimensions of the untransformed object
        // this function also calls updatetransform on all its children as part of the measuring.
        // This means we don't need to update the transform again in this function
        // TODO pass an object to clone too? saves having to create a new one each time!
        var bounds = this.getLocalBounds().clone();
    
        // add some padding!
        if (this._filters) {
            var padding = this._filters[0].padding;
    
            bounds.pad(padding);
        }
    
        // for now we cache the current renderTarget that the webGL renderer is currently using.
        // this could be more elegent..
        var cachedRenderTarget = renderer._activeRenderTarget;
        // We also store the filter stack - I will definitely look to change how this works a little later down the line.
        var stack = renderer.filterManager.filterStack;
    
        // this renderTexture will be used to store the cached DisplayObject
    
        var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
    
        // need to set //
        var m = _tempMatrix;
    
        m.tx = -bounds.x;
        m.ty = -bounds.y;
    
        // reset
        this.transform.worldTransform.identity();
    
        // set all properties to there original so we can render to a texture
        this.renderWebGL = this._cacheData.originalRenderWebGL;
    
        renderer.render(this, renderTexture, true, m, true);
        // now restore the state be setting the new properties
    
        renderer.bindRenderTarget(cachedRenderTarget);
    
        renderer.filterManager.filterStack = stack;
    
        this.renderWebGL = this._renderCachedWebGL;
        this.updateTransform = this.displayObjectUpdateTransform;
    
        this._mask = null;
        this.filterArea = null;
    
        // create our cached sprite
        var cachedSprite = new core.Sprite(renderTexture);
    
        cachedSprite.transform.worldTransform = this.transform.worldTransform;
        cachedSprite.anchor.x = -(bounds.x / bounds.width);
        cachedSprite.anchor.y = -(bounds.y / bounds.height);
        cachedSprite.alpha = cacheAlpha;
        cachedSprite._bounds = this._bounds;
    
        // easy bounds..
        this._calculateBounds = this._calculateCachedBounds;
        this.getLocalBounds = this._getCachedLocalBounds;
    
        this._cacheData.sprite = cachedSprite;
    
        this.transform._parentID = -1;
        // restore the transform of the cached sprite to avoid the nasty flicker..
        this.updateTransform();
    
        // map the hit test..
        this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
    };
    
    /**
     * Renders a cached version of the sprite with canvas
     *
     * @private
     * @memberof PIXI.DisplayObject#
     * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
     */
    DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }
    
        this._initCachedDisplayObjectCanvas(renderer);
    
        this._cacheData.sprite.worldAlpha = this.worldAlpha;
    
        this._cacheData.sprite.renderCanvas(renderer);
    };
    
    // TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
    /**
     * Prepares the Canvas renderer to cache the sprite
     *
     * @private
     * @memberof PIXI.DisplayObject#
     * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
     */
    DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
        if (this._cacheData && this._cacheData.sprite) {
            return;
        }
    
        // get bounds actually transforms the object for us already!
        var bounds = this.getLocalBounds();
    
        var cacheAlpha = this.alpha;
    
        this.alpha = 1;
    
        var cachedRenderTarget = renderer.context;
    
        var renderTexture = core.RenderTexture.create(bounds.width | 0, bounds.height | 0);
    
        // need to set //
        var m = _tempMatrix;
    
        this.transform.localTransform.copy(m);
        m.invert();
    
        m.tx -= bounds.x;
        m.ty -= bounds.y;
    
        // m.append(this.transform.worldTransform.)
        // set all properties to there original so we can render to a texture
        this.renderCanvas = this._cacheData.originalRenderCanvas;
    
        // renderTexture.render(this, m, true);
        renderer.render(this, renderTexture, true, m, false);
    
        // now restore the state be setting the new properties
        renderer.context = cachedRenderTarget;
    
        this.renderCanvas = this._renderCachedCanvas;
        this._calculateBounds = this._calculateCachedBounds;
    
        this._mask = null;
        this.filterArea = null;
    
        // create our cached sprite
        var cachedSprite = new core.Sprite(renderTexture);
    
        cachedSprite.transform.worldTransform = this.transform.worldTransform;
        cachedSprite.anchor.x = -(bounds.x / bounds.width);
        cachedSprite.anchor.y = -(bounds.y / bounds.height);
        cachedSprite._bounds = this._bounds;
        cachedSprite.alpha = cacheAlpha;
    
        this.updateTransform();
        this.updateTransform = this.displayObjectUpdateTransform;
    
        this._cacheData.sprite = cachedSprite;
    
        this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
    };
    
    /**
     * Calculates the bounds of the cached sprite
     *
     * @private
     */
    DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
        this._cacheData.sprite._calculateBounds();
    };
    
    /**
     * Gets the bounds of the cached sprite.
     *
     * @private
     * @return {Rectangle} The local bounds.
     */
    DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
        return this._cacheData.sprite.getLocalBounds();
    };
    
    /**
     * Destroys the cached sprite.
     *
     * @private
     */
    DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
        this._cacheData.sprite._texture.destroy(true);
        this._cacheData.sprite = null;
    };
    
    /**
     * Destroys the cached object.
     *
     * @private
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value.
     *  Used when destroying containers, see the Container.destroy method.
     */
    DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
        this.cacheAsBitmap = false;
        this.destroy(options);
    };
    
    },{"../core":64}],135:[function(require,module,exports){
    'use strict';
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    /**
     * The instance name of the object.
     *
     * @memberof PIXI.DisplayObject#
     * @member {string}
     */
    core.DisplayObject.prototype.name = null;
    
    /**
     * Returns the display object in the container
     *
     * @memberof PIXI.Container#
     * @param {string} name - instance name
     * @return {PIXI.DisplayObject} The child with the specified name.
     */
    core.Container.prototype.getChildByName = function getChildByName(name) {
        for (var i = 0; i < this.children.length; i++) {
            if (this.children[i].name === name) {
                return this.children[i];
            }
        }
    
        return null;
    };
    
    },{"../core":64}],136:[function(require,module,exports){
    'use strict';
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    /**
     * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
     *
     * @memberof PIXI.DisplayObject#
     * @param {Point} point - the point to write the global value to. If null a new point will be returned
     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
     *  nice performance boost
     * @return {Point} The updated point
     */
    core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
        var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
        var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    
        if (this.parent) {
            this.parent.toGlobal(this.position, point, skipUpdate);
        } else {
            point.x = this.position.x;
            point.y = this.position.y;
        }
    
        return point;
    };
    
    },{"../core":64}],137:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = exports.TextureTransform = undefined;
    
    var _TextureTransform = require('./TextureTransform');
    
    Object.defineProperty(exports, 'TextureTransform', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TextureTransform).default;
      }
    });
    
    var _AnimatedSprite = require('./AnimatedSprite');
    
    Object.defineProperty(exports, 'AnimatedSprite', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_AnimatedSprite).default;
      }
    });
    
    var _TilingSprite = require('./TilingSprite');
    
    Object.defineProperty(exports, 'TilingSprite', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TilingSprite).default;
      }
    });
    
    var _TilingSpriteRenderer = require('./webgl/TilingSpriteRenderer');
    
    Object.defineProperty(exports, 'TilingSpriteRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TilingSpriteRenderer).default;
      }
    });
    
    var _BitmapText = require('./BitmapText');
    
    Object.defineProperty(exports, 'BitmapText', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BitmapText).default;
      }
    });
    
    require('./cacheAsBitmap');
    
    require('./getChildByName');
    
    require('./getGlobalPosition');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    // imported for side effect of extending the prototype only, contains no exports
    
    },{"./AnimatedSprite":130,"./BitmapText":131,"./TextureTransform":132,"./TilingSprite":133,"./cacheAsBitmap":134,"./getChildByName":135,"./getGlobalPosition":136,"./webgl/TilingSpriteRenderer":138}],138:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _const = require('../../core/const');
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var tempMat = new core.Matrix();
    var tempArray = new Float32Array(4);
    
    /**
     * WebGL renderer plugin for tiling sprites
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.ObjectRenderer
     */
    
    var TilingSpriteRenderer = function (_core$ObjectRenderer) {
        _inherits(TilingSpriteRenderer, _core$ObjectRenderer);
    
        /**
         * constructor for renderer
         *
         * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
         */
        function TilingSpriteRenderer(renderer) {
            _classCallCheck(this, TilingSpriteRenderer);
    
            var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
    
            _this.shader = null;
            _this.simpleShader = null;
            _this.quad = null;
            return _this;
        }
    
        /**
         * Sets up the renderer context and necessary buffers.
         *
         * @private
         */
    
    
        TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
            var gl = this.renderer.gl;
    
            this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    vec4 color = vec4(uColor.rgb * uColor.a, uColor.a);\n\n    gl_FragColor = sample * color ;\n}\n');
            this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    vec4 color = vec4(uColor.rgb * uColor.a, uColor.a);\n    gl_FragColor = sample * color;\n}\n');
    
            this.renderer.bindVao(null);
            this.quad = new core.Quad(gl, this.renderer.state.attribState);
            this.quad.initVao(this.shader);
        };
    
        /**
         *
         * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
         */
    
    
        TilingSpriteRenderer.prototype.render = function render(ts) {
            var renderer = this.renderer;
            var quad = this.quad;
    
            renderer.bindVao(quad.vao);
    
            var vertices = quad.vertices;
    
            vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
            vertices[1] = vertices[3] = ts._height * -ts.anchor.y;
    
            vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
            vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);
    
            if (ts.uvRespectAnchor) {
                vertices = quad.uvs;
    
                vertices[0] = vertices[6] = -ts.anchor.x;
                vertices[1] = vertices[3] = -ts.anchor.y;
    
                vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
                vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
            }
    
            quad.upload();
    
            var tex = ts._texture;
            var baseTex = tex.baseTexture;
            var lt = ts.tileTransform.localTransform;
            var uv = ts.uvTransform;
            var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;
    
            // auto, force repeat wrapMode for big tiling textures
            if (isSimple) {
                if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                    if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
                        baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
                    }
                } else {
                    isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
                }
            }
    
            var shader = isSimple ? this.simpleShader : this.shader;
    
            renderer.bindShader(shader);
    
            var w = tex.width;
            var h = tex.height;
            var W = ts._width;
            var H = ts._height;
    
            tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);
    
            // that part is the same as above:
            // tempMat.identity();
            // tempMat.scale(tex.width, tex.height);
            // tempMat.prepend(lt);
            // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);
    
            tempMat.invert();
            if (isSimple) {
                tempMat.append(uv.mapCoord);
            } else {
                shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
                shader.uniforms.uClampFrame = uv.uClampFrame;
                shader.uniforms.uClampOffset = uv.uClampOffset;
            }
    
            shader.uniforms.uTransform = tempMat.toArray(true);
    
            var color = tempArray;
    
            core.utils.hex2rgb(ts.tint, color);
            color[3] = ts.worldAlpha;
            shader.uniforms.uColor = color;
            shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);
    
            shader.uniforms.uSampler = renderer.bindTexture(tex);
    
            renderer.setBlendMode(ts.blendMode);
    
            quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
        };
    
        return TilingSpriteRenderer;
    }(core.ObjectRenderer);
    
    exports.default = TilingSpriteRenderer;
    
    
    core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
    
    },{"../../core":64,"../../core/const":45,"path":9}],139:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _BlurXFilter = require('./BlurXFilter');
    
    var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);
    
    var _BlurYFilter = require('./BlurYFilter');
    
    var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The BlurFilter applies a Gaussian blur to an object.
     * The strength of the blur can be set for x- and y-axis separately.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var BlurFilter = function (_core$Filter) {
        _inherits(BlurFilter, _core$Filter);
    
        /**
         * @param {number} strength - The strength of the blur filter.
         * @param {number} quality - The quality of the blur filter.
         * @param {number} resolution - The resolution of the blur filter.
         * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
         */
        function BlurFilter(strength, quality, resolution, kernelSize) {
            _classCallCheck(this, BlurFilter);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this));
    
            _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
            _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);
    
            _this.padding = 0;
            _this.resolution = resolution || core.settings.RESOLUTION;
            _this.quality = quality || 4;
            _this.blur = strength || 8;
            return _this;
        }
    
        /**
         * Applies the filter.
         *
         * @param {PIXI.FilterManager} filterManager - The manager.
         * @param {PIXI.RenderTarget} input - The input target.
         * @param {PIXI.RenderTarget} output - The output target.
         */
    
    
        BlurFilter.prototype.apply = function apply(filterManager, input, output) {
            var renderTarget = filterManager.getRenderTarget(true);
    
            this.blurXFilter.apply(filterManager, input, renderTarget, true);
            this.blurYFilter.apply(filterManager, renderTarget, output, false);
    
            filterManager.returnRenderTarget(renderTarget);
        };
    
        /**
         * Sets the strength of both the blurX and blurY properties simultaneously
         *
         * @member {number}
         * @default 2
         */
    
    
        _createClass(BlurFilter, [{
            key: 'blur',
            get: function get() {
                return this.blurXFilter.blur;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.blurXFilter.blur = this.blurYFilter.blur = value;
                this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
            }
    
            /**
             * Sets the number of passes for blur. More passes means higher quaility bluring.
             *
             * @member {number}
             * @default 1
             */
    
        }, {
            key: 'quality',
            get: function get() {
                return this.blurXFilter.quality;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.blurXFilter.quality = this.blurYFilter.quality = value;
            }
    
            /**
             * Sets the strength of the blurX property
             *
             * @member {number}
             * @default 2
             */
    
        }, {
            key: 'blurX',
            get: function get() {
                return this.blurXFilter.blur;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.blurXFilter.blur = value;
                this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
            }
    
            /**
             * Sets the strength of the blurY property
             *
             * @member {number}
             * @default 2
             */
    
        }, {
            key: 'blurY',
            get: function get() {
                return this.blurYFilter.blur;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.blurYFilter.blur = value;
                this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
            }
        }]);
    
        return BlurFilter;
    }(core.Filter);
    
    exports.default = BlurFilter;
    
    },{"../../core":64,"./BlurXFilter":140,"./BlurYFilter":141}],140:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _generateBlurVertSource = require('./generateBlurVertSource');
    
    var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
    
    var _generateBlurFragSource = require('./generateBlurFragSource');
    
    var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
    
    var _getMaxBlurKernelSize = require('./getMaxBlurKernelSize');
    
    var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The BlurXFilter applies a horizontal Gaussian blur to an object.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var BlurXFilter = function (_core$Filter) {
        _inherits(BlurXFilter, _core$Filter);
    
        /**
         * @param {number} strength - The strength of the blur filter.
         * @param {number} quality - The quality of the blur filter.
         * @param {number} resolution - The resolution of the blur filter.
         * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
         */
        function BlurXFilter(strength, quality, resolution, kernelSize) {
            _classCallCheck(this, BlurXFilter);
    
            kernelSize = kernelSize || 5;
            var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
            var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            vertSrc,
            // fragment shader
            fragSrc));
    
            _this.resolution = resolution || core.settings.RESOLUTION;
    
            _this._quality = 0;
    
            _this.quality = quality || 4;
            _this.strength = strength || 8;
    
            _this.firstRun = true;
            return _this;
        }
    
        /**
         * Applies the filter.
         *
         * @param {PIXI.FilterManager} filterManager - The manager.
         * @param {PIXI.RenderTarget} input - The input target.
         * @param {PIXI.RenderTarget} output - The output target.
         * @param {boolean} clear - Should the output be cleared before rendering?
         */
    
    
        BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
            if (this.firstRun) {
                var gl = filterManager.renderer.gl;
                var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
    
                this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
                this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
    
                this.firstRun = false;
            }
    
            this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);
    
            // screen space!
            this.uniforms.strength *= this.strength;
            this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);
    
            if (this.passes === 1) {
                filterManager.applyFilter(this, input, output, clear);
            } else {
                var renderTarget = filterManager.getRenderTarget(true);
                var flip = input;
                var flop = renderTarget;
    
                for (var i = 0; i < this.passes - 1; i++) {
                    filterManager.applyFilter(this, flip, flop, true);
    
                    var temp = flop;
    
                    flop = flip;
                    flip = temp;
                }
    
                filterManager.applyFilter(this, flip, output, clear);
    
                filterManager.returnRenderTarget(renderTarget);
            }
        };
    
        /**
         * Sets the strength of both the blur.
         *
         * @member {number}
         * @default 16
         */
    
    
        _createClass(BlurXFilter, [{
            key: 'blur',
            get: function get() {
                return this.strength;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.padding = Math.abs(value) * 2;
                this.strength = value;
            }
    
            /**
            * Sets the quality of the blur by modifying the number of passes. More passes means higher
            * quaility bluring but the lower the performance.
            *
            * @member {number}
            * @default 4
            */
    
        }, {
            key: 'quality',
            get: function get() {
                return this._quality;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._quality = value;
                this.passes = value;
            }
        }]);
    
        return BlurXFilter;
    }(core.Filter);
    
    exports.default = BlurXFilter;
    
    },{"../../core":64,"./generateBlurFragSource":142,"./generateBlurVertSource":143,"./getMaxBlurKernelSize":144}],141:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _generateBlurVertSource = require('./generateBlurVertSource');
    
    var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);
    
    var _generateBlurFragSource = require('./generateBlurFragSource');
    
    var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);
    
    var _getMaxBlurKernelSize = require('./getMaxBlurKernelSize');
    
    var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The BlurYFilter applies a horizontal Gaussian blur to an object.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var BlurYFilter = function (_core$Filter) {
        _inherits(BlurYFilter, _core$Filter);
    
        /**
         * @param {number} strength - The strength of the blur filter.
         * @param {number} quality - The quality of the blur filter.
         * @param {number} resolution - The resolution of the blur filter.
         * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
         */
        function BlurYFilter(strength, quality, resolution, kernelSize) {
            _classCallCheck(this, BlurYFilter);
    
            kernelSize = kernelSize || 5;
            var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
            var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            vertSrc,
            // fragment shader
            fragSrc));
    
            _this.resolution = resolution || core.settings.RESOLUTION;
    
            _this._quality = 0;
    
            _this.quality = quality || 4;
            _this.strength = strength || 8;
    
            _this.firstRun = true;
            return _this;
        }
    
        /**
         * Applies the filter.
         *
         * @param {PIXI.FilterManager} filterManager - The manager.
         * @param {PIXI.RenderTarget} input - The input target.
         * @param {PIXI.RenderTarget} output - The output target.
         * @param {boolean} clear - Should the output be cleared before rendering?
         */
    
    
        BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
            if (this.firstRun) {
                var gl = filterManager.renderer.gl;
                var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);
    
                this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
                this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);
    
                this.firstRun = false;
            }
    
            this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);
    
            this.uniforms.strength *= this.strength;
            this.uniforms.strength /= this.passes;
    
            if (this.passes === 1) {
                filterManager.applyFilter(this, input, output, clear);
            } else {
                var renderTarget = filterManager.getRenderTarget(true);
                var flip = input;
                var flop = renderTarget;
    
                for (var i = 0; i < this.passes - 1; i++) {
                    filterManager.applyFilter(this, flip, flop, true);
    
                    var temp = flop;
    
                    flop = flip;
                    flip = temp;
                }
    
                filterManager.applyFilter(this, flip, output, clear);
    
                filterManager.returnRenderTarget(renderTarget);
            }
        };
    
        /**
         * Sets the strength of both the blur.
         *
         * @member {number}
         * @default 2
         */
    
    
        _createClass(BlurYFilter, [{
            key: 'blur',
            get: function get() {
                return this.strength;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.padding = Math.abs(value) * 2;
                this.strength = value;
            }
    
            /**
             * Sets the quality of the blur by modifying the number of passes. More passes means higher
             * quaility bluring but the lower the performance.
             *
             * @member {number}
             * @default 4
             */
    
        }, {
            key: 'quality',
            get: function get() {
                return this._quality;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._quality = value;
                this.passes = value;
            }
        }]);
    
        return BlurYFilter;
    }(core.Filter);
    
    exports.default = BlurYFilter;
    
    },{"../../core":64,"./generateBlurFragSource":142,"./generateBlurVertSource":143,"./getMaxBlurKernelSize":144}],142:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = generateFragBlurSource;
    var GAUSSIAN_VALUES = {
        5: [0.153388, 0.221461, 0.250301],
        7: [0.071303, 0.131514, 0.189879, 0.214607],
        9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
        11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
        13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
        15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
    };
    
    var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');
    
    function generateFragBlurSource(kernelSize) {
        var kernel = GAUSSIAN_VALUES[kernelSize];
        var halfLength = kernel.length;
    
        var fragSource = fragTemplate;
    
        var blurLoop = '';
        var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
        var value = void 0;
    
        for (var i = 0; i < kernelSize; i++) {
            var blur = template.replace('%index%', i);
    
            value = i;
    
            if (i >= halfLength) {
                value = kernelSize - i - 1;
            }
    
            blur = blur.replace('%value%', kernel[value]);
    
            blurLoop += blur;
            blurLoop += '\n';
        }
    
        fragSource = fragSource.replace('%blur%', blurLoop);
        fragSource = fragSource.replace('%size%', kernelSize);
    
        return fragSource;
    }
    
    },{}],143:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.default = generateVertBlurSource;
    var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');
    
    function generateVertBlurSource(kernelSize, x) {
        var halfLength = Math.ceil(kernelSize / 2);
    
        var vertSource = vertTemplate;
    
        var blurLoop = '';
        var template = void 0;
        // let value;
    
        if (x) {
            template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
        } else {
            template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
        }
    
        for (var i = 0; i < kernelSize; i++) {
            var blur = template.replace('%index%', i);
    
            // value = i;
    
            // if(i >= halfLength)
            // {
            //     value = kernelSize - i - 1;
            // }
    
            blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');
    
            blurLoop += blur;
            blurLoop += '\n';
        }
    
        vertSource = vertSource.replace('%blur%', blurLoop);
        vertSource = vertSource.replace('%size%', kernelSize);
    
        return vertSource;
    }
    
    },{}],144:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    exports.default = getMaxKernelSize;
    function getMaxKernelSize(gl) {
        var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
        var kernelSize = 15;
    
        while (kernelSize > maxVaryings) {
            kernelSize -= 2;
        }
    
        return kernelSize;
    }
    
    },{}],145:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
     * color and alpha values of every pixel on your displayObject to produce a result
     * with a new set of RGBA color and alpha values. It's pretty powerful!
     *
     * ```js
     *  let colorMatrix = new PIXI.ColorMatrixFilter();
     *  container.filters = [colorMatrix];
     *  colorMatrix.contrast(2);
     * ```
     * @author ClÃ©ment Chenebault <clement@goodboydigital.com>
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var ColorMatrixFilter = function (_core$Filter) {
        _inherits(ColorMatrixFilter, _core$Filter);
    
        /**
         *
         */
        function ColorMatrixFilter() {
            _classCallCheck(this, ColorMatrixFilter);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
            // fragment shader
            'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n    vec4 result;\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    // Premultiply alpha again.\n    result.rgb *= result.a;\n\n    gl_FragColor = result;\n}\n'));
    
            _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
            return _this;
        }
    
        /**
         * Transforms current matrix and set the new one
         *
         * @param {number[]} matrix - 5x4 matrix
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
            var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    
            var newMatrix = matrix;
    
            if (multiply) {
                this._multiply(newMatrix, this.uniforms.m, matrix);
                newMatrix = this._colorMatrix(newMatrix);
            }
    
            // set the new matrix
            this.uniforms.m = newMatrix;
        };
    
        /**
         * Multiplies two mat5's
         *
         * @private
         * @param {number[]} out - 5x4 matrix the receiving matrix
         * @param {number[]} a - 5x4 matrix the first operand
         * @param {number[]} b - 5x4 matrix the second operand
         * @returns {number[]} 5x4 matrix
         */
    
    
        ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
            // Red Channel
            out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
            out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
            out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
            out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
            out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];
    
            // Green Channel
            out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
            out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
            out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
            out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
            out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];
    
            // Blue Channel
            out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
            out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
            out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
            out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
            out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];
    
            // Alpha Channel
            out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
            out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
            out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
            out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
            out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];
    
            return out;
        };
    
        /**
         * Create a Float32 Array and normalize the offset component to 0-1
         *
         * @private
         * @param {number[]} matrix - 5x4 matrix
         * @return {number[]} 5x4 matrix with all values between 0-1
         */
    
    
        ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
            // Create a Float32 Array and normalize the offset component to 0-1
            var m = new Float32Array(matrix);
    
            m[4] /= 255;
            m[9] /= 255;
            m[14] /= 255;
            m[19] /= 255;
    
            return m;
        };
    
        /**
         * Adjusts brightness
         *
         * @param {number} b - value of the brigthness (0-1, where 0 is black)
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
            var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Set the matrices in grey scales
         *
         * @param {number} scale - value of the grey (0-1, where 0 is black)
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
            var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Set the black and white matrice.
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
            var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Set the hue property of the color
         *
         * @param {number} rotation - in degrees
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
            rotation = (rotation || 0) / 180 * Math.PI;
    
            var cosR = Math.cos(rotation);
            var sinR = Math.sin(rotation);
            var sqrt = Math.sqrt;
    
            /* a good approximation for hue rotation
             This matrix is far better than the versions with magic luminance constants
             formerly used here, but also used in the starling framework (flash) and known from this
             old part of the internet: quasimondo.com/archives/000565.php
              This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
             implementation as a shader not a general matrix:
             https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
              This is the source for the code:
             see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
             */
    
            var w = 1 / 3;
            var sqrW = sqrt(w); // weight is
    
            var a00 = cosR + (1.0 - cosR) * w;
            var a01 = w * (1.0 - cosR) - sqrW * sinR;
            var a02 = w * (1.0 - cosR) + sqrW * sinR;
    
            var a10 = w * (1.0 - cosR) + sqrW * sinR;
            var a11 = cosR + w * (1.0 - cosR);
            var a12 = w * (1.0 - cosR) - sqrW * sinR;
    
            var a20 = w * (1.0 - cosR) - sqrW * sinR;
            var a21 = w * (1.0 - cosR) + sqrW * sinR;
            var a22 = cosR + w * (1.0 - cosR);
    
            var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Set the contrast matrix, increase the separation between dark and bright
         * Increase contrast : shadows darker and highlights brighter
         * Decrease contrast : bring the shadows up and the highlights down
         *
         * @param {number} amount - value of the contrast (0-1)
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
            var v = (amount || 0) + 1;
            var o = -128 * (v - 1);
    
            var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Set the saturation matrix, increase the separation between colors
         * Increase saturation : increase contrast, brightness, and sharpness
         *
         * @param {number} amount - The saturation amount (0-1)
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.saturate = function saturate() {
            var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var multiply = arguments[1];
    
            var x = amount * 2 / 3 + 1;
            var y = (x - 1) * -0.5;
    
            var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Desaturate image (remove color)
         *
         * Call the saturate function
         *
         */
    
    
        ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
        {
            this.saturate(-1);
        };
    
        /**
         * Negative image (inverse of classic rgb matrix)
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.negative = function negative(multiply) {
            var matrix = [0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Sepia image
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
            var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
            var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Polaroid filter
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
            var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Filter who transforms : Red -> Blue and Blue -> Red
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
            var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
            var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Brown delicious browni filter (thanks Dominic Szablewski)
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.browni = function browni(multiply) {
            var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Vintage filter (thanks Dominic Szablewski)
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
            var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * We don't know exactly what it does, kind of gradient map, but funny to play with!
         *
         * @param {number} desaturation - Tone values.
         * @param {number} toned - Tone values.
         * @param {string} lightColor - Tone values, example: `0xFFE580`
         * @param {string} darkColor - Tone values, example: `0xFFE580`
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
            desaturation = desaturation || 0.2;
            toned = toned || 0.15;
            lightColor = lightColor || 0xFFE580;
            darkColor = darkColor || 0x338000;
    
            var lR = (lightColor >> 16 & 0xFF) / 255;
            var lG = (lightColor >> 8 & 0xFF) / 255;
            var lB = (lightColor & 0xFF) / 255;
    
            var dR = (darkColor >> 16 & 0xFF) / 255;
            var dG = (darkColor >> 8 & 0xFF) / 255;
            var dB = (darkColor & 0xFF) / 255;
    
            var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Night effect
         *
         * @param {number} intensity - The intensity of the night effect.
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
            intensity = intensity || 0.1;
            var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Predator effect
         *
         * Erase the current matrix by setting a new indepent one
         *
         * @param {number} amount - how much the predator feels his future victim
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
            var matrix = [
            // row 1
            11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
            // row 2
            -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
            // row 3
            -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
            // row 4
            0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * LSD effect
         *
         * Multiply the current matrix
         *
         * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
         *  just set the current matrix with @param matrix
         */
    
    
        ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
            var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, multiply);
        };
    
        /**
         * Erase the current matrix by setting the default one
         *
         */
    
    
        ColorMatrixFilter.prototype.reset = function reset() {
            var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
    
            this._loadMatrix(matrix, false);
        };
    
        /**
         * The matrix of the color matrix filter
         *
         * @member {number[]}
         * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
         */
    
    
        _createClass(ColorMatrixFilter, [{
            key: 'matrix',
            get: function get() {
                return this.uniforms.m;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.uniforms.m = value;
            }
        }]);
    
        return ColorMatrixFilter;
    }(core.Filter);
    
    // Americanized alias
    
    
    exports.default = ColorMatrixFilter;
    ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
    
    },{"../../core":64,"path":9}],146:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The DisplacementFilter class uses the pixel values from the specified texture
     * (called the displacement map) to perform a displacement of an object. You can
     * use this filter to apply all manor of crazy warping effects. Currently the r
     * property of the texture is used to offset the x and the g property of the texture
     * is used to offset the y.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var DisplacementFilter = function (_core$Filter) {
        _inherits(DisplacementFilter, _core$Filter);
    
        /**
         * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
         * @param {number} scale - The scale of the displacement
         */
        function DisplacementFilter(sprite, scale) {
            _classCallCheck(this, DisplacementFilter);
    
            var maskMatrix = new core.Matrix();
    
            sprite.renderable = false;
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
            // fragment shader
            'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n   vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n   map -= 0.5;\n   map.xy *= scale;\n\n   gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));
    
            _this.maskSprite = sprite;
            _this.maskMatrix = maskMatrix;
    
            _this.uniforms.mapSampler = sprite.texture;
            _this.uniforms.filterMatrix = maskMatrix;
            _this.uniforms.scale = { x: 1, y: 1 };
    
            if (scale === null || scale === undefined) {
                scale = 20;
            }
    
            _this.scale = new core.Point(scale, scale);
            return _this;
        }
    
        /**
         * Applies the filter.
         *
         * @param {PIXI.FilterManager} filterManager - The manager.
         * @param {PIXI.RenderTarget} input - The input target.
         * @param {PIXI.RenderTarget} output - The output target.
         */
    
    
        DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
            var ratio = 1 / output.destinationFrame.width * (output.size.width / input.size.width);
    
            this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
            this.uniforms.scale.x = this.scale.x * ratio;
            this.uniforms.scale.y = this.scale.y * ratio;
    
            // draw the filter...
            filterManager.applyFilter(this, input, output);
        };
    
        /**
         * The texture used for the displacement map. Must be power of 2 sized texture.
         *
         * @member {PIXI.Texture}
         */
    
    
        _createClass(DisplacementFilter, [{
            key: 'map',
            get: function get() {
                return this.uniforms.mapSampler;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.uniforms.mapSampler = value;
            }
        }]);
    
        return DisplacementFilter;
    }(core.Filter);
    
    exports.default = DisplacementFilter;
    
    },{"../../core":64,"path":9}],147:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     *
     * Basic FXAA implementation based on the code on geeks3d.com with the
     * modification that the texture2DLod stuff was removed since it's
     * unsupported by WebGL.
     *
     * @see https://github.com/mitsuhiko/webgl-meincraft
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     *
     */
    var FXAAFilter = function (_core$Filter) {
        _inherits(FXAAFilter, _core$Filter);
    
        /**
         *
         */
        function FXAAFilter() {
            _classCallCheck(this, FXAAFilter);
    
            // TODO - needs work
            return _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
            // fragment shader
            'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
        }
    
        return FXAAFilter;
    }(core.Filter);
    
    exports.default = FXAAFilter;
    
    },{"../../core":64,"path":9}],148:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _FXAAFilter = require('./fxaa/FXAAFilter');
    
    Object.defineProperty(exports, 'FXAAFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_FXAAFilter).default;
      }
    });
    
    var _NoiseFilter = require('./noise/NoiseFilter');
    
    Object.defineProperty(exports, 'NoiseFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_NoiseFilter).default;
      }
    });
    
    var _DisplacementFilter = require('./displacement/DisplacementFilter');
    
    Object.defineProperty(exports, 'DisplacementFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_DisplacementFilter).default;
      }
    });
    
    var _BlurFilter = require('./blur/BlurFilter');
    
    Object.defineProperty(exports, 'BlurFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BlurFilter).default;
      }
    });
    
    var _BlurXFilter = require('./blur/BlurXFilter');
    
    Object.defineProperty(exports, 'BlurXFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BlurXFilter).default;
      }
    });
    
    var _BlurYFilter = require('./blur/BlurYFilter');
    
    Object.defineProperty(exports, 'BlurYFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BlurYFilter).default;
      }
    });
    
    var _ColorMatrixFilter = require('./colormatrix/ColorMatrixFilter');
    
    Object.defineProperty(exports, 'ColorMatrixFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ColorMatrixFilter).default;
      }
    });
    
    var _VoidFilter = require('./void/VoidFilter');
    
    Object.defineProperty(exports, 'VoidFilter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_VoidFilter).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./blur/BlurFilter":139,"./blur/BlurXFilter":140,"./blur/BlurYFilter":141,"./colormatrix/ColorMatrixFilter":145,"./displacement/DisplacementFilter":146,"./fxaa/FXAAFilter":147,"./noise/NoiseFilter":149,"./void/VoidFilter":150}],149:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @author Vico @vicocotea
     * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
     */
    
    /**
     * A Noise effect filter.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var NoiseFilter = function (_core$Filter) {
        _inherits(NoiseFilter, _core$Filter);
    
        /**
         *
         */
        function NoiseFilter() {
            _classCallCheck(this, NoiseFilter);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
            // fragment shader
            'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float noise;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n\n    float diff = (rand(gl_FragCoord.xy) - 0.5) * noise;\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    gl_FragColor = color;\n}\n'));
    
            _this.noise = 0.5;
            return _this;
        }
    
        /**
         * The amount of noise to apply.
         *
         * @member {number}
         * @default 0.5
         */
    
    
        _createClass(NoiseFilter, [{
            key: 'noise',
            get: function get() {
                return this.uniforms.noise;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this.uniforms.noise = value;
            }
        }]);
    
        return NoiseFilter;
    }(core.Filter);
    
    exports.default = NoiseFilter;
    
    },{"../../core":64,"path":9}],150:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _path = require('path');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * Does nothing. Very handy.
     *
     * @class
     * @extends PIXI.Filter
     * @memberof PIXI.filters
     */
    var VoidFilter = function (_core$Filter) {
        _inherits(VoidFilter, _core$Filter);
    
        /**
         *
         */
        function VoidFilter() {
            _classCallCheck(this, VoidFilter);
    
            var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
            // vertex shader
            'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
            // fragment shader
            'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord);\n}\n'));
    
            _this.glShaderKey = 'void';
            return _this;
        }
    
        return VoidFilter;
    }(core.Filter);
    
    exports.default = VoidFilter;
    
    },{"../../core":64,"path":9}],151:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Holds all information related to an Interaction event
     *
     * @class
     * @memberof PIXI.interaction
     */
    var InteractionData = function () {
      /**
       *
       */
      function InteractionData() {
        _classCallCheck(this, InteractionData);
    
        /**
         * This point stores the global coords of where the touch/mouse event happened
         *
         * @member {PIXI.Point}
         */
        this.global = new core.Point();
    
        /**
         * The target DisplayObject that was interacted with
         *
         * @member {PIXI.DisplayObject}
         */
        this.target = null;
    
        /**
         * When passed to an event handler, this will be the original DOM Event that was captured
         *
         * @member {Event}
         */
        this.originalEvent = null;
    
        /**
         * Unique identifier for this interaction
         *
         * @member {number}
         */
        this.identifier = null;
      }
    
      /**
       * This will return the local coordinates of the specified displayObject for this InteractionData
       *
       * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
       *  coords off
       * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
       *  will create a new point)
       * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
       *  (otherwise will use the current global coords)
       * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
       *  to the DisplayObject
       */
    
    
      InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
        return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
      };
    
      return InteractionData;
    }();
    
    exports.default = InteractionData;
    
    },{"../core":64}],152:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Event class that mimics native DOM events.
     *
     * @class
     * @memberof PIXI.interaction
     */
    var InteractionEvent = function () {
      /**
       *
       */
      function InteractionEvent() {
        _classCallCheck(this, InteractionEvent);
    
        /**
         * Whether this event will continue propagating in the tree
         *
         * @member {boolean}
         */
        this.stopped = false;
    
        /**
         * The object which caused this event to be dispatched.
         * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
         *
         * @member {PIXI.DisplayObject}
         */
        this.target = null;
    
        /**
         * The object whose event listenerâ€™s callback is currently being invoked.
         *
         * @member {PIXI.DisplayObject}
         */
        this.currentTarget = null;
    
        /*
         * Type of the event
         *
         * @member {string}
         */
        this.type = null;
    
        /*
         * InteractionData related to this event
         *
         * @member {PIXI.interaction.InteractionData}
         */
        this.data = null;
      }
    
      /**
       * Prevents event from reaching any objects other than the current object.
       *
       */
    
    
      InteractionEvent.prototype.stopPropagation = function stopPropagation() {
        this.stopped = true;
      };
    
      /**
       * Resets the event.
       *
       * @private
       */
    
    
      InteractionEvent.prototype._reset = function _reset() {
        this.stopped = false;
        this.currentTarget = null;
        this.target = null;
      };
    
      return InteractionEvent;
    }();
    
    exports.default = InteractionEvent;
    
    },{}],153:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _InteractionData = require('./InteractionData');
    
    var _InteractionData2 = _interopRequireDefault(_InteractionData);
    
    var _InteractionEvent = require('./InteractionEvent');
    
    var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);
    
    var _InteractionTrackingData = require('./InteractionTrackingData');
    
    var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _interactiveTarget = require('./interactiveTarget');
    
    var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    // Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
    core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);
    
    var MOUSE_POINTER_ID = 'MOUSE';
    
    /**
     * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
     * if its interactive parameter is set to true
     * This manager also supports multitouch.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
     *
     * @class
     * @extends EventEmitter
     * @memberof PIXI.interaction
     */
    
    var InteractionManager = function (_EventEmitter) {
        _inherits(InteractionManager, _EventEmitter);
    
        /**
         * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
         * @param {object} [options] - The options for the manager.
         * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
         * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
         */
        function InteractionManager(renderer, options) {
            _classCallCheck(this, InteractionManager);
    
            var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
    
            options = options || {};
    
            /**
             * The renderer this interaction manager works for.
             *
             * @member {PIXI.SystemRenderer}
             */
            _this.renderer = renderer;
    
            /**
             * Should default browser actions automatically be prevented.
             * Does not apply to pointer events for backwards compatibility
             * preventDefault on pointer events stops mouse events from firing
             * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
             *
             * @member {boolean}
             * @default true
             */
            _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;
    
            /**
             * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
             *
             * @member {number}
             * @default 10
             */
            _this.interactionFrequency = options.interactionFrequency || 10;
    
            /**
             * The mouse data
             *
             * @member {PIXI.interaction.InteractionData}
             */
            _this.mouse = new _InteractionData2.default();
            _this.mouse.identifier = MOUSE_POINTER_ID;
    
            // setting the mouse to start off far off screen will mean that mouse over does
            //  not get called before we even move the mouse.
            _this.mouse.global.set(-999999);
    
            /**
             * Actively tracked InteractionData
             *
             * @private
             * @member {Object.<number,PIXI.interation.InteractionData>}
             */
            _this.activeInteractionData = {};
            _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;
    
            /**
             * Pool of unused InteractionData
             *
             * @private
             * @member {PIXI.interation.InteractionData[]}
             */
            _this.interactionDataPool = [];
    
            /**
             * An event data object to handle all the event tracking/dispatching
             *
             * @member {object}
             */
            _this.eventData = new _InteractionEvent2.default();
    
            /**
             * The DOM element to bind to.
             *
             * @private
             * @member {HTMLElement}
             */
            _this.interactionDOMElement = null;
    
            /**
             * This property determines if mousemove and touchmove events are fired only when the cursor
             * is over the object.
             * Setting to true will make things work more in line with how the DOM verison works.
             * Setting to false can make things easier for things like dragging
             * It is currently set to false as this is how pixi used to work. This will be set to true in
             * future versions of pixi.
             *
             * @member {boolean}
             * @default false
             */
            _this.moveWhenInside = false;
    
            /**
             * Have events been attached to the dom element?
             *
             * @private
             * @member {boolean}
             */
            _this.eventsAdded = false;
    
            /**
             * Is the mouse hovering over the renderer?
             *
             * @private
             * @member {boolean}
             */
            _this.mouseOverRenderer = false;
    
            /**
             * Does the device support touch events
             * https://www.w3.org/TR/touch-events/
             *
             * @readonly
             * @member {boolean}
             */
            _this.supportsTouchEvents = 'ontouchstart' in window;
    
            /**
             * Does the device support pointer events
             * https://www.w3.org/Submission/pointer-events/
             *
             * @readonly
             * @member {boolean}
             */
            _this.supportsPointerEvents = !!window.PointerEvent;
    
            // this will make it so that you don't have to call bind all the time
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerUp = _this.onPointerUp.bind(_this);
            _this.processPointerUp = _this.processPointerUp.bind(_this);
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerCancel = _this.onPointerCancel.bind(_this);
            _this.processPointerCancel = _this.processPointerCancel.bind(_this);
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerDown = _this.onPointerDown.bind(_this);
            _this.processPointerDown = _this.processPointerDown.bind(_this);
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerMove = _this.onPointerMove.bind(_this);
            _this.processPointerMove = _this.processPointerMove.bind(_this);
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerOut = _this.onPointerOut.bind(_this);
            _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);
    
            /**
             * @private
             * @member {Function}
             */
            _this.onPointerOver = _this.onPointerOver.bind(_this);
    
            /**
             * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
             * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
             * and functions are called instead of changing the CSS.
             * Default CSS cursor values are provided for 'default' and 'pointer' modes.
             * @member {Object.<string, (string|Function|Object.<string, string>)>}
             */
            _this.cursorStyles = {
                default: 'inherit',
                pointer: 'pointer'
            };
    
            /**
             * The mode of the cursor that is being used.
             * The value of this is a key from the cursorStyles dictionary.
             *
             * @member {string}
             */
            _this.currentCursorMode = null;
    
            /**
             * Internal cached let.
             *
             * @private
             * @member {string}
             */
            _this.cursor = null;
    
            /**
             * Internal cached let.
             *
             * @private
             * @member {PIXI.Point}
             */
            _this._tempPoint = new core.Point();
    
            /**
             * The current resolution / device pixel ratio.
             *
             * @member {number}
             * @default 1
             */
            _this.resolution = 1;
    
            _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);
    
            /**
             * Fired when a pointer device button (usually a mouse button) is pressed on the display
             * object.
             *
             * @event mousedown
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
             * on the display object.
             *
             * @event rightdown
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button (usually a mouse button) is released over the display
             * object.
             *
             * @event mouseup
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device secondary button (usually a mouse right-button) is released
             * over the display object.
             *
             * @event rightup
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button (usually a mouse button) is pressed and released on
             * the display object.
             *
             * @event click
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
             * and released on the display object.
             *
             * @event rightclick
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button (usually a mouse button) is released outside the
             * display object that initially registered a
             * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
             *
             * @event mouseupoutside
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device secondary button (usually a mouse right-button) is released
             * outside the display object that initially registered a
             * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
             *
             * @event rightupoutside
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device (usually a mouse) is moved while over the display object
             *
             * @event mousemove
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device (usually a mouse) is moved onto the display object
             *
             * @event mouseover
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device (usually a mouse) is moved off the display object
             *
             * @event mouseout
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button is pressed on the display object.
             *
             * @event pointerdown
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button is released over the display object.
             *
             * @event pointerup
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when the operating system cancels a pointer event
             *
             * @event pointercancel
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button is pressed and released on the display object.
             *
             * @event pointertap
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device button is released outside the display object that initially
             * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
             *
             * @event pointerupoutside
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device is moved while over the display object
             *
             * @event pointermove
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device is moved onto the display object
             *
             * @event pointerover
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a pointer device is moved off the display object
             *
             * @event pointerout
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a touch point is placed on the display object.
             *
             * @event touchstart
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a touch point is removed from the display object.
             *
             * @event touchend
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when the operating system cancels a touch
             *
             * @event touchcancel
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a touch point is placed and removed from the display object.
             *
             * @event tap
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a touch point is removed outside of the display object that initially
             * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
             *
             * @event touchendoutside
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
    
            /**
             * Fired when a touch point is moved along the display object.
             *
             * @event touchmove
             * @type {PIXI.interaction.InteractionData}
             * @memberof PIXI.interaction.InteractionManager#
             */
            return _this;
        }
    
        /**
         * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
         * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
         * another DOM element to receive those events.
         *
         * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
         * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
         * @private
         */
    
    
        InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
            var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    
            this.removeEvents();
    
            this.interactionDOMElement = element;
    
            this.resolution = resolution;
    
            this.addEvents();
        };
    
        /**
         * Registers all the DOM events
         *
         * @private
         */
    
    
        InteractionManager.prototype.addEvents = function addEvents() {
            if (!this.interactionDOMElement) {
                return;
            }
    
            core.ticker.shared.add(this.update, this);
    
            if (window.navigator.msPointerEnabled) {
                this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
                this.interactionDOMElement.style['-ms-touch-action'] = 'none';
            } else if (this.supportsPointerEvents) {
                this.interactionDOMElement.style['touch-action'] = 'none';
            }
    
            /**
             * These events are added first, so that if pointer events are normalised, they are fired
             * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
             */
            if (this.supportsPointerEvents) {
                window.document.addEventListener('pointermove', this.onPointerMove, true);
                this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
                // pointerout is fired in addition to pointerup (for touch events) and pointercancel
                // we already handle those, so for the purposes of what we do in onPointerOut, we only
                // care about the pointerleave event
                this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
                this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
                window.addEventListener('pointercancel', this.onPointerCancel, true);
                window.addEventListener('pointerup', this.onPointerUp, true);
            } else {
                window.document.addEventListener('mousemove', this.onPointerMove, true);
                this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
                this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
                this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
                window.addEventListener('mouseup', this.onPointerUp, true);
    
                if (this.supportsTouchEvents) {
                    this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
                    this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
                    this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
                    this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
                }
            }
    
            this.eventsAdded = true;
        };
    
        /**
         * Removes all the DOM events that were previously registered
         *
         * @private
         */
    
    
        InteractionManager.prototype.removeEvents = function removeEvents() {
            if (!this.interactionDOMElement) {
                return;
            }
    
            core.ticker.shared.remove(this.update, this);
    
            if (window.navigator.msPointerEnabled) {
                this.interactionDOMElement.style['-ms-content-zooming'] = '';
                this.interactionDOMElement.style['-ms-touch-action'] = '';
            } else if (this.supportsPointerEvents) {
                this.interactionDOMElement.style['touch-action'] = '';
            }
    
            if (this.supportsPointerEvents) {
                window.document.removeEventListener('pointermove', this.onPointerMove, true);
                this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
                this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
                this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
                window.removeEventListener('pointercancel', this.onPointerCancel, true);
                window.removeEventListener('pointerup', this.onPointerUp, true);
            } else {
                window.document.removeEventListener('mousemove', this.onPointerMove, true);
                this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
                this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
                this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
                window.removeEventListener('mouseup', this.onPointerUp, true);
    
                if (this.supportsTouchEvents) {
                    this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
                    this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
                    this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
                    this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
                }
            }
    
            this.interactionDOMElement = null;
    
            this.eventsAdded = false;
        };
    
        /**
         * Updates the state of interactive objects.
         * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
         *
         * @param {number} deltaTime - time delta since last tick
         */
    
    
        InteractionManager.prototype.update = function update(deltaTime) {
            this._deltaTime += deltaTime;
    
            if (this._deltaTime < this.interactionFrequency) {
                return;
            }
    
            this._deltaTime = 0;
    
            if (!this.interactionDOMElement) {
                return;
            }
    
            // if the user move the mouse this check has already been done using the mouse move!
            if (this.didMove) {
                this.didMove = false;
    
                return;
            }
    
            this.cursor = null;
    
            // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
            // but there was a scenario of a display object moving under a static mouse cursor.
            // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
            for (var k in this.activeInteractionData) {
                // eslint-disable-next-line no-prototype-builtins
                if (this.activeInteractionData.hasOwnProperty(k)) {
                    var interactionData = this.activeInteractionData[k];
    
                    if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
                        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);
    
                        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
                    }
                }
            }
    
            this.setCursorMode(this.cursor);
    
            // TODO
        };
    
        /**
         * Sets the current cursor mode, handling any callbacks or CSS style changes.
         *
         * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
         */
    
    
        InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
            mode = mode || 'default';
            // if the mode didn't actually change, bail early
            if (this.currentCursorMode === mode) {
                return;
            }
            this.currentCursorMode = mode;
            var style = this.cursorStyles[mode];
    
            // only do things if there is a cursor style for it
            if (style) {
                switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
                    case 'string':
                        // string styles are handled as cursor CSS
                        this.interactionDOMElement.style.cursor = style;
                        break;
                    case 'function':
                        // functions are just called, and passed the cursor mode
                        style(mode);
                        break;
                    case 'object':
                        // if it is an object, assume that it is a dictionary of CSS styles,
                        // apply it to the interactionDOMElement
                        Object.assign(this.interactionDOMElement.style, style);
                        break;
                }
            }
        };
    
        /**
         * Dispatches an event on the display object that was interacted with
         *
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
         * @param {string} eventString - the name of the event (e.g, mousedown)
         * @param {object} eventData - the event data object
         * @private
         */
    
    
        InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
            if (!eventData.stopped) {
                eventData.currentTarget = displayObject;
                eventData.type = eventString;
    
                displayObject.emit(eventString, eventData);
    
                if (displayObject[eventString]) {
                    displayObject[eventString](eventData);
                }
            }
        };
    
        /**
         * Maps x and y coords from a DOM object and maps them correctly to the pixi view. The
         * resulting value is stored in the point. This takes into account the fact that the DOM
         * element could be scaled and positioned anywhere on the screen.
         *
         * @param  {PIXI.Point} point - the point that the result will be stored in
         * @param  {number} x - the x coord of the position to map
         * @param  {number} y - the y coord of the position to map
         */
    
    
        InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
            var rect = void 0;
    
            // IE 11 fix
            if (!this.interactionDOMElement.parentElement) {
                rect = { x: 0, y: 0, width: 0, height: 0 };
            } else {
                rect = this.interactionDOMElement.getBoundingClientRect();
            }
    
            var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;
    
            point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
            point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
        };
    
        /**
         * This function is provides a neat way of crawling through the scene graph and running a
         * specified function on all interactive objects it finds. It will also take care of hit
         * testing the interactive objects and passes the hit across in the function.
         *
         * @private
         * @param {InteractionEvent} interactionEvent - event containing the point that
         *  is tested for collision
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
         *  that will be hit test (recursively crawls its children)
         * @param {Function} [func] - the function that will be called on each interactive object. The
         *  interactionEvent, displayObject and hit will be passed to the function
         * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
         * @param {boolean} [interactive] - Whether the displayObject is interactive
         * @return {boolean} returns true if the displayObject hit the point
         */
    
    
        InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
            if (!displayObject || !displayObject.visible) {
                return false;
            }
    
            var point = interactionEvent.data.global;
    
            // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
            //
            // This function will now loop through all objects and then only hit test the objects it HAS
            // to, not all of them. MUCH faster..
            // An object will be hit test if the following is true:
            //
            // 1: It is interactive.
            // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
            //
            // As another little optimisation once an interactive object has been hit we can carry on
            // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
            // A final optimisation is that an object is not hit test directly if a child has already been hit.
    
            interactive = displayObject.interactive || interactive;
    
            var hit = false;
            var interactiveParent = interactive;
    
            // if the displayobject has a hitArea, then it does not need to hitTest children.
            if (displayObject.hitArea) {
                interactiveParent = false;
            }
            // it has a mask! Then lets hit test that before continuing
            else if (hitTest && displayObject._mask) {
                    if (!displayObject._mask.containsPoint(point)) {
                        hitTest = false;
                    }
                }
    
            // ** FREE TIP **! If an object is not interactive or has no buttons in it
            // (such as a game scene!) set interactiveChildren to false for that displayObject.
            // This will allow pixi to completely ignore and bypass checking the displayObjects children.
            if (displayObject.interactiveChildren && displayObject.children) {
                var children = displayObject.children;
    
                for (var i = children.length - 1; i >= 0; i--) {
                    var child = children[i];
    
                    // time to get recursive.. if this function will return if something is hit..
                    var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);
    
                    if (childHit) {
                        // its a good idea to check if a child has lost its parent.
                        // this means it has been removed whilst looping so its best
                        if (!child.parent) {
                            continue;
                        }
    
                        // we no longer need to hit test any more objects in this container as we we
                        // now know the parent has been hit
                        interactiveParent = false;
    
                        // If the child is interactive , that means that the object hit was actually
                        // interactive and not just the child of an interactive object.
                        // This means we no longer need to hit test anything else. We still need to run
                        // through all objects, but we don't need to perform any hit tests.
    
                        if (childHit) {
                            if (interactionEvent.target) {
                                hitTest = false;
                            }
                            hit = true;
                        }
                    }
                }
            }
    
            // no point running this if the item is not interactive or does not have an interactive parent.
            if (interactive) {
                // if we are hit testing (as in we have no hit any objects yet)
                // We also don't need to worry about hit testing if once of the displayObjects children
                // has already been hit - but only if it was interactive, otherwise we need to keep
                // looking for an interactive child, just in case we hit one
                if (hitTest && !interactionEvent.target) {
                    if (displayObject.hitArea) {
                        displayObject.worldTransform.applyInverse(point, this._tempPoint);
                        if (displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                            hit = true;
                        }
                    } else if (displayObject.containsPoint) {
                        if (displayObject.containsPoint(point)) {
                            hit = true;
                        }
                    }
                }
    
                if (displayObject.interactive) {
                    if (hit && !interactionEvent.target) {
                        interactionEvent.target = displayObject;
                    }
    
                    func(interactionEvent, displayObject, !!hit);
                }
            }
    
            return hit;
        };
    
        /**
         * Is called when the pointer button is pressed down on the renderer element
         *
         * @private
         * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
         */
    
    
        InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
            var events = this.normalizeToPointerData(originalEvent);
    
            /**
             * No need to prevent default on natural pointer events, as there are no side effects
             * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
             * so still need to be prevented.
             */
    
            // Guaranteed that there will be at least one event in events, and all events must have the same pointer type
    
            if (this.autoPreventDefault && events[0].isNormalized) {
                originalEvent.preventDefault();
            }
    
            var eventLen = events.length;
    
            for (var i = 0; i < eventLen; i++) {
                var event = events[i];
    
                var interactionData = this.getInteractionDataForPointerId(event);
    
                var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
    
                interactionEvent.data.originalEvent = originalEvent;
    
                this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);
    
                this.emit('pointerdown', interactionEvent);
                if (event.pointerType === 'touch') {
                    this.emit('touchstart', interactionEvent);
                } else if (event.pointerType === 'mouse') {
                    var isRightButton = event.button === 2 || event.which === 3;
    
                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
                }
            }
        };
    
        /**
         * Processes the result of the pointer down check and dispatches the event if need be
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
         * @param {boolean} hit - the result of the hit test on the display object
         */
    
    
        InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
            var e = interactionEvent.data.originalEvent;
    
            var id = interactionEvent.data.identifier;
    
            if (hit) {
                if (!displayObject.trackedPointers[id]) {
                    displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
                }
                this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);
    
                if (e.type === 'touchstart' || e.pointerType === 'touch') {
                    this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
                } else if (e.type === 'mousedown' || e.pointerType === 'mouse') {
                    var isRightButton = e.button === 2 || e.which === 3;
    
                    if (isRightButton) {
                        displayObject.trackedPointers[id].rightDown = true;
                    } else {
                        displayObject.trackedPointers[id].leftDown = true;
                    }
    
                    this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
                }
            }
        };
    
        /**
         * Is called when the pointer button is released on the renderer element
         *
         * @private
         * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
         * @param {boolean} cancelled - true if the pointer is cancelled
         * @param {Function} func - Function passed to {@link processInteractive}
         */
    
    
        InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
            var events = this.normalizeToPointerData(originalEvent);
    
            var eventLen = events.length;
    
            for (var i = 0; i < eventLen; i++) {
                var event = events[i];
    
                var interactionData = this.getInteractionDataForPointerId(event);
    
                var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
    
                interactionEvent.data.originalEvent = originalEvent;
    
                this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, true);
    
                this.emit(cancelled ? 'pointercancel' : 'pointerup', interactionEvent);
    
                if (event.pointerType === 'mouse') {
                    var isRightButton = event.button === 2 || event.which === 3;
    
                    this.emit(isRightButton ? 'rightup' : 'mouseup', interactionEvent);
                } else if (event.pointerType === 'touch') {
                    this.emit(cancelled ? 'touchcancel' : 'touchend', interactionEvent);
                    this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
                }
            }
        };
    
        /**
         * Is called when the pointer button is cancelled
         *
         * @private
         * @param {PointerEvent} event - The DOM event of a pointer button being released
         */
    
    
        InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
            this.onPointerComplete(event, true, this.processPointerCancel);
        };
    
        /**
         * Processes the result of the pointer cancel check and dispatches the event if need be
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
         */
    
    
        InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
            var e = interactionEvent.data.originalEvent;
    
            var id = interactionEvent.data.identifier;
    
            if (displayObject.trackedPointers[id] !== undefined) {
                delete displayObject.trackedPointers[id];
                this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);
    
                if (e.type === 'touchcancel' || e.pointerType === 'touch') {
                    this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
                }
            }
        };
    
        /**
         * Is called when the pointer button is released on the renderer element
         *
         * @private
         * @param {PointerEvent} event - The DOM event of a pointer button being released
         */
    
    
        InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
            this.onPointerComplete(event, false, this.processPointerUp);
        };
    
        /**
         * Processes the result of the pointer up check and dispatches the event if need be
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
         * @param {boolean} hit - the result of the hit test on the display object
         */
    
    
        InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
            var e = interactionEvent.data.originalEvent;
    
            var id = interactionEvent.data.identifier;
    
            var trackingData = displayObject.trackedPointers[id];
    
            var isTouch = e.type === 'touchend' || e.pointerType === 'touch';
    
            var isMouse = e.type.indexOf('mouse') === 0 || e.pointerType === 'mouse';
    
            // Mouse only
            if (isMouse) {
                var isRightButton = e.button === 2 || e.which === 3;
    
                var flags = _InteractionTrackingData2.default.FLAGS;
    
                var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;
    
                var isDown = trackingData !== undefined && trackingData.flags & test;
    
                if (hit) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);
    
                    if (isDown) {
                        this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
                    }
                } else if (isDown) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
                }
                // update the down state of the tracking data
                if (trackingData) {
                    if (isRightButton) {
                        trackingData.rightDown = false;
                    } else {
                        trackingData.leftDown = false;
                    }
                }
            }
    
            // Pointers and Touches, and Mouse
            if (hit) {
                this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
                if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);
    
                if (trackingData) {
                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
                    if (isTouch) {
                        this.dispatchEvent(displayObject, 'tap', interactionEvent);
                        // touches are no longer over (if they ever were) when we get the touchend
                        // so we should ensure that we don't keep pretending that they are
                        trackingData.over = false;
                    }
                }
            } else if (trackingData) {
                this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
                if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
            }
            // Only remove the tracking data if there is no over/down state still associated with it
            if (trackingData && trackingData.none) {
                delete displayObject.trackedPointers[id];
            }
        };
    
        /**
         * Is called when the pointer moves across the renderer element
         *
         * @private
         * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
         */
    
    
        InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
            var events = this.normalizeToPointerData(originalEvent);
    
            if (events[0].pointerType === 'mouse') {
                this.didMove = true;
    
                this.cursor = null;
            }
    
            var eventLen = events.length;
    
            for (var i = 0; i < eventLen; i++) {
                var event = events[i];
    
                var interactionData = this.getInteractionDataForPointerId(event);
    
                var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
    
                interactionEvent.data.originalEvent = originalEvent;
    
                var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;
    
                this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
                this.emit('pointermove', interactionEvent);
                if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
                if (event.pointerType === 'mouse') this.emit('mousemove', interactionEvent);
            }
    
            if (events[0].pointerType === 'mouse') {
                this.setCursorMode(this.cursor);
    
                // TODO BUG for parents interactive object (border order issue)
            }
        };
    
        /**
         * Processes the result of the pointer move check and dispatches the event if need be
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
         * @param {boolean} hit - the result of the hit test on the display object
         */
    
    
        InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
            var e = interactionEvent.data.originalEvent;
    
            var isTouch = e.type === 'touchmove' || e.pointerType === 'touch';
    
            var isMouse = e.type === 'mousemove' || e.pointerType === 'mouse';
    
            if (isMouse) {
                this.processPointerOverOut(interactionEvent, displayObject, hit);
            }
    
            if (!this.moveWhenInside || hit) {
                this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
                if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
                if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
            }
        };
    
        /**
         * Is called when the pointer is moved out of the renderer element
         *
         * @private
         * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
         */
    
    
        InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
            var events = this.normalizeToPointerData(originalEvent);
    
            // Only mouse and pointer can call onPointerOut, so events will always be length 1
            var event = events[0];
    
            if (event.pointerType === 'mouse') {
                this.mouseOverRenderer = false;
                this.setCursorMode(null);
            }
    
            var interactionData = this.getInteractionDataForPointerId(event);
    
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
    
            interactionEvent.data.originalEvent = event;
    
            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);
    
            this.emit('pointerout', interactionEvent);
            if (event.pointerType === 'mouse') {
                this.emit('mouseout', interactionEvent);
            } else {
                // we can get touchleave events after touchend, so we want to make sure we don't
                // introduce memory leaks
                this.releaseInteractionDataForPointerId(interactionData.identifier);
            }
        };
    
        /**
         * Processes the result of the pointer over/out check and dispatches the event if need be
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
         * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
         * @param {boolean} hit - the result of the hit test on the display object
         */
    
    
        InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
            var e = interactionEvent.data.originalEvent;
    
            var id = interactionEvent.data.identifier;
    
            var isMouse = e.type === 'mouseover' || e.type === 'mouseout' || e.pointerType === 'mouse';
    
            var trackingData = displayObject.trackedPointers[id];
    
            // if we just moused over the display object, then we need to track that state
            if (hit && !trackingData) {
                trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
            }
    
            if (trackingData === undefined) return;
    
            if (hit && this.mouseOverRenderer) {
                if (!trackingData.over) {
                    trackingData.over = true;
                    this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
                    if (isMouse) {
                        this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
                    }
                }
    
                // only change the cursor if it has not already been changed (by something deeper in the
                // display tree)
                if (isMouse && this.cursor === null) {
                    this.cursor = displayObject.cursor;
                }
            } else if (trackingData.over) {
                trackingData.over = false;
                this.dispatchEvent(displayObject, 'pointerout', this.eventData);
                if (isMouse) {
                    this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
                }
                // if there is no mouse down information for the pointer, then it is safe to delete
                if (trackingData.none) {
                    delete displayObject.trackedPointers[id];
                }
            }
        };
    
        /**
         * Is called when the pointer is moved into the renderer element
         *
         * @private
         * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
         */
    
    
        InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
            var events = this.normalizeToPointerData(originalEvent);
    
            // Only mouse and pointer can call onPointerOver, so events will always be length 1
            var event = events[0];
    
            var interactionData = this.getInteractionDataForPointerId(event);
    
            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);
    
            interactionEvent.data.originalEvent = event;
    
            if (event.pointerType === 'mouse') {
                this.mouseOverRenderer = true;
            }
    
            this.emit('pointerover', interactionEvent);
            if (event.pointerType === 'mouse') {
                this.emit('mouseover', interactionEvent);
            }
        };
    
        /**
         * Get InteractionData for a given pointerId. Store that data as well
         *
         * @private
         * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
         * @return {InteractionData} - Interaction data for the given pointer identifier
         */
    
    
        InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
            var pointerId = event.pointerId;
    
            if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
                return this.mouse;
            } else if (this.activeInteractionData[pointerId]) {
                return this.activeInteractionData[pointerId];
            }
    
            var interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
    
            interactionData.identifier = pointerId;
            this.activeInteractionData[pointerId] = interactionData;
    
            return interactionData;
        };
    
        /**
         * Return unused InteractionData to the pool, for a given pointerId
         *
         * @private
         * @param {number} pointerId - Identifier from a pointer event
         */
    
    
        InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
            var interactionData = this.activeInteractionData[pointerId];
    
            if (interactionData) {
                delete this.activeInteractionData[pointerId];
                this.interactionDataPool.push(interactionData);
            }
        };
    
        /**
         * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
         *
         * @private
         * @param {InteractionEvent} interactionEvent - The event to be configured
         * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
         * @param {InteractionData} interactionData - The InteractionData that will be paired with the InteractionEvent
         * @return {InteractionEvent} the interaction event that was passed in
         */
    
    
        InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
            interactionEvent.data = interactionData;
    
            this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);
    
            // This is the way InteractionManager processed touch events before the refactoring, so I've kept
            // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
            // in this.resolution, so this just divides by this.resolution twice for touch events...
            if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
                interactionData.global.x = interactionData.global.x / this.resolution;
                interactionData.global.y = interactionData.global.y / this.resolution;
            }
    
            // Not really sure why this is happening, but it's how a previous version handled things
            if (pointerEvent.pointerType === 'touch') {
                pointerEvent.globalX = interactionData.global.x;
                pointerEvent.globalY = interactionData.global.y;
            }
    
            interactionData.originalEvent = pointerEvent;
            interactionEvent._reset();
    
            return interactionEvent;
        };
    
        /**
         * Ensures that the original event object contains all data that a regular pointer event would have
         *
         * @private
         * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
         * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
         *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
         */
    
    
        InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
            var normalizedEvents = [];
    
            if (this.supportsTouchEvents && event instanceof TouchEvent) {
                for (var i = 0, li = event.changedTouches.length; i < li; i++) {
                    var touch = event.changedTouches[i];
    
                    if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
                    if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
                    if (typeof touch.isPrimary === 'undefined') touch.isPrimary = event.touches.length === 1;
                    if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
                    if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
                    if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
                    if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
                    if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
                    if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
                    if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
                    if (typeof touch.rotation === 'undefined') touch.rotation = touch.rotationAngle || 0;
    
                    if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
                    if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;
    
                    // mark the touch as normalized, just so that we know we did it
                    touch.isNormalized = true;
    
                    normalizedEvents.push(touch);
                }
            }
            // apparently PointerEvent subclasses MouseEvent, so yay
            else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
                    if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
                    if (typeof event.width === 'undefined') event.width = 1;
                    if (typeof event.height === 'undefined') event.height = 1;
                    if (typeof event.tiltX === 'undefined') event.tiltX = 0;
                    if (typeof event.tiltY === 'undefined') event.tiltY = 0;
                    if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
                    if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
                    if (typeof event.pressure === 'undefined') event.pressure = 0.5;
                    if (typeof event.rotation === 'undefined') event.rotation = 0;
    
                    // mark the mouse event as normalized, just so that we know we did it
                    event.isNormalized = true;
    
                    normalizedEvents.push(event);
                } else {
                    normalizedEvents.push(event);
                }
    
            return normalizedEvents;
        };
    
        /**
         * Destroys the interaction manager
         *
         */
    
    
        InteractionManager.prototype.destroy = function destroy() {
            this.removeEvents();
    
            this.removeAllListeners();
    
            this.renderer = null;
    
            this.mouse = null;
    
            this.eventData = null;
    
            this.interactionDOMElement = null;
    
            this.onPointerDown = null;
            this.processPointerDown = null;
    
            this.onPointerUp = null;
            this.processPointerUp = null;
    
            this.onPointerCancel = null;
            this.processPointerCancel = null;
    
            this.onPointerMove = null;
            this.processPointerMove = null;
    
            this.onPointerOut = null;
            this.processPointerOverOut = null;
    
            this.onPointerOver = null;
    
            this._tempPoint = null;
        };
    
        return InteractionManager;
    }(_eventemitter2.default);
    
    exports.default = InteractionManager;
    
    
    core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
    core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
    
    },{"../core":64,"./InteractionData":151,"./InteractionEvent":152,"./InteractionTrackingData":154,"./interactiveTarget":156,"eventemitter3":4}],154:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
     *
     * @class
     * @private
     * @memberof PIXI.interaction
     */
    var InteractionTrackingData = function () {
        /**
         * @param {number} pointerId - Unique pointer id of the event
         */
        function InteractionTrackingData(pointerId) {
            _classCallCheck(this, InteractionTrackingData);
    
            this._pointerId = pointerId;
            this._flags = InteractionTrackingData.FLAGS.NONE;
        }
    
        /**
         *
         * @private
         * @param {number} flag - The interaction flag to set
         * @param {boolean} yn - Should the flag be set or unset
         */
    
    
        InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
            if (yn) {
                this._flags = this._flags | flag;
            } else {
                this._flags = this._flags & ~flag;
            }
        };
    
        /**
         * @readonly
         * @type {number} Unique pointer id of the event
         */
    
    
        _createClass(InteractionTrackingData, [{
            key: "pointerId",
            get: function get() {
                return this._pointerId;
            }
    
            /**
             * State of the tracking data, expressed as bit flags
             *
             * @member {number}
             * @memberof PIXI.interaction.InteractionTrackingData#
             */
    
        }, {
            key: "flags",
            get: function get() {
                return this._flags;
            }
    
            /**
             * Set the flags for the tracking data
             *
             * @param {number} flags - Flags to set
             */
            ,
            set: function set(flags) {
                this._flags = flags;
            }
    
            /**
             * Is the tracked event inactive (not over or down)?
             *
             * @member {number}
             * @memberof PIXI.interaction.InteractionTrackingData#
             */
    
        }, {
            key: "none",
            get: function get() {
                return this._flags === this.constructor.FLAGS.NONE;
            }
    
            /**
             * Is the tracked event over the DisplayObject?
             *
             * @member {boolean}
             * @memberof PIXI.interaction.InteractionTrackingData#
             */
    
        }, {
            key: "over",
            get: function get() {
                return (this._flags & this.constructor.FLAGS.OVER) !== 0;
            }
    
            /**
             * Set the over flag
             *
             * @param {boolean} yn - Is the event over?
             */
            ,
            set: function set(yn) {
                this._doSet(this.constructor.FLAGS.OVER, yn);
            }
    
            /**
             * Did the right mouse button come down in the DisplayObject?
             *
             * @member {boolean}
             * @memberof PIXI.interaction.InteractionTrackingData#
             */
    
        }, {
            key: "rightDown",
            get: function get() {
                return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
            }
    
            /**
             * Set the right down flag
             *
             * @param {boolean} yn - Is the right mouse button down?
             */
            ,
            set: function set(yn) {
                this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
            }
    
            /**
             * Did the left mouse button come down in the DisplayObject?
             *
             * @member {boolean}
             * @memberof PIXI.interaction.InteractionTrackingData#
             */
    
        }, {
            key: "leftDown",
            get: function get() {
                return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
            }
    
            /**
             * Set the left down flag
             *
             * @param {boolean} yn - Is the left mouse button down?
             */
            ,
            set: function set(yn) {
                this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
            }
        }]);
    
        return InteractionTrackingData;
    }();
    
    exports.default = InteractionTrackingData;
    
    
    InteractionTrackingData.FLAGS = Object.freeze({
        NONE: 0,
        OVER: 1 << 0,
        LEFT_DOWN: 1 << 1,
        RIGHT_DOWN: 1 << 2
    });
    
    },{}],155:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _InteractionData = require('./InteractionData');
    
    Object.defineProperty(exports, 'InteractionData', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_InteractionData).default;
      }
    });
    
    var _InteractionManager = require('./InteractionManager');
    
    Object.defineProperty(exports, 'InteractionManager', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_InteractionManager).default;
      }
    });
    
    var _interactiveTarget = require('./interactiveTarget');
    
    Object.defineProperty(exports, 'interactiveTarget', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_interactiveTarget).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./InteractionData":151,"./InteractionManager":153,"./interactiveTarget":156}],156:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    /**
     * Default property values of interactive objects
     * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
     *
     * @mixin
     * @name interactiveTarget
     * @memberof PIXI.interaction
     * @example
     *      function MyObject() {}
     *
     *      Object.assign(
     *          core.DisplayObject.prototype,
     *          PIXI.interaction.interactiveTarget
     *      );
     */
    exports.default = {
      /**
       * Determines if the displayObject be clicked/touched
       *
       * @inner {boolean}
       */
      interactive: false,
    
      /**
       * Determines if the children to the displayObject can be clicked/touched
       * Setting this to false allows pixi to bypass a recursive hitTest function
       *
       * @inner {boolean}
       */
      interactiveChildren: true,
    
      /**
       * Interaction shape. Children will be hit first, then this shape will be checked.
       * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
       *
       * @inner {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
       */
      hitArea: null,
    
      /**
       * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
       * Setting this changes the 'cursor' property to `'pointer'`.
       *
       * @member {boolean}
       * @memberof PIXI.interaction.interactiveTarget#
       */
      get buttonMode() {
        return this.cursor === 'pointer';
      },
      set buttonMode(value) {
        if (value) {
          this.cursor = 'pointer';
        } else if (this.cursor === 'pointer') {
          this.cursor = null;
        }
      },
    
      /**
       * This defines what cursor mode is used when the mouse cursor
       * is hovered over the displayObject.
       *
       * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
       *
       * @inner {string}
       */
      cursor: null,
    
      /**
       * Internal set of all active pointers, by identifier
       *
       * @member {Map<number, InteractionTrackingData>}
       * @memberof PIXI.interaction.interactiveTarget#
       * @private
       */
      get trackedPointers() {
        if (this._trackedPointers === undefined) this._trackedPointers = {};
    
        return this._trackedPointers;
      },
    
      /**
       * Map of all tracked pointers, by identifier. Use trackedPointers to access.
       *
       * @private {Map<number, InteractionTrackingData>}
       */
      _trackedPointers: undefined
    };
    
    },{}],157:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    exports.parse = parse;
    
    exports.default = function () {
        return function bitmapFontParser(resource, next) {
            // skip if no data or not xml data
            if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
                next();
    
                return;
            }
    
            // skip if not bitmap font data, using some silly duck-typing
            if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
                next();
    
                return;
            }
    
            var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';
    
            if (resource.isDataUrl) {
                if (xmlUrl === '.') {
                    xmlUrl = '';
                }
    
                if (this.baseUrl && xmlUrl) {
                    // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
                    if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
                        xmlUrl += '/';
                    }
    
                    // remove baseUrl from xmlUrl
                    xmlUrl = xmlUrl.replace(this.baseUrl, '');
                }
            }
    
            // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
            if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
                xmlUrl += '/';
            }
    
            var textureUrl = xmlUrl + resource.data.getElementsByTagName('page')[0].getAttribute('file');
    
            if (_core.utils.TextureCache[textureUrl]) {
                // reuse existing texture
                parse(resource, _core.utils.TextureCache[textureUrl]);
                next();
            } else {
                var loadOptions = {
                    crossOrigin: resource.crossOrigin,
                    loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
                    metadata: resource.metadata.imageMetadata,
                    parentResource: resource
                };
    
                // load the texture for the font
                this.add(resource.name + '_image', textureUrl, loadOptions, function (res) {
                    parse(resource, res.texture);
                    next();
                });
            }
        };
    };
    
    var _path = require('path');
    
    var path = _interopRequireWildcard(_path);
    
    var _core = require('../core');
    
    var _resourceLoader = require('resource-loader');
    
    var _extras = require('../extras');
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    /**
     * Register a BitmapText font from loader resource.
     *
     * @function parseBitmapFontData
     * @memberof PIXI.loaders
     * @param {PIXI.loaders.Resource} resource - Loader resource.
     * @param {PIXI.Texture} texture - Reference to texture.
     */
    function parse(resource, texture) {
        resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, texture);
    }
    
    },{"../core":64,"../extras":137,"path":9,"resource-loader":35}],158:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _loader = require('./loader');
    
    Object.defineProperty(exports, 'Loader', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_loader).default;
      }
    });
    
    var _bitmapFontParser = require('./bitmapFontParser');
    
    Object.defineProperty(exports, 'bitmapFontParser', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_bitmapFontParser).default;
      }
    });
    Object.defineProperty(exports, 'parseBitmapFontData', {
      enumerable: true,
      get: function get() {
        return _bitmapFontParser.parse;
      }
    });
    
    var _spritesheetParser = require('./spritesheetParser');
    
    Object.defineProperty(exports, 'spritesheetParser', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_spritesheetParser).default;
      }
    });
    
    var _textureParser = require('./textureParser');
    
    Object.defineProperty(exports, 'textureParser', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_textureParser).default;
      }
    });
    
    var _resourceLoader = require('resource-loader');
    
    Object.defineProperty(exports, 'Resource', {
      enumerable: true,
      get: function get() {
        return _resourceLoader.Resource;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./bitmapFontParser":157,"./loader":159,"./spritesheetParser":160,"./textureParser":161,"resource-loader":35}],159:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _resourceLoader = require('resource-loader');
    
    var _resourceLoader2 = _interopRequireDefault(_resourceLoader);
    
    var _blob = require('resource-loader/lib/middlewares/parsing/blob');
    
    var _eventemitter = require('eventemitter3');
    
    var _eventemitter2 = _interopRequireDefault(_eventemitter);
    
    var _textureParser = require('./textureParser');
    
    var _textureParser2 = _interopRequireDefault(_textureParser);
    
    var _spritesheetParser = require('./spritesheetParser');
    
    var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);
    
    var _bitmapFontParser = require('./bitmapFontParser');
    
    var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     *
     * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
     *
     * ```js
     * const loader = PIXI.loader; // pixi exposes a premade instance for you to use.
     * //or
     * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
     *
     * const sprites = {};
     *
     * // Chainable `add` to enqueue a resource
     * loader.add('bunny', 'data/bunny.png')
     *       .add('spaceship', 'assets/spritesheet.json');
     * loader.add('scoreFont', 'assets/score.fnt');
     *
     * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
     * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
     * loader.pre(cachingMiddleware);
     *
     * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
     * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
     * loader.use(parsingMiddleware);
     *
     * // The `load` method loads the queue of resources, and calls the passed in callback called once all
     * // resources have loaded.
     * loader.load((loader, resources) => {
     *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
     *     // They have a couple default properties:
     *     // - `url`: The URL that the resource was loaded from
     *     // - `error`: The error that happened when trying to load (if any)
     *     // - `data`: The raw data that was loaded
     *     // also may contain other properties based on the middleware that runs.
     *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
     *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
     *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
     * });
     *
     * // throughout the process multiple signals can be dispatched.
     * loader.onProgress.add(() => {}); // called once per loaded/errored file
     * loader.onError.add(() => {}); // called once per errored file
     * loader.onLoad.add(() => {}); // called once per loaded file
     * loader.onComplete.add(() => {}); // called once when the queued resources all load.
     * ```
     *
     * @see https://github.com/englercj/resource-loader
     *
     * @class
     * @extends module:resource-loader.ResourceLoader
     * @memberof PIXI.loaders
     */
    var Loader = function (_ResourceLoader) {
        _inherits(Loader, _ResourceLoader);
    
        /**
         * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
         * @param {number} [concurrency=10] - The number of resources to load concurrently.
         */
        function Loader(baseUrl, concurrency) {
            _classCallCheck(this, Loader);
    
            var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));
    
            _eventemitter2.default.call(_this);
    
            for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
                _this.use(Loader._pixiMiddleware[i]());
            }
    
            // Compat layer, translate the new v2 signals into old v1 events.
            _this.onStart.add(function (l) {
                return _this.emit('start', l);
            });
            _this.onProgress.add(function (l, r) {
                return _this.emit('progress', l, r);
            });
            _this.onError.add(function (e, l, r) {
                return _this.emit('error', e, l, r);
            });
            _this.onLoad.add(function (l, r) {
                return _this.emit('load', l, r);
            });
            _this.onComplete.add(function (l, r) {
                return _this.emit('complete', l, r);
            });
            return _this;
        }
    
        /**
         * Adds a default middleware to the pixi loader.
         *
         * @static
         * @param {Function} fn - The middleware to add.
         */
    
    
        Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
            Loader._pixiMiddleware.push(fn);
        };
    
        return Loader;
    }(_resourceLoader2.default);
    
    // Copy EE3 prototype (mixin)
    
    
    exports.default = Loader;
    for (var k in _eventemitter2.default.prototype) {
        Loader.prototype[k] = _eventemitter2.default.prototype[k];
    }
    
    Loader._pixiMiddleware = [
    // parse any blob into more usable objects (e.g. Image)
    _blob.blobMiddlewareFactory,
    // parse any Image objects into textures
    _textureParser2.default,
    // parse any spritesheet data into multiple textures
    _spritesheetParser2.default,
    // parse bitmap font data into multiple textures
    _bitmapFontParser2.default];
    
    // Add custom extentions
    var Resource = _resourceLoader2.default.Resource;
    
    Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
    
    },{"./bitmapFontParser":157,"./spritesheetParser":160,"./textureParser":161,"eventemitter3":4,"resource-loader":35,"resource-loader/lib/middlewares/parsing/blob":36}],160:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    exports.default = function () {
        return function spritesheetParser(resource, next) {
            var resourcePath = void 0;
            var imageResourceName = resource.name + '_image';
    
            // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
            if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
                next();
    
                return;
            }
    
            var loadOptions = {
                crossOrigin: resource.crossOrigin,
                loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
                metadata: resource.metadata.imageMetadata,
                parentResource: resource
            };
    
            // Prepend url path unless the resource image is a data url
            if (resource.isDataUrl) {
                resourcePath = resource.data.meta.image;
            } else {
                resourcePath = _path2.default.dirname(resource.url.replace(this.baseUrl, '')) + '/' + resource.data.meta.image;
            }
    
            // load the image for this sheet
            this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
                var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);
    
                spritesheet.parse(function () {
                    resource.spritesheet = spritesheet;
                    resource.textures = spritesheet.textures;
                    next();
                });
            });
        };
    };
    
    var _resourceLoader = require('resource-loader');
    
    var _path = require('path');
    
    var _path2 = _interopRequireDefault(_path);
    
    var _core = require('../core');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"../core":64,"path":9,"resource-loader":35}],161:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    exports.default = function () {
        return function textureParser(resource, next) {
            // create a new texture if the data is an Image object
            if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
                resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
            }
            next();
        };
    };
    
    var _resourceLoader = require('resource-loader');
    
    var _Texture = require('../core/textures/Texture');
    
    var _Texture2 = _interopRequireDefault(_Texture);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"../core/textures/Texture":113,"resource-loader":35}],162:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var tempPoint = new core.Point();
    var tempPolygon = new core.Polygon();
    
    /**
     * Base mesh class
     * @class
     * @extends PIXI.Container
     * @memberof PIXI.mesh
     */
    
    var Mesh = function (_core$Container) {
      _inherits(Mesh, _core$Container);
    
      /**
       * @param {PIXI.Texture} texture - The texture to use
       * @param {Float32Array} [vertices] - if you want to specify the vertices
       * @param {Float32Array} [uvs] - if you want to specify the uvs
       * @param {Uint16Array} [indices] - if you want to specify the indices
       * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
       */
      function Mesh(texture, vertices, uvs, indices, drawMode) {
        _classCallCheck(this, Mesh);
    
        /**
         * The texture of the Mesh
         *
         * @member {PIXI.Texture}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));
    
        _this._texture = null;
    
        /**
         * The Uvs of the Mesh
         *
         * @member {Float32Array}
         */
        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);
    
        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */
        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);
    
        /*
         * @member {Uint16Array} An array containing the indices of the vertices
         */
        //  TODO auto generate this based on draw mode!
        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);
    
        /**
         * Version of mesh uvs are dirty or not
         *
         * @member {number}
         */
        _this.dirty = 0;
    
        /**
         * Version of mesh indices
         *
         * @member {number}
         */
        _this.indexDirty = 0;
    
        /**
         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
         * any blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = core.BLEND_MODES.NORMAL;
    
        /**
         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
         * to overlap a bit with each other.
         *
         * @member {number}
         */
        _this.canvasPadding = 0;
    
        /**
         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
         *
         * @member {number}
         * @see PIXI.mesh.Mesh.DRAW_MODES
         */
        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;
    
        // run texture setter;
        _this.texture = texture;
    
        /**
         * The default shader that is used if a mesh doesn't have a more specific one.
         *
         * @member {PIXI.Shader}
         */
        _this.shader = null;
    
        /**
         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
         * tint effect.
         *
         * @member {number}
         */
        _this.tintRgb = new Float32Array([1, 1, 1]);
    
        /**
         * A map of renderer IDs to webgl render data
         *
         * @private
         * @member {object<number, object>}
         */
        _this._glDatas = {};
    
        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
         *
         * @member {string}
         * @default 'mesh'
         */
        _this.pluginName = 'mesh';
        return _this;
      }
    
      /**
       * Renders the object using the WebGL renderer
       *
       * @private
       * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
       */
    
    
      Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
      };
    
      /**
       * Renders the object using the Canvas renderer
       *
       * @private
       * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
       */
    
    
      Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
        renderer.plugins[this.pluginName].render(this);
      };
    
      /**
       * When the texture is updated, this event will fire to update the scale and frame
       *
       * @private
       */
    
    
      Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {}
      /* empty */
    
    
      /**
       * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
       *
       */
      ;
    
      Mesh.prototype._calculateBounds = function _calculateBounds() {
        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
      };
    
      /**
       * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
       *
       * @param {PIXI.Point} point - the point to test
       * @return {boolean} the result of the test
       */
    
    
      Mesh.prototype.containsPoint = function containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) {
          return false;
        }
    
        this.worldTransform.applyInverse(point, tempPoint);
    
        var vertices = this.vertices;
        var points = tempPolygon.points;
        var indices = this.indices;
        var len = this.indices.length;
        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;
    
        for (var i = 0; i + 2 < len; i += step) {
          var ind0 = indices[i] * 2;
          var ind1 = indices[i + 1] * 2;
          var ind2 = indices[i + 2] * 2;
    
          points[0] = vertices[ind0];
          points[1] = vertices[ind0 + 1];
          points[2] = vertices[ind1];
          points[3] = vertices[ind1 + 1];
          points[4] = vertices[ind2];
          points[5] = vertices[ind2 + 1];
    
          if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
            return true;
          }
        }
    
        return false;
      };
    
      /**
       * The texture that the mesh uses.
       *
       * @member {PIXI.Texture}
       */
    
    
      _createClass(Mesh, [{
        key: 'texture',
        get: function get() {
          return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
          if (this._texture === value) {
            return;
          }
    
          this._texture = value;
    
          if (value) {
            // wait for the texture to load
            if (value.baseTexture.hasLoaded) {
              this._onTextureUpdate();
            } else {
              value.once('update', this._onTextureUpdate, this);
            }
          }
        }
    
        /**
         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */
    
      }, {
        key: 'tint',
        get: function get() {
          return core.utils.rgb2hex(this.tintRgb);
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
          this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
        }
      }]);
    
      return Mesh;
    }(core.Container);
    
    /**
     * Different drawing buffer modes supported
     *
     * @static
     * @constant
     * @type {object}
     * @property {number} TRIANGLE_MESH
     * @property {number} TRIANGLES
     */
    
    
    exports.default = Mesh;
    Mesh.DRAW_MODES = {
      TRIANGLE_MESH: 0,
      TRIANGLES: 1
    };
    
    },{"../core":64}],163:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
    
    var _Plane2 = require('./Plane');
    
    var _Plane3 = _interopRequireDefault(_Plane2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var DEFAULT_BORDER_SIZE = 10;
    
    /**
     * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
     * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
     *
     *```js
     * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
     *  ```
     * <pre>
     *      A                          B
     *    +---+----------------------+---+
     *  C | 1 |          2           | 3 |
     *    +---+----------------------+---+
     *    |   |                      |   |
     *    | 4 |          5           | 6 |
     *    |   |                      |   |
     *    +---+----------------------+---+
     *  D | 7 |          8           | 9 |
     *    +---+----------------------+---+
    
     *  When changing this objects width and/or height:
     *     areas 1 3 7 and 9 will remain unscaled.
     *     areas 2 and 8 will be stretched horizontally
     *     areas 4 and 6 will be stretched vertically
     *     area 5 will be stretched both horizontally and vertically
     * </pre>
     *
     * @class
     * @extends PIXI.mesh.Plane
     * @memberof PIXI.mesh
     *
     */
    
    var NineSlicePlane = function (_Plane) {
        _inherits(NineSlicePlane, _Plane);
    
        /**
         * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
         * @param {int} [leftWidth=10] size of the left vertical bar (A)
         * @param {int} [topHeight=10] size of the top horizontal bar (C)
         * @param {int} [rightWidth=10] size of the right vertical bar (B)
         * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
         */
        function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
            _classCallCheck(this, NineSlicePlane);
    
            var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));
    
            var uvs = _this.uvs;
    
            // right and bottom uv's are always 1
            uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
            uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;
    
            _this._origWidth = texture.width;
            _this._origHeight = texture.height;
            _this._uvw = 1 / _this._origWidth;
            _this._uvh = 1 / _this._origHeight;
    
            /**
             * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.width = texture.width;
    
            /**
             * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.height = texture.height;
    
            uvs[2] = uvs[10] = uvs[18] = uvs[26] = _this._uvw * leftWidth;
            uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _this._uvw * rightWidth;
            uvs[9] = uvs[11] = uvs[13] = uvs[15] = _this._uvh * topHeight;
            uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _this._uvh * bottomHeight;
    
            /**
             * The width of the left column (a)
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;
    
            /**
             * The width of the right column (b)
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;
    
            /**
             * The height of the top row (c)
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;
    
            /**
             * The height of the bottom row (d)
             *
             * @member {number}
             * @memberof PIXI.NineSlicePlane#
             * @override
             */
            _this.bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;
            return _this;
        }
    
        /**
         * Updates the horizontal vertices.
         *
         */
    
    
        NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
            var vertices = this.vertices;
    
            vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight;
            vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight;
            vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
        };
    
        /**
         * Updates the vertical vertices.
         *
         */
    
    
        NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
            var vertices = this.vertices;
    
            vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth;
            vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth;
            vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
        };
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
         */
    
    
        NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
            var context = renderer.context;
    
            context.globalAlpha = this.worldAlpha;
    
            var transform = this.worldTransform;
            var res = renderer.resolution;
    
            if (renderer.roundPixels) {
                context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
            } else {
                context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
            }
    
            var base = this._texture.baseTexture;
            var textureSource = base.source;
            var w = base.width;
            var h = base.height;
    
            this.drawSegment(context, textureSource, w, h, 0, 1, 10, 11);
            this.drawSegment(context, textureSource, w, h, 2, 3, 12, 13);
            this.drawSegment(context, textureSource, w, h, 4, 5, 14, 15);
            this.drawSegment(context, textureSource, w, h, 8, 9, 18, 19);
            this.drawSegment(context, textureSource, w, h, 10, 11, 20, 21);
            this.drawSegment(context, textureSource, w, h, 12, 13, 22, 23);
            this.drawSegment(context, textureSource, w, h, 16, 17, 26, 27);
            this.drawSegment(context, textureSource, w, h, 18, 19, 28, 29);
            this.drawSegment(context, textureSource, w, h, 20, 21, 30, 31);
        };
    
        /**
         * Renders one segment of the plane.
         * to mimic the exact drawing behavior of stretching the image like WebGL does, we need to make sure
         * that the source area is at least 1 pixel in size, otherwise nothing gets drawn when a slice size of 0 is used.
         *
         * @private
         * @param {CanvasRenderingContext2D} context - The context to draw with.
         * @param {CanvasImageSource} textureSource - The source to draw.
         * @param {number} w - width of the texture
         * @param {number} h - height of the texture
         * @param {number} x1 - x index 1
         * @param {number} y1 - y index 1
         * @param {number} x2 - x index 2
         * @param {number} y2 - y index 2
         */
    
    
        NineSlicePlane.prototype.drawSegment = function drawSegment(context, textureSource, w, h, x1, y1, x2, y2) {
            // otherwise you get weird results when using slices of that are 0 wide or high.
            var uvs = this.uvs;
            var vertices = this.vertices;
    
            var sw = (uvs[x2] - uvs[x1]) * w;
            var sh = (uvs[y2] - uvs[y1]) * h;
            var dw = vertices[x2] - vertices[x1];
            var dh = vertices[y2] - vertices[y1];
    
            // make sure the source is at least 1 pixel wide and high, otherwise nothing will be drawn.
            if (sw < 1) {
                sw = 1;
            }
    
            if (sh < 1) {
                sh = 1;
            }
    
            // make sure destination is at least 1 pixel wide and high, otherwise you get
            // lines when rendering close to original size.
            if (dw < 1) {
                dw = 1;
            }
    
            if (dh < 1) {
                dh = 1;
            }
    
            context.drawImage(textureSource, uvs[x1] * w, uvs[y1] * h, sw, sh, vertices[x1], vertices[y1], dw, dh);
        };
    
        /**
         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         */
    
    
        _createClass(NineSlicePlane, [{
            key: 'width',
            get: function get() {
                return this._width;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._width = value;
                this.updateVerticalVertices();
            }
    
            /**
             * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
             *
             * @member {number}
             */
    
        }, {
            key: 'height',
            get: function get() {
                return this._height;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._height = value;
                this.updateHorizontalVertices();
            }
    
            /**
             * The width of the left column
             *
             * @member {number}
             */
    
        }, {
            key: 'leftWidth',
            get: function get() {
                return this._leftWidth;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._leftWidth = value;
    
                var uvs = this.uvs;
                var vertices = this.vertices;
    
                uvs[2] = uvs[10] = uvs[18] = uvs[26] = this._uvw * value;
                vertices[2] = vertices[10] = vertices[18] = vertices[26] = value;
    
                this.dirty = true;
            }
    
            /**
             * The width of the right column
             *
             * @member {number}
             */
    
        }, {
            key: 'rightWidth',
            get: function get() {
                return this._rightWidth;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._rightWidth = value;
    
                var uvs = this.uvs;
                var vertices = this.vertices;
    
                uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - this._uvw * value;
                vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - value;
    
                this.dirty = true;
            }
    
            /**
             * The height of the top row
             *
             * @member {number}
             */
    
        }, {
            key: 'topHeight',
            get: function get() {
                return this._topHeight;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._topHeight = value;
    
                var uvs = this.uvs;
                var vertices = this.vertices;
    
                uvs[9] = uvs[11] = uvs[13] = uvs[15] = this._uvh * value;
                vertices[9] = vertices[11] = vertices[13] = vertices[15] = value;
    
                this.dirty = true;
            }
    
            /**
             * The height of the bottom row
             *
             * @member {number}
             */
    
        }, {
            key: 'bottomHeight',
            get: function get() {
                return this._bottomHeight;
            },
            set: function set(value) // eslint-disable-line require-jsdoc
            {
                this._bottomHeight = value;
    
                var uvs = this.uvs;
                var vertices = this.vertices;
    
                uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - this._uvh * value;
                vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - value;
    
                this.dirty = true;
            }
        }]);
    
        return NineSlicePlane;
    }(_Plane3.default);
    
    exports.default = NineSlicePlane;
    
    },{"./Plane":164}],164:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Mesh2 = require('./Mesh');
    
    var _Mesh3 = _interopRequireDefault(_Mesh2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The Plane allows you to draw a texture across several points and them manipulate these points
     *
     *```js
     * for (let i = 0; i < 20; i++) {
     *     points.push(new PIXI.Point(i * 50, 0));
     * };
     * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
     *  ```
     *
     * @class
     * @extends PIXI.mesh.Mesh
     * @memberof PIXI.mesh
     *
     */
    var Plane = function (_Mesh) {
        _inherits(Plane, _Mesh);
    
        /**
         * @param {PIXI.Texture} texture - The texture to use on the Plane.
         * @param {number} verticesX - The number of vertices in the x-axis
         * @param {number} verticesY - The number of vertices in the y-axis
         */
        function Plane(texture, verticesX, verticesY) {
            _classCallCheck(this, Plane);
    
            /**
             * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
             * call _onTextureUpdated which could call refresh too early.
             *
             * @member {boolean}
             * @private
             */
            var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
    
            _this._ready = true;
    
            _this.verticesX = verticesX || 10;
            _this.verticesY = verticesY || 10;
    
            _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
            _this.refresh();
            return _this;
        }
    
        /**
         * Refreshes
         *
         */
    
    
        Plane.prototype.refresh = function refresh() {
            var total = this.verticesX * this.verticesY;
            var verts = [];
            var colors = [];
            var uvs = [];
            var indices = [];
            var texture = this.texture;
    
            var segmentsX = this.verticesX - 1;
            var segmentsY = this.verticesY - 1;
    
            var sizeX = texture.width / segmentsX;
            var sizeY = texture.height / segmentsY;
    
            for (var i = 0; i < total; i++) {
                if (texture._uvs) {
                    var x = i % this.verticesX;
                    var y = i / this.verticesX | 0;
    
                    verts.push(x * sizeX, y * sizeY);
    
                    // this works for rectangular textures.
                    uvs.push(texture._uvs.x0 + (texture._uvs.x1 - texture._uvs.x0) * (x / (this.verticesX - 1)), texture._uvs.y0 + (texture._uvs.y3 - texture._uvs.y0) * (y / (this.verticesY - 1)));
                } else {
                    uvs.push(0);
                }
            }
    
            //  cons
    
            var totalSub = segmentsX * segmentsY;
    
            for (var _i = 0; _i < totalSub; _i++) {
                var xpos = _i % segmentsX;
                var ypos = _i / segmentsX | 0;
    
                var value = ypos * this.verticesX + xpos;
                var value2 = ypos * this.verticesX + xpos + 1;
                var value3 = (ypos + 1) * this.verticesX + xpos;
                var value4 = (ypos + 1) * this.verticesX + xpos + 1;
    
                indices.push(value, value2, value3);
                indices.push(value2, value4, value3);
            }
    
            // console.log(indices)
            this.vertices = new Float32Array(verts);
            this.uvs = new Float32Array(uvs);
            this.colors = new Float32Array(colors);
            this.indices = new Uint16Array(indices);
    
            this.indexDirty = true;
        };
    
        /**
         * Clear texture UVs when new texture is set
         *
         * @private
         */
    
    
        Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
            _Mesh3.default.prototype._onTextureUpdate.call(this);
    
            // wait for the Plane ctor to finish before calling refresh
            if (this._ready) {
                this.refresh();
            }
        };
    
        return Plane;
    }(_Mesh3.default);
    
    exports.default = Plane;
    
    },{"./Mesh":162}],165:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Mesh2 = require('./Mesh');
    
    var _Mesh3 = _interopRequireDefault(_Mesh2);
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The rope allows you to draw a texture across several points and them manipulate these points
     *
     *```js
     * for (let i = 0; i < 20; i++) {
     *     points.push(new PIXI.Point(i * 50, 0));
     * };
     * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
     *  ```
     *
     * @class
     * @extends PIXI.mesh.Mesh
     * @memberof PIXI.mesh
     *
     */
    var Rope = function (_Mesh) {
        _inherits(Rope, _Mesh);
    
        /**
         * @param {PIXI.Texture} texture - The texture to use on the rope.
         * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
         */
        function Rope(texture, points) {
            _classCallCheck(this, Rope);
    
            /*
             * @member {PIXI.Point[]} An array of points that determine the rope
             */
            var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));
    
            _this.points = points;
    
            /*
             * @member {Float32Array} An array of vertices used to construct this rope.
             */
            _this.vertices = new Float32Array(points.length * 4);
    
            /*
             * @member {Float32Array} The WebGL Uvs of the rope.
             */
            _this.uvs = new Float32Array(points.length * 4);
    
            /*
             * @member {Float32Array} An array containing the color components
             */
            _this.colors = new Float32Array(points.length * 2);
    
            /*
             * @member {Uint16Array} An array containing the indices of the vertices
             */
            _this.indices = new Uint16Array(points.length * 2);
    
            /**
             * Tracker for if the rope is ready to be drawn. Needed because Mesh ctor can
             * call _onTextureUpdated which could call refresh too early.
             *
             * @member {boolean}
             * @private
             */
            _this._ready = true;
    
            _this.refresh();
            return _this;
        }
    
        /**
         * Refreshes
         *
         */
    
    
        Rope.prototype.refresh = function refresh() {
            var points = this.points;
    
            // if too little points, or texture hasn't got UVs set yet just move on.
            if (points.length < 1 || !this._texture._uvs) {
                return;
            }
    
            // if the number of points has changed we will need to recreate the arraybuffers
            if (this.vertices.length / 4 !== points.length) {
                this.vertices = new Float32Array(points.length * 4);
                this.uvs = new Float32Array(points.length * 4);
                this.colors = new Float32Array(points.length * 2);
                this.indices = new Uint16Array(points.length * 2);
            }
    
            var uvs = this.uvs;
    
            var indices = this.indices;
            var colors = this.colors;
    
            var textureUvs = this._texture._uvs;
            var offset = new core.Point(textureUvs.x0, textureUvs.y0);
            var factor = new core.Point(textureUvs.x2 - textureUvs.x0, Number(textureUvs.y2 - textureUvs.y0));
    
            uvs[0] = 0 + offset.x;
            uvs[1] = 0 + offset.y;
            uvs[2] = 0 + offset.x;
            uvs[3] = factor.y + offset.y;
    
            colors[0] = 1;
            colors[1] = 1;
    
            indices[0] = 0;
            indices[1] = 1;
    
            var total = points.length;
    
            for (var i = 1; i < total; i++) {
                // time to do some smart drawing!
                var index = i * 4;
                var amount = i / (total - 1);
    
                uvs[index] = amount * factor.x + offset.x;
                uvs[index + 1] = 0 + offset.y;
    
                uvs[index + 2] = amount * factor.x + offset.x;
                uvs[index + 3] = factor.y + offset.y;
    
                index = i * 2;
                colors[index] = 1;
                colors[index + 1] = 1;
    
                index = i * 2;
                indices[index] = index;
                indices[index + 1] = index + 1;
            }
    
            // ensure that the changes are uploaded
            this.dirty++;
            this.indexDirty++;
        };
    
        /**
         * Clear texture UVs when new texture is set
         *
         * @private
         */
    
    
        Rope.prototype._onTextureUpdate = function _onTextureUpdate() {
            _Mesh.prototype._onTextureUpdate.call(this);
    
            // wait for the Rope ctor to finish before calling refresh
            if (this._ready) {
                this.refresh();
            }
        };
    
        /**
         * Updates the object transform for rendering
         *
         * @private
         */
    
    
        Rope.prototype.updateTransform = function updateTransform() {
            var points = this.points;
    
            if (points.length < 1) {
                return;
            }
    
            var lastPoint = points[0];
            var nextPoint = void 0;
            var perpX = 0;
            var perpY = 0;
    
            // this.count -= 0.2;
    
            var vertices = this.vertices;
            var total = points.length;
    
            for (var i = 0; i < total; i++) {
                var point = points[i];
                var index = i * 4;
    
                if (i < points.length - 1) {
                    nextPoint = points[i + 1];
                } else {
                    nextPoint = point;
                }
    
                perpY = -(nextPoint.x - lastPoint.x);
                perpX = nextPoint.y - lastPoint.y;
    
                var ratio = (1 - i / (total - 1)) * 10;
    
                if (ratio > 1) {
                    ratio = 1;
                }
    
                var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
                var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;
    
                perpX /= perpLength;
                perpY /= perpLength;
    
                perpX *= num;
                perpY *= num;
    
                vertices[index] = point.x + perpX;
                vertices[index + 1] = point.y + perpY;
                vertices[index + 2] = point.x - perpX;
                vertices[index + 3] = point.y - perpY;
    
                lastPoint = point;
            }
    
            this.containerUpdateTransform();
        };
    
        return Rope;
    }(_Mesh3.default);
    
    exports.default = Rope;
    
    },{"../core":64,"./Mesh":162}],166:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _Mesh = require('../Mesh');
    
    var _Mesh2 = _interopRequireDefault(_Mesh);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * Renderer dedicated to meshes.
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var MeshSpriteRenderer = function () {
        /**
         * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
         */
        function MeshSpriteRenderer(renderer) {
            _classCallCheck(this, MeshSpriteRenderer);
    
            this.renderer = renderer;
        }
    
        /**
         * Renders the Mesh
         *
         * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
         */
    
    
        MeshSpriteRenderer.prototype.render = function render(mesh) {
            var renderer = this.renderer;
            var context = renderer.context;
    
            var transform = mesh.worldTransform;
            var res = renderer.resolution;
    
            if (renderer.roundPixels) {
                context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
            } else {
                context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
            }
    
            renderer.setBlendMode(mesh.blendMode);
    
            if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
                this._renderTriangleMesh(mesh);
            } else {
                this._renderTriangles(mesh);
            }
        };
    
        /**
         * Draws the object in Triangle Mesh mode
         *
         * @private
         * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
         */
    
    
        MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
            // draw triangles!!
            var length = mesh.vertices.length / 2;
    
            for (var i = 0; i < length - 2; i++) {
                // draw some triangles!
                var index = i * 2;
    
                this._renderDrawTriangle(mesh, index, index + 2, index + 4);
            }
        };
    
        /**
         * Draws the object in triangle mode using canvas
         *
         * @private
         * @param {PIXI.mesh.Mesh} mesh - the current mesh
         */
    
    
        MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
            // draw triangles!!
            var indices = mesh.indices;
            var length = indices.length;
    
            for (var i = 0; i < length; i += 3) {
                // draw some triangles!
                var index0 = indices[i] * 2;
                var index1 = indices[i + 1] * 2;
                var index2 = indices[i + 2] * 2;
    
                this._renderDrawTriangle(mesh, index0, index1, index2);
            }
        };
    
        /**
         * Draws one of the triangles that from the Mesh
         *
         * @private
         * @param {PIXI.mesh.Mesh} mesh - the current mesh
         * @param {number} index0 - the index of the first vertex
         * @param {number} index1 - the index of the second vertex
         * @param {number} index2 - the index of the third vertex
         */
    
    
        MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
            var context = this.renderer.context;
            var uvs = mesh.uvs;
            var vertices = mesh.vertices;
            var texture = mesh._texture;
    
            if (!texture.valid) {
                return;
            }
    
            var base = texture.baseTexture;
            var textureSource = base.source;
            var textureWidth = base.width;
            var textureHeight = base.height;
    
            var u0 = uvs[index0] * base.width;
            var u1 = uvs[index1] * base.width;
            var u2 = uvs[index2] * base.width;
            var v0 = uvs[index0 + 1] * base.height;
            var v1 = uvs[index1 + 1] * base.height;
            var v2 = uvs[index2 + 1] * base.height;
    
            var x0 = vertices[index0];
            var x1 = vertices[index1];
            var x2 = vertices[index2];
            var y0 = vertices[index0 + 1];
            var y1 = vertices[index1 + 1];
            var y2 = vertices[index2 + 1];
    
            if (mesh.canvasPadding > 0) {
                var paddingX = mesh.canvasPadding / mesh.worldTransform.a;
                var paddingY = mesh.canvasPadding / mesh.worldTransform.d;
                var centerX = (x0 + x1 + x2) / 3;
                var centerY = (y0 + y1 + y2) / 3;
    
                var normX = x0 - centerX;
                var normY = y0 - centerY;
    
                var dist = Math.sqrt(normX * normX + normY * normY);
    
                x0 = centerX + normX / dist * (dist + paddingX);
                y0 = centerY + normY / dist * (dist + paddingY);
    
                //
    
                normX = x1 - centerX;
                normY = y1 - centerY;
    
                dist = Math.sqrt(normX * normX + normY * normY);
                x1 = centerX + normX / dist * (dist + paddingX);
                y1 = centerY + normY / dist * (dist + paddingY);
    
                normX = x2 - centerX;
                normY = y2 - centerY;
    
                dist = Math.sqrt(normX * normX + normY * normY);
                x2 = centerX + normX / dist * (dist + paddingX);
                y2 = centerY + normY / dist * (dist + paddingY);
            }
    
            context.save();
            context.beginPath();
    
            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
    
            context.closePath();
    
            context.clip();
    
            // Compute matrix transform
            var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
            var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
            var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
            var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
            var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
            var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
            var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;
    
            context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);
    
            context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);
    
            context.restore();
        };
    
        /**
         * Renders a flat Mesh
         *
         * @private
         * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
         */
    
    
        MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
            var context = this.renderer.context;
            var vertices = mesh.vertices;
            var length = vertices.length / 2;
    
            // this.count++;
    
            context.beginPath();
    
            for (var i = 1; i < length - 2; ++i) {
                // draw some triangles!
                var index = i * 2;
    
                var x0 = vertices[index];
                var y0 = vertices[index + 1];
    
                var x1 = vertices[index + 2];
                var y1 = vertices[index + 3];
    
                var x2 = vertices[index + 4];
                var y2 = vertices[index + 5];
    
                context.moveTo(x0, y0);
                context.lineTo(x1, y1);
                context.lineTo(x2, y2);
            }
    
            context.fillStyle = '#FF0000';
            context.fill();
            context.closePath();
        };
    
        /**
         * destroy the the renderer.
         *
         */
    
    
        MeshSpriteRenderer.prototype.destroy = function destroy() {
            this.renderer = null;
        };
    
        return MeshSpriteRenderer;
    }();
    
    exports.default = MeshSpriteRenderer;
    
    
    core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
    
    },{"../../core":64,"../Mesh":162}],167:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Mesh = require('./Mesh');
    
    Object.defineProperty(exports, 'Mesh', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Mesh).default;
      }
    });
    
    var _MeshRenderer = require('./webgl/MeshRenderer');
    
    Object.defineProperty(exports, 'MeshRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_MeshRenderer).default;
      }
    });
    
    var _CanvasMeshRenderer = require('./canvas/CanvasMeshRenderer');
    
    Object.defineProperty(exports, 'CanvasMeshRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasMeshRenderer).default;
      }
    });
    
    var _Plane = require('./Plane');
    
    Object.defineProperty(exports, 'Plane', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Plane).default;
      }
    });
    
    var _NineSlicePlane = require('./NineSlicePlane');
    
    Object.defineProperty(exports, 'NineSlicePlane', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_NineSlicePlane).default;
      }
    });
    
    var _Rope = require('./Rope');
    
    Object.defineProperty(exports, 'Rope', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_Rope).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./Mesh":162,"./NineSlicePlane":163,"./Plane":164,"./Rope":165,"./canvas/CanvasMeshRenderer":166,"./webgl/MeshRenderer":168}],168:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    var _Mesh = require('../Mesh');
    
    var _Mesh2 = _interopRequireDefault(_Mesh);
    
    var _path = require('path');
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * WebGL renderer plugin for tiling sprites
     *
     * @class
     * @memberof PIXI
     * @extends PIXI.ObjectRenderer
     */
    var MeshRenderer = function (_core$ObjectRenderer) {
        _inherits(MeshRenderer, _core$ObjectRenderer);
    
        /**
         * constructor for renderer
         *
         * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
         */
        function MeshRenderer(renderer) {
            _classCallCheck(this, MeshRenderer);
    
            var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
    
            _this.shader = null;
            return _this;
        }
    
        /**
         * Sets up the renderer context and necessary buffers.
         *
         * @private
         */
    
    
        MeshRenderer.prototype.onContextChange = function onContextChange() {
            var gl = this.renderer.gl;
    
            this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 translationMatrix;\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n}\n', 'varying vec2 vTextureCoord;\nuniform float alpha;\nuniform vec3 tint;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * vec4(tint * alpha, alpha);\n}\n');
        };
    
        /**
         * renders mesh
         *
         * @param {PIXI.mesh.Mesh} mesh mesh instance
         */
    
    
        MeshRenderer.prototype.render = function render(mesh) {
            var renderer = this.renderer;
            var gl = renderer.gl;
            var texture = mesh._texture;
    
            if (!texture.valid) {
                return;
            }
    
            var glData = mesh._glDatas[renderer.CONTEXT_UID];
    
            if (!glData) {
                renderer.bindVao(null);
    
                glData = {
                    shader: this.shader,
                    vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
                    uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
                    indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
                    // build the vao object that will render..
                    vao: null,
                    dirty: mesh.dirty,
                    indexDirty: mesh.indexDirty
                };
    
                // build the vao object that will render..
                glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);
    
                mesh._glDatas[renderer.CONTEXT_UID] = glData;
            }
    
            renderer.bindVao(glData.vao);
    
            if (mesh.dirty !== glData.dirty) {
                glData.dirty = mesh.dirty;
                glData.uvBuffer.upload(mesh.uvs);
            }
    
            if (mesh.indexDirty !== glData.indexDirty) {
                glData.indexDirty = mesh.indexDirty;
                glData.indexBuffer.upload(mesh.indices);
            }
    
            glData.vertexBuffer.upload(mesh.vertices);
    
            renderer.bindShader(glData.shader);
    
            glData.shader.uniforms.uSampler = renderer.bindTexture(texture);
    
            renderer.state.setBlendMode(mesh.blendMode);
    
            glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);
            glData.shader.uniforms.alpha = mesh.worldAlpha;
            glData.shader.uniforms.tint = mesh.tintRgb;
    
            var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;
    
            glData.vao.draw(drawMode, mesh.indices.length, 0);
        };
    
        return MeshRenderer;
    }(core.ObjectRenderer);
    
    exports.default = MeshRenderer;
    
    
    core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
    
    },{"../../core":64,"../Mesh":162,"path":9,"pixi-gl-core":16}],169:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The ParticleContainer class is a really fast version of the Container built solely for speed,
     * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that advanced
     * functionality will not work. ParticleContainer implements only the basic object transform (position, scale, rotation).
     * Any other functionality like tinting, masking, etc will not work on sprites in this batch.
     *
     * It's extremely easy to use :
     *
     * ```js
     * let container = new ParticleContainer();
     *
     * for (let i = 0; i < 100; ++i)
     * {
     *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
     *     container.addChild(sprite);
     * }
     * ```
     *
     * And here you have a hundred sprites that will be renderer at the speed of light.
     *
     * @class
     * @extends PIXI.Container
     * @memberof PIXI.particles
     */
    var ParticleContainer = function (_core$Container) {
        _inherits(ParticleContainer, _core$Container);
    
        /**
         * @param {number} [maxSize=15000] - The maximum number of particles that can be renderer by the container.
         * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
         * @param {boolean} [properties.scale=false] - When true, scale be uploaded and applied.
         * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
         * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
         * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
         * @param {boolean} [properties.alpha=false] - When true, alpha be uploaded and applied.
         * @param {number} [batchSize=15000] - Number of particles per batch.
         */
        function ParticleContainer() {
            var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
            var properties = arguments[1];
            var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
    
            _classCallCheck(this, ParticleContainer);
    
            // Making sure the batch size is valid
            // 65535 is max vertex index in the index buffer (see ParticleRenderer)
            // so max number of particles is 65536 / 4 = 16384
            var _this = _possibleConstructorReturn(this, _core$Container.call(this));
    
            var maxBatchSize = 16384;
    
            if (batchSize > maxBatchSize) {
                batchSize = maxBatchSize;
            }
    
            if (batchSize > maxSize) {
                batchSize = maxSize;
            }
    
            /**
             * Set properties to be dynamic (true) / static (false)
             *
             * @member {boolean[]}
             * @private
             */
            _this._properties = [false, true, false, false, false];
    
            /**
             * @member {number}
             * @private
             */
            _this._maxSize = maxSize;
    
            /**
             * @member {number}
             * @private
             */
            _this._batchSize = batchSize;
    
            /**
             * @member {object<number, WebGLBuffer>}
             * @private
             */
            _this._glBuffers = {};
    
            /**
             * @member {number}
             * @private
             */
            _this._bufferToUpdate = 0;
    
            /**
             * @member {boolean}
             *
             */
            _this.interactiveChildren = false;
    
            /**
             * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
             * to reset the blend mode.
             *
             * @member {number}
             * @default PIXI.BLEND_MODES.NORMAL
             * @see PIXI.BLEND_MODES
             */
            _this.blendMode = core.BLEND_MODES.NORMAL;
    
            /**
             * Used for canvas renderering. If true then the elements will be positioned at the
             * nearest pixel. This provides a nice speed boost.
             *
             * @member {boolean}
             * @default true;
             */
            _this.roundPixels = true;
    
            /**
             * The texture used to render the children.
             *
             * @readonly
             * @member {BaseTexture}
             */
            _this.baseTexture = null;
    
            _this.setProperties(properties);
            return _this;
        }
    
        /**
         * Sets the private properties array to dynamic / static based on the passed properties object
         *
         * @param {object} properties - The properties to be uploaded
         */
    
    
        ParticleContainer.prototype.setProperties = function setProperties(properties) {
            if (properties) {
                this._properties[0] = 'scale' in properties ? !!properties.scale : this._properties[0];
                this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
                this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
                this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
                this._properties[4] = 'alpha' in properties ? !!properties.alpha : this._properties[4];
            }
        };
    
        /**
         * Updates the object transform for rendering
         *
         * @private
         */
    
    
        ParticleContainer.prototype.updateTransform = function updateTransform() {
            // TODO don't need to!
            this.displayObjectUpdateTransform();
            //  PIXI.Container.prototype.updateTransform.call( this );
        };
    
        /**
         * Renders the container using the WebGL renderer
         *
         * @private
         * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
         */
    
    
        ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
            var _this2 = this;
    
            if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
                return;
            }
    
            if (!this.baseTexture) {
                this.baseTexture = this.children[0]._texture.baseTexture;
                if (!this.baseTexture.hasLoaded) {
                    this.baseTexture.once('update', function () {
                        return _this2.onChildrenChange(0);
                    });
                }
            }
    
            renderer.setObjectRenderer(renderer.plugins.particle);
            renderer.plugins.particle.render(this);
        };
    
        /**
         * Set the flag that static data should be updated to true
         *
         * @private
         * @param {number} smallestChildIndex - The smallest child index
         */
    
    
        ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
            var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);
    
            if (bufferIndex < this._bufferToUpdate) {
                this._bufferToUpdate = bufferIndex;
            }
        };
    
        /**
         * Renders the object using the Canvas renderer
         *
         * @private
         * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
         */
    
    
        ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
            if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
                return;
            }
    
            var context = renderer.context;
            var transform = this.worldTransform;
            var isRotated = true;
    
            var positionX = 0;
            var positionY = 0;
    
            var finalWidth = 0;
            var finalHeight = 0;
    
            var compositeOperation = renderer.blendModes[this.blendMode];
    
            if (compositeOperation !== context.globalCompositeOperation) {
                context.globalCompositeOperation = compositeOperation;
            }
    
            context.globalAlpha = this.worldAlpha;
    
            this.displayObjectUpdateTransform();
    
            for (var i = 0; i < this.children.length; ++i) {
                var child = this.children[i];
    
                if (!child.visible) {
                    continue;
                }
    
                var frame = child._texture.frame;
    
                context.globalAlpha = this.worldAlpha * child.alpha;
    
                if (child.rotation % (Math.PI * 2) === 0) {
                    // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
                    if (isRotated) {
                        context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);
    
                        isRotated = false;
                    }
    
                    positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
                    positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;
    
                    finalWidth = frame.width * child.scale.x;
                    finalHeight = frame.height * child.scale.y;
                } else {
                    if (!isRotated) {
                        isRotated = true;
                    }
    
                    child.displayObjectUpdateTransform();
    
                    var childTransform = child.worldTransform;
    
                    if (renderer.roundPixels) {
                        context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
                    } else {
                        context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
                    }
    
                    positionX = child.anchor.x * -frame.width + 0.5;
                    positionY = child.anchor.y * -frame.height + 0.5;
    
                    finalWidth = frame.width;
                    finalHeight = frame.height;
                }
    
                var resolution = child._texture.baseTexture.resolution;
    
                context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * resolution, positionY * resolution, finalWidth * resolution, finalHeight * resolution);
            }
        };
    
        /**
         * Destroys the container
         *
         * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
         *  have been set to that value
         * @param {boolean} [options.children=false] - if set to true, all the children will have their
         *  destroy method called as well. 'options' will be passed on to those calls.
         * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the texture of the child sprite
         * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
         *  Should it destroy the base texture of the child sprite
         */
    
    
        ParticleContainer.prototype.destroy = function destroy(options) {
            _core$Container.prototype.destroy.call(this, options);
    
            if (this._buffers) {
                for (var i = 0; i < this._buffers.length; ++i) {
                    this._buffers[i].destroy();
                }
            }
    
            this._properties = null;
            this._buffers = null;
        };
    
        return ParticleContainer;
    }(core.Container);
    
    exports.default = ParticleContainer;
    
    },{"../core":64}],170:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _ParticleContainer = require('./ParticleContainer');
    
    Object.defineProperty(exports, 'ParticleContainer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ParticleContainer).default;
      }
    });
    
    var _ParticleRenderer = require('./webgl/ParticleRenderer');
    
    Object.defineProperty(exports, 'ParticleRenderer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ParticleRenderer).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./ParticleContainer":169,"./webgl/ParticleRenderer":172}],171:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _pixiGlCore = require('pixi-gl-core');
    
    var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);
    
    var _createIndicesForQuads = require('../../core/utils/createIndicesForQuads');
    
    var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * @author Mat Groves
     *
     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
     * for creating the original pixi version!
     * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
     * they now share 4 bytes on the vertex buffer
     *
     * Heavily inspired by LibGDX's ParticleBuffer:
     * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
     */
    
    /**
     * The particle buffer manages the static and dynamic buffers for a particle container.
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var ParticleBuffer = function () {
        /**
         * @param {WebGLRenderingContext} gl - The rendering context.
         * @param {object} properties - The properties to upload.
         * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
         * @param {number} size - The size of the batch.
         */
        function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
            _classCallCheck(this, ParticleBuffer);
    
            /**
             * The current WebGL drawing context.
             *
             * @member {WebGLRenderingContext}
             */
            this.gl = gl;
    
            /**
             * Size of a single vertex.
             *
             * @member {number}
             */
            this.vertSize = 2;
    
            /**
             * Size of a single vertex in bytes.
             *
             * @member {number}
             */
            this.vertByteSize = this.vertSize * 4;
    
            /**
             * The number of particles the buffer can hold
             *
             * @member {number}
             */
            this.size = size;
    
            /**
             * A list of the properties that are dynamic.
             *
             * @member {object[]}
             */
            this.dynamicProperties = [];
    
            /**
             * A list of the properties that are static.
             *
             * @member {object[]}
             */
            this.staticProperties = [];
    
            for (var i = 0; i < properties.length; ++i) {
                var property = properties[i];
    
                // Make copy of properties object so that when we edit the offset it doesn't
                // change all other instances of the object literal
                property = {
                    attribute: property.attribute,
                    size: property.size,
                    uploadFunction: property.uploadFunction,
                    offset: property.offset
                };
    
                if (dynamicPropertyFlags[i]) {
                    this.dynamicProperties.push(property);
                } else {
                    this.staticProperties.push(property);
                }
            }
    
            this.staticStride = 0;
            this.staticBuffer = null;
            this.staticData = null;
    
            this.dynamicStride = 0;
            this.dynamicBuffer = null;
            this.dynamicData = null;
    
            this.initBuffers();
        }
    
        /**
         * Sets up the renderer context and necessary buffers.
         *
         * @private
         */
    
    
        ParticleBuffer.prototype.initBuffers = function initBuffers() {
            var gl = this.gl;
            var dynamicOffset = 0;
    
            /**
             * Holds the indices of the geometry (quads) to draw
             *
             * @member {Uint16Array}
             */
            this.indices = (0, _createIndicesForQuads2.default)(this.size);
            this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);
    
            this.dynamicStride = 0;
    
            for (var i = 0; i < this.dynamicProperties.length; ++i) {
                var property = this.dynamicProperties[i];
    
                property.offset = dynamicOffset;
                dynamicOffset += property.size;
                this.dynamicStride += property.size;
            }
    
            this.dynamicData = new Float32Array(this.size * this.dynamicStride * 4);
            this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.dynamicData, gl.STREAM_DRAW);
    
            // static //
            var staticOffset = 0;
    
            this.staticStride = 0;
    
            for (var _i = 0; _i < this.staticProperties.length; ++_i) {
                var _property = this.staticProperties[_i];
    
                _property.offset = staticOffset;
                staticOffset += _property.size;
                this.staticStride += _property.size;
            }
    
            this.staticData = new Float32Array(this.size * this.staticStride * 4);
            this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.staticData, gl.STATIC_DRAW);
    
            this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);
    
            for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
                var _property2 = this.dynamicProperties[_i2];
    
                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
            }
    
            for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
                var _property3 = this.staticProperties[_i3];
    
                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
            }
        };
    
        /**
         * Uploads the dynamic properties.
         *
         * @param {PIXI.DisplayObject[]} children - The children to upload.
         * @param {number} startIndex - The index to start at.
         * @param {number} amount - The number to upload.
         */
    
    
        ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
            for (var i = 0; i < this.dynamicProperties.length; i++) {
                var property = this.dynamicProperties[i];
    
                property.uploadFunction(children, startIndex, amount, this.dynamicData, this.dynamicStride, property.offset);
            }
    
            this.dynamicBuffer.upload();
        };
    
        /**
         * Uploads the static properties.
         *
         * @param {PIXI.DisplayObject[]} children - The children to upload.
         * @param {number} startIndex - The index to start at.
         * @param {number} amount - The number to upload.
         */
    
    
        ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
            for (var i = 0; i < this.staticProperties.length; i++) {
                var property = this.staticProperties[i];
    
                property.uploadFunction(children, startIndex, amount, this.staticData, this.staticStride, property.offset);
            }
    
            this.staticBuffer.upload();
        };
    
        /**
         * Destroys the ParticleBuffer.
         *
         */
    
    
        ParticleBuffer.prototype.destroy = function destroy() {
            this.dynamicProperties = null;
            this.dynamicData = null;
            this.dynamicBuffer.destroy();
    
            this.staticProperties = null;
            this.staticData = null;
            this.staticBuffer.destroy();
        };
    
        return ParticleBuffer;
    }();
    
    exports.default = ParticleBuffer;
    
    },{"../../core/utils/createIndicesForQuads":119,"pixi-gl-core":16}],172:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _ParticleShader = require('./ParticleShader');
    
    var _ParticleShader2 = _interopRequireDefault(_ParticleShader);
    
    var _ParticleBuffer = require('./ParticleBuffer');
    
    var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @author Mat Groves
     *
     * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
     * for creating the original pixi version!
     * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
     * share 4 bytes on the vertex buffer
     *
     * Heavily inspired by LibGDX's ParticleRenderer:
     * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
     */
    
    /**
     *
     * @class
     * @private
     * @memberof PIXI
     */
    var ParticleRenderer = function (_core$ObjectRenderer) {
        _inherits(ParticleRenderer, _core$ObjectRenderer);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
         */
        function ParticleRenderer(renderer) {
            _classCallCheck(this, ParticleRenderer);
    
            // 65535 is max vertex index in the index buffer (see ParticleRenderer)
            // so max number of particles is 65536 / 4 = 16384
            // and max number of element in the index buffer is 16384 * 6 = 98304
            // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
            // let numIndices = 98304;
    
            /**
             * The default shader that is used if a sprite doesn't have a more specific one.
             *
             * @member {PIXI.Shader}
             */
            var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));
    
            _this.shader = null;
    
            _this.indexBuffer = null;
    
            _this.properties = null;
    
            _this.tempMatrix = new core.Matrix();
    
            _this.CONTEXT_UID = 0;
            return _this;
        }
    
        /**
         * When there is a WebGL context change
         *
         * @private
         */
    
    
        ParticleRenderer.prototype.onContextChange = function onContextChange() {
            var gl = this.renderer.gl;
    
            this.CONTEXT_UID = this.renderer.CONTEXT_UID;
    
            // setup default shader
            this.shader = new _ParticleShader2.default(gl);
    
            this.properties = [
            // verticesData
            {
                attribute: this.shader.attributes.aVertexPosition,
                size: 2,
                uploadFunction: this.uploadVertices,
                offset: 0
            },
            // positionData
            {
                attribute: this.shader.attributes.aPositionCoord,
                size: 2,
                uploadFunction: this.uploadPosition,
                offset: 0
            },
            // rotationData
            {
                attribute: this.shader.attributes.aRotation,
                size: 1,
                uploadFunction: this.uploadRotation,
                offset: 0
            },
            // uvsData
            {
                attribute: this.shader.attributes.aTextureCoord,
                size: 2,
                uploadFunction: this.uploadUvs,
                offset: 0
            },
            // alphaData
            {
                attribute: this.shader.attributes.aColor,
                size: 1,
                uploadFunction: this.uploadAlpha,
                offset: 0
            }];
        };
    
        /**
         * Starts a new particle batch.
         *
         */
    
    
        ParticleRenderer.prototype.start = function start() {
            this.renderer.bindShader(this.shader);
        };
    
        /**
         * Renders the particle container object.
         *
         * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
         */
    
    
        ParticleRenderer.prototype.render = function render(container) {
            var children = container.children;
            var maxSize = container._maxSize;
            var batchSize = container._batchSize;
            var renderer = this.renderer;
            var totalChildren = children.length;
    
            if (totalChildren === 0) {
                return;
            } else if (totalChildren > maxSize) {
                totalChildren = maxSize;
            }
    
            var buffers = container._glBuffers[renderer.CONTEXT_UID];
    
            if (!buffers) {
                buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
            }
    
            // if the uvs have not updated then no point rendering just yet!
            this.renderer.setBlendMode(container.blendMode);
    
            var gl = renderer.gl;
    
            var m = container.worldTransform.copy(this.tempMatrix);
    
            m.prepend(renderer._activeRenderTarget.projectionMatrix);
    
            this.shader.uniforms.projectionMatrix = m.toArray(true);
            this.shader.uniforms.uAlpha = container.worldAlpha;
    
            // make sure the texture is bound..
            var baseTexture = children[0]._texture.baseTexture;
    
            this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);
    
            // now lets upload and render the buffers..
            for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
                var amount = totalChildren - i;
    
                if (amount > batchSize) {
                    amount = batchSize;
                }
    
                var buffer = buffers[j];
    
                // we always upload the dynamic
                buffer.uploadDynamic(children, i, amount);
    
                // we only upload the static content when we have to!
                if (container._bufferToUpdate === j) {
                    buffer.uploadStatic(children, i, amount);
                    container._bufferToUpdate = j + 1;
                }
    
                // bind the buffer
                renderer.bindVao(buffer.vao);
                buffer.vao.draw(gl.TRIANGLES, amount * 6);
            }
        };
    
        /**
         * Creates one particle buffer for each child in the container we want to render and updates internal properties
         *
         * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
         * @return {PIXI.ParticleBuffer[]} The buffers
         */
    
    
        ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
            var gl = this.renderer.gl;
            var buffers = [];
            var size = container._maxSize;
            var batchSize = container._batchSize;
            var dynamicPropertyFlags = container._properties;
    
            for (var i = 0; i < size; i += batchSize) {
                buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
            }
    
            return buffers;
        };
    
        /**
         * Uploads the verticies.
         *
         * @param {PIXI.DisplayObject[]} children - the array of display objects to render
         * @param {number} startIndex - the index to start from in the children array
         * @param {number} amount - the amount of children that will have their vertices uploaded
         * @param {number[]} array - The vertices to upload.
         * @param {number} stride - Stride to use for iteration.
         * @param {number} offset - Offset to start at.
         */
    
    
        ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
            var w0 = 0;
            var w1 = 0;
            var h0 = 0;
            var h1 = 0;
    
            for (var i = 0; i < amount; ++i) {
                var sprite = children[startIndex + i];
                var texture = sprite._texture;
                var sx = sprite.scale.x;
                var sy = sprite.scale.y;
                var trim = texture.trim;
                var orig = texture.orig;
    
                if (trim) {
                    // if the sprite is trimmed and is not a tilingsprite then we need to add the
                    // extra space before transforming the sprite coords..
                    w1 = trim.x - sprite.anchor.x * orig.width;
                    w0 = w1 + trim.width;
    
                    h1 = trim.y - sprite.anchor.y * orig.height;
                    h0 = h1 + trim.height;
                } else {
                    w0 = orig.width * (1 - sprite.anchor.x);
                    w1 = orig.width * -sprite.anchor.x;
    
                    h0 = orig.height * (1 - sprite.anchor.y);
                    h1 = orig.height * -sprite.anchor.y;
                }
    
                array[offset] = w1 * sx;
                array[offset + 1] = h1 * sy;
    
                array[offset + stride] = w0 * sx;
                array[offset + stride + 1] = h1 * sy;
    
                array[offset + stride * 2] = w0 * sx;
                array[offset + stride * 2 + 1] = h0 * sy;
    
                array[offset + stride * 3] = w1 * sx;
                array[offset + stride * 3 + 1] = h0 * sy;
    
                offset += stride * 4;
            }
        };
    
        /**
         *
         * @param {PIXI.DisplayObject[]} children - the array of display objects to render
         * @param {number} startIndex - the index to start from in the children array
         * @param {number} amount - the amount of children that will have their positions uploaded
         * @param {number[]} array - The vertices to upload.
         * @param {number} stride - Stride to use for iteration.
         * @param {number} offset - Offset to start at.
         */
    
    
        ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
            for (var i = 0; i < amount; i++) {
                var spritePosition = children[startIndex + i].position;
    
                array[offset] = spritePosition.x;
                array[offset + 1] = spritePosition.y;
    
                array[offset + stride] = spritePosition.x;
                array[offset + stride + 1] = spritePosition.y;
    
                array[offset + stride * 2] = spritePosition.x;
                array[offset + stride * 2 + 1] = spritePosition.y;
    
                array[offset + stride * 3] = spritePosition.x;
                array[offset + stride * 3 + 1] = spritePosition.y;
    
                offset += stride * 4;
            }
        };
    
        /**
         *
         * @param {PIXI.DisplayObject[]} children - the array of display objects to render
         * @param {number} startIndex - the index to start from in the children array
         * @param {number} amount - the amount of children that will have their rotation uploaded
         * @param {number[]} array - The vertices to upload.
         * @param {number} stride - Stride to use for iteration.
         * @param {number} offset - Offset to start at.
         */
    
    
        ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
            for (var i = 0; i < amount; i++) {
                var spriteRotation = children[startIndex + i].rotation;
    
                array[offset] = spriteRotation;
                array[offset + stride] = spriteRotation;
                array[offset + stride * 2] = spriteRotation;
                array[offset + stride * 3] = spriteRotation;
    
                offset += stride * 4;
            }
        };
    
        /**
         *
         * @param {PIXI.DisplayObject[]} children - the array of display objects to render
         * @param {number} startIndex - the index to start from in the children array
         * @param {number} amount - the amount of children that will have their rotation uploaded
         * @param {number[]} array - The vertices to upload.
         * @param {number} stride - Stride to use for iteration.
         * @param {number} offset - Offset to start at.
         */
    
    
        ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
            for (var i = 0; i < amount; ++i) {
                var textureUvs = children[startIndex + i]._texture._uvs;
    
                if (textureUvs) {
                    array[offset] = textureUvs.x0;
                    array[offset + 1] = textureUvs.y0;
    
                    array[offset + stride] = textureUvs.x1;
                    array[offset + stride + 1] = textureUvs.y1;
    
                    array[offset + stride * 2] = textureUvs.x2;
                    array[offset + stride * 2 + 1] = textureUvs.y2;
    
                    array[offset + stride * 3] = textureUvs.x3;
                    array[offset + stride * 3 + 1] = textureUvs.y3;
    
                    offset += stride * 4;
                } else {
                    // TODO you know this can be easier!
                    array[offset] = 0;
                    array[offset + 1] = 0;
    
                    array[offset + stride] = 0;
                    array[offset + stride + 1] = 0;
    
                    array[offset + stride * 2] = 0;
                    array[offset + stride * 2 + 1] = 0;
    
                    array[offset + stride * 3] = 0;
                    array[offset + stride * 3 + 1] = 0;
    
                    offset += stride * 4;
                }
            }
        };
    
        /**
         *
         * @param {PIXI.DisplayObject[]} children - the array of display objects to render
         * @param {number} startIndex - the index to start from in the children array
         * @param {number} amount - the amount of children that will have their rotation uploaded
         * @param {number[]} array - The vertices to upload.
         * @param {number} stride - Stride to use for iteration.
         * @param {number} offset - Offset to start at.
         */
    
    
        ParticleRenderer.prototype.uploadAlpha = function uploadAlpha(children, startIndex, amount, array, stride, offset) {
            for (var i = 0; i < amount; i++) {
                var spriteAlpha = children[startIndex + i].alpha;
    
                array[offset] = spriteAlpha;
                array[offset + stride] = spriteAlpha;
                array[offset + stride * 2] = spriteAlpha;
                array[offset + stride * 3] = spriteAlpha;
    
                offset += stride * 4;
            }
        };
    
        /**
         * Destroys the ParticleRenderer.
         *
         */
    
    
        ParticleRenderer.prototype.destroy = function destroy() {
            if (this.renderer.gl) {
                this.renderer.gl.deleteBuffer(this.indexBuffer);
            }
    
            _core$ObjectRenderer.prototype.destroy.call(this);
    
            this.shader.destroy();
    
            this.indices = null;
            this.tempMatrix = null;
        };
    
        return ParticleRenderer;
    }(core.ObjectRenderer);
    
    exports.default = ParticleRenderer;
    
    
    core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
    
    },{"../../core":64,"./ParticleBuffer":171,"./ParticleShader":173}],173:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _Shader2 = require('../../core/Shader');
    
    var _Shader3 = _interopRequireDefault(_Shader2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * @class
     * @extends PIXI.Shader
     * @memberof PIXI
     */
    var ParticleShader = function (_Shader) {
        _inherits(ParticleShader, _Shader);
    
        /**
         * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
         */
        function ParticleShader(gl) {
            _classCallCheck(this, ParticleShader);
    
            return _possibleConstructorReturn(this, _Shader.call(this, gl,
            // vertex shader
            ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute float aColor;', 'attribute vec2 aPositionCoord;', 'attribute vec2 aScale;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'varying vec2 vTextureCoord;', 'varying float vColor;', 'void main(void){', '   vec2 v = aVertexPosition;', '   v.x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   v.y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor;', '}'].join('\n'),
            // hello
            ['varying vec2 vTextureCoord;', 'varying float vColor;', 'uniform sampler2D uSampler;', 'uniform float uAlpha;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor * uAlpha;', '  if (color.a == 0.0) discard;', '  gl_FragColor = color;', '}'].join('\n')));
        }
    
        return ParticleShader;
    }(_Shader3.default);
    
    exports.default = ParticleShader;
    
    },{"../../core/Shader":43}],174:[function(require,module,exports){
    "use strict";
    
    // References:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign
    
    if (!Math.sign) {
        Math.sign = function mathSign(x) {
            x = Number(x);
    
            if (x === 0 || isNaN(x)) {
                return x;
            }
    
            return x > 0 ? 1 : -1;
        };
    }
    
    },{}],175:[function(require,module,exports){
    'use strict';
    
    var _objectAssign = require('object-assign');
    
    var _objectAssign2 = _interopRequireDefault(_objectAssign);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    if (!Object.assign) {
        Object.assign = _objectAssign2.default;
    } // References:
    // https://github.com/sindresorhus/object-assign
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
    
    },{"object-assign":7}],176:[function(require,module,exports){
    'use strict';
    
    require('./Object.assign');
    
    require('./requestAnimationFrame');
    
    require('./Math.sign');
    
    if (!window.ArrayBuffer) {
        window.ArrayBuffer = Array;
    }
    
    if (!window.Float32Array) {
        window.Float32Array = Array;
    }
    
    if (!window.Uint32Array) {
        window.Uint32Array = Array;
    }
    
    if (!window.Uint16Array) {
        window.Uint16Array = Array;
    }
    
    },{"./Math.sign":174,"./Object.assign":175,"./requestAnimationFrame":177}],177:[function(require,module,exports){
    (function (global){(function (){
    'use strict';
    
    // References:
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    // https://gist.github.com/1579671
    // http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
    // https://gist.github.com/timhall/4078614
    // https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame
    
    // Expected to be used with Browserfiy
    // Browserify automatically detects the use of `global` and passes the
    // correct reference of `global`, `self`, and finally `window`
    
    var ONE_FRAME_TIME = 16;
    
    // Date.now
    if (!(Date.now && Date.prototype.getTime)) {
        Date.now = function now() {
            return new Date().getTime();
        };
    }
    
    // performance.now
    if (!(global.performance && global.performance.now)) {
        var startTime = Date.now();
    
        if (!global.performance) {
            global.performance = {};
        }
    
        global.performance.now = function () {
            return Date.now() - startTime;
        };
    }
    
    // requestAnimationFrame
    var lastTime = Date.now();
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    
    for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
        var p = vendors[x];
    
        global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
        global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
    }
    
    if (!global.requestAnimationFrame) {
        global.requestAnimationFrame = function (callback) {
            if (typeof callback !== 'function') {
                throw new TypeError(callback + 'is not a function');
            }
    
            var currentTime = Date.now();
            var delay = ONE_FRAME_TIME + lastTime - currentTime;
    
            if (delay < 0) {
                delay = 0;
            }
    
            lastTime = currentTime;
    
            return setTimeout(function () {
                lastTime = Date.now();
                callback(performance.now());
            }, delay);
        };
    }
    
    if (!global.cancelAnimationFrame) {
        global.cancelAnimationFrame = function (id) {
            return clearTimeout(id);
        };
    }
    
    }).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    
    },{}],178:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _CountLimiter = require('./limiters/CountLimiter');
    
    var _CountLimiter2 = _interopRequireDefault(_CountLimiter);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    var SharedTicker = core.ticker.shared;
    
    /**
     * Default number of uploads per frame using prepare plugin.
     *
     * @static
     * @memberof PIXI.settings
     * @name UPLOADS_PER_FRAME
     * @type {number}
     * @default 4
     */
    core.settings.UPLOADS_PER_FRAME = 4;
    
    /**
     * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
     * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
     * to provide preparation capabilities specific to their respective renderers.
     *
     * @abstract
     * @class
     * @memberof PIXI.prepare
     */
    
    var BasePrepare = function () {
        /**
         * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
         */
        function BasePrepare(renderer) {
            var _this = this;
    
            _classCallCheck(this, BasePrepare);
    
            /**
             * The limiter to be used to control how quickly items are prepared.
             * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
             */
            this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);
    
            /**
             * Reference to the renderer.
             * @type {PIXI.SystemRenderer}
             * @protected
             */
            this.renderer = renderer;
    
            /**
             * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
             * to upload hooks. That different parameter is stored here.
             * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
             * @protected
             */
            this.uploadHookHelper = null;
    
            /**
             * Collection of items to uploads at once.
             * @type {Array<*>}
             * @private
             */
            this.queue = [];
    
            /**
             * Collection of additional hooks for finding assets.
             * @type {Array<Function>}
             * @private
             */
            this.addHooks = [];
    
            /**
             * Collection of additional hooks for processing assets.
             * @type {Array<Function>}
             * @private
             */
            this.uploadHooks = [];
    
            /**
             * Callback to call after completed.
             * @type {Array<Function>}
             * @private
             */
            this.completes = [];
    
            /**
             * If prepare is ticking (running).
             * @type {boolean}
             * @private
             */
            this.ticking = false;
    
            /**
             * 'bound' call for prepareItems().
             * @type {Function}
             * @private
             */
            this.delayedTick = function () {
                // unlikely, but in case we were destroyed between tick() and delayedTick()
                if (!_this.queue) {
                    return;
                }
                _this.prepareItems();
            };
    
            this.register(findText, drawText);
            this.register(findTextStyle, calculateTextStyle);
        }
    
        /**
         * Upload all the textures and graphics to the GPU.
         *
         * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
         *        Either the container or display object to search for items to upload, the items to upload themselves,
         *        or the callback function, if items have been added using `prepare.add`.
         * @param {Function} [done] - Optional callback when all queued uploads have completed
         */
    
    
        BasePrepare.prototype.upload = function upload(item, done) {
            if (typeof item === 'function') {
                done = item;
                item = null;
            }
    
            // If a display object, search for items
            // that we could upload
            if (item) {
                this.add(item);
            }
    
            // Get the items for upload from the display
            if (this.queue.length) {
                if (done) {
                    this.completes.push(done);
                }
    
                if (!this.ticking) {
                    this.ticking = true;
                    SharedTicker.addOnce(this.tick, this);
                }
            } else if (done) {
                done();
            }
        };
    
        /**
         * Handle tick update
         *
         * @private
         */
    
    
        BasePrepare.prototype.tick = function tick() {
            setTimeout(this.delayedTick, 0);
        };
    
        /**
         * Actually prepare items. This is handled outside of the tick because it will take a while
         * and we do NOT want to block the current animation frame from rendering.
         *
         * @private
         */
    
    
        BasePrepare.prototype.prepareItems = function prepareItems() {
            this.limiter.beginFrame();
            // Upload the graphics
            while (this.queue.length && this.limiter.allowedToUpload()) {
                var item = this.queue[0];
                var uploaded = false;
    
                if (item && !item._destroyed) {
                    for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
                        if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                            this.queue.shift();
                            uploaded = true;
                            break;
                        }
                    }
                }
    
                if (!uploaded) {
                    this.queue.shift();
                }
            }
    
            // We're finished
            if (!this.queue.length) {
                this.ticking = false;
    
                var completes = this.completes.slice(0);
    
                this.completes.length = 0;
    
                for (var _i = 0, _len = completes.length; _i < _len; _i++) {
                    completes[_i]();
                }
            } else {
                // if we are not finished, on the next rAF do this again
                SharedTicker.addOnce(this.tick, this);
            }
        };
    
        /**
         * Adds hooks for finding and uploading items.
         *
         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
                  function must return `true` if it was able to add item to the queue.
         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
         *        function must return `true` if it was able to handle upload of item.
         * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
         */
    
    
        BasePrepare.prototype.register = function register(addHook, uploadHook) {
            if (addHook) {
                this.addHooks.push(addHook);
            }
    
            if (uploadHook) {
                this.uploadHooks.push(uploadHook);
            }
    
            return this;
        };
    
        /**
         * Manually add an item to the uploading queue.
         *
         * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
         *        add to the queue
         * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
         */
    
    
        BasePrepare.prototype.add = function add(item) {
            // Add additional hooks for finding elements on special
            // types of objects that
            for (var i = 0, len = this.addHooks.length; i < len; i++) {
                if (this.addHooks[i](item, this.queue)) {
                    break;
                }
            }
    
            // Get childen recursively
            if (item instanceof core.Container) {
                for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
                    this.add(item.children[_i2]);
                }
            }
    
            return this;
        };
    
        /**
         * Destroys the plugin, don't use after this.
         *
         */
    
    
        BasePrepare.prototype.destroy = function destroy() {
            if (this.ticking) {
                SharedTicker.remove(this.tick, this);
            }
            this.ticking = false;
            this.addHooks = null;
            this.uploadHooks = null;
            this.renderer = null;
            this.completes = null;
            this.queue = null;
            this.limiter = null;
            this.uploadHookHelper = null;
        };
    
        return BasePrepare;
    }();
    
    /**
     * Built-in hook to draw PIXI.Text to its texture.
     *
     * @private
     * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
     * @param {PIXI.DisplayObject} item - Item to check
     * @return {boolean} If item was uploaded.
     */
    
    
    exports.default = BasePrepare;
    function drawText(helper, item) {
        if (item instanceof core.Text) {
            // updating text will return early if it is not dirty
            item.updateText(true);
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to calculate a text style for a PIXI.Text object.
     *
     * @private
     * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
     * @param {PIXI.DisplayObject} item - Item to check
     * @return {boolean} If item was uploaded.
     */
    function calculateTextStyle(helper, item) {
        if (item instanceof core.TextStyle) {
            var font = core.Text.getFontStyle(item);
    
            if (!core.Text.fontPropertiesCache[font]) {
                core.Text.calculateFontProperties(font);
            }
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to find Text objects.
     *
     * @private
     * @param {PIXI.DisplayObject} item - Display object to check
     * @param {Array<*>} queue - Collection of items to upload
     * @return {boolean} if a PIXI.Text object was found.
     */
    function findText(item, queue) {
        if (item instanceof core.Text) {
            // push the text style to prepare it - this can be really expensive
            if (queue.indexOf(item.style) === -1) {
                queue.push(item.style);
            }
            // also push the text object so that we can render it (to canvas/texture) if needed
            if (queue.indexOf(item) === -1) {
                queue.push(item);
            }
            // also push the Text's texture for upload to GPU
            var texture = item._texture.baseTexture;
    
            if (queue.indexOf(texture) === -1) {
                queue.push(texture);
            }
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to find TextStyle objects.
     *
     * @private
     * @param {PIXI.TextStyle} item - Display object to check
     * @param {Array<*>} queue - Collection of items to upload
     * @return {boolean} if a PIXI.TextStyle object was found.
     */
    function findTextStyle(item, queue) {
        if (item instanceof core.TextStyle) {
            if (queue.indexOf(item) === -1) {
                queue.push(item);
            }
    
            return true;
        }
    
        return false;
    }
    
    },{"../core":64,"./limiters/CountLimiter":181}],179:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _BasePrepare2 = require('../BasePrepare');
    
    var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    var CANVAS_START_SIZE = 16;
    
    /**
     * The prepare manager provides functionality to upload content to the GPU
     * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
     * textures to an offline canvas.
     * This draw call will force the texture to be moved onto the GPU.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
     *
     * @class
     * @extends PIXI.prepare.BasePrepare
     * @memberof PIXI.prepare
     */
    
    var CanvasPrepare = function (_BasePrepare) {
        _inherits(CanvasPrepare, _BasePrepare);
    
        /**
         * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
         */
        function CanvasPrepare(renderer) {
            _classCallCheck(this, CanvasPrepare);
    
            var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
    
            _this.uploadHookHelper = _this;
    
            /**
            * An offline canvas to render textures to
            * @type {HTMLCanvasElement}
            * @private
            */
            _this.canvas = document.createElement('canvas');
            _this.canvas.width = CANVAS_START_SIZE;
            _this.canvas.height = CANVAS_START_SIZE;
    
            /**
             * The context to the canvas
            * @type {CanvasRenderingContext2D}
            * @private
            */
            _this.ctx = _this.canvas.getContext('2d');
    
            // Add textures to upload
            _this.register(findBaseTextures, uploadBaseTextures);
            return _this;
        }
    
        /**
         * Destroys the plugin, don't use after this.
         *
         */
    
    
        CanvasPrepare.prototype.destroy = function destroy() {
            _BasePrepare.prototype.destroy.call(this);
            this.ctx = null;
            this.canvas = null;
        };
    
        return CanvasPrepare;
    }(_BasePrepare3.default);
    
    /**
     * Built-in hook to upload PIXI.Texture objects to the GPU.
     *
     * @private
     * @param {*} prepare - Instance of CanvasPrepare
     * @param {*} item - Item to check
     * @return {boolean} If item was uploaded.
     */
    
    
    exports.default = CanvasPrepare;
    function uploadBaseTextures(prepare, item) {
        if (item instanceof core.BaseTexture) {
            var image = item.source;
    
            // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
            // So if the width or height is equal to zero then use the canvas size
            // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
            var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
            var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);
    
            // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
            // A smaller draw can be faster.
            prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to find textures from Sprites.
     *
     * @private
     * @param {PIXI.DisplayObject} item  -Display object to check
     * @param {Array<*>} queue - Collection of items to upload
     * @return {boolean} if a PIXI.Texture object was found.
     */
    function findBaseTextures(item, queue) {
        // Objects with textures, like Sprites/Text
        if (item instanceof core.BaseTexture) {
            if (queue.indexOf(item) === -1) {
                queue.push(item);
            }
    
            return true;
        } else if (item._texture && item._texture instanceof core.Texture) {
            var texture = item._texture.baseTexture;
    
            if (queue.indexOf(texture) === -1) {
                queue.push(texture);
            }
    
            return true;
        }
    
        return false;
    }
    
    core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
    
    },{"../../core":64,"../BasePrepare":178}],180:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _WebGLPrepare = require('./webgl/WebGLPrepare');
    
    Object.defineProperty(exports, 'webgl', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_WebGLPrepare).default;
      }
    });
    
    var _CanvasPrepare = require('./canvas/CanvasPrepare');
    
    Object.defineProperty(exports, 'canvas', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CanvasPrepare).default;
      }
    });
    
    var _BasePrepare = require('./BasePrepare');
    
    Object.defineProperty(exports, 'BasePrepare', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_BasePrepare).default;
      }
    });
    
    var _CountLimiter = require('./limiters/CountLimiter');
    
    Object.defineProperty(exports, 'CountLimiter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_CountLimiter).default;
      }
    });
    
    var _TimeLimiter = require('./limiters/TimeLimiter');
    
    Object.defineProperty(exports, 'TimeLimiter', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_TimeLimiter).default;
      }
    });
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    },{"./BasePrepare":178,"./canvas/CanvasPrepare":179,"./limiters/CountLimiter":181,"./limiters/TimeLimiter":182,"./webgl/WebGLPrepare":183}],181:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
     * number of items per frame.
     *
     * @class
     * @memberof PIXI
     */
    var CountLimiter = function () {
      /**
       * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
       */
      function CountLimiter(maxItemsPerFrame) {
        _classCallCheck(this, CountLimiter);
    
        /**
         * The maximum number of items that can be prepared each frame.
         * @private
         */
        this.maxItemsPerFrame = maxItemsPerFrame;
        /**
         * The number of items that can be prepared in the current frame.
         * @type {number}
         * @private
         */
        this.itemsLeft = 0;
      }
    
      /**
       * Resets any counting properties to start fresh on a new frame.
       */
    
    
      CountLimiter.prototype.beginFrame = function beginFrame() {
        this.itemsLeft = this.maxItemsPerFrame;
      };
    
      /**
       * Checks to see if another item can be uploaded. This should only be called once per item.
       * @return {boolean} If the item is allowed to be uploaded.
       */
    
    
      CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
        return this.itemsLeft-- > 0;
      };
    
      return CountLimiter;
    }();
    
    exports.default = CountLimiter;
    
    },{}],182:[function(require,module,exports){
    "use strict";
    
    exports.__esModule = true;
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    /**
     * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
     * number of milliseconds per frame.
     *
     * @class
     * @memberof PIXI
     */
    var TimeLimiter = function () {
      /**
       * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
       */
      function TimeLimiter(maxMilliseconds) {
        _classCallCheck(this, TimeLimiter);
    
        /**
         * The maximum milliseconds that can be spent preparing items each frame.
         * @private
         */
        this.maxMilliseconds = maxMilliseconds;
        /**
         * The start time of the current frame.
         * @type {number}
         * @private
         */
        this.frameStart = 0;
      }
    
      /**
       * Resets any counting properties to start fresh on a new frame.
       */
    
    
      TimeLimiter.prototype.beginFrame = function beginFrame() {
        this.frameStart = Date.now();
      };
    
      /**
       * Checks to see if another item can be uploaded. This should only be called once per item.
       * @return {boolean} If the item is allowed to be uploaded.
       */
    
    
      TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
        return Date.now() - this.frameStart < this.maxMilliseconds;
      };
    
      return TimeLimiter;
    }();
    
    exports.default = TimeLimiter;
    
    },{}],183:[function(require,module,exports){
    'use strict';
    
    exports.__esModule = true;
    
    var _core = require('../../core');
    
    var core = _interopRequireWildcard(_core);
    
    var _BasePrepare2 = require('../BasePrepare');
    
    var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);
    
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    
    function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
    
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
    
    /**
     * The prepare manager provides functionality to upload content to the GPU.
     *
     * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
     *
     * @class
     * @extends PIXI.prepare.BasePrepare
     * @memberof PIXI.prepare
     */
    var WebGLPrepare = function (_BasePrepare) {
        _inherits(WebGLPrepare, _BasePrepare);
    
        /**
         * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
         */
        function WebGLPrepare(renderer) {
            _classCallCheck(this, WebGLPrepare);
    
            var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));
    
            _this.uploadHookHelper = _this.renderer;
    
            // Add textures and graphics to upload
            _this.register(findBaseTextures, uploadBaseTextures).register(findGraphics, uploadGraphics);
            return _this;
        }
    
        return WebGLPrepare;
    }(_BasePrepare3.default);
    
    /**
     * Built-in hook to upload PIXI.Texture objects to the GPU.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
     * @param {PIXI.DisplayObject} item - Item to check
     * @return {boolean} If item was uploaded.
     */
    
    
    exports.default = WebGLPrepare;
    function uploadBaseTextures(renderer, item) {
        if (item instanceof core.BaseTexture) {
            // if the texture already has a GL texture, then the texture has been prepared or rendered
            // before now. If the texture changed, then the changer should be calling texture.update() which
            // reuploads the texture without need for preparing it again
            if (!item._glTextures[renderer.CONTEXT_UID]) {
                renderer.textureManager.updateTexture(item);
            }
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to upload PIXI.Graphics to the GPU.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
     * @param {PIXI.DisplayObject} item - Item to check
     * @return {boolean} If item was uploaded.
     */
    function uploadGraphics(renderer, item) {
        if (item instanceof core.Graphics) {
            // if the item is not dirty and already has webgl data, then it got prepared or rendered
            // before now and we shouldn't waste time updating it again
            if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
                renderer.plugins.graphics.updateGraphics(item);
            }
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to find textures from Sprites.
     *
     * @private
     * @param {PIXI.DisplayObject} item - Display object to check
     * @param {Array<*>} queue - Collection of items to upload
     * @return {boolean} if a PIXI.Texture object was found.
     */
    function findBaseTextures(item, queue) {
        // Objects with textures, like Sprites/Text
        if (item instanceof core.BaseTexture) {
            if (queue.indexOf(item) === -1) {
                queue.push(item);
            }
    
            return true;
        } else if (item._texture && item._texture instanceof core.Texture) {
            var texture = item._texture.baseTexture;
    
            if (queue.indexOf(texture) === -1) {
                queue.push(texture);
            }
    
            return true;
        }
    
        return false;
    }
    
    /**
     * Built-in hook to find graphics.
     *
     * @private
     * @param {PIXI.DisplayObject} item - Display object to check
     * @param {Array<*>} queue - Collection of items to upload
     * @return {boolean} if a PIXI.Graphics object was found.
     */
    function findGraphics(item, queue) {
        if (item instanceof core.Graphics) {
            queue.push(item);
    
            return true;
        }
    
        return false;
    }
    
    core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
    
    },{"../../core":64,"../BasePrepare":178}],184:[function(require,module,exports){
    (function (global){(function (){
    'use strict';
    
    exports.__esModule = true;
    exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;
    
    var _polyfill = require('./polyfill');
    
    Object.keys(_polyfill).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
            enumerable: true,
            get: function get() {
                return _polyfill[key];
            }
        });
    });
    
    var _deprecation = require('./deprecation');
    
    Object.keys(_deprecation).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
            enumerable: true,
            get: function get() {
                return _deprecation[key];
            }
        });
    });
    
    var _core = require('./core');
    
    Object.keys(_core).forEach(function (key) {
        if (key === "default" || key === "__esModule") return;
        Object.defineProperty(exports, key, {
            enumerable: true,
            get: function get() {
                return _core[key];
            }
        });
    });
    
    var _accessibility = require('./accessibility');
    
    var accessibility = _interopRequireWildcard(_accessibility);
    
    var _extract = require('./extract');
    
    var extract = _interopRequireWildcard(_extract);
    
    var _extras = require('./extras');
    
    var extras = _interopRequireWildcard(_extras);
    
    var _filters = require('./filters');
    
    var filters = _interopRequireWildcard(_filters);
    
    var _interaction = require('./interaction');
    
    var interaction = _interopRequireWildcard(_interaction);
    
    var _loaders = require('./loaders');
    
    var loaders = _interopRequireWildcard(_loaders);
    
    var _mesh = require('./mesh');
    
    var mesh = _interopRequireWildcard(_mesh);
    
    var _particles = require('./particles');
    
    var particles = _interopRequireWildcard(_particles);
    
    var _prepare = require('./prepare');
    
    var prepare = _interopRequireWildcard(_prepare);
    
    function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
    
    // export libs
    
    
    // export core
    _core.utils.mixins.performMixins();
    
    // handle mixins now, after all code has been added, including deprecation
    // import polyfills. Done as an export to make sure polyfills are imported first
    exports.accessibility = accessibility;
    exports.extract = extract;
    exports.extras = extras;
    exports.filters = filters;
    exports.interaction = interaction;
    exports.loaders = loaders;
    exports.mesh = mesh;
    exports.particles = particles;
    exports.prepare = prepare;
    
    /**
     * A premade instance of the loader that can be used to load resources.
     *
     * @name loader
     * @memberof PIXI
     * @property {PIXI.loaders.Loader}
     */
    
    var loader = loaders && loaders.Loader ? new loaders.Loader() : null; // check is there in case user excludes loader lib
    
    exports.loader = loader;
    
    // Always export pixi globally.
    
    global.PIXI = exports; // eslint-disable-line
    
    }).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
    
    },{"./accessibility":41,"./core":64,"./deprecation":126,"./extract":128,"./extras":137,"./filters":148,"./interaction":155,"./loaders":158,"./mesh":167,"./particles":170,"./polyfill":176,"./prepare":180}]},{},[184])(184)
    });
    
    
    //# sourceMappingURL=pixi.js.map
    